import require$$0, { useRef, useState, useEffect, useMemo, forwardRef, useImperativeHandle, useCallback, Suspense } from "react";
import anime from "animejs";
import { Html, shaderMaterial, Float, PerspectiveCamera } from "@react-three/drei";
import { useLoader, useThree, useFrame, extend, Canvas } from "@react-three/fiber";
import * as THREE from "three";
import { Vector2, Group, Vector3, BufferGeometry, BufferAttribute, MultiplyBlending, Color, Loader, CanvasTexture, NearestFilter, FileLoader, NoToneMapping } from "three";
import Alea from "alea";
import { useSpring, animated } from "@react-spring/three";
import { useControls, button, Leva } from "leva";
import { GeoJsonGeometry } from "three-geojson-geometry";
import { ConicPolygonGeometry } from "three-conic-polygon-geometry";
import { useSpring as useSpring$1, animated as animated$1 } from "@react-spring/web";
var jsxRuntimeExports = {},
  jsxRuntime = {
    get exports() {
      return jsxRuntimeExports;
    },
    set exports(e) {
      jsxRuntimeExports = e;
    }
  },
  reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var e = require$$0,
    t = Symbol.for("react.element"),
    r = Symbol.for("react.fragment"),
    i = Object.prototype.hasOwnProperty,
    a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    n = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function u(f, p, y) {
    var v,
      A = {},
      c = null,
      E = null;
    y !== void 0 && (c = "" + y), p.key !== void 0 && (c = "" + p.key), p.ref !== void 0 && (E = p.ref);
    for (v in p) i.call(p, v) && !n.hasOwnProperty(v) && (A[v] = p[v]);
    if (f && f.defaultProps) for (v in p = f.defaultProps, p) A[v] === void 0 && (A[v] = p[v]);
    return {
      $$typeof: t,
      type: f,
      key: c,
      ref: E,
      props: A,
      _owner: a.current
    };
  }
  return reactJsxRuntime_production_min.Fragment = r, reactJsxRuntime_production_min.jsx = u, reactJsxRuntime_production_min.jsxs = u, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && function () {
    var e = require$$0,
      t = Symbol.for("react.element"),
      r = Symbol.for("react.portal"),
      i = Symbol.for("react.fragment"),
      a = Symbol.for("react.strict_mode"),
      n = Symbol.for("react.profiler"),
      u = Symbol.for("react.provider"),
      f = Symbol.for("react.context"),
      p = Symbol.for("react.forward_ref"),
      y = Symbol.for("react.suspense"),
      v = Symbol.for("react.suspense_list"),
      A = Symbol.for("react.memo"),
      c = Symbol.for("react.lazy"),
      E = Symbol.for("react.offscreen"),
      d = Symbol.iterator,
      g = "@@iterator";
    function I(O) {
      if (O === null || typeof O != "object") return null;
      var V = d && O[d] || O[g];
      return typeof V == "function" ? V : null;
    }
    var o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function s(O) {
      {
        for (var V = arguments.length, U = new Array(V > 1 ? V - 1 : 0), j = 1; j < V; j++) U[j - 1] = arguments[j];
        l("error", O, U);
      }
    }
    function l(O, V, U) {
      {
        var j = o.ReactDebugCurrentFrame,
          $ = j.getStackAddendum();
        $ !== "" && (V += "%s", U = U.concat([$]));
        var J = U.map(function (K) {
          return String(K);
        });
        J.unshift("Warning: " + V), Function.prototype.apply.call(console[O], console, J);
      }
    }
    var h = !1,
      m = !1,
      S = !1,
      b = !1,
      T = !1,
      C;
    C = Symbol.for("react.module.reference");
    function F(O) {
      return !!(typeof O == "string" || typeof O == "function" || O === i || O === n || T || O === a || O === y || O === v || b || O === E || h || m || S || typeof O == "object" && O !== null && (O.$$typeof === c || O.$$typeof === A || O.$$typeof === u || O.$$typeof === f || O.$$typeof === p ||
      // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      O.$$typeof === C || O.getModuleId !== void 0));
    }
    function w(O, V, U) {
      var j = O.displayName;
      if (j) return j;
      var $ = V.displayName || V.name || "";
      return $ !== "" ? U + "(" + $ + ")" : U;
    }
    function k(O) {
      return O.displayName || "Context";
    }
    function L(O) {
      if (O == null) return null;
      if (typeof O.tag == "number" && s("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof O == "function") return O.displayName || O.name || null;
      if (typeof O == "string") return O;
      switch (O) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case n:
          return "Profiler";
        case a:
          return "StrictMode";
        case y:
          return "Suspense";
        case v:
          return "SuspenseList";
      }
      if (typeof O == "object") switch (O.$$typeof) {
        case f:
          var V = O;
          return k(V) + ".Consumer";
        case u:
          var U = O;
          return k(U._context) + ".Provider";
        case p:
          return w(O, O.render, "ForwardRef");
        case A:
          var j = O.displayName || null;
          return j !== null ? j : L(O.type) || "Memo";
        case c:
          {
            var $ = O,
              J = $._payload,
              K = $._init;
            try {
              return L(K(J));
            } catch {
              return null;
            }
          }
      }
      return null;
    }
    var B = Object.assign,
      x = 0,
      N,
      P,
      _,
      M,
      R,
      G,
      D;
    function z() {}
    z.__reactDisabledLog = !0;
    function Y() {
      {
        if (x === 0) {
          N = console.log, P = console.info, _ = console.warn, M = console.error, R = console.group, G = console.groupCollapsed, D = console.groupEnd;
          var O = {
            configurable: !0,
            enumerable: !0,
            value: z,
            writable: !0
          };
          Object.defineProperties(console, {
            info: O,
            log: O,
            warn: O,
            error: O,
            group: O,
            groupCollapsed: O,
            groupEnd: O
          });
        }
        x++;
      }
    }
    function Z() {
      {
        if (x--, x === 0) {
          var O = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, O, {
              value: N
            }),
            info: B({}, O, {
              value: P
            }),
            warn: B({}, O, {
              value: _
            }),
            error: B({}, O, {
              value: M
            }),
            group: B({}, O, {
              value: R
            }),
            groupCollapsed: B({}, O, {
              value: G
            }),
            groupEnd: B({}, O, {
              value: D
            })
          });
        }
        x < 0 && s("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var q = o.ReactCurrentDispatcher,
      t1;
    function r1(O, V, U) {
      {
        if (t1 === void 0) try {
          throw Error();
        } catch ($) {
          var j = $.stack.trim().match(/\n( *(at )?)/);
          t1 = j && j[1] || "";
        }
        return `
` + t1 + O;
      }
    }
    var a1 = !1,
      e1;
    {
      var X = typeof WeakMap == "function" ? WeakMap : Map;
      e1 = new X();
    }
    function s1(O, V) {
      if (!O || a1) return "";
      {
        var U = e1.get(O);
        if (U !== void 0) return U;
      }
      var j;
      a1 = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var J;
      J = q.current, q.current = null, Y();
      try {
        if (V) {
          var K = function () {
            throw Error();
          };
          if (Object.defineProperty(K.prototype, "props", {
            set: function () {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(K, []);
            } catch (A1) {
              j = A1;
            }
            Reflect.construct(O, [], K);
          } else {
            try {
              K.call();
            } catch (A1) {
              j = A1;
            }
            O.call(K.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (A1) {
            j = A1;
          }
          O();
        }
      } catch (A1) {
        if (A1 && j && typeof A1.stack == "string") {
          for (var W = A1.stack.split(`
`), l1 = j.stack.split(`
`), i1 = W.length - 1, n1 = l1.length - 1; i1 >= 1 && n1 >= 0 && W[i1] !== l1[n1];) n1--;
          for (; i1 >= 1 && n1 >= 0; i1--, n1--) if (W[i1] !== l1[n1]) {
            if (i1 !== 1 || n1 !== 1) do if (i1--, n1--, n1 < 0 || W[i1] !== l1[n1]) {
              var v1 = `
` + W[i1].replace(" at new ", " at ");
              return O.displayName && v1.includes("<anonymous>") && (v1 = v1.replace("<anonymous>", O.displayName)), typeof O == "function" && e1.set(O, v1), v1;
            } while (i1 >= 1 && n1 >= 0);
            break;
          }
        }
      } finally {
        a1 = !1, q.current = J, Z(), Error.prepareStackTrace = $;
      }
      var P1 = O ? O.displayName || O.name : "",
        V1 = P1 ? r1(P1) : "";
      return typeof O == "function" && e1.set(O, V1), V1;
    }
    function H(O, V, U) {
      return s1(O, !1);
    }
    function Q(O) {
      var V = O.prototype;
      return !!(V && V.isReactComponent);
    }
    function h1(O, V, U) {
      if (O == null) return "";
      if (typeof O == "function") return s1(O, Q(O));
      if (typeof O == "string") return r1(O);
      switch (O) {
        case y:
          return r1("Suspense");
        case v:
          return r1("SuspenseList");
      }
      if (typeof O == "object") switch (O.$$typeof) {
        case p:
          return H(O.render);
        case A:
          return h1(O.type, V, U);
        case c:
          {
            var j = O,
              $ = j._payload,
              J = j._init;
            try {
              return h1(J($), V, U);
            } catch {}
          }
      }
      return "";
    }
    var p1 = Object.prototype.hasOwnProperty,
      y1 = {},
      f1 = o.ReactDebugCurrentFrame;
    function u1(O) {
      if (O) {
        var V = O._owner,
          U = h1(O.type, O._source, V ? V.type : null);
        f1.setExtraStackFrame(U);
      } else f1.setExtraStackFrame(null);
    }
    function E1(O, V, U, j, $) {
      {
        var J = Function.call.bind(p1);
        for (var K in O) if (J(O, K)) {
          var W = void 0;
          try {
            if (typeof O[K] != "function") {
              var l1 = Error((j || "React class") + ": " + U + " type `" + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof O[K] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw l1.name = "Invariant Violation", l1;
            }
            W = O[K](V, K, j, U, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (i1) {
            W = i1;
          }
          W && !(W instanceof Error) && (u1($), s("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", j || "React class", U, K, typeof W), u1(null)), W instanceof Error && !(W.message in y1) && (y1[W.message] = !0, u1($), s("Failed %s type: %s", U, W.message), u1(null));
        }
      }
    }
    var o1 = Array.isArray;
    function g1(O) {
      return o1(O);
    }
    function _1(O) {
      {
        var V = typeof Symbol == "function" && Symbol.toStringTag,
          U = V && O[Symbol.toStringTag] || O.constructor.name || "Object";
        return U;
      }
    }
    function d1(O) {
      try {
        return S1(O), !1;
      } catch {
        return !0;
      }
    }
    function S1(O) {
      return "" + O;
    }
    function c1(O) {
      if (d1(O)) return s("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", _1(O)), S1(O);
    }
    var m1 = o.ReactCurrentOwner,
      b1 = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      },
      I1,
      C1,
      N1;
    N1 = {};
    function B1(O) {
      if (p1.call(O, "ref")) {
        var V = Object.getOwnPropertyDescriptor(O, "ref").get;
        if (V && V.isReactWarning) return !1;
      }
      return O.ref !== void 0;
    }
    function U1(O) {
      if (p1.call(O, "key")) {
        var V = Object.getOwnPropertyDescriptor(O, "key").get;
        if (V && V.isReactWarning) return !1;
      }
      return O.key !== void 0;
    }
    function D1(O, V) {
      if (typeof O.ref == "string" && m1.current && V && m1.current.stateNode !== V) {
        var U = L(m1.current.type);
        N1[U] || (s('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', L(m1.current.type), O.ref), N1[U] = !0);
      }
    }
    function H1(O, V) {
      {
        var U = function () {
          I1 || (I1 = !0, s("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", V));
        };
        U.isReactWarning = !0, Object.defineProperty(O, "key", {
          get: U,
          configurable: !0
        });
      }
    }
    function z1(O, V) {
      {
        var U = function () {
          C1 || (C1 = !0, s("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", V));
        };
        U.isReactWarning = !0, Object.defineProperty(O, "ref", {
          get: U,
          configurable: !0
        });
      }
    }
    var Y1 = function (O, V, U, j, $, J, K) {
      var W = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: O,
        key: V,
        ref: U,
        props: K,
        // Record the component responsible for creating this element.
        _owner: J
      };
      return W._store = {}, Object.defineProperty(W._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(W, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: j
      }), Object.defineProperty(W, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(W.props), Object.freeze(W)), W;
    };
    function j1(O, V, U, j, $) {
      {
        var J,
          K = {},
          W = null,
          l1 = null;
        U !== void 0 && (c1(U), W = "" + U), U1(V) && (c1(V.key), W = "" + V.key), B1(V) && (l1 = V.ref, D1(V, $));
        for (J in V) p1.call(V, J) && !b1.hasOwnProperty(J) && (K[J] = V[J]);
        if (O && O.defaultProps) {
          var i1 = O.defaultProps;
          for (J in i1) K[J] === void 0 && (K[J] = i1[J]);
        }
        if (W || l1) {
          var n1 = typeof O == "function" ? O.displayName || O.name || "Unknown" : O;
          W && H1(K, n1), l1 && z1(K, n1);
        }
        return Y1(O, W, l1, $, j, m1.current, K);
      }
    }
    var M1 = o.ReactCurrentOwner,
      G1 = o.ReactDebugCurrentFrame;
    function T1(O) {
      if (O) {
        var V = O._owner,
          U = h1(O.type, O._source, V ? V.type : null);
        G1.setExtraStackFrame(U);
      } else G1.setExtraStackFrame(null);
    }
    var O1;
    O1 = !1;
    function x1(O) {
      return typeof O == "object" && O !== null && O.$$typeof === t;
    }
    function F1() {
      {
        if (M1.current) {
          var O = L(M1.current.type);
          if (O) return `

Check the render method of \`` + O + "`.";
        }
        return "";
      }
    }
    function q1(O) {
      {
        if (O !== void 0) {
          var V = O.fileName.replace(/^.*[\\\/]/, ""),
            U = O.lineNumber;
          return `

Check your code at ` + V + ":" + U + ".";
        }
        return "";
      }
    }
    var R1 = {};
    function W1(O) {
      {
        var V = F1();
        if (!V) {
          var U = typeof O == "string" ? O : O.displayName || O.name;
          U && (V = `

Check the top-level render call using <` + U + ">.");
        }
        return V;
      }
    }
    function k1(O, V) {
      {
        if (!O._store || O._store.validated || O.key != null) return;
        O._store.validated = !0;
        var U = W1(V);
        if (R1[U]) return;
        R1[U] = !0;
        var j = "";
        O && O._owner && O._owner !== M1.current && (j = " It was passed a child from " + L(O._owner.type) + "."), T1(O), s('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', U, j), T1(null);
      }
    }
    function w1(O, V) {
      {
        if (typeof O != "object") return;
        if (g1(O)) for (var U = 0; U < O.length; U++) {
          var j = O[U];
          x1(j) && k1(j, V);
        } else if (x1(O)) O._store && (O._store.validated = !0);else if (O) {
          var $ = I(O);
          if (typeof $ == "function" && $ !== O.entries) for (var J = $.call(O), K; !(K = J.next()).done;) x1(K.value) && k1(K.value, V);
        }
      }
    }
    function K1(O) {
      {
        var V = O.type;
        if (V == null || typeof V == "string") return;
        var U;
        if (typeof V == "function") U = V.propTypes;else if (typeof V == "object" && (V.$$typeof === p ||
        // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        V.$$typeof === A)) U = V.propTypes;else return;
        if (U) {
          var j = L(V);
          E1(U, O.props, "prop", j, O);
        } else if (V.PropTypes !== void 0 && !O1) {
          O1 = !0;
          var $ = L(V);
          s("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof V.getDefaultProps == "function" && !V.getDefaultProps.isReactClassApproved && s("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function $1(O) {
      {
        for (var V = Object.keys(O.props), U = 0; U < V.length; U++) {
          var j = V[U];
          if (j !== "children" && j !== "key") {
            T1(O), s("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", j), T1(null);
            break;
          }
        }
        O.ref !== null && (T1(O), s("Invalid attribute `ref` supplied to `React.Fragment`."), T1(null));
      }
    }
    function L1(O, V, U, j, $, J) {
      {
        var K = F(O);
        if (!K) {
          var W = "";
          (O === void 0 || typeof O == "object" && O !== null && Object.keys(O).length === 0) && (W += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var l1 = q1($);
          l1 ? W += l1 : W += F1();
          var i1;
          O === null ? i1 = "null" : g1(O) ? i1 = "array" : O !== void 0 && O.$$typeof === t ? (i1 = "<" + (L(O.type) || "Unknown") + " />", W = " Did you accidentally export a JSX literal instead of a component?") : i1 = typeof O, s("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", i1, W);
        }
        var n1 = j1(O, V, U, $, J);
        if (n1 == null) return n1;
        if (K) {
          var v1 = V.children;
          if (v1 !== void 0) if (j) {
            if (g1(v1)) {
              for (var P1 = 0; P1 < v1.length; P1++) w1(v1[P1], O);
              Object.freeze && Object.freeze(v1);
            } else s("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          } else w1(v1, O);
        }
        return O === i ? $1(n1) : K1(n1), n1;
      }
    }
    function J1(O, V, U) {
      return L1(O, V, U, !0);
    }
    function Z1(O, V, U) {
      return L1(O, V, U, !1);
    }
    var X1 = Z1,
      Q1 = J1;
    reactJsxRuntime_development.Fragment = i, reactJsxRuntime_development.jsx = X1, reactJsxRuntime_development.jsxs = Q1;
  }()), reactJsxRuntime_development;
}
(function (e) {
  process.env.NODE_ENV === "production" ? e.exports = requireReactJsxRuntime_production_min() : e.exports = requireReactJsxRuntime_development();
})(jsxRuntime);
const Fragment = jsxRuntimeExports.Fragment,
  jsx = jsxRuntimeExports.jsx,
  jsxs = jsxRuntimeExports.jsxs,
  postmanGlobe = "",
  Stars = _ref => {
    let {
      seed: e,
      image: t,
      count: r = 100,
      distance: i = 1e3,
      size: a = 30
    } = _ref;
    const n = useLoader(THREE.TextureLoader, t),
      u = new Alea(e),
      f = [];
    for (let v = 0; v < r; v++) f.push((u() - 0.5) * i), f.push((u() - 0.5) * i), f.push((u() - 0.5) * i);
    const p = new THREE.BufferGeometry();
    p.setAttribute("position", new THREE.Float32BufferAttribute(f, 3));
    const y = new THREE.PointsMaterial({
      map: n,
      sizeAttenuation: !1,
      size: a,
      transparent: !0
    });
    return /* @__PURE__ */jsx("points", {
      args: [p, y]
    });
  };
function lerp(e, t, r) {
  return round((1 - r) * e + r * t);
}
function damp(e, t, r, i) {
  return lerp(e, t, 1 - Math.exp(-r * i));
}
function round(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  const r = Math.pow(10, t);
  return Math.round(e * r) / r;
}
function clamp(e, t, r) {
  return round(Math.min(Math.max(t, e), r));
}
function RotatableMesh(_ref2) {
  let {
    startRotation: e = [0.72, 0.1],
    children: t
  } = _ref2;
  const {
      startRotationControl: r
    } = useControls("Globe", {
      startRotationControl: {
        value: {
          x: e[0],
          y: e[1]
        },
        step: 0.01
      }
    }, {
      collapsed: !0
    }),
    i = useRef(),
    a = useRef(),
    n = useRef({
      horizontal: !0,
      vertical: !0,
      dampingFactor: 5
    }),
    u = useRef(r),
    [f, p] = useState(!1),
    y = useRef({
      x: window.innerWidth / 2,
      y: window.innerHeight / 2
    }),
    v = useRef({
      x: 0,
      y: 0
    }),
    A = useRef({
      x: 0,
      y: 0
    }),
    c = useRef({
      x: 0,
      y: 0
    });
  useEffect(() => {
    u.current = r;
  }, [r]);
  const {
      scale: E
    } = useSpring({
      scale: f ? 0.99 : 1,
      config: {
        mass: 15,
        tension: 750,
        friction: 150,
        precision: 1e-4
      }
    }),
    d = s => {
      if (f) return;
      p(!0);
      const l = s.touches ? s.touches[0].clientX : s.clientX,
        h = s.touches ? s.touches[0].clientY : s.clientY;
      y.current = {
        x: l,
        y: h
      }, v.current = u.current;
    },
    g = s => {
      if (!f) return;
      const l = s.touches ? s.touches[0].clientX : s.clientX,
        h = s.touches ? s.touches[0].clientY : s.clientY;
      A.current = {
        x: l - y.current.x,
        y: h - y.current.y
      }, u.current = {
        y: clamp(v.current.y + (A.current.y - c.current.y) * 0.01, -0.35, 0.35),
        x: v.current.x + (A.current.x - c.current.x) * 0.01
      };
    },
    I = () => {
      p(!1);
    },
    {
      gl: o
    } = useThree();
  return useEffect(() => (o.domElement.addEventListener("mousedown", d, {
    passive: !0
  }), o.domElement.addEventListener("mousemove", g, {
    passive: !0
  }), o.domElement.addEventListener("mouseup", I), o.domElement.addEventListener("touchstart", d, {
    passive: !0
  }), o.domElement.addEventListener("touchmove", g, {
    passive: !0
  }), o.domElement.addEventListener("touchend", I), () => {
    o.domElement.removeEventListener("mousedown", d), o.domElement.removeEventListener("mousemove", g), o.domElement.removeEventListener("mouseup", I), o.domElement.removeEventListener("touchstart", d), o.domElement.removeEventListener("touchmove", g), o.domElement.removeEventListener("touchend", I);
  }), [f]), useFrame((s, l) => {
    if (a.current) {
      const {
        horizontal: h,
        vertical: m
      } = n.current;
      if (h) {
        const S = u.current.x;
        a.current.rotation.y = damp(a.current.rotation.y, S, n.current.dampingFactor, l);
      }
      if (m) {
        const S = u.current.y;
        i.current.rotation.x = damp(i.current.rotation.x, S, n.current.dampingFactor, l);
      }
    }
  }), /* @__PURE__ */jsx(animated.group, {
    ref: i,
    scale: E,
    children: /* @__PURE__ */jsx("group", {
      ref: a,
      children: t
    })
  });
}
const DEG2RAD = Math.PI / 180;
function mapLinear(e, t, r, i, a) {
  return i + (e - t) * (a - i) / (r - t);
}
function degToRad(e) {
  return e * DEG2RAD;
}
function Rig(_ref3) {
  let {
    cameraPan: e,
    cameraPanRotation: t
  } = _ref3;
  const {
      cameraPanX: r,
      cameraPanY: i,
      cameraRotation: a
    } = useControls("Camera", {
      cameraPanX: {
        label: "PanX",
        value: e[0],
        min: 0,
        max: 2,
        step: 0.01
      },
      cameraPanY: {
        label: "PanY",
        value: e[1],
        min: 0,
        max: 0.25,
        step: 0.01
      },
      cameraRotation: {
        label: "Rotation",
        value: t,
        min: 0,
        max: 10,
        step: 0.01
      }
    }, {
      collapsed: !0
    }),
    {
      camera: n
    } = useThree(),
    u = useRef(new Vector2(document.documentElement.clientWidth / 2, document.documentElement.clientHeight / 2)),
    f = useRef(new Vector2(document.documentElement.clientWidth / 2, document.documentElement.clientHeight / 2)),
    p = useRef(new Vector2()),
    y = useRef(new Group()),
    v = useRef(new Group()),
    A = useRef(new Group());
  v.current.add(A.current), y.current.add(v.current), y.current.matrixAutoUpdate = !1, v.current.matrixAutoUpdate = !1, A.current.matrixAutoUpdate = !1, v.current.rotation.y = Math.PI;
  const c = useRef(new Vector3(0, 0, 1)),
    E = useRef(new Vector3()),
    d = useRef(new Vector3()),
    g = useRef(0),
    I = useRef(0.01),
    o = useRef(0.07);
  useEffect(() => (window.addEventListener("mousemove", s, {
    passive: !0
  }), window.addEventListener("resize", l, {
    passive: !0
  }), () => {
    window.removeEventListener("mousemove", s), window.removeEventListener("resize", l);
  }), []), useEffect(() => {
    y.current.position.copy(n.position), E.current.copy(y.current.position), y.current.position.z = 12.5, E.current.z = y.current.position.z;
  }, [n]);
  function s(_ref4) {
    let {
      clientX: m,
      clientY: S
    } = _ref4;
    u.current.set(m, S);
  }
  function l() {
    y.current.lookAt(c.current);
  }
  function h() {
    y.current.updateMatrix(), v.current.updateMatrix(), A.current.updateMatrix(), y.current.updateMatrixWorld(), A.current.matrixWorld.decompose(n.position, n.quaternion, n.scale);
  }
  return useFrame(_ref5 => {
    let {
      size: m
    } = _ref5;
    p.current.subVectors(u.current, f.current), f.current.copy(u.current);
    const {
        width: S,
        height: b
      } = m,
      T = mapLinear(u.current.x, 0, S, -1, 1),
      C = mapLinear(u.current.y, 0, b, 1, -1);
    d.current.x = E.current.x + r * T, d.current.y = E.current.y, d.current.z = E.current.z + i * C, y.current.position.lerp(d.current, I.current), y.current.lookAt(c.current);
    const F = mapLinear(Math.abs(p.current.x) / S, 0, 0.02, 0, 1);
    g.current += (degToRad(a) * F * Math.sign(p.current.x) - g.current) * I.current, v.current.rotation.z += (g.current - v.current.rotation.z) * o.current, h();
  });
}
const type = "FeatureCollection",
  features = [{
    type: "Feature",
    properties: {
      SOVEREIGNT: "Afghanistan",
      TYPE: "Sovereign country",
      ADMIN: "Afghanistan",
      GEOUNIT: "Afghanistan",
      SUBUNIT: "Afghanistan",
      NAME: "Afghanistan",
      NAME_LONG: "Afghanistan",
      ISO_A3: "AFG",
      ISO_A3_EH: "AFG"
    },
    bbox: [60.52843, 29.318572, 75.158028, 38.486282],
    geometry: {
      type: "Polygon",
      coordinates: [[[61.210817, 35.650072], [62.230651, 35.270664], [62.984662, 35.404041], [63.193538, 35.857166], [63.982896, 36.007957], [64.546479, 36.312073], [64.746105, 37.111818], [65.588948, 37.305217], [65.745631, 37.661164], [66.217385, 37.39379], [66.518607, 37.362784], [67.075782, 37.356144], [67.83, 37.144994], [68.135562, 37.023115], [68.859446, 37.344336], [69.196273, 37.151144], [69.518785, 37.608997], [70.116578, 37.588223], [70.270574, 37.735165], [70.376304, 38.138396], [70.806821, 38.486282], [71.348131, 38.258905], [71.239404, 37.953265], [71.541918, 37.905774], [71.448693, 37.065645], [71.844638, 36.738171], [72.193041, 36.948288], [72.63689, 37.047558], [73.260056, 37.495257], [73.948696, 37.421566], [74.980002, 37.41999], [75.158028, 37.133031], [74.575893, 37.020841], [74.067552, 36.836176], [72.920025, 36.720007], [71.846292, 36.509942], [71.262348, 36.074388], [71.498768, 35.650563], [71.613076, 35.153203], [71.115019, 34.733126], [71.156773, 34.348911], [70.881803, 33.988856], [69.930543, 34.02012], [70.323594, 33.358533], [69.687147, 33.105499], [69.262522, 32.501944], [69.317764, 31.901412], [68.926677, 31.620189], [68.556932, 31.71331], [67.792689, 31.58293], [67.683394, 31.303154], [66.938891, 31.304911], [66.381458, 30.738899], [66.346473, 29.887943], [65.046862, 29.472181], [64.350419, 29.560031], [64.148002, 29.340819], [63.550261, 29.468331], [62.549857, 29.318572], [60.874248, 29.829239], [61.781222, 30.73585], [61.699314, 31.379506], [60.941945, 31.548075], [60.863655, 32.18292], [60.536078, 32.981269], [60.9637, 33.528832], [60.52843, 33.676446], [60.803193, 34.404102], [61.210817, 35.650072]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Angola",
      TYPE: "Sovereign country",
      ADMIN: "Angola",
      GEOUNIT: "Angola",
      SUBUNIT: "Angola",
      NAME: "Angola",
      NAME_LONG: "Angola",
      ISO_A3: "AGO",
      ISO_A3_EH: "AGO"
    },
    bbox: [11.640096, -17.930636, 24.079905, -4.438023],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[23.904154, -11.722282], [24.079905, -12.191297], [23.930922, -12.565848], [24.016137, -12.911046], [21.933886, -12.898437], [21.887843, -16.08031], [22.562478, -16.898451], [23.215048, -17.523116], [21.377176, -17.930636], [18.956187, -17.789095], [18.263309, -17.309951], [14.209707, -17.353101], [14.058501, -17.423381], [13.462362, -16.971212], [12.814081, -16.941343], [12.215461, -17.111668], [11.734199, -17.301889], [11.640096, -16.673142], [11.778537, -15.793816], [12.123581, -14.878316], [12.175619, -14.449144], [12.500095, -13.5477], [12.738479, -13.137906], [13.312914, -12.48363], [13.633721, -12.038645], [13.738728, -11.297863], [13.686379, -10.731076], [13.387328, -10.373578], [13.120988, -9.766897], [12.87537, -9.166934], [12.929061, -8.959091], [13.236433, -8.562629], [12.93304, -7.596539], [12.728298, -6.927122], [12.227347, -6.294448], [12.322432, -6.100092], [12.735171, -5.965682], [13.024869, -5.984389], [13.375597, -5.864241], [16.326528, -5.87747], [16.57318, -6.622645], [16.860191, -7.222298], [17.089996, -7.545689], [17.47297, -8.068551], [18.134222, -7.987678], [18.464176, -7.847014], [19.016752, -7.988246], [19.166613, -7.738184], [19.417502, -7.155429], [20.037723, -7.116361], [20.091622, -6.94309], [20.601823, -6.939318], [20.514748, -7.299606], [21.728111, -7.290872], [21.746456, -7.920085], [21.949131, -8.305901], [21.801801, -8.908707], [21.875182, -9.523708], [22.208753, -9.894796], [22.155268, -11.084801], [22.402798, -10.993075], [22.837345, -11.017622], [23.456791, -10.867863], [23.912215, -10.926826], [24.017894, -11.237298], [23.904154, -11.722282]]], [[[12.182337, -5.789931], [11.914963, -5.037987], [12.318608, -4.60623], [12.62076, -4.438023], [12.995517, -4.781103], [12.631612, -4.991271], [12.468004, -5.248362], [12.436688, -5.684304], [12.182337, -5.789931]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Albania",
      TYPE: "Sovereign country",
      ADMIN: "Albania",
      GEOUNIT: "Albania",
      SUBUNIT: "Albania",
      NAME: "Albania",
      NAME_LONG: "Albania",
      ISO_A3: "ALB",
      ISO_A3_EH: "ALB"
    },
    bbox: [19.304486, 39.624998, 21.02004, 42.688247],
    geometry: {
      type: "Polygon",
      coordinates: [[[21.02004, 40.842727], [20.99999, 40.580004], [20.674997, 40.435], [20.615, 40.110007], [20.150016, 39.624998], [19.98, 39.694993], [19.960002, 39.915006], [19.406082, 40.250773], [19.319059, 40.72723], [19.40355, 41.409566], [19.540027, 41.719986], [19.371769, 41.877548], [19.371768, 41.877551], [19.304486, 42.195745], [19.738051, 42.688247], [19.801613, 42.500093], [20.0707, 42.58863], [20.283755, 42.32026], [20.52295, 42.21787], [20.590247, 41.855409], [20.590247, 41.855404], [20.463175, 41.515089], [20.605182, 41.086226], [21.02004, 40.842727]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "United Arab Emirates",
      TYPE: "Sovereign country",
      ADMIN: "United Arab Emirates",
      GEOUNIT: "United Arab Emirates",
      SUBUNIT: "United Arab Emirates",
      NAME: "United Arab Emirates",
      NAME_LONG: "United Arab Emirates",
      ISO_A3: "ARE",
      ISO_A3_EH: "ARE"
    },
    bbox: [51.579519, 22.496948, 56.396847, 26.055464],
    geometry: {
      type: "Polygon",
      coordinates: [[[51.579519, 24.245497], [51.757441, 24.294073], [51.794389, 24.019826], [52.577081, 24.177439], [53.404007, 24.151317], [54.008001, 24.121758], [54.693024, 24.797892], [55.439025, 25.439145], [56.070821, 26.055464], [56.261042, 25.714606], [56.396847, 24.924732], [55.886233, 24.920831], [55.804119, 24.269604], [55.981214, 24.130543], [55.528632, 23.933604], [55.525841, 23.524869], [55.234489, 23.110993], [55.208341, 22.70833], [55.006803, 22.496948], [52.000733, 23.001154], [51.617708, 24.014219], [51.579519, 24.245497]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Argentina",
      TYPE: "Sovereign country",
      ADMIN: "Argentina",
      GEOUNIT: "Argentina",
      SUBUNIT: "Argentina",
      NAME: "Argentina",
      NAME_LONG: "Argentina",
      ISO_A3: "ARG",
      ISO_A3_EH: "ARG"
    },
    bbox: [-73.415436, -55.25, -53.628349, -21.83231],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[-66.95992, -54.89681], [-67.56244, -54.87001], [-68.63335, -54.8695], [-68.63401, -52.63637], [-68.25, -53.1], [-67.75, -53.85], [-66.45, -54.45], [-65.05, -54.7], [-65.5, -55.2], [-66.45, -55.25], [-66.95992, -54.89681]]], [[[-68.571545, -52.299444], [-69.498362, -52.142761], [-71.914804, -52.009022], [-72.329404, -51.425956], [-72.309974, -50.67701], [-72.975747, -50.74145], [-73.328051, -50.378785], [-73.415436, -49.318436], [-72.648247, -48.878618], [-72.331161, -48.244238], [-72.447355, -47.738533], [-71.917258, -46.884838], [-71.552009, -45.560733], [-71.659316, -44.973689], [-71.222779, -44.784243], [-71.329801, -44.407522], [-71.793623, -44.207172], [-71.464056, -43.787611], [-71.915424, -43.408565], [-72.148898, -42.254888], [-71.746804, -42.051386], [-71.915734, -40.832339], [-71.680761, -39.808164], [-71.413517, -38.916022], [-70.814664, -38.552995], [-71.118625, -37.576827], [-71.121881, -36.658124], [-70.364769, -36.005089], [-70.388049, -35.169688], [-69.817309, -34.193571], [-69.814777, -33.273886], [-70.074399, -33.09121], [-70.535069, -31.36501], [-69.919008, -30.336339], [-70.01355, -29.367923], [-69.65613, -28.459141], [-69.001235, -27.521214], [-68.295542, -26.89934], [-68.5948, -26.506909], [-68.386001, -26.185016], [-68.417653, -24.518555], [-67.328443, -24.025303], [-66.985234, -22.986349], [-67.106674, -22.735925], [-66.273339, -21.83231], [-64.964892, -22.075862], [-64.377021, -22.798091], [-63.986838, -21.993644], [-62.846468, -22.034985], [-62.685057, -22.249029], [-60.846565, -23.880713], [-60.028966, -24.032796], [-58.807128, -24.771459], [-57.777217, -25.16234], [-57.63366, -25.603657], [-58.618174, -27.123719], [-57.60976, -27.395899], [-56.486702, -27.548499], [-55.695846, -27.387837], [-54.788795, -26.621786], [-54.625291, -25.739255], [-54.13005, -25.547639], [-53.628349, -26.124865], [-53.648735, -26.923473], [-54.490725, -27.474757], [-55.162286, -27.881915], [-56.2909, -28.852761], [-57.625133, -30.216295], [-57.874937, -31.016556], [-58.14244, -32.044504], [-58.132648, -33.040567], [-58.349611, -33.263189], [-58.427074, -33.909454], [-58.495442, -34.43149], [-57.22583, -35.288027], [-57.362359, -35.97739], [-56.737487, -36.413126], [-56.788285, -36.901572], [-57.749157, -38.183871], [-59.231857, -38.72022], [-61.237445, -38.928425], [-62.335957, -38.827707], [-62.125763, -39.424105], [-62.330531, -40.172586], [-62.145994, -40.676897], [-62.745803, -41.028761], [-63.770495, -41.166789], [-64.73209, -40.802677], [-65.118035, -41.064315], [-64.978561, -42.058001], [-64.303408, -42.359016], [-63.755948, -42.043687], [-63.458059, -42.563138], [-64.378804, -42.873558], [-65.181804, -43.495381], [-65.328823, -44.501366], [-65.565269, -45.036786], [-66.509966, -45.039628], [-67.293794, -45.551896], [-67.580546, -46.301773], [-66.597066, -47.033925], [-65.641027, -47.236135], [-65.985088, -48.133289], [-67.166179, -48.697337], [-67.816088, -49.869669], [-68.728745, -50.264218], [-69.138539, -50.73251], [-68.815561, -51.771104], [-68.149995, -52.349983], [-68.571545, -52.299444]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Armenia",
      TYPE: "Sovereign country",
      ADMIN: "Armenia",
      GEOUNIT: "Armenia",
      SUBUNIT: "Armenia",
      NAME: "Armenia",
      NAME_LONG: "Armenia",
      ISO_A3: "ARM",
      ISO_A3_EH: "ARM"
    },
    bbox: [43.582746, 38.741201, 46.50572, 41.248129],
    geometry: {
      type: "Polygon",
      coordinates: [[[43.582746, 41.092143], [44.97248, 41.248129], [45.179496, 40.985354], [45.560351, 40.81229], [45.359175, 40.561504], [45.891907, 40.218476], [45.610012, 39.899994], [46.034534, 39.628021], [46.483499, 39.464155], [46.50572, 38.770605], [46.143623, 38.741201], [45.735379, 39.319719], [45.739978, 39.473999], [45.298145, 39.471751], [45.001987, 39.740004], [44.79399, 39.713003], [44.400009, 40.005], [43.656436, 40.253564], [43.752658, 40.740201], [43.582746, 41.092143]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Antarctica",
      TYPE: "Indeterminate",
      ADMIN: "Antarctica",
      GEOUNIT: "Antarctica",
      SUBUNIT: "Antarctica",
      NAME: "Antarctica",
      NAME_LONG: "Antarctica",
      ISO_A3: "ATA",
      ISO_A3_EH: "ATA"
    },
    bbox: [-180, -90, 180, -63.27066],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[-59.572095, -80.040179], [-59.865849, -80.549657], [-60.159656, -81.000327], [-62.255393, -80.863178], [-64.488125, -80.921934], [-65.741666, -80.588827], [-65.741666, -80.549657], [-66.290031, -80.255773], [-64.037688, -80.294944], [-61.883246, -80.39287], [-61.138976, -79.981371], [-60.610119, -79.628679], [-59.572095, -80.040179]]], [[[-159.208184, -79.497059], [-161.127601, -79.634209], [-162.439847, -79.281465], [-163.027408, -78.928774], [-163.066604, -78.869966], [-163.712896, -78.595667], [-163.712896, -78.595667], [-163.105801, -78.223338], [-161.245113, -78.380176], [-160.246208, -78.693645], [-159.482405, -79.046338], [-159.208184, -79.497059]]], [[[-45.154758, -78.04707], [-43.920828, -78.478103], [-43.48995, -79.08556], [-43.372438, -79.516645], [-43.333267, -80.026123], [-44.880537, -80.339644], [-46.506174, -80.594357], [-48.386421, -80.829485], [-50.482107, -81.025442], [-52.851988, -80.966685], [-54.164259, -80.633528], [-53.987991, -80.222028], [-51.853134, -79.94773], [-50.991326, -79.614623], [-50.364595, -79.183487], [-49.914131, -78.811209], [-49.306959, -78.458569], [-48.660616, -78.047018], [-48.660616, -78.047019], [-48.151396, -78.04707], [-46.662857, -77.831476], [-45.154758, -78.04707]]], [[[-121.211511, -73.50099], [-119.918851, -73.657725], [-118.724143, -73.481353], [-119.292119, -73.834097], [-120.232217, -74.08881], [-121.62283, -74.010468], [-122.621735, -73.657778], [-122.621735, -73.657777], [-122.406245, -73.324619], [-121.211511, -73.50099]]], [[[-125.559566, -73.481353], [-124.031882, -73.873268], [-124.619469, -73.834097], [-125.912181, -73.736118], [-127.28313, -73.461769], [-127.28313, -73.461768], [-126.558472, -73.246226], [-125.559566, -73.481353]]], [[[-98.98155, -71.933334], [-97.884743, -72.070535], [-96.787937, -71.952971], [-96.20035, -72.521205], [-96.983765, -72.442864], [-98.198083, -72.482035], [-99.432013, -72.442864], [-100.783455, -72.50162], [-101.801868, -72.305663], [-102.330725, -71.894164], [-102.330725, -71.894164], [-101.703967, -71.717792], [-100.430919, -71.854993], [-98.98155, -71.933334]]], [[[-68.451346, -70.955823], [-68.333834, -71.406493], [-68.510128, -71.798407], [-68.784297, -72.170736], [-69.959471, -72.307885], [-71.075889, -72.503842], [-72.388134, -72.484257], [-71.8985, -72.092343], [-73.073622, -72.229492], [-74.19004, -72.366693], [-74.953895, -72.072757], [-75.012625, -71.661258], [-73.915819, -71.269345], [-73.915819, -71.269344], [-73.230331, -71.15178], [-72.074717, -71.190951], [-71.780962, -70.681473], [-71.72218, -70.309196], [-71.741791, -69.505782], [-71.173815, -69.035475], [-70.253252, -68.87874], [-69.724447, -69.251017], [-69.489422, -69.623346], [-69.058518, -70.074016], [-68.725541, -70.505153], [-68.451346, -70.955823]]], [[[-58.614143, -64.152467], [-59.045073, -64.36801], [-59.789342, -64.211223], [-60.611928, -64.309202], [-61.297416, -64.54433], [-62.0221, -64.799094], [-62.51176, -65.09303], [-62.648858, -65.484942], [-62.590128, -65.857219], [-62.120079, -66.190326], [-62.805567, -66.425505], [-63.74569, -66.503847], [-64.294106, -66.837004], [-64.881693, -67.150474], [-65.508425, -67.58161], [-65.665082, -67.953887], [-65.312545, -68.365335], [-64.783715, -68.678908], [-63.961103, -68.913984], [-63.1973, -69.227556], [-62.785955, -69.619419], [-62.570516, -69.991747], [-62.276736, -70.383661], [-61.806661, -70.716768], [-61.512906, -71.089045], [-61.375809, -72.010074], [-61.081977, -72.382351], [-61.003661, -72.774265], [-60.690269, -73.166179], [-60.827367, -73.695242], [-61.375809, -74.106742], [-61.96337, -74.439848], [-63.295201, -74.576997], [-63.74569, -74.92974], [-64.352836, -75.262847], [-65.860987, -75.635124], [-67.192818, -75.79191], [-68.446282, -76.007452], [-69.797724, -76.222995], [-70.600724, -76.634494], [-72.206776, -76.673665], [-73.969536, -76.634494], [-75.555977, -76.712887], [-77.24037, -76.712887], [-76.926979, -77.104802], [-75.399294, -77.28107], [-74.282876, -77.55542], [-73.656119, -77.908112], [-74.772536, -78.221633], [-76.4961, -78.123654], [-77.925858, -78.378419], [-77.984666, -78.789918], [-78.023785, -79.181833], [-76.848637, -79.514939], [-76.633224, -79.887216], [-75.360097, -80.259545], [-73.244852, -80.416331], [-71.442946, -80.69063], [-70.013163, -81.004151], [-68.191646, -81.317672], [-65.704279, -81.474458], [-63.25603, -81.748757], [-61.552026, -82.042692], [-59.691416, -82.37585], [-58.712121, -82.846106], [-58.222487, -83.218434], [-57.008117, -82.865691], [-55.362894, -82.571755], [-53.619771, -82.258235], [-51.543644, -82.003521], [-49.76135, -81.729171], [-47.273931, -81.709586], [-44.825708, -81.846735], [-42.808363, -82.081915], [-42.16202, -81.65083], [-40.771433, -81.356894], [-38.244818, -81.337309], [-36.26667, -81.121715], [-34.386397, -80.906172], [-32.310296, -80.769023], [-30.097098, -80.592651], [-28.549802, -80.337938], [-29.254901, -79.985195], [-29.685805, -79.632503], [-29.685805, -79.260226], [-31.624808, -79.299397], [-33.681324, -79.456132], [-35.639912, -79.456132], [-35.914107, -79.083855], [-35.77701, -78.339248], [-35.326546, -78.123654], [-33.896763, -77.888526], [-32.212369, -77.65345], [-30.998051, -77.359515], [-29.783732, -77.065579], [-28.882779, -76.673665], [-27.511752, -76.497345], [-26.160336, -76.360144], [-25.474822, -76.281803], [-23.927552, -76.24258], [-22.458598, -76.105431], [-21.224694, -75.909474], [-20.010375, -75.674346], [-18.913543, -75.439218], [-17.522982, -75.125698], [-16.641589, -74.79254], [-15.701491, -74.498604], [-15.40771, -74.106742], [-16.46532, -73.871614], [-16.112784, -73.460114], [-15.446855, -73.146542], [-14.408805, -72.950585], [-13.311973, -72.715457], [-12.293508, -72.401936], [-11.510067, -72.010074], [-11.020433, -71.539767], [-10.295774, -71.265416], [-9.101015, -71.324224], [-8.611381, -71.65733], [-7.416622, -71.696501], [-7.377451, -71.324224], [-6.868232, -70.93231], [-5.790985, -71.030289], [-5.536375, -71.402617], [-4.341667, -71.461373], [-3.048981, -71.285053], [-1.795492, -71.167438], [-0.659489, -71.226246], [-0.228637, -71.637745], [0.868195, -71.304639], [1.886686, -71.128267], [3.022638, -70.991118], [4.139055, -70.853917], [5.157546, -70.618789], [6.273912, -70.462055], [7.13572, -70.246512], [7.742866, -69.893769], [8.48711, -70.148534], [9.525135, -70.011333], [10.249845, -70.48164], [10.817821, -70.834332], [11.953824, -70.638375], [12.404287, -70.246512], [13.422778, -69.972162], [14.734998, -70.030918], [15.126757, -70.403247], [15.949342, -70.030918], [17.026589, -69.913354], [18.201711, -69.874183], [19.259373, -69.893769], [20.375739, -70.011333], [21.452985, -70.07014], [21.923034, -70.403247], [22.569403, -70.697182], [23.666184, -70.520811], [24.841357, -70.48164], [25.977309, -70.48164], [27.093726, -70.462055], [28.09258, -70.324854], [29.150242, -70.20729], [30.031583, -69.93294], [30.971733, -69.75662], [31.990172, -69.658641], [32.754053, -69.384291], [33.302443, -68.835642], [33.870419, -68.502588], [34.908495, -68.659271], [35.300202, -69.012014], [36.16201, -69.247142], [37.200035, -69.168748], [37.905108, -69.52144], [38.649404, -69.776205], [39.667894, -69.541077], [40.020431, -69.109941], [40.921358, -68.933621], [41.959434, -68.600514], [42.938702, -68.463313], [44.113876, -68.267408], [44.897291, -68.051866], [45.719928, -67.816738], [46.503343, -67.601196], [47.44344, -67.718759], [48.344419, -67.366068], [48.990736, -67.091718], [49.930885, -67.111303], [50.753471, -66.876175], [50.949325, -66.523484], [51.791547, -66.249133], [52.614133, -66.053176], [53.613038, -65.89639], [54.53355, -65.818049], [55.414943, -65.876805], [56.355041, -65.974783], [57.158093, -66.249133], [57.255968, -66.680218], [58.137361, -67.013324], [58.744508, -67.287675], [59.939318, -67.405239], [60.605221, -67.679589], [61.427806, -67.953887], [62.387489, -68.012695], [63.19049, -67.816738], [64.052349, -67.405239], [64.992447, -67.620729], [65.971715, -67.738345], [66.911864, -67.855909], [67.891133, -67.934302], [68.890038, -67.934302], [69.712624, -68.972791], [69.673453, -69.227556], [69.555941, -69.678226], [68.596258, -69.93294], [67.81274, -70.305268], [67.949889, -70.697182], [69.066307, -70.677545], [68.929157, -71.069459], [68.419989, -71.441788], [67.949889, -71.853287], [68.71377, -72.166808], [69.869307, -72.264787], [71.024895, -72.088415], [71.573285, -71.696501], [71.906288, -71.324224], [72.454627, -71.010703], [73.08141, -70.716768], [73.33602, -70.364024], [73.864877, -69.874183], [74.491557, -69.776205], [75.62756, -69.737034], [76.626465, -69.619419], [77.644904, -69.462684], [78.134539, -69.07077], [78.428371, -68.698441], [79.113859, -68.326216], [80.093127, -68.071503], [80.93535, -67.875546], [81.483792, -67.542388], [82.051767, -67.366068], [82.776426, -67.209282], [83.775331, -67.30726], [84.676206, -67.209282], [85.655527, -67.091718], [86.752359, -67.150474], [87.477017, -66.876175], [87.986289, -66.209911], [88.358411, -66.484261], [88.828408, -66.954568], [89.67063, -67.150474], [90.630365, -67.228867], [91.5901, -67.111303], [92.608539, -67.189696], [93.548637, -67.209282], [94.17542, -67.111303], [95.017591, -67.170111], [95.781472, -67.385653], [96.682399, -67.248504], [97.759646, -67.248504], [98.68021, -67.111303], [99.718182, -67.248504], [100.384188, -66.915346], [100.893356, -66.58224], [101.578896, -66.30789], [102.832411, -65.563284], [103.478676, -65.700485], [104.242557, -65.974783], [104.90846, -66.327527], [106.181561, -66.934931], [107.160881, -66.954568], [108.081393, -66.954568], [109.15864, -66.837004], [110.235835, -66.699804], [111.058472, -66.425505], [111.74396, -66.13157], [112.860378, -66.092347], [113.604673, -65.876805], [114.388088, -66.072762], [114.897308, -66.386283], [115.602381, -66.699804], [116.699161, -66.660633], [117.384701, -66.915346], [118.57946, -67.170111], [119.832924, -67.268089], [120.871, -67.189696], [121.654415, -66.876175], [122.320369, -66.562654], [123.221296, -66.484261], [124.122274, -66.621462], [125.160247, -66.719389], [126.100396, -66.562654], [127.001427, -66.562654], [127.882768, -66.660633], [128.80328, -66.758611], [129.704259, -66.58224], [130.781454, -66.425505], [131.799945, -66.386283], [132.935896, -66.386283], [133.85646, -66.288304], [134.757387, -66.209963], [135.031582, -65.72007], [135.070753, -65.308571], [135.697485, -65.582869], [135.873805, -66.033591], [136.206705, -66.44509], [136.618049, -66.778197], [137.460271, -66.954568], [138.596223, -66.895761], [139.908442, -66.876175], [140.809421, -66.817367], [142.121692, -66.817367], [143.061842, -66.797782], [144.374061, -66.837004], [145.490427, -66.915346], [146.195552, -67.228867], [145.999699, -67.601196], [146.646067, -67.895131], [147.723263, -68.130259], [148.839629, -68.385024], [150.132314, -68.561292], [151.483705, -68.71813], [152.502247, -68.874813], [153.638199, -68.894502], [154.284567, -68.561292], [155.165857, -68.835642], [155.92979, -69.149215], [156.811132, -69.384291], [158.025528, -69.482269], [159.181013, -69.599833], [159.670699, -69.991747], [160.80665, -70.226875], [161.570479, -70.579618], [162.686897, -70.736353], [163.842434, -70.716768], [164.919681, -70.775524], [166.11444, -70.755938], [167.309095, -70.834332], [168.425616, -70.971481], [169.463589, -71.20666], [170.501665, -71.402617], [171.20679, -71.696501], [171.089227, -72.088415], [170.560422, -72.441159], [170.109958, -72.891829], [169.75737, -73.24452], [169.287321, -73.65602], [167.975101, -73.812806], [167.387489, -74.165498], [166.094803, -74.38104], [165.644391, -74.772954], [164.958851, -75.145283], [164.234193, -75.458804], [163.822797, -75.870303], [163.568239, -76.24258], [163.47026, -76.693302], [163.489897, -77.065579], [164.057873, -77.457442], [164.273363, -77.82977], [164.743464, -78.182514], [166.604126, -78.319611], [166.995781, -78.750748], [165.193876, -78.907483], [163.666217, -79.123025], [161.766385, -79.162248], [160.924162, -79.730482], [160.747894, -80.200737], [160.316964, -80.573066], [159.788211, -80.945395], [161.120016, -81.278501], [161.629287, -81.690001], [162.490992, -82.062278], [163.705336, -82.395435], [165.095949, -82.708956], [166.604126, -83.022477], [168.895665, -83.335998], [169.404782, -83.825891], [172.283934, -84.041433], [172.477049, -84.117914], [173.224083, -84.41371], [175.985672, -84.158997], [178.277212, -84.472518], [180, -84.71338], [180, -90], [-180, -90], [-180, -84.71338], [-179.942499, -84.721443], [-179.058677, -84.139412], [-177.256772, -84.452933], [-177.140807, -84.417941], [-176.084673, -84.099259], [-175.947235, -84.110449], [-175.829882, -84.117914], [-174.382503, -84.534323], [-173.116559, -84.117914], [-172.889106, -84.061019], [-169.951223, -83.884647], [-168.999989, -84.117914], [-168.530199, -84.23739], [-167.022099, -84.570497], [-164.182144, -84.82521], [-161.929775, -85.138731], [-158.07138, -85.37391], [-155.192253, -85.09956], [-150.942099, -85.295517], [-148.533073, -85.609038], [-145.888918, -85.315102], [-143.107718, -85.040752], [-142.892279, -84.570497], [-146.829068, -84.531274], [-150.060732, -84.296146], [-150.902928, -83.904232], [-153.586201, -83.68869], [-153.409907, -83.23802], [-153.037759, -82.82652], [-152.665637, -82.454192], [-152.861517, -82.042692], [-154.526299, -81.768394], [-155.29018, -81.41565], [-156.83745, -81.102129], [-154.408787, -81.160937], [-152.097662, -81.004151], [-150.648293, -81.337309], [-148.865998, -81.043373], [-147.22075, -80.671045], [-146.417749, -80.337938], [-146.770286, -79.926439], [-148.062947, -79.652089], [-149.531901, -79.358205], [-151.588416, -79.299397], [-153.390322, -79.162248], [-155.329376, -79.064269], [-155.975668, -78.69194], [-157.268302, -78.378419], [-158.051768, -78.025676], [-158.365134, -76.889207], [-157.875474, -76.987238], [-156.974573, -77.300759], [-155.329376, -77.202728], [-153.742832, -77.065579], [-152.920247, -77.496664], [-151.33378, -77.398737], [-150.00195, -77.183143], [-148.748486, -76.908845], [-147.612483, -76.575738], [-146.104409, -76.47776], [-146.143528, -76.105431], [-146.496091, -75.733154], [-146.20231, -75.380411], [-144.909624, -75.204039], [-144.322037, -75.537197], [-142.794353, -75.34124], [-141.638764, -75.086475], [-140.209007, -75.06689], [-138.85759, -74.968911], [-137.5062, -74.733783], [-136.428901, -74.518241], [-135.214583, -74.302699], [-134.431194, -74.361455], [-133.745654, -74.439848], [-132.257168, -74.302699], [-130.925311, -74.479019], [-129.554284, -74.459433], [-128.242038, -74.322284], [-126.890622, -74.420263], [-125.402082, -74.518241], [-124.011496, -74.479019], [-122.562152, -74.498604], [-121.073613, -74.518241], [-119.70256, -74.479019], [-118.684145, -74.185083], [-117.469801, -74.028348], [-116.216312, -74.243891], [-115.021552, -74.067519], [-113.944331, -73.714828], [-113.297988, -74.028348], [-112.945452, -74.38104], [-112.299083, -74.714198], [-111.261059, -74.420263], [-110.066325, -74.79254], [-108.714909, -74.910103], [-107.559346, -75.184454], [-106.149148, -75.125698], [-104.876074, -74.949326], [-103.367949, -74.988497], [-102.016507, -75.125698], [-100.645531, -75.302018], [-100.1167, -74.870933], [-100.763043, -74.537826], [-101.252703, -74.185083], [-102.545337, -74.106742], [-103.113313, -73.734413], [-103.328752, -73.362084], [-103.681289, -72.61753], [-102.917485, -72.754679], [-101.60524, -72.813436], [-100.312528, -72.754679], [-99.13738, -72.911414], [-98.118889, -73.20535], [-97.688037, -73.558041], [-96.336595, -73.616849], [-95.043961, -73.4797], [-93.672907, -73.283743], [-92.439003, -73.166179], [-91.420564, -73.401307], [-90.088733, -73.322914], [-89.226951, -72.558722], [-88.423951, -73.009393], [-87.268337, -73.185764], [-86.014822, -73.087786], [-85.192236, -73.4797], [-83.879991, -73.518871], [-82.665646, -73.636434], [-81.470913, -73.851977], [-80.687447, -73.4797], [-80.295791, -73.126956], [-79.296886, -73.518871], [-77.925858, -73.420892], [-76.907367, -73.636434], [-76.221879, -73.969541], [-74.890049, -73.871614], [-73.852024, -73.65602], [-72.833533, -73.401307], [-71.619215, -73.264157], [-70.209042, -73.146542], [-68.935916, -73.009393], [-67.956622, -72.79385], [-67.369061, -72.480329], [-67.134036, -72.049244], [-67.251548, -71.637745], [-67.56494, -71.245831], [-67.917477, -70.853917], [-68.230843, -70.462055], [-68.485452, -70.109311], [-68.544209, -69.717397], [-68.446282, -69.325535], [-67.976233, -68.953206], [-67.5845, -68.541707], [-67.427843, -68.149844], [-67.62367, -67.718759], [-67.741183, -67.326845], [-67.251548, -66.876175], [-66.703184, -66.58224], [-66.056815, -66.209963], [-65.371327, -65.89639], [-64.568276, -65.602506], [-64.176542, -65.171423], [-63.628152, -64.897073], [-63.001394, -64.642308], [-62.041686, -64.583552], [-61.414928, -64.270031], [-60.709855, -64.074074], [-59.887269, -63.95651], [-59.162585, -63.701745], [-58.594557, -63.388224], [-57.811143, -63.27066], [-57.223582, -63.525425], [-57.59573, -63.858532], [-58.614143, -64.152467]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "France",
      ISO_A3: "FRA",
      TYPE: "Dependency",
      ADMIN: "French Southern and Antarctic Lands",
      GEOUNIT: "French Southern and Antarctic Lands",
      SUBUNIT: "French Southern and Antarctic Lands",
      NAME: "Fr. S. Antarctic Lands",
      NAME_LONG: "French Southern and Antarctic Lands",
      ISO_A3_EH: "ATF",
      TINY: 2
    },
    bbox: [68.72, -49.775, 70.56, -48.625],
    geometry: {
      type: "Polygon",
      coordinates: [[[68.935, -48.625], [69.58, -48.94], [70.525, -49.065], [70.56, -49.255], [70.28, -49.71], [68.745, -49.775], [68.72, -49.2425], [68.8675, -48.83], [68.935, -48.625]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Australia",
      TYPE: "Country",
      ADMIN: "Australia",
      GEOUNIT: "Australia",
      SUBUNIT: "Australia",
      NAME: "Australia",
      NAME_LONG: "Australia",
      ISO_A3: "AUS",
      ISO_A3_EH: "AUS"
    },
    bbox: [113.338953, -43.634597, 153.569469, -10.668186],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[145.397978, -40.792549], [146.364121, -41.137695], [146.908584, -41.000546], [147.689259, -40.808258], [148.289068, -40.875438], [148.359865, -42.062445], [148.017301, -42.407024], [147.914052, -43.211522], [147.564564, -42.937689], [146.870343, -43.634597], [146.663327, -43.580854], [146.048378, -43.549745], [145.43193, -42.693776], [145.29509, -42.03361], [144.718071, -41.162552], [144.743755, -40.703975], [145.397978, -40.792549]]], [[[143.561811, -13.763656], [143.922099, -14.548311], [144.563714, -14.171176], [144.894908, -14.594458], [145.374724, -14.984976], [145.271991, -15.428205], [145.48526, -16.285672], [145.637033, -16.784918], [145.888904, -16.906926], [146.160309, -17.761655], [146.063674, -18.280073], [146.387478, -18.958274], [147.471082, -19.480723], [148.177602, -19.955939], [148.848414, -20.39121], [148.717465, -20.633469], [149.28942, -21.260511], [149.678337, -22.342512], [150.077382, -22.122784], [150.482939, -22.556142], [150.727265, -22.402405], [150.899554, -23.462237], [151.609175, -24.076256], [152.07354, -24.457887], [152.855197, -25.267501], [153.136162, -26.071173], [153.161949, -26.641319], [153.092909, -27.2603], [153.569469, -28.110067], [153.512108, -28.995077], [153.339095, -29.458202], [153.069241, -30.35024], [153.089602, -30.923642], [152.891578, -31.640446], [152.450002, -32.550003], [151.709117, -33.041342], [151.343972, -33.816023], [151.010555, -34.31036], [150.714139, -35.17346], [150.32822, -35.671879], [150.075212, -36.420206], [149.946124, -37.109052], [149.997284, -37.425261], [149.423882, -37.772681], [148.304622, -37.809061], [147.381733, -38.219217], [146.922123, -38.606532], [146.317922, -39.035757], [145.489652, -38.593768], [144.876976, -38.417448], [145.032212, -37.896188], [144.485682, -38.085324], [143.609974, -38.809465], [142.745427, -38.538268], [142.17833, -38.380034], [141.606582, -38.308514], [140.638579, -38.019333], [139.992158, -37.402936], [139.806588, -36.643603], [139.574148, -36.138362], [139.082808, -35.732754], [138.120748, -35.612296], [138.449462, -35.127261], [138.207564, -34.384723], [137.71917, -35.076825], [136.829406, -35.260535], [137.352371, -34.707339], [137.503886, -34.130268], [137.890116, -33.640479], [137.810328, -32.900007], [136.996837, -33.752771], [136.372069, -34.094766], [135.989043, -34.890118], [135.208213, -34.47867], [135.239218, -33.947953], [134.613417, -33.222778], [134.085904, -32.848072], [134.273903, -32.617234], [132.990777, -32.011224], [132.288081, -31.982647], [131.326331, -31.495803], [129.535794, -31.590423], [128.240938, -31.948489], [127.102867, -32.282267], [126.148714, -32.215966], [125.088623, -32.728751], [124.221648, -32.959487], [124.028947, -33.483847], [123.659667, -33.890179], [122.811036, -33.914467], [122.183064, -34.003402], [121.299191, -33.821036], [120.580268, -33.930177], [119.893695, -33.976065], [119.298899, -34.509366], [119.007341, -34.464149], [118.505718, -34.746819], [118.024972, -35.064733], [117.295507, -35.025459], [116.625109, -35.025097], [115.564347, -34.386428], [115.026809, -34.196517], [115.048616, -33.623425], [115.545123, -33.487258], [115.714674, -33.259572], [115.679379, -32.900369], [115.801645, -32.205062], [115.689611, -31.612437], [115.160909, -30.601594], [114.997043, -30.030725], [115.040038, -29.461095], [114.641974, -28.810231], [114.616498, -28.516399], [114.173579, -28.118077], [114.048884, -27.334765], [113.477498, -26.543134], [113.338953, -26.116545], [113.778358, -26.549025], [113.440962, -25.621278], [113.936901, -25.911235], [114.232852, -26.298446], [114.216161, -25.786281], [113.721255, -24.998939], [113.625344, -24.683971], [113.393523, -24.384764], [113.502044, -23.80635], [113.706993, -23.560215], [113.843418, -23.059987], [113.736552, -22.475475], [114.149756, -21.755881], [114.225307, -22.517488], [114.647762, -21.82952], [115.460167, -21.495173], [115.947373, -21.068688], [116.711615, -20.701682], [117.166316, -20.623599], [117.441545, -20.746899], [118.229559, -20.374208], [118.836085, -20.263311], [118.987807, -20.044203], [119.252494, -19.952942], [119.805225, -19.976506], [120.85622, -19.683708], [121.399856, -19.239756], [121.655138, -18.705318], [122.241665, -18.197649], [122.286624, -17.798603], [122.312772, -17.254967], [123.012574, -16.4052], [123.433789, -17.268558], [123.859345, -17.069035], [123.503242, -16.596506], [123.817073, -16.111316], [124.258287, -16.327944], [124.379726, -15.56706], [124.926153, -15.0751], [125.167275, -14.680396], [125.670087, -14.51007], [125.685796, -14.230656], [126.125149, -14.347341], [126.142823, -14.095987], [126.582589, -13.952791], [127.065867, -13.817968], [127.804633, -14.276906], [128.35969, -14.86917], [128.985543, -14.875991], [129.621473, -14.969784], [129.4096, -14.42067], [129.888641, -13.618703], [130.339466, -13.357376], [130.183506, -13.10752], [130.617795, -12.536392], [131.223495, -12.183649], [131.735091, -12.302453], [132.575298, -12.114041], [132.557212, -11.603012], [131.824698, -11.273782], [132.357224, -11.128519], [133.019561, -11.376411], [133.550846, -11.786515], [134.393068, -12.042365], [134.678632, -11.941183], [135.298491, -12.248606], [135.882693, -11.962267], [136.258381, -12.049342], [136.492475, -11.857209], [136.95162, -12.351959], [136.685125, -12.887223], [136.305407, -13.29123], [135.961758, -13.324509], [136.077617, -13.724278], [135.783836, -14.223989], [135.428664, -14.715432], [135.500184, -14.997741], [136.295175, -15.550265], [137.06536, -15.870762], [137.580471, -16.215082], [138.303217, -16.807604], [138.585164, -16.806622], [139.108543, -17.062679], [139.260575, -17.371601], [140.215245, -17.710805], [140.875463, -17.369069], [141.07111, -16.832047], [141.274095, -16.38887], [141.398222, -15.840532], [141.702183, -15.044921], [141.56338, -14.561333], [141.63552, -14.270395], [141.519869, -13.698078], [141.65092, -12.944688], [141.842691, -12.741548], [141.68699, -12.407614], [141.928629, -11.877466], [142.118488, -11.328042], [142.143706, -11.042737], [142.51526, -10.668186], [142.79731, -11.157355], [142.866763, -11.784707], [143.115947, -11.90563], [143.158632, -12.325656], [143.522124, -12.834358], [143.597158, -13.400422], [143.561811, -13.763656]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Austria",
      TYPE: "Sovereign country",
      ADMIN: "Austria",
      GEOUNIT: "Austria",
      SUBUNIT: "Austria",
      NAME: "Austria",
      NAME_LONG: "Austria",
      ISO_A3: "AUT",
      ISO_A3_EH: "AUT"
    },
    bbox: [9.47997, 46.431817, 16.979667, 49.039074],
    geometry: {
      type: "Polygon",
      coordinates: [[[16.979667, 48.123497], [16.903754, 47.714866], [16.340584, 47.712902], [16.534268, 47.496171], [16.202298, 46.852386], [16.011664, 46.683611], [15.137092, 46.658703], [14.632472, 46.431817], [13.806475, 46.509306], [12.376485, 46.767559], [12.153088, 47.115393], [11.164828, 46.941579], [11.048556, 46.751359], [10.442701, 46.893546], [9.932448, 46.920728], [9.47997, 47.10281], [9.632932, 47.347601], [9.594226, 47.525058], [9.896068, 47.580197], [10.402084, 47.302488], [10.544504, 47.566399], [11.426414, 47.523766], [12.141357, 47.703083], [12.62076, 47.672388], [12.932627, 47.467646], [13.025851, 47.637584], [12.884103, 48.289146], [13.243357, 48.416115], [13.595946, 48.877172], [14.338898, 48.555305], [14.901447, 48.964402], [15.253416, 49.039074], [16.029647, 48.733899], [16.499283, 48.785808], [16.960288, 48.596982], [16.879983, 48.470013], [16.979667, 48.123497]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Azerbaijan",
      TYPE: "Sovereign country",
      ADMIN: "Azerbaijan",
      GEOUNIT: "Azerbaijan",
      SUBUNIT: "Azerbaijan",
      NAME: "Azerbaijan",
      NAME_LONG: "Azerbaijan",
      ISO_A3: "AZE",
      ISO_A3_EH: "AZE"
    },
    bbox: [44.79399, 38.270378, 50.392821, 41.860675],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[46.50572, 38.770605], [46.483499, 39.464155], [46.034534, 39.628021], [45.610012, 39.899994], [45.891907, 40.218476], [45.359175, 40.561504], [45.560351, 40.81229], [45.179496, 40.985354], [44.97248, 41.248129], [45.217426, 41.411452], [45.962601, 41.123873], [46.501637, 41.064445], [46.637908, 41.181673], [46.145432, 41.722802], [46.404951, 41.860675], [46.686071, 41.827137], [47.373315, 41.219732], [47.815666, 41.151416], [47.987283, 41.405819], [48.584353, 41.808869], [49.110264, 41.282287], [49.618915, 40.572924], [50.08483, 40.526157], [50.392821, 40.256561], [49.569202, 40.176101], [49.395259, 39.399482], [49.223228, 39.049219], [48.856532, 38.815486], [48.883249, 38.320245], [48.634375, 38.270378], [48.010744, 38.794015], [48.355529, 39.288765], [48.060095, 39.582235], [47.685079, 39.508364], [46.50572, 38.770605]]], [[[44.79399, 39.713003], [45.001987, 39.740004], [45.298145, 39.471751], [45.739978, 39.473999], [45.735379, 39.319719], [46.143623, 38.741201], [45.457722, 38.874139], [44.952688, 39.335765], [44.79399, 39.713003]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Burundi",
      TYPE: "Sovereign country",
      ADMIN: "Burundi",
      GEOUNIT: "Burundi",
      SUBUNIT: "Burundi",
      NAME: "Burundi",
      NAME_LONG: "Burundi",
      ISO_A3: "BDI",
      ISO_A3_EH: "BDI"
    },
    bbox: [29.024926, -4.499983, 30.75224, -2.348487],
    geometry: {
      type: "Polygon",
      coordinates: [[[29.339998, -4.499983], [29.276384, -3.293907], [29.024926, -2.839258], [29.632176, -2.917858], [29.938359, -2.348487], [30.469674, -2.413855], [30.52766, -2.80762], [30.74301, -3.03431], [30.75224, -3.35931], [30.50554, -3.56858], [30.11632, -4.09012], [29.753512, -4.452389], [29.339998, -4.499983]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Belgium",
      TYPE: "Sovereign country",
      ADMIN: "Belgium",
      GEOUNIT: "Belgium",
      SUBUNIT: "Belgium",
      NAME: "Belgium",
      NAME_LONG: "Belgium",
      ISO_A3: "BEL",
      ISO_A3_EH: "BEL"
    },
    bbox: [2.513573, 49.529484, 6.156658, 51.475024],
    geometry: {
      type: "Polygon",
      coordinates: [[[4.047071, 51.267259], [4.973991, 51.475024], [5.606976, 51.037298], [6.156658, 50.803721], [6.043073, 50.128052], [5.782417, 50.090328], [5.674052, 49.529484], [4.799222, 49.985373], [4.286023, 49.907497], [3.588184, 50.378992], [3.123252, 50.780363], [2.658422, 50.796848], [2.513573, 51.148506], [3.314971, 51.345781], [3.315011, 51.345777], [3.314971, 51.345755], [4.047071, 51.267259]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Benin",
      TYPE: "Sovereign country",
      ADMIN: "Benin",
      GEOUNIT: "Benin",
      SUBUNIT: "Benin",
      NAME: "Benin",
      NAME_LONG: "Benin",
      ISO_A3: "BEN",
      ISO_A3_EH: "BEN"
    },
    bbox: [0.772336, 6.142158, 3.797112, 12.235636],
    geometry: {
      type: "Polygon",
      coordinates: [[[2.691702, 6.258817], [1.865241, 6.142158], [1.618951, 6.832038], [1.664478, 9.12859], [1.463043, 9.334624], [1.425061, 9.825395], [1.077795, 10.175607], [0.772336, 10.470808], [0.899563, 10.997339], [1.24347, 11.110511], [1.447178, 11.547719], [1.935986, 11.64115], [2.154474, 11.94015], [2.490164, 12.233052], [2.848643, 12.235636], [3.61118, 11.660167], [3.572216, 11.327939], [3.797112, 10.734746], [3.60007, 10.332186], [3.705438, 10.06321], [3.220352, 9.444153], [2.912308, 9.137608], [2.723793, 8.506845], [2.749063, 7.870734], [2.691702, 6.258817]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Burkina Faso",
      TYPE: "Sovereign country",
      ADMIN: "Burkina Faso",
      GEOUNIT: "Burkina Faso",
      SUBUNIT: "Burkina Faso",
      NAME: "Burkina Faso",
      NAME_LONG: "Burkina Faso",
      ISO_A3: "BFA",
      ISO_A3_EH: "BFA"
    },
    bbox: [-5.470565, 9.610835, 2.177108, 15.116158],
    geometry: {
      type: "Polygon",
      coordinates: [[[2.154474, 11.94015], [1.935986, 11.64115], [1.447178, 11.547719], [1.24347, 11.110511], [0.899563, 10.997339], [0.023803, 11.018682], [-0.438702, 11.098341], [-0.761576, 10.93693], [-1.203358, 11.009819], [-2.940409, 10.96269], [-2.963896, 10.395335], [-2.827496, 9.642461], [-3.511899, 9.900326], [-3.980449, 9.862344], [-4.330247, 9.610835], [-4.779884, 9.821985], [-4.954653, 10.152714], [-5.404342, 10.370737], [-5.470565, 10.95127], [-5.197843, 11.375146], [-5.220942, 11.713859], [-4.427166, 12.542646], [-4.280405, 13.228444], [-4.006391, 13.472485], [-3.522803, 13.337662], [-3.103707, 13.541267], [-2.967694, 13.79815], [-2.191825, 14.246418], [-2.001035, 14.559008], [-1.066363, 14.973815], [-0.515854, 15.116158], [-0.266257, 14.924309], [0.374892, 14.928908], [0.295646, 14.444235], [0.429928, 13.988733], [0.993046, 13.33575], [1.024103, 12.851826], [2.177108, 12.625018], [2.154474, 11.94015]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Bangladesh",
      TYPE: "Sovereign country",
      ADMIN: "Bangladesh",
      GEOUNIT: "Bangladesh",
      SUBUNIT: "Bangladesh",
      NAME: "Bangladesh",
      NAME_LONG: "Bangladesh",
      ISO_A3: "BGD",
      ISO_A3_EH: "BGD"
    },
    bbox: [88.084422, 20.670883, 92.672721, 26.446526],
    geometry: {
      type: "Polygon",
      coordinates: [[[92.672721, 22.041239], [92.652257, 21.324048], [92.303234, 21.475485], [92.368554, 20.670883], [92.082886, 21.192195], [92.025215, 21.70157], [91.834891, 22.182936], [91.417087, 22.765019], [90.496006, 22.805017], [90.586957, 22.392794], [90.272971, 21.836368], [89.847467, 22.039146], [89.70205, 21.857116], [89.418863, 21.966179], [89.031961, 22.055708], [88.876312, 22.879146], [88.52977, 23.631142], [88.69994, 24.233715], [88.084422, 24.501657], [88.306373, 24.866079], [88.931554, 25.238692], [88.209789, 25.768066], [88.563049, 26.446526], [89.355094, 26.014407], [89.832481, 25.965082], [89.920693, 25.26975], [90.872211, 25.132601], [91.799596, 25.147432], [92.376202, 24.976693], [91.915093, 24.130414], [91.46773, 24.072639], [91.158963, 23.503527], [91.706475, 22.985264], [91.869928, 23.624346], [92.146035, 23.627499], [92.672721, 22.041239]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Bulgaria",
      TYPE: "Sovereign country",
      ADMIN: "Bulgaria",
      GEOUNIT: "Bulgaria",
      SUBUNIT: "Bulgaria",
      NAME: "Bulgaria",
      NAME_LONG: "Bulgaria",
      ISO_A3: "BGR",
      ISO_A3_EH: "BGR"
    },
    bbox: [22.380526, 41.234486, 28.558081, 44.234923],
    geometry: {
      type: "Polygon",
      coordinates: [[[22.65715, 44.234923], [22.944832, 43.823785], [23.332302, 43.897011], [24.100679, 43.741051], [25.569272, 43.688445], [26.065159, 43.943494], [27.2424, 44.175986], [27.970107, 43.812468], [28.558081, 43.707462], [28.039095, 43.293172], [27.673898, 42.577892], [27.99672, 42.007359], [27.135739, 42.141485], [26.117042, 41.826905], [26.106138, 41.328899], [25.197201, 41.234486], [24.492645, 41.583896], [23.692074, 41.309081], [22.952377, 41.337994], [22.881374, 41.999297], [22.380526, 42.32026], [22.545012, 42.461362], [22.436595, 42.580321], [22.604801, 42.898519], [22.986019, 43.211161], [22.500157, 43.642814], [22.410446, 44.008063], [22.65715, 44.234923]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "The Bahamas",
      TYPE: "Sovereign country",
      ADMIN: "The Bahamas",
      GEOUNIT: "The Bahamas",
      SUBUNIT: "The Bahamas",
      NAME: "Bahamas",
      NAME_LONG: "Bahamas",
      ISO_A3: "BHS",
      ISO_A3_EH: "BHS"
    },
    bbox: [-78.98, 23.71, -77, 27.04],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[-77.53466, 23.75975], [-77.78, 23.71], [-78.03405, 24.28615], [-78.40848, 24.57564], [-78.19087, 25.2103], [-77.89, 25.17], [-77.54, 24.34], [-77.53466, 23.75975]]], [[[-77.82, 26.58], [-78.91, 26.42], [-78.98, 26.79], [-78.51, 26.87], [-77.85, 26.84], [-77.82, 26.58]]], [[[-77, 26.59], [-77.17255, 25.87918], [-77.35641, 26.00735], [-77.34, 26.53], [-77.78802, 26.92516], [-77.79, 27.04], [-77, 26.59]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Bosnia and Herzegovina",
      TYPE: "Sovereign country",
      ADMIN: "Bosnia and Herzegovina",
      GEOUNIT: "Bosnia and Herzegovina",
      SUBUNIT: "Bosnia and Herzegovina",
      NAME: "Bosnia and Herz.",
      NAME_LONG: "Bosnia and Herzegovina",
      ISO_A3: "BIH",
      ISO_A3_EH: "BIH"
    },
    bbox: [15.750026, 42.65, 19.59976, 45.233777],
    geometry: {
      type: "Polygon",
      coordinates: [[[19.36803, 44.863], [19.11761, 44.42307], [19.59976, 44.03847], [19.454, 43.5681], [19.21852, 43.52384], [19.03165, 43.43253], [18.70648, 43.20011], [18.56, 42.65], [17.674922, 43.028563], [17.297373, 43.446341], [16.916156, 43.667722], [16.456443, 44.04124], [16.23966, 44.351143], [15.750026, 44.818712], [15.959367, 45.233777], [16.318157, 45.004127], [16.534939, 45.211608], [17.002146, 45.233777], [17.861783, 45.06774], [18.553214, 45.08159], [19.005485, 44.860234], [19.00548, 44.86023], [19.36803, 44.863]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Belarus",
      TYPE: "Sovereign country",
      ADMIN: "Belarus",
      GEOUNIT: "Belarus",
      SUBUNIT: "Belarus",
      NAME: "Belarus",
      NAME_LONG: "Belarus",
      ISO_A3: "BLR",
      ISO_A3_EH: "BLR"
    },
    bbox: [23.199494, 51.319503, 32.693643, 56.16913],
    geometry: {
      type: "Polygon",
      coordinates: [[[23.484128, 53.912498], [24.450684, 53.905702], [25.536354, 54.282423], [25.768433, 54.846963], [26.588279, 55.167176], [26.494331, 55.615107], [27.10246, 55.783314], [28.176709, 56.16913], [29.229513, 55.918344], [29.371572, 55.670091], [29.896294, 55.789463], [30.873909, 55.550976], [30.971836, 55.081548], [30.757534, 54.811771], [31.384472, 54.157056], [31.791424, 53.974639], [31.731273, 53.794029], [32.405599, 53.618045], [32.693643, 53.351421], [32.304519, 53.132726], [31.49764, 53.16743], [31.305201, 53.073996], [31.540018, 52.742052], [31.78597, 52.10168], [31.785992, 52.101678], [30.927549, 52.042353], [30.619454, 51.822806], [30.555117, 51.319503], [30.157364, 51.416138], [29.254938, 51.368234], [28.992835, 51.602044], [28.617613, 51.427714], [28.241615, 51.572227], [27.454066, 51.592303], [26.337959, 51.832289], [25.327788, 51.910656], [24.553106, 51.888461], [24.005078, 51.617444], [23.527071, 51.578454], [23.508002, 52.023647], [23.199494, 52.486977], [23.799199, 52.691099], [23.804935, 53.089731], [23.527536, 53.470122], [23.484128, 53.912498]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Belize",
      TYPE: "Sovereign country",
      ADMIN: "Belize",
      GEOUNIT: "Belize",
      SUBUNIT: "Belize",
      NAME: "Belize",
      NAME_LONG: "Belize",
      ISO_A3: "BLZ",
      ISO_A3_EH: "BLZ"
    },
    bbox: [-89.229122, 15.886938, -88.106813, 18.499982],
    geometry: {
      type: "Polygon",
      coordinates: [[[-89.14308, 17.808319], [-89.150909, 17.955468], [-89.029857, 18.001511], [-88.848344, 17.883198], [-88.490123, 18.486831], [-88.300031, 18.499982], [-88.296336, 18.353273], [-88.106813, 18.348674], [-88.123479, 18.076675], [-88.285355, 17.644143], [-88.197867, 17.489475], [-88.302641, 17.131694], [-88.239518, 17.036066], [-88.355428, 16.530774], [-88.551825, 16.265467], [-88.732434, 16.233635], [-88.930613, 15.887273], [-89.229122, 15.886938], [-89.150806, 17.015577], [-89.14308, 17.808319]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Bolivia",
      TYPE: "Sovereign country",
      ADMIN: "Bolivia",
      GEOUNIT: "Bolivia",
      SUBUNIT: "Bolivia",
      NAME: "Bolivia",
      NAME_LONG: "Bolivia",
      ISO_A3: "BOL",
      ISO_A3_EH: "BOL"
    },
    bbox: [-69.590424, -22.872919, -57.498371, -9.761988],
    geometry: {
      type: "Polygon",
      coordinates: [[[-62.685057, -22.249029], [-62.846468, -22.034985], [-63.986838, -21.993644], [-64.377021, -22.798091], [-64.964892, -22.075862], [-66.273339, -21.83231], [-67.106674, -22.735925], [-67.82818, -22.872919], [-68.219913, -21.494347], [-68.757167, -20.372658], [-68.442225, -19.405068], [-68.966818, -18.981683], [-69.100247, -18.260125], [-69.590424, -17.580012], [-68.959635, -16.500698], [-69.389764, -15.660129], [-69.160347, -15.323974], [-69.339535, -14.953195], [-68.948887, -14.453639], [-68.929224, -13.602684], [-68.88008, -12.899729], [-68.66508, -12.5613], [-69.529678, -10.951734], [-68.786158, -11.03638], [-68.271254, -11.014521], [-68.048192, -10.712059], [-67.173801, -10.306812], [-66.646908, -9.931331], [-65.338435, -9.761988], [-65.444837, -10.511451], [-65.321899, -10.895872], [-65.402281, -11.56627], [-64.316353, -12.461978], [-63.196499, -12.627033], [-62.80306, -13.000653], [-62.127081, -13.198781], [-61.713204, -13.489202], [-61.084121, -13.479384], [-60.503304, -13.775955], [-60.459198, -14.354007], [-60.264326, -14.645979], [-60.251149, -15.077219], [-60.542966, -15.09391], [-60.15839, -16.258284], [-58.24122, -16.299573], [-58.388058, -16.877109], [-58.280804, -17.27171], [-57.734558, -17.552468], [-57.498371, -18.174188], [-57.676009, -18.96184], [-57.949997, -19.400004], [-57.853802, -19.969995], [-58.166392, -20.176701], [-58.183471, -19.868399], [-59.115042, -19.356906], [-60.043565, -19.342747], [-61.786326, -19.633737], [-62.265961, -20.513735], [-62.291179, -21.051635], [-62.685057, -22.249029]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Brazil",
      TYPE: "Sovereign country",
      ADMIN: "Brazil",
      GEOUNIT: "Brazil",
      SUBUNIT: "Brazil",
      NAME: "Brazil",
      NAME_LONG: "Brazil",
      ISO_A3: "BRA",
      ISO_A3_EH: "BRA"
    },
    bbox: [-73.987235, -33.768378, -34.729993, 5.244486],
    geometry: {
      type: "Polygon",
      coordinates: [[[-57.625133, -30.216295], [-56.2909, -28.852761], [-55.162286, -27.881915], [-54.490725, -27.474757], [-53.648735, -26.923473], [-53.628349, -26.124865], [-54.13005, -25.547639], [-54.625291, -25.739255], [-54.428946, -25.162185], [-54.293476, -24.5708], [-54.29296, -24.021014], [-54.652834, -23.839578], [-55.027902, -24.001274], [-55.400747, -23.956935], [-55.517639, -23.571998], [-55.610683, -22.655619], [-55.797958, -22.35693], [-56.473317, -22.0863], [-56.88151, -22.282154], [-57.937156, -22.090176], [-57.870674, -20.732688], [-58.166392, -20.176701], [-57.853802, -19.969995], [-57.949997, -19.400004], [-57.676009, -18.96184], [-57.498371, -18.174188], [-57.734558, -17.552468], [-58.280804, -17.27171], [-58.388058, -16.877109], [-58.24122, -16.299573], [-60.15839, -16.258284], [-60.542966, -15.09391], [-60.251149, -15.077219], [-60.264326, -14.645979], [-60.459198, -14.354007], [-60.503304, -13.775955], [-61.084121, -13.479384], [-61.713204, -13.489202], [-62.127081, -13.198781], [-62.80306, -13.000653], [-63.196499, -12.627033], [-64.316353, -12.461978], [-65.402281, -11.56627], [-65.321899, -10.895872], [-65.444837, -10.511451], [-65.338435, -9.761988], [-66.646908, -9.931331], [-67.173801, -10.306812], [-68.048192, -10.712059], [-68.271254, -11.014521], [-68.786158, -11.03638], [-69.529678, -10.951734], [-70.093752, -11.123972], [-70.548686, -11.009147], [-70.481894, -9.490118], [-71.302412, -10.079436], [-72.184891, -10.053598], [-72.563033, -9.520194], [-73.226713, -9.462213], [-73.015383, -9.032833], [-73.571059, -8.424447], [-73.987235, -7.52383], [-73.723401, -7.340999], [-73.724487, -6.918595], [-73.120027, -6.629931], [-73.219711, -6.089189], [-72.964507, -5.741251], [-72.891928, -5.274561], [-71.748406, -4.593983], [-70.928843, -4.401591], [-70.794769, -4.251265], [-69.893635, -4.298187], [-69.444102, -1.556287], [-69.420486, -1.122619], [-69.577065, -0.549992], [-70.020656, -0.185156], [-70.015566, 0.541414], [-69.452396, 0.706159], [-69.252434, 0.602651], [-69.218638, 0.985677], [-69.804597, 1.089081], [-69.816973, 1.714805], [-67.868565, 1.692455], [-67.53781, 2.037163], [-67.259998, 1.719999], [-67.065048, 1.130112], [-66.876326, 1.253361], [-66.325765, 0.724452], [-65.548267, 0.789254], [-65.354713, 1.095282], [-64.611012, 1.328731], [-64.199306, 1.492855], [-64.083085, 1.916369], [-63.368788, 2.2009], [-63.422867, 2.411068], [-64.269999, 2.497006], [-64.408828, 3.126786], [-64.368494, 3.79721], [-64.816064, 4.056445], [-64.628659, 4.148481], [-63.888343, 4.02053], [-63.093198, 3.770571], [-62.804533, 4.006965], [-62.08543, 4.162124], [-60.966893, 4.536468], [-60.601179, 4.918098], [-60.733574, 5.200277], [-60.213683, 5.244486], [-59.980959, 5.014061], [-60.111002, 4.574967], [-59.767406, 4.423503], [-59.53804, 3.958803], [-59.815413, 3.606499], [-59.974525, 2.755233], [-59.718546, 2.24963], [-59.646044, 1.786894], [-59.030862, 1.317698], [-58.540013, 1.268088], [-58.429477, 1.463942], [-58.11345, 1.507195], [-57.660971, 1.682585], [-57.335823, 1.948538], [-56.782704, 1.863711], [-56.539386, 1.899523], [-55.995698, 1.817667], [-55.9056, 2.021996], [-56.073342, 2.220795], [-55.973322, 2.510364], [-55.569755, 2.421506], [-55.097587, 2.523748], [-54.524754, 2.311849], [-54.088063, 2.105557], [-53.778521, 2.376703], [-53.554839, 2.334897], [-53.418465, 2.053389], [-52.939657, 2.124858], [-52.556425, 2.504705], [-52.249338, 3.241094], [-51.657797, 4.156232], [-51.317146, 4.203491], [-51.069771, 3.650398], [-50.508875, 1.901564], [-49.974076, 1.736483], [-49.947101, 1.04619], [-50.699251, 0.222984], [-50.388211, -0.078445], [-48.620567, -0.235489], [-48.584497, -1.237805], [-47.824956, -0.581618], [-46.566584, -0.941028], [-44.905703, -1.55174], [-44.417619, -2.13775], [-44.581589, -2.691308], [-43.418791, -2.38311], [-41.472657, -2.912018], [-39.978665, -2.873054], [-38.500383, -3.700652], [-37.223252, -4.820946], [-36.452937, -5.109404], [-35.597796, -5.149504], [-35.235389, -5.464937], [-34.89603, -6.738193], [-34.729993, -7.343221], [-35.128212, -8.996401], [-35.636967, -9.649282], [-37.046519, -11.040721], [-37.683612, -12.171195], [-38.423877, -13.038119], [-38.673887, -13.057652], [-38.953276, -13.79337], [-38.882298, -15.667054], [-39.161092, -17.208407], [-39.267339, -17.867746], [-39.583521, -18.262296], [-39.760823, -19.599113], [-40.774741, -20.904512], [-40.944756, -21.937317], [-41.754164, -22.370676], [-41.988284, -22.97007], [-43.074704, -22.967693], [-44.647812, -23.351959], [-45.352136, -23.796842], [-46.472093, -24.088969], [-47.648972, -24.885199], [-48.495458, -25.877025], [-48.641005, -26.623698], [-48.474736, -27.175912], [-48.66152, -28.186135], [-48.888457, -28.674115], [-49.587329, -29.224469], [-50.696874, -30.984465], [-51.576226, -31.777698], [-52.256081, -32.24537], [-52.7121, -33.196578], [-53.373662, -33.768378], [-53.650544, -33.202004], [-53.209589, -32.727666], [-53.787952, -32.047243], [-54.572452, -31.494511], [-55.60151, -30.853879], [-55.973245, -30.883076], [-56.976026, -30.109686], [-57.625133, -30.216295]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Brunei",
      TYPE: "Sovereign country",
      ADMIN: "Brunei",
      GEOUNIT: "Brunei",
      SUBUNIT: "Brunei",
      NAME: "Brunei",
      NAME_LONG: "Brunei Darussalam",
      ISO_A3: "BRN",
      ISO_A3_EH: "BRN",
      TINY: 2
    },
    bbox: [114.204017, 4.007637, 115.45071, 5.44773],
    geometry: {
      type: "Polygon",
      coordinates: [[[114.204017, 4.525874], [114.599961, 4.900011], [115.45071, 5.44773], [115.4057, 4.955228], [115.347461, 4.316636], [114.869557, 4.348314], [114.659596, 4.007637], [114.204017, 4.525874]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Bhutan",
      TYPE: "Sovereign country",
      ADMIN: "Bhutan",
      GEOUNIT: "Bhutan",
      SUBUNIT: "Bhutan",
      NAME: "Bhutan",
      NAME_LONG: "Bhutan",
      ISO_A3: "BTN",
      ISO_A3_EH: "BTN"
    },
    bbox: [88.814248, 26.719403, 92.103712, 28.296439],
    geometry: {
      type: "Polygon",
      coordinates: [[[91.696657, 27.771742], [92.103712, 27.452614], [92.033484, 26.83831], [91.217513, 26.808648], [90.373275, 26.875724], [89.744528, 26.719403], [88.835643, 27.098966], [88.814248, 27.299316], [89.47581, 28.042759], [90.015829, 28.296439], [90.730514, 28.064954], [91.258854, 28.040614], [91.696657, 27.771742]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Botswana",
      TYPE: "Sovereign country",
      ADMIN: "Botswana",
      GEOUNIT: "Botswana",
      SUBUNIT: "Botswana",
      NAME: "Botswana",
      NAME_LONG: "Botswana",
      ISO_A3: "BWA",
      ISO_A3_EH: "BWA"
    },
    bbox: [19.895458, -26.828543, 29.432188, -17.661816],
    geometry: {
      type: "Polygon",
      coordinates: [[[29.432188, -22.091313], [28.017236, -22.827754], [27.11941, -23.574323], [26.786407, -24.240691], [26.485753, -24.616327], [25.941652, -24.696373], [25.765849, -25.174845], [25.664666, -25.486816], [25.025171, -25.71967], [24.211267, -25.670216], [23.73357, -25.390129], [23.312097, -25.26869], [22.824271, -25.500459], [22.579532, -25.979448], [22.105969, -26.280256], [21.605896, -26.726534], [20.889609, -26.828543], [20.66647, -26.477453], [20.758609, -25.868136], [20.165726, -24.917962], [19.895768, -24.76779], [19.895458, -21.849157], [20.881134, -21.814327], [20.910641, -18.252219], [21.65504, -18.219146], [23.196858, -17.869038], [23.579006, -18.281261], [24.217365, -17.889347], [24.520705, -17.887125], [25.084443, -17.661816], [25.264226, -17.73654], [25.649163, -18.536026], [25.850391, -18.714413], [26.164791, -19.293086], [27.296505, -20.39152], [27.724747, -20.499059], [27.727228, -20.851802], [28.02137, -21.485975], [28.794656, -21.639454], [29.432188, -22.091313]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Central African Republic",
      TYPE: "Sovereign country",
      ADMIN: "Central African Republic",
      GEOUNIT: "Central African Republic",
      SUBUNIT: "Central African Republic",
      NAME: "Central African Rep.",
      NAME_LONG: "Central African Republic",
      ISO_A3: "CAF",
      ISO_A3_EH: "CAF"
    },
    bbox: [14.459407, 2.26764, 27.374226, 11.142395],
    geometry: {
      type: "Polygon",
      coordinates: [[[15.27946, 7.421925], [16.106232, 7.497088], [16.290562, 7.754307], [16.456185, 7.734774], [16.705988, 7.508328], [17.96493, 7.890914], [18.389555, 8.281304], [18.911022, 8.630895], [18.81201, 8.982915], [19.094008, 9.074847], [20.059685, 9.012706], [21.000868, 9.475985], [21.723822, 10.567056], [22.231129, 10.971889], [22.864165, 11.142395], [22.977544, 10.714463], [23.554304, 10.089255], [23.55725, 9.681218], [23.394779, 9.265068], [23.459013, 8.954286], [23.805813, 8.666319], [24.567369, 8.229188], [25.114932, 7.825104], [25.124131, 7.500085], [25.796648, 6.979316], [26.213418, 6.546603], [26.465909, 5.946717], [27.213409, 5.550953], [27.374226, 5.233944], [27.044065, 5.127853], [26.402761, 5.150875], [25.650455, 5.256088], [25.278798, 5.170408], [25.128833, 4.927245], [24.805029, 4.897247], [24.410531, 5.108784], [23.297214, 4.609693], [22.84148, 4.710126], [22.704124, 4.633051], [22.405124, 4.02916], [21.659123, 4.224342], [20.927591, 4.322786], [20.290679, 4.691678], [19.467784, 5.031528], [18.932312, 4.709506], [18.542982, 4.201785], [18.453065, 3.504386], [17.8099, 3.560196], [17.133042, 3.728197], [16.537058, 3.198255], [16.012852, 2.26764], [15.907381, 2.557389], [15.862732, 3.013537], [15.405396, 3.335301], [15.03622, 3.851367], [14.950953, 4.210389], [14.478372, 4.732605], [14.558936, 5.030598], [14.459407, 5.451761], [14.53656, 6.226959], [14.776545, 6.408498], [15.27946, 7.421925]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Canada",
      TYPE: "Sovereign country",
      ADMIN: "Canada",
      GEOUNIT: "Canada",
      SUBUNIT: "Canada",
      NAME: "Canada",
      NAME_LONG: "Canada",
      ISO_A3: "CAN",
      ISO_A3_EH: "CAN"
    },
    bbox: [-140.99778, 41.675105, -52.648099, 83.23324],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[-63.6645, 46.55001], [-62.9393, 46.41587], [-62.01208, 46.44314], [-62.50391, 46.03339], [-62.87433, 45.96818], [-64.1428, 46.39265], [-64.39261, 46.72747], [-64.01486, 47.03601], [-63.6645, 46.55001]]], [[[-61.806305, 49.10506], [-62.29318, 49.08717], [-63.58926, 49.40069], [-64.51912, 49.87304], [-64.17322, 49.95718], [-62.85829, 49.70641], [-61.835585, 49.28855], [-61.806305, 49.10506]]], [[[-123.510002, 48.510011], [-124.012891, 48.370846], [-125.655013, 48.825005], [-125.954994, 49.179996], [-126.850004, 49.53], [-127.029993, 49.814996], [-128.059336, 49.994959], [-128.444584, 50.539138], [-128.358414, 50.770648], [-127.308581, 50.552574], [-126.695001, 50.400903], [-125.755007, 50.295018], [-125.415002, 49.950001], [-124.920768, 49.475275], [-123.922509, 49.062484], [-123.510002, 48.510011]]], [[[-56.134036, 50.68701], [-56.795882, 49.812309], [-56.143105, 50.150117], [-55.471492, 49.935815], [-55.822401, 49.587129], [-54.935143, 49.313011], [-54.473775, 49.556691], [-53.476549, 49.249139], [-53.786014, 48.516781], [-53.086134, 48.687804], [-52.958648, 48.157164], [-52.648099, 47.535548], [-53.069158, 46.655499], [-53.521456, 46.618292], [-54.178936, 46.807066], [-53.961869, 47.625207], [-54.240482, 47.752279], [-55.400773, 46.884994], [-55.997481, 46.91972], [-55.291219, 47.389562], [-56.250799, 47.632545], [-57.325229, 47.572807], [-59.266015, 47.603348], [-59.419494, 47.899454], [-58.796586, 48.251525], [-59.231625, 48.523188], [-58.391805, 49.125581], [-57.35869, 50.718274], [-56.73865, 51.287438], [-55.870977, 51.632094], [-55.406974, 51.588273], [-55.600218, 51.317075], [-56.134036, 50.68701]]], [[[-133.180004, 54.169975], [-132.710008, 54.040009], [-131.74999, 54.120004], [-132.04948, 52.984621], [-131.179043, 52.180433], [-131.57783, 52.182371], [-132.180428, 52.639707], [-132.549992, 53.100015], [-133.054611, 53.411469], [-133.239664, 53.85108], [-133.180004, 54.169975]]], [[[-79.26582, 62.158675], [-79.65752, 61.63308], [-80.09956, 61.7181], [-80.36215, 62.01649], [-80.315395, 62.085565], [-79.92939, 62.3856], [-79.52002, 62.36371], [-79.26582, 62.158675]]], [[[-81.89825, 62.7108], [-83.06857, 62.15922], [-83.77462, 62.18231], [-83.99367, 62.4528], [-83.25048, 62.91409], [-81.87699, 62.90458], [-81.89825, 62.7108]]], [[[-85.161308, 65.657285], [-84.975764, 65.217518], [-84.464012, 65.371772], [-83.882626, 65.109618], [-82.787577, 64.766693], [-81.642014, 64.455136], [-81.55344, 63.979609], [-80.817361, 64.057486], [-80.103451, 63.725981], [-80.99102, 63.411246], [-82.547178, 63.651722], [-83.108798, 64.101876], [-84.100417, 63.569712], [-85.523405, 63.052379], [-85.866769, 63.637253], [-87.221983, 63.541238], [-86.35276, 64.035833], [-86.224886, 64.822917], [-85.883848, 65.738778], [-85.161308, 65.657285]]], [[[-75.86588, 67.14886], [-76.98687, 67.09873], [-77.2364, 67.58809], [-76.81166, 68.14856], [-75.89521, 68.28721], [-75.1145, 68.01036], [-75.10333, 67.58202], [-75.21597, 67.44425], [-75.86588, 67.14886]]], [[[-95.647681, 69.10769], [-96.269521, 68.75704], [-97.617401, 69.06003], [-98.431801, 68.9507], [-99.797401, 69.40003], [-98.917401, 69.71003], [-98.218261, 70.14354], [-97.157401, 69.86003], [-96.557401, 69.68003], [-96.257401, 69.49003], [-95.647681, 69.10769]]], [[[-68.23444, 47.35486], [-68.905, 47.185], [-69.237216, 47.447781], [-69.99997, 46.69307], [-70.305, 45.915], [-70.66, 45.46], [-71.08482, 45.30524], [-71.405, 45.255], [-71.50506, 45.0082], [-73.34783, 45.00738], [-74.867, 45.00048], [-75.31821, 44.81645], [-76.375, 44.09631], [-76.5, 44.018459], [-76.820034, 43.628784], [-77.737885, 43.629056], [-78.72028, 43.625089], [-79.171674, 43.466339], [-79.01, 43.27], [-78.92, 42.965], [-78.939362, 42.863611], [-80.247448, 42.3662], [-81.277747, 42.209026], [-82.439278, 41.675105], [-82.690089, 41.675105], [-83.02981, 41.832796], [-83.142, 41.975681], [-83.12, 42.08], [-82.9, 42.43], [-82.43, 42.98], [-82.137642, 43.571088], [-82.337763, 44.44], [-82.550925, 45.347517], [-83.592851, 45.816894], [-83.469551, 45.994686], [-83.616131, 46.116927], [-83.890765, 46.116927], [-84.091851, 46.275419], [-84.14212, 46.512226], [-84.3367, 46.40877], [-84.6049, 46.4396], [-84.543749, 46.538684], [-84.779238, 46.637102], [-84.87608, 46.900083], [-85.652363, 47.220219], [-86.461991, 47.553338], [-87.439793, 47.94], [-88.378114, 48.302918], [-89.272917, 48.019808], [-89.6, 48.01], [-90.83, 48.27], [-91.64, 48.14], [-92.61, 48.45], [-93.63087, 48.60926], [-94.32914, 48.67074], [-94.64, 48.84], [-94.81758, 49.38905], [-95.15609, 49.38425], [-95.15907, 49], [-97.22872, 49.0007], [-100.65, 49], [-104.04826, 48.99986], [-107.05, 49], [-110.05, 49], [-113, 49], [-116.04818, 49], [-117.03121, 49], [-120, 49], [-122.84, 49], [-122.97421, 49.002538], [-124.91024, 49.98456], [-125.62461, 50.41656], [-127.43561, 50.83061], [-127.99276, 51.71583], [-127.85032, 52.32961], [-129.12979, 52.75538], [-129.30523, 53.56159], [-130.51497, 54.28757], [-130.536109, 54.802754], [-130.53611, 54.80278], [-129.98, 55.285], [-130.00778, 55.91583], [-131.70781, 56.55212], [-132.73042, 57.69289], [-133.35556, 58.41028], [-134.27111, 58.86111], [-134.945, 59.27056], [-135.47583, 59.78778], [-136.47972, 59.46389], [-137.4525, 58.905], [-138.34089, 59.56211], [-139.039, 60], [-140.013, 60.27682], [-140.99778, 60.30639], [-140.9925, 66.00003], [-140.986, 69.712], [-140.985988, 69.711998], [-139.12052, 69.47102], [-137.54636, 68.99002], [-136.50358, 68.89804], [-135.62576, 69.31512], [-134.41464, 69.62743], [-132.92925, 69.50534], [-131.43136, 69.94451], [-129.79471, 70.19369], [-129.10773, 69.77927], [-128.36156, 70.01286], [-128.13817, 70.48384], [-127.44712, 70.37721], [-125.75632, 69.48058], [-124.42483, 70.1584], [-124.28968, 69.39969], [-123.06108, 69.56372], [-122.6835, 69.85553], [-121.47226, 69.79778], [-119.94288, 69.37786], [-117.60268, 69.01128], [-116.22643, 68.84151], [-115.2469, 68.90591], [-113.89794, 68.3989], [-115.30489, 67.90261], [-113.49727, 67.68815], [-110.798, 67.80612], [-109.94619, 67.98104], [-108.8802, 67.38144], [-107.79239, 67.88736], [-108.81299, 68.31164], [-108.16721, 68.65392], [-106.95, 68.7], [-106.15, 68.8], [-105.34282, 68.56122], [-104.33791, 68.018], [-103.22115, 68.09775], [-101.45433, 67.64689], [-99.90195, 67.80566], [-98.4432, 67.78165], [-98.5586, 68.40394], [-97.66948, 68.57864], [-96.11991, 68.23939], [-96.12588, 67.29338], [-95.48943, 68.0907], [-94.685, 68.06383], [-94.23282, 69.06903], [-95.30408, 69.68571], [-96.47131, 70.08976], [-96.39115, 71.19482], [-95.2088, 71.92053], [-93.88997, 71.76015], [-92.87818, 71.31869], [-91.51964, 70.19129], [-92.40692, 69.69997], [-90.5471, 69.49766], [-90.55151, 68.47499], [-89.21515, 69.25873], [-88.01966, 68.61508], [-88.31749, 67.87338], [-87.35017, 67.19872], [-86.30607, 67.92146], [-85.57664, 68.78456], [-85.52197, 69.88211], [-84.10081, 69.80539], [-82.62258, 69.65826], [-81.28043, 69.16202], [-81.2202, 68.66567], [-81.96436, 68.13253], [-81.25928, 67.59716], [-81.38653, 67.11078], [-83.34456, 66.41154], [-84.73542, 66.2573], [-85.76943, 66.55833], [-86.0676, 66.05625], [-87.03143, 65.21297], [-87.32324, 64.77563], [-88.48296, 64.09897], [-89.91444, 64.03273], [-90.70398, 63.61017], [-90.77004, 62.96021], [-91.93342, 62.83508], [-93.15698, 62.02469], [-94.24153, 60.89865], [-94.62931, 60.11021], [-94.6846, 58.94882], [-93.21502, 58.78212], [-92.76462, 57.84571], [-92.29703, 57.08709], [-90.89769, 57.28468], [-89.03953, 56.85172], [-88.03978, 56.47162], [-87.32421, 55.99914], [-86.07121, 55.72383], [-85.01181, 55.3026], [-83.36055, 55.24489], [-82.27285, 55.14832], [-82.4362, 54.28227], [-82.12502, 53.27703], [-81.40075, 52.15788], [-79.91289, 51.20842], [-79.14301, 51.53393], [-78.60191, 52.56208], [-79.12421, 54.14145], [-79.82958, 54.66772], [-78.22874, 55.13645], [-77.0956, 55.83741], [-76.54137, 56.53423], [-76.62319, 57.20263], [-77.30226, 58.05209], [-78.51688, 58.80458], [-77.33676, 59.85261], [-77.77272, 60.75788], [-78.10687, 62.31964], [-77.41067, 62.55053], [-75.69621, 62.2784], [-74.6682, 62.18111], [-73.83988, 62.4438], [-72.90853, 62.10507], [-71.67708, 61.52535], [-71.37369, 61.13717], [-69.59042, 61.06141], [-69.62033, 60.22125], [-69.2879, 58.95736], [-68.37455, 58.80106], [-67.64976, 58.21206], [-66.20178, 58.76731], [-65.24517, 59.87071], [-64.58352, 60.33558], [-63.80475, 59.4426], [-62.50236, 58.16708], [-61.39655, 56.96745], [-61.79866, 56.33945], [-60.46853, 55.77548], [-59.56962, 55.20407], [-57.97508, 54.94549], [-57.3332, 54.6265], [-56.93689, 53.78032], [-56.15811, 53.64749], [-55.75632, 53.27036], [-55.68338, 52.14664], [-56.40916, 51.7707], [-57.12691, 51.41972], [-58.77482, 51.0643], [-60.03309, 50.24277], [-61.72366, 50.08046], [-63.86251, 50.29099], [-65.36331, 50.2982], [-66.39905, 50.22897], [-67.23631, 49.51156], [-68.51114, 49.06836], [-69.95362, 47.74488], [-71.10458, 46.82171], [-70.25522, 46.98606], [-68.65, 48.3], [-66.55243, 49.1331], [-65.05626, 49.23278], [-64.17099, 48.74248], [-65.11545, 48.07085], [-64.79854, 46.99297], [-64.47219, 46.23849], [-63.17329, 45.73902], [-61.52072, 45.88377], [-60.51815, 47.00793], [-60.4486, 46.28264], [-59.80287, 45.9204], [-61.03988, 45.26525], [-63.25471, 44.67014], [-64.24656, 44.26553], [-65.36406, 43.54523], [-66.1234, 43.61867], [-66.16173, 44.46512], [-64.42549, 45.29204], [-66.02605, 45.25931], [-67.13741, 45.13753], [-67.79134, 45.70281], [-67.79046, 47.06636], [-68.23444, 47.35486]]], [[[-114.16717, 73.12145], [-114.66634, 72.65277], [-112.44102, 72.9554], [-111.05039, 72.4504], [-109.92035, 72.96113], [-109.00654, 72.63335], [-108.18835, 71.65089], [-107.68599, 72.06548], [-108.39639, 73.08953], [-107.51645, 73.23598], [-106.52259, 73.07601], [-105.40246, 72.67259], [-104.77484, 71.6984], [-104.46476, 70.99297], [-102.78537, 70.49776], [-100.98078, 70.02432], [-101.08929, 69.58447], [-102.73116, 69.50402], [-102.09329, 69.11962], [-102.43024, 68.75282], [-104.24, 68.91], [-105.96, 69.18], [-107.12254, 69.11922], [-109, 68.78], [-111.534149, 68.630059], [-113.3132, 68.53554], [-113.85496, 69.00744], [-115.22, 69.28], [-116.10794, 69.16821], [-117.34, 69.96], [-116.67473, 70.06655], [-115.13112, 70.2373], [-113.72141, 70.19237], [-112.4161, 70.36638], [-114.35, 70.6], [-116.48684, 70.52045], [-117.9048, 70.54056], [-118.43238, 70.9092], [-116.11311, 71.30918], [-117.65568, 71.2952], [-119.40199, 71.55859], [-118.56267, 72.30785], [-117.86642, 72.70594], [-115.18909, 73.31459], [-114.16717, 73.12145]]], [[[-104.5, 73.42], [-105.38, 72.76], [-106.94, 73.46], [-106.6, 73.6], [-105.26, 73.64], [-104.5, 73.42]]], [[[-76.34, 73.102685], [-76.251404, 72.826385], [-77.314438, 72.855545], [-78.39167, 72.876656], [-79.486252, 72.742203], [-79.775833, 72.802902], [-80.876099, 73.333183], [-80.833885, 73.693184], [-80.353058, 73.75972], [-78.064438, 73.651932], [-76.34, 73.102685]]], [[[-86.562179, 73.157447], [-85.774371, 72.534126], [-84.850112, 73.340278], [-82.31559, 73.750951], [-80.600088, 72.716544], [-80.748942, 72.061907], [-78.770639, 72.352173], [-77.824624, 72.749617], [-75.605845, 72.243678], [-74.228616, 71.767144], [-74.099141, 71.33084], [-72.242226, 71.556925], [-71.200015, 70.920013], [-68.786054, 70.525024], [-67.91497, 70.121948], [-66.969033, 69.186087], [-68.805123, 68.720198], [-66.449866, 68.067163], [-64.862314, 67.847539], [-63.424934, 66.928473], [-61.851981, 66.862121], [-62.163177, 66.160251], [-63.918444, 64.998669], [-65.14886, 65.426033], [-66.721219, 66.388041], [-68.015016, 66.262726], [-68.141287, 65.689789], [-67.089646, 65.108455], [-65.73208, 64.648406], [-65.320168, 64.382737], [-64.669406, 63.392927], [-65.013804, 62.674185], [-66.275045, 62.945099], [-68.783186, 63.74567], [-67.369681, 62.883966], [-66.328297, 62.280075], [-66.165568, 61.930897], [-68.877367, 62.330149], [-71.023437, 62.910708], [-72.235379, 63.397836], [-71.886278, 63.679989], [-73.378306, 64.193963], [-74.834419, 64.679076], [-74.818503, 64.389093], [-77.70998, 64.229542], [-78.555949, 64.572906], [-77.897281, 65.309192], [-76.018274, 65.326969], [-73.959795, 65.454765], [-74.293883, 65.811771], [-73.944912, 66.310578], [-72.651167, 67.284576], [-72.92606, 67.726926], [-73.311618, 68.069437], [-74.843307, 68.554627], [-76.869101, 68.894736], [-76.228649, 69.147769], [-77.28737, 69.76954], [-78.168634, 69.826488], [-78.957242, 70.16688], [-79.492455, 69.871808], [-81.305471, 69.743185], [-84.944706, 69.966634], [-87.060003, 70.260001], [-88.681713, 70.410741], [-89.51342, 70.762038], [-88.467721, 71.218186], [-89.888151, 71.222552], [-90.20516, 72.235074], [-89.436577, 73.129464], [-88.408242, 73.537889], [-85.826151, 73.803816], [-86.562179, 73.157447]]], [[[-100.35642, 73.84389], [-99.16387, 73.63339], [-97.38, 73.76], [-97.12, 73.47], [-98.05359, 72.99052], [-96.54, 72.56], [-96.72, 71.66], [-98.35966, 71.27285], [-99.32286, 71.35639], [-100.01482, 71.73827], [-102.5, 72.51], [-102.48, 72.83], [-100.43836, 72.70588], [-101.54, 73.36], [-100.35642, 73.84389]]], [[[-93.196296, 72.771992], [-94.269047, 72.024596], [-95.409856, 72.061881], [-96.033745, 72.940277], [-96.018268, 73.43743], [-95.495793, 73.862417], [-94.503658, 74.134907], [-92.420012, 74.100025], [-90.509793, 73.856732], [-92.003965, 72.966244], [-93.196296, 72.771992]]], [[[-120.46, 71.383602], [-123.09219, 70.90164], [-123.62, 71.34], [-125.928949, 71.868688], [-125.5, 72.292261], [-124.80729, 73.02256], [-123.94, 73.68], [-124.91775, 74.29275], [-121.53788, 74.44893], [-120.10978, 74.24135], [-117.55564, 74.18577], [-116.58442, 73.89607], [-115.51081, 73.47519], [-116.76794, 73.22292], [-119.22, 72.52], [-120.46, 71.82], [-120.46, 71.383602]]], [[[-93.612756, 74.979997], [-94.156909, 74.592347], [-95.608681, 74.666864], [-96.820932, 74.927623], [-96.288587, 75.377828], [-94.85082, 75.647218], [-93.977747, 75.29649], [-93.612756, 74.979997]]], [[[-98.5, 76.72], [-97.735585, 76.25656], [-97.704415, 75.74344], [-98.16, 75], [-99.80874, 74.89744], [-100.88366, 75.05736], [-100.86292, 75.64075], [-102.50209, 75.5638], [-102.56552, 76.3366], [-101.48973, 76.30537], [-99.98349, 76.64634], [-98.57699, 76.58859], [-98.5, 76.72]]], [[[-108.21141, 76.20168], [-107.81943, 75.84552], [-106.92893, 76.01282], [-105.881, 75.9694], [-105.70498, 75.47951], [-106.31347, 75.00527], [-109.7, 74.85], [-112.22307, 74.41696], [-113.74381, 74.39427], [-113.87135, 74.72029], [-111.79421, 75.1625], [-116.31221, 75.04343], [-117.7104, 75.2222], [-116.34602, 76.19903], [-115.40487, 76.47887], [-112.59056, 76.14134], [-110.81422, 75.54919], [-109.0671, 75.47321], [-110.49726, 76.42982], [-109.5811, 76.79417], [-108.54859, 76.67832], [-108.21141, 76.20168]]], [[[-94.684086, 77.097878], [-93.573921, 76.776296], [-91.605023, 76.778518], [-90.741846, 76.449597], [-90.969661, 76.074013], [-89.822238, 75.847774], [-89.187083, 75.610166], [-87.838276, 75.566189], [-86.379192, 75.482421], [-84.789625, 75.699204], [-82.753445, 75.784315], [-81.128531, 75.713983], [-80.057511, 75.336849], [-79.833933, 74.923127], [-80.457771, 74.657304], [-81.948843, 74.442459], [-83.228894, 74.564028], [-86.097452, 74.410032], [-88.15035, 74.392307], [-89.764722, 74.515555], [-92.422441, 74.837758], [-92.768285, 75.38682], [-92.889906, 75.882655], [-93.893824, 76.319244], [-95.962457, 76.441381], [-97.121379, 76.751078], [-96.745123, 77.161389], [-94.684086, 77.097878]]], [[[-116.198587, 77.645287], [-116.335813, 76.876962], [-117.106051, 76.530032], [-118.040412, 76.481172], [-119.899318, 76.053213], [-121.499995, 75.900019], [-122.854924, 76.116543], [-122.854925, 76.116543], [-121.157535, 76.864508], [-119.103939, 77.51222], [-117.570131, 77.498319], [-116.198587, 77.645287]]], [[[-93.840003, 77.519997], [-94.295608, 77.491343], [-96.169654, 77.555111], [-96.436304, 77.834629], [-94.422577, 77.820005], [-93.720656, 77.634331], [-93.840003, 77.519997]]], [[[-110.186938, 77.697015], [-112.051191, 77.409229], [-113.534279, 77.732207], [-112.724587, 78.05105], [-111.264443, 78.152956], [-109.854452, 77.996325], [-110.186938, 77.697015]]], [[[-109.663146, 78.601973], [-110.881314, 78.40692], [-112.542091, 78.407902], [-112.525891, 78.550555], [-111.50001, 78.849994], [-110.963661, 78.804441], [-109.663146, 78.601973]]], [[[-95.830295, 78.056941], [-97.309843, 77.850597], [-98.124289, 78.082857], [-98.552868, 78.458105], [-98.631984, 78.87193], [-97.337231, 78.831984], [-96.754399, 78.765813], [-95.559278, 78.418315], [-95.830295, 78.056941]]], [[[-100.060192, 78.324754], [-99.670939, 77.907545], [-101.30394, 78.018985], [-102.949809, 78.343229], [-105.176133, 78.380332], [-104.210429, 78.67742], [-105.41958, 78.918336], [-105.492289, 79.301594], [-103.529282, 79.165349], [-100.825158, 78.800462], [-100.060192, 78.324754]]], [[[-87.02, 79.66], [-85.81435, 79.3369], [-87.18756, 79.0393], [-89.03535, 78.28723], [-90.80436, 78.21533], [-92.87669, 78.34333], [-93.95116, 78.75099], [-93.93574, 79.11373], [-93.14524, 79.3801], [-94.974, 79.37248], [-96.07614, 79.70502], [-96.70972, 80.15777], [-96.01644, 80.60233], [-95.32345, 80.90729], [-94.29843, 80.97727], [-94.73542, 81.20646], [-92.40984, 81.25739], [-91.13289, 80.72345], [-89.45, 80.509322], [-87.81, 80.32], [-87.02, 79.66]]], [[[-68.5, 83.106322], [-65.82735, 83.02801], [-63.68, 82.9], [-61.85, 82.6286], [-61.89388, 82.36165], [-64.334, 81.92775], [-66.75342, 81.72527], [-67.65755, 81.50141], [-65.48031, 81.50657], [-67.84, 80.9], [-69.4697, 80.61683], [-71.18, 79.8], [-73.2428, 79.63415], [-73.88, 79.430162], [-76.90773, 79.32309], [-75.52924, 79.19766], [-76.22046, 79.01907], [-75.39345, 78.52581], [-76.34354, 78.18296], [-77.88851, 77.89991], [-78.36269, 77.50859], [-79.75951, 77.20968], [-79.61965, 76.98336], [-77.91089, 77.022045], [-77.88911, 76.777955], [-80.56125, 76.17812], [-83.17439, 76.45403], [-86.11184, 76.29901], [-87.6, 76.42], [-89.49068, 76.47239], [-89.6161, 76.95213], [-87.76739, 77.17833], [-88.26, 77.9], [-87.65, 77.970222], [-84.97634, 77.53873], [-86.34, 78.18], [-87.96192, 78.37181], [-87.15198, 78.75867], [-85.37868, 78.9969], [-85.09495, 79.34543], [-86.50734, 79.73624], [-86.93179, 80.25145], [-84.19844, 80.20836], [-83.408696, 80.1], [-81.84823, 80.46442], [-84.1, 80.58], [-87.59895, 80.51627], [-89.36663, 80.85569], [-90.2, 81.26], [-91.36786, 81.5531], [-91.58702, 81.89429], [-90.1, 82.085], [-88.93227, 82.11751], [-86.97024, 82.27961], [-85.5, 82.652273], [-84.260005, 82.6], [-83.18, 82.32], [-82.42, 82.86], [-81.1, 83.02], [-79.30664, 83.13056], [-76.25, 83.172059], [-75.71878, 83.06404], [-72.83153, 83.23324], [-70.665765, 83.169781], [-68.5, 83.106322]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Switzerland",
      TYPE: "Sovereign country",
      ADMIN: "Switzerland",
      GEOUNIT: "Switzerland",
      SUBUNIT: "Switzerland",
      NAME: "Switzerland",
      NAME_LONG: "Switzerland",
      ISO_A3: "CHE",
      ISO_A3_EH: "CHE"
    },
    bbox: [6.022609, 45.776948, 10.442701, 47.830828],
    geometry: {
      type: "Polygon",
      coordinates: [[[9.594226, 47.525058], [9.632932, 47.347601], [9.47997, 47.10281], [9.932448, 46.920728], [10.442701, 46.893546], [10.363378, 46.483571], [9.922837, 46.314899], [9.182882, 46.440215], [8.966306, 46.036932], [8.489952, 46.005151], [8.31663, 46.163642], [7.755992, 45.82449], [7.273851, 45.776948], [6.843593, 45.991147], [6.5001, 46.429673], [6.022609, 46.27299], [6.037389, 46.725779], [6.768714, 47.287708], [6.736571, 47.541801], [7.192202, 47.449766], [7.466759, 47.620582], [8.317301, 47.61358], [8.522612, 47.830828], [9.594226, 47.525058]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Chile",
      TYPE: "Sovereign country",
      ADMIN: "Chile",
      GEOUNIT: "Chile",
      SUBUNIT: "Chile",
      NAME: "Chile",
      NAME_LONG: "Chile",
      ISO_A3: "CHL",
      ISO_A3_EH: "CHL"
    },
    bbox: [-75.644395, -55.61183, -66.95992, -17.580012],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[-68.63401, -52.63637], [-68.63335, -54.8695], [-67.56244, -54.87001], [-66.95992, -54.89681], [-67.29103, -55.30124], [-68.14863, -55.61183], [-68.639991, -55.580018], [-69.2321, -55.49906], [-69.95809, -55.19843], [-71.00568, -55.05383], [-72.2639, -54.49514], [-73.2852, -53.95752], [-74.66253, -52.83749], [-73.8381, -53.04743], [-72.43418, -53.7154], [-71.10773, -54.07433], [-70.59178, -53.61583], [-70.26748, -52.93123], [-69.34565, -52.5183], [-68.63401, -52.63637]]], [[[-67.106674, -22.735925], [-66.985234, -22.986349], [-67.328443, -24.025303], [-68.417653, -24.518555], [-68.386001, -26.185016], [-68.5948, -26.506909], [-68.295542, -26.89934], [-69.001235, -27.521214], [-69.65613, -28.459141], [-70.01355, -29.367923], [-69.919008, -30.336339], [-70.535069, -31.36501], [-70.074399, -33.09121], [-69.814777, -33.273886], [-69.817309, -34.193571], [-70.388049, -35.169688], [-70.364769, -36.005089], [-71.121881, -36.658124], [-71.118625, -37.576827], [-70.814664, -38.552995], [-71.413517, -38.916022], [-71.680761, -39.808164], [-71.915734, -40.832339], [-71.746804, -42.051386], [-72.148898, -42.254888], [-71.915424, -43.408565], [-71.464056, -43.787611], [-71.793623, -44.207172], [-71.329801, -44.407522], [-71.222779, -44.784243], [-71.659316, -44.973689], [-71.552009, -45.560733], [-71.917258, -46.884838], [-72.447355, -47.738533], [-72.331161, -48.244238], [-72.648247, -48.878618], [-73.415436, -49.318436], [-73.328051, -50.378785], [-72.975747, -50.74145], [-72.309974, -50.67701], [-72.329404, -51.425956], [-71.914804, -52.009022], [-69.498362, -52.142761], [-68.571545, -52.299444], [-69.461284, -52.291951], [-69.94278, -52.537931], [-70.845102, -52.899201], [-71.006332, -53.833252], [-71.429795, -53.856455], [-72.557943, -53.53141], [-73.702757, -52.835069], [-73.702757, -52.83507], [-74.946763, -52.262754], [-75.260026, -51.629355], [-74.976632, -51.043396], [-75.479754, -50.378372], [-75.608015, -48.673773], [-75.18277, -47.711919], [-74.126581, -46.939253], [-75.644395, -46.647643], [-74.692154, -45.763976], [-74.351709, -44.103044], [-73.240356, -44.454961], [-72.717804, -42.383356], [-73.3889, -42.117532], [-73.701336, -43.365776], [-74.331943, -43.224958], [-74.017957, -41.794813], [-73.677099, -39.942213], [-73.217593, -39.258689], [-73.505559, -38.282883], [-73.588061, -37.156285], [-73.166717, -37.12378], [-72.553137, -35.50884], [-71.861732, -33.909093], [-71.43845, -32.418899], [-71.668721, -30.920645], [-71.370083, -30.095682], [-71.489894, -28.861442], [-70.905124, -27.64038], [-70.724954, -25.705924], [-70.403966, -23.628997], [-70.091246, -21.393319], [-70.16442, -19.756468], [-70.372572, -18.347975], [-69.858444, -18.092694], [-69.590424, -17.580012], [-69.100247, -18.260125], [-68.966818, -18.981683], [-68.442225, -19.405068], [-68.757167, -20.372658], [-68.219913, -21.494347], [-67.82818, -22.872919], [-67.106674, -22.735925]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "China",
      TYPE: "Country",
      ADMIN: "China",
      GEOUNIT: "China",
      SUBUNIT: "China",
      NAME: "China",
      NAME_LONG: "China",
      ISO_A3: "CHN",
      ISO_A3_EH: "CHN"
    },
    bbox: [73.675379, 18.197701, 135.026311, 53.4588],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[75.158028, 37.133031], [74.980002, 37.41999], [74.829986, 37.990007], [74.864816, 38.378846], [74.257514, 38.606507], [73.928852, 38.505815], [73.675379, 39.431237], [73.960013, 39.660008], [73.822244, 39.893973], [74.776862, 40.366425], [75.467828, 40.562072], [76.526368, 40.427946], [76.904484, 41.066486], [78.187197, 41.185316], [78.543661, 41.582243], [80.11943, 42.123941], [80.25999, 42.349999], [80.18015, 42.920068], [80.866206, 43.180362], [79.966106, 44.917517], [81.947071, 45.317027], [82.458926, 45.53965], [83.180484, 47.330031], [85.16429, 47.000956], [85.720484, 47.452969], [85.768233, 48.455751], [86.598776, 48.549182], [87.35997, 49.214981], [87.751264, 49.297198], [88.013832, 48.599463], [88.854298, 48.069082], [90.280826, 47.693549], [90.970809, 46.888146], [90.585768, 45.719716], [90.94554, 45.286073], [92.133891, 45.115076], [93.480734, 44.975472], [94.688929, 44.352332], [95.306875, 44.241331], [95.762455, 43.319449], [96.349396, 42.725635], [97.451757, 42.74889], [99.515817, 42.524691], [100.845866, 42.663804], [101.83304, 42.514873], [103.312278, 41.907468], [104.522282, 41.908347], [104.964994, 41.59741], [106.129316, 42.134328], [107.744773, 42.481516], [109.243596, 42.519446], [110.412103, 42.871234], [111.129682, 43.406834], [111.829588, 43.743118], [111.667737, 44.073176], [111.348377, 44.457442], [111.873306, 45.102079], [112.436062, 45.011646], [113.463907, 44.808893], [114.460332, 45.339817], [115.985096, 45.727235], [116.717868, 46.388202], [117.421701, 46.672733], [118.874326, 46.805412], [119.66327, 46.69268], [119.772824, 47.048059], [118.866574, 47.74706], [118.064143, 48.06673], [117.295507, 47.697709], [116.308953, 47.85341], [115.742837, 47.726545], [115.485282, 48.135383], [116.191802, 49.134598], [116.678801, 49.888531], [117.879244, 49.510983], [119.288461, 50.142883], [119.27939, 50.58292], [120.18208, 51.64355], [120.7382, 51.96411], [120.725789, 52.516226], [120.177089, 52.753886], [121.003085, 53.251401], [122.245748, 53.431726], [123.57147, 53.4588], [125.068211, 53.161045], [125.946349, 52.792799], [126.564399, 51.784255], [126.939157, 51.353894], [127.287456, 50.739797], [127.6574, 49.76027], [129.397818, 49.4406], [130.582293, 48.729687], [130.98726, 47.79013], [132.50669, 47.78896], [133.373596, 48.183442], [135.026311, 48.47823], [134.50081, 47.57845], [134.11235, 47.21248], [133.769644, 46.116927], [133.09712, 45.14409], [131.883454, 45.321162], [131.02519, 44.96796], [131.288555, 44.11152], [131.144688, 42.92999], [130.633866, 42.903015], [130.64, 42.395024], [129.994267, 42.985387], [129.596669, 42.424982], [128.052215, 41.994285], [128.208433, 41.466772], [127.343783, 41.503152], [126.869083, 41.816569], [126.182045, 41.107336], [125.079942, 40.569824], [124.265625, 39.928493], [122.86757, 39.637788], [122.131388, 39.170452], [121.054554, 38.897471], [121.585995, 39.360854], [121.376757, 39.750261], [122.168595, 40.422443], [121.640359, 40.94639], [120.768629, 40.593388], [119.639602, 39.898056], [119.023464, 39.252333], [118.042749, 39.204274], [117.532702, 38.737636], [118.059699, 38.061476], [118.87815, 37.897325], [118.911636, 37.448464], [119.702802, 37.156389], [120.823457, 37.870428], [121.711259, 37.481123], [122.357937, 37.454484], [122.519995, 36.930614], [121.104164, 36.651329], [120.637009, 36.11144], [119.664562, 35.609791], [119.151208, 34.909859], [120.227525, 34.360332], [120.620369, 33.376723], [121.229014, 32.460319], [121.908146, 31.692174], [121.891919, 30.949352], [121.264257, 30.676267], [121.503519, 30.142915], [122.092114, 29.83252], [121.938428, 29.018022], [121.684439, 28.225513], [121.125661, 28.135673], [120.395473, 27.053207], [119.585497, 25.740781], [118.656871, 24.547391], [117.281606, 23.624501], [115.890735, 22.782873], [114.763827, 22.668074], [114.152547, 22.22376], [113.80678, 22.54834], [113.241078, 22.051367], [111.843592, 21.550494], [110.785466, 21.397144], [110.444039, 20.341033], [109.889861, 20.282457], [109.627655, 21.008227], [109.864488, 21.395051], [108.522813, 21.715212], [108.05018, 21.55238], [107.04342, 21.811899], [106.567273, 22.218205], [106.725403, 22.794268], [105.811247, 22.976892], [105.329209, 23.352063], [104.476858, 22.81915], [103.504515, 22.703757], [102.706992, 22.708795], [102.170436, 22.464753], [101.652018, 22.318199], [101.80312, 21.174367], [101.270026, 21.201652], [101.180005, 21.436573], [101.150033, 21.849984], [100.416538, 21.558839], [99.983489, 21.742937], [99.240899, 22.118314], [99.531992, 22.949039], [98.898749, 23.142722], [98.660262, 24.063286], [97.60472, 23.897405], [97.724609, 25.083637], [98.671838, 25.918703], [98.712094, 26.743536], [98.68269, 27.508812], [98.246231, 27.747221], [97.911988, 28.335945], [97.327114, 28.261583], [96.248833, 28.411031], [96.586591, 28.83098], [96.117679, 29.452802], [95.404802, 29.031717], [94.56599, 29.277438], [93.413348, 28.640629], [92.503119, 27.896876], [91.696657, 27.771742], [91.258854, 28.040614], [90.730514, 28.064954], [90.015829, 28.296439], [89.47581, 28.042759], [88.814248, 27.299316], [88.730326, 28.086865], [88.120441, 27.876542], [86.954517, 27.974262], [85.82332, 28.203576], [85.011638, 28.642774], [84.23458, 28.839894], [83.898993, 29.320226], [83.337115, 29.463732], [82.327513, 30.115268], [81.525804, 30.422717], [81.111256, 30.183481], [79.721367, 30.882715], [78.738894, 31.515906], [78.458446, 32.618164], [79.176129, 32.48378], [79.208892, 32.994395], [78.811086, 33.506198], [78.912269, 34.321936], [77.837451, 35.49401], [76.192848, 35.898403], [75.896897, 36.666806], [75.158028, 37.133031]]], [[[110.339188, 18.678395], [109.47521, 18.197701], [108.655208, 18.507682], [108.626217, 19.367888], [109.119056, 19.821039], [110.211599, 20.101254], [110.786551, 20.077534], [111.010051, 19.69593], [110.570647, 19.255879], [110.339188, 18.678395]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Ivory Coast",
      TYPE: "Sovereign country",
      ADMIN: "Ivory Coast",
      GEOUNIT: "Ivory Coast",
      SUBUNIT: "Ivory Coast",
      NAME: "Côte d'Ivoire",
      NAME_LONG: "Côte d'Ivoire",
      ISO_A3: "CIV",
      ISO_A3_EH: "CIV"
    },
    bbox: [-8.60288, 4.338288, -2.56219, 10.524061],
    geometry: {
      type: "Polygon",
      coordinates: [[[-5.404342, 10.370737], [-4.954653, 10.152714], [-4.779884, 9.821985], [-4.330247, 9.610835], [-3.980449, 9.862344], [-3.511899, 9.900326], [-2.827496, 9.642461], [-2.56219, 8.219628], [-2.983585, 7.379705], [-3.24437, 6.250472], [-2.810701, 5.389051], [-2.856125, 4.994476], [-3.311084, 4.984296], [-4.00882, 5.179813], [-4.649917, 5.168264], [-5.834496, 4.993701], [-6.528769, 4.705088], [-7.518941, 4.338288], [-7.712159, 4.364566], [-7.635368, 5.188159], [-7.539715, 5.313345], [-7.570153, 5.707352], [-7.993693, 6.12619], [-8.311348, 6.193033], [-8.60288, 6.467564], [-8.385452, 6.911801], [-8.485446, 7.395208], [-8.439298, 7.686043], [-8.280703, 7.68718], [-8.221792, 8.123329], [-8.299049, 8.316444], [-8.203499, 8.455453], [-7.8321, 8.575704], [-8.079114, 9.376224], [-8.309616, 9.789532], [-8.229337, 10.12902], [-8.029944, 10.206535], [-7.89959, 10.297382], [-7.622759, 10.147236], [-6.850507, 10.138994], [-6.666461, 10.430811], [-6.493965, 10.411303], [-6.205223, 10.524061], [-6.050452, 10.096361], [-5.816926, 10.222555], [-5.404342, 10.370737]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Cameroon",
      TYPE: "Sovereign country",
      ADMIN: "Cameroon",
      GEOUNIT: "Cameroon",
      SUBUNIT: "Cameroon",
      NAME: "Cameroon",
      NAME_LONG: "Cameroon",
      ISO_A3: "CMR",
      ISO_A3_EH: "CMR"
    },
    bbox: [8.488816, 1.727673, 16.012852, 12.859396],
    geometry: {
      type: "Polygon",
      coordinates: [[[15.27946, 7.421925], [14.776545, 6.408498], [14.53656, 6.226959], [14.459407, 5.451761], [14.558936, 5.030598], [14.478372, 4.732605], [14.950953, 4.210389], [15.03622, 3.851367], [15.405396, 3.335301], [15.862732, 3.013537], [15.907381, 2.557389], [16.012852, 2.26764], [15.940919, 1.727673], [15.146342, 1.964015], [14.337813, 2.227875], [13.075822, 2.267097], [12.951334, 2.321616], [12.35938, 2.192812], [11.751665, 2.326758], [11.276449, 2.261051], [9.649158, 2.283866], [9.795196, 3.073404], [9.404367, 3.734527], [8.948116, 3.904129], [8.744924, 4.352215], [8.488816, 4.495617], [8.500288, 4.771983], [8.757533, 5.479666], [9.233163, 6.444491], [9.522706, 6.453482], [10.118277, 7.03877], [10.497375, 7.055358], [11.058788, 6.644427], [11.745774, 6.981383], [11.839309, 7.397042], [12.063946, 7.799808], [12.218872, 8.305824], [12.753672, 8.717763], [12.955468, 9.417772], [13.1676, 9.640626], [13.308676, 10.160362], [13.57295, 10.798566], [14.415379, 11.572369], [14.468192, 11.904752], [14.577178, 12.085361], [14.181336, 12.483657], [14.213531, 12.802035], [14.495787, 12.859396], [14.89336, 12.21905], [14.960152, 11.555574], [14.923565, 10.891325], [15.467873, 9.982337], [14.909354, 9.992129], [14.627201, 9.920919], [14.171466, 10.021378], [13.954218, 9.549495], [14.544467, 8.965861], [14.979996, 8.796104], [15.120866, 8.38215], [15.436092, 7.692812], [15.27946, 7.421925]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Democratic Republic of the Congo",
      TYPE: "Sovereign country",
      ADMIN: "Democratic Republic of the Congo",
      GEOUNIT: "Democratic Republic of the Congo",
      SUBUNIT: "Democratic Republic of the Congo",
      NAME: "Dem. Rep. Congo",
      NAME_LONG: "Democratic Republic of the Congo",
      ISO_A3: "COD",
      ISO_A3_EH: "COD"
    },
    bbox: [12.182337, -13.257227, 31.174149, 5.256088],
    geometry: {
      type: "Polygon",
      coordinates: [[[23.912215, -10.926826], [23.456791, -10.867863], [22.837345, -11.017622], [22.402798, -10.993075], [22.155268, -11.084801], [22.208753, -9.894796], [21.875182, -9.523708], [21.801801, -8.908707], [21.949131, -8.305901], [21.746456, -7.920085], [21.728111, -7.290872], [20.514748, -7.299606], [20.601823, -6.939318], [20.091622, -6.94309], [20.037723, -7.116361], [19.417502, -7.155429], [19.166613, -7.738184], [19.016752, -7.988246], [18.464176, -7.847014], [18.134222, -7.987678], [17.47297, -8.068551], [17.089996, -7.545689], [16.860191, -7.222298], [16.57318, -6.622645], [16.326528, -5.87747], [13.375597, -5.864241], [13.024869, -5.984389], [12.735171, -5.965682], [12.322432, -6.100092], [12.182337, -5.789931], [12.436688, -5.684304], [12.468004, -5.248362], [12.631612, -4.991271], [12.995517, -4.781103], [13.25824, -4.882957], [13.600235, -4.500138], [14.144956, -4.510009], [14.209035, -4.793092], [14.582604, -4.970239], [15.170992, -4.343507], [15.75354, -3.855165], [16.00629, -3.535133], [15.972803, -2.712392], [16.407092, -1.740927], [16.865307, -1.225816], [17.523716, -0.74383], [17.638645, -0.424832], [17.663553, -0.058084], [17.82654, 0.288923], [17.774192, 0.855659], [17.898835, 1.741832], [18.094276, 2.365722], [18.393792, 2.900443], [18.453065, 3.504386], [18.542982, 4.201785], [18.932312, 4.709506], [19.467784, 5.031528], [20.290679, 4.691678], [20.927591, 4.322786], [21.659123, 4.224342], [22.405124, 4.02916], [22.704124, 4.633051], [22.84148, 4.710126], [23.297214, 4.609693], [24.410531, 5.108784], [24.805029, 4.897247], [25.128833, 4.927245], [25.278798, 5.170408], [25.650455, 5.256088], [26.402761, 5.150875], [27.044065, 5.127853], [27.374226, 5.233944], [27.979977, 4.408413], [28.428994, 4.287155], [28.696678, 4.455077], [29.159078, 4.389267], [29.715995, 4.600805], [29.9535, 4.173699], [30.833852, 3.509172], [30.83386, 3.509166], [30.773347, 2.339883], [31.174149, 2.204465], [30.85267, 1.849396], [30.468508, 1.583805], [30.086154, 1.062313], [29.875779, 0.59738], [29.819503, -0.20531], [29.587838, -0.587406], [29.579466, -1.341313], [29.291887, -1.620056], [29.254835, -2.21511], [29.117479, -2.292211], [29.024926, -2.839258], [29.276384, -3.293907], [29.339998, -4.499983], [29.519987, -5.419979], [29.419993, -5.939999], [29.620032, -6.520015], [30.199997, -7.079981], [30.740015, -8.340007], [30.74001, -8.340006], [30.346086, -8.238257], [29.002912, -8.407032], [28.734867, -8.526559], [28.449871, -9.164918], [28.673682, -9.605925], [28.49607, -10.789884], [28.372253, -11.793647], [28.642417, -11.971569], [29.341548, -12.360744], [29.616001, -12.178895], [29.699614, -13.257227], [28.934286, -13.248958], [28.523562, -12.698604], [28.155109, -12.272481], [27.388799, -12.132747], [27.16442, -11.608748], [26.553088, -11.92444], [25.75231, -11.784965], [25.418118, -11.330936], [24.78317, -11.238694], [24.314516, -11.262826], [24.257155, -10.951993], [23.912215, -10.926826]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Republic of the Congo",
      TYPE: "Sovereign country",
      ADMIN: "Republic of the Congo",
      GEOUNIT: "Republic of the Congo",
      SUBUNIT: "Republic of the Congo",
      NAME: "Congo",
      NAME_LONG: "Republic of the Congo",
      ISO_A3: "COG",
      ISO_A3_EH: "COG"
    },
    bbox: [11.093773, -5.037987, 18.453065, 3.728197],
    geometry: {
      type: "Polygon",
      coordinates: [[[12.995517, -4.781103], [12.62076, -4.438023], [12.318608, -4.60623], [11.914963, -5.037987], [11.093773, -3.978827], [11.855122, -3.426871], [11.478039, -2.765619], [11.820964, -2.514161], [12.495703, -2.391688], [12.575284, -1.948511], [13.109619, -2.42874], [13.992407, -2.470805], [14.29921, -1.998276], [14.425456, -1.333407], [14.316418, -0.552627], [13.843321, 0.038758], [14.276266, 1.19693], [14.026669, 1.395677], [13.282631, 1.314184], [13.003114, 1.830896], [13.075822, 2.267097], [14.337813, 2.227875], [15.146342, 1.964015], [15.940919, 1.727673], [16.012852, 2.26764], [16.537058, 3.198255], [17.133042, 3.728197], [17.8099, 3.560196], [18.453065, 3.504386], [18.393792, 2.900443], [18.094276, 2.365722], [17.898835, 1.741832], [17.774192, 0.855659], [17.82654, 0.288923], [17.663553, -0.058084], [17.638645, -0.424832], [17.523716, -0.74383], [16.865307, -1.225816], [16.407092, -1.740927], [15.972803, -2.712392], [16.00629, -3.535133], [15.75354, -3.855165], [15.170992, -4.343507], [14.582604, -4.970239], [14.209035, -4.793092], [14.144956, -4.510009], [13.600235, -4.500138], [13.25824, -4.882957], [12.995517, -4.781103]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Colombia",
      TYPE: "Sovereign country",
      ADMIN: "Colombia",
      GEOUNIT: "Colombia",
      SUBUNIT: "Colombia",
      NAME: "Colombia",
      NAME_LONG: "Colombia",
      ISO_A3: "COL",
      ISO_A3_EH: "COL"
    },
    bbox: [-78.990935, -4.298187, -66.876326, 12.437303],
    geometry: {
      type: "Polygon",
      coordinates: [[[-66.876326, 1.253361], [-67.065048, 1.130112], [-67.259998, 1.719999], [-67.53781, 2.037163], [-67.868565, 1.692455], [-69.816973, 1.714805], [-69.804597, 1.089081], [-69.218638, 0.985677], [-69.252434, 0.602651], [-69.452396, 0.706159], [-70.015566, 0.541414], [-70.020656, -0.185156], [-69.577065, -0.549992], [-69.420486, -1.122619], [-69.444102, -1.556287], [-69.893635, -4.298187], [-70.394044, -3.766591], [-70.692682, -3.742872], [-70.047709, -2.725156], [-70.813476, -2.256865], [-71.413646, -2.342802], [-71.774761, -2.16979], [-72.325787, -2.434218], [-73.070392, -2.308954], [-73.659504, -1.260491], [-74.122395, -1.002833], [-74.441601, -0.53082], [-75.106625, -0.057205], [-75.373223, -0.152032], [-75.801466, 0.084801], [-76.292314, 0.416047], [-76.57638, 0.256936], [-77.424984, 0.395687], [-77.668613, 0.825893], [-77.855061, 0.809925], [-78.855259, 1.380924], [-78.990935, 1.69137], [-78.617831, 1.766404], [-78.662118, 2.267355], [-78.42761, 2.629556], [-77.931543, 2.696606], [-77.510431, 3.325017], [-77.12769, 3.849636], [-77.496272, 4.087606], [-77.307601, 4.667984], [-77.533221, 5.582812], [-77.318815, 5.845354], [-77.476661, 6.691116], [-77.881571, 7.223771], [-77.753414, 7.70984], [-77.431108, 7.638061], [-77.242566, 7.935278], [-77.474723, 8.524286], [-77.353361, 8.670505], [-76.836674, 8.638749], [-76.086384, 9.336821], [-75.6746, 9.443248], [-75.664704, 9.774003], [-75.480426, 10.61899], [-74.906895, 11.083045], [-74.276753, 11.102036], [-74.197223, 11.310473], [-73.414764, 11.227015], [-72.627835, 11.731972], [-72.238195, 11.95555], [-71.75409, 12.437303], [-71.399822, 12.376041], [-71.137461, 12.112982], [-71.331584, 11.776284], [-71.973922, 11.608672], [-72.227575, 11.108702], [-72.614658, 10.821975], [-72.905286, 10.450344], [-73.027604, 9.73677], [-73.304952, 9.152], [-72.78873, 9.085027], [-72.660495, 8.625288], [-72.439862, 8.405275], [-72.360901, 8.002638], [-72.479679, 7.632506], [-72.444487, 7.423785], [-72.198352, 7.340431], [-71.960176, 6.991615], [-70.674234, 7.087785], [-70.093313, 6.960376], [-69.38948, 6.099861], [-68.985319, 6.206805], [-68.265052, 6.153268], [-67.695087, 6.267318], [-67.34144, 6.095468], [-67.521532, 5.55687], [-67.744697, 5.221129], [-67.823012, 4.503937], [-67.621836, 3.839482], [-67.337564, 3.542342], [-67.303173, 3.318454], [-67.809938, 2.820655], [-67.447092, 2.600281], [-67.181294, 2.250638], [-66.876326, 1.253361]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Costa Rica",
      TYPE: "Sovereign country",
      ADMIN: "Costa Rica",
      GEOUNIT: "Costa Rica",
      SUBUNIT: "Costa Rica",
      NAME: "Costa Rica",
      NAME_LONG: "Costa Rica",
      ISO_A3: "CRI",
      ISO_A3_EH: "CRI"
    },
    bbox: [-85.941725, 8.225028, -82.546196, 11.217119],
    geometry: {
      type: "Polygon",
      coordinates: [[[-82.965783, 8.225028], [-83.508437, 8.446927], [-83.711474, 8.656836], [-83.596313, 8.830443], [-83.632642, 9.051386], [-83.909886, 9.290803], [-84.303402, 9.487354], [-84.647644, 9.615537], [-84.713351, 9.908052], [-84.97566, 10.086723], [-84.911375, 9.795992], [-85.110923, 9.55704], [-85.339488, 9.834542], [-85.660787, 9.933347], [-85.797445, 10.134886], [-85.791709, 10.439337], [-85.659314, 10.754331], [-85.941725, 10.895278], [-85.71254, 11.088445], [-85.561852, 11.217119], [-84.903003, 10.952303], [-84.673069, 11.082657], [-84.355931, 10.999226], [-84.190179, 10.79345], [-83.895054, 10.726839], [-83.655612, 10.938764], [-83.40232, 10.395438], [-83.015677, 9.992982], [-82.546196, 9.566135], [-82.932891, 9.476812], [-82.927155, 9.07433], [-82.719183, 8.925709], [-82.868657, 8.807266], [-82.829771, 8.626295], [-82.913176, 8.423517], [-82.965783, 8.225028]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Cuba",
      TYPE: "Sovereign country",
      ADMIN: "Cuba",
      GEOUNIT: "Cuba",
      SUBUNIT: "Cuba",
      NAME: "Cuba",
      NAME_LONG: "Cuba",
      ISO_A3: "CUB",
      ISO_A3_EH: "CUB"
    },
    bbox: [-84.974911, 19.855481, -74.178025, 23.188611],
    geometry: {
      type: "Polygon",
      coordinates: [[[-82.268151, 23.188611], [-81.404457, 23.117271], [-80.618769, 23.10598], [-79.679524, 22.765303], [-79.281486, 22.399202], [-78.347434, 22.512166], [-77.993296, 22.277194], [-77.146422, 21.657851], [-76.523825, 21.20682], [-76.19462, 21.220565], [-75.598222, 21.016624], [-75.67106, 20.735091], [-74.933896, 20.693905], [-74.178025, 20.284628], [-74.296648, 20.050379], [-74.961595, 19.923435], [-75.63468, 19.873774], [-76.323656, 19.952891], [-77.755481, 19.855481], [-77.085108, 20.413354], [-77.492655, 20.673105], [-78.137292, 20.739949], [-78.482827, 21.028613], [-78.719867, 21.598114], [-79.285, 21.559175], [-80.217475, 21.827324], [-80.517535, 22.037079], [-81.820943, 22.192057], [-82.169992, 22.387109], [-81.795002, 22.636965], [-82.775898, 22.68815], [-83.494459, 22.168518], [-83.9088, 22.154565], [-84.052151, 21.910575], [-84.54703, 21.801228], [-84.974911, 21.896028], [-84.447062, 22.20495], [-84.230357, 22.565755], [-83.77824, 22.788118], [-83.267548, 22.983042], [-82.510436, 23.078747], [-82.268151, 23.188611]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Northern Cyprus",
      TYPE: "Sovereign country",
      ADMIN: "Northern Cyprus",
      GEOUNIT: "Northern Cyprus",
      SUBUNIT: "Northern Cyprus",
      NAME: "N. Cyprus",
      NAME_LONG: "Northern Cyprus",
      ISO_A3: "-99",
      ISO_A3_EH: "-99"
    },
    bbox: [32.73178, 35.000345, 34.576474, 35.671596],
    geometry: {
      type: "Polygon",
      coordinates: [[[32.73178, 35.140026], [32.802474, 35.145504], [32.946961, 35.386703], [33.667227, 35.373216], [34.576474, 35.671596], [33.900804, 35.245756], [33.973617, 35.058506], [33.86644, 35.093595], [33.675392, 35.017863], [33.525685, 35.038688], [33.475817, 35.000345], [33.455922, 35.101424], [33.383833, 35.162712], [33.190977, 35.173125], [32.919572, 35.087833], [32.73178, 35.140026]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Cyprus",
      TYPE: "Sovereign country",
      ADMIN: "Cyprus",
      GEOUNIT: "Cyprus",
      SUBUNIT: "Cyprus",
      NAME: "Cyprus",
      NAME_LONG: "Cyprus",
      ISO_A3: "CYP",
      ISO_A3_EH: "CYP"
    },
    bbox: [32.256667, 34.571869, 34.004881, 35.173125],
    geometry: {
      type: "Polygon",
      coordinates: [[[32.73178, 35.140026], [32.919572, 35.087833], [33.190977, 35.173125], [33.383833, 35.162712], [33.455922, 35.101424], [33.475817, 35.000345], [33.525685, 35.038688], [33.675392, 35.017863], [33.86644, 35.093595], [33.973617, 35.058506], [34.004881, 34.978098], [32.979827, 34.571869], [32.490296, 34.701655], [32.256667, 35.103232], [32.73178, 35.140026]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Czechia",
      TYPE: "Sovereign country",
      ADMIN: "Czechia",
      GEOUNIT: "Czechia",
      SUBUNIT: "Czechia",
      NAME: "Czechia",
      NAME_LONG: "Czech Republic",
      ISO_A3: "CZE",
      ISO_A3_EH: "CZE"
    },
    bbox: [12.240111, 48.555305, 18.853144, 51.117268],
    geometry: {
      type: "Polygon",
      coordinates: [[[16.960288, 48.596982], [16.499283, 48.785808], [16.029647, 48.733899], [15.253416, 49.039074], [14.901447, 48.964402], [14.338898, 48.555305], [13.595946, 48.877172], [13.031329, 49.307068], [12.521024, 49.547415], [12.415191, 49.969121], [12.240111, 50.266338], [12.966837, 50.484076], [13.338132, 50.733234], [14.056228, 50.926918], [14.307013, 51.117268], [14.570718, 51.002339], [15.016996, 51.106674], [15.490972, 50.78473], [16.238627, 50.697733], [16.176253, 50.422607], [16.719476, 50.215747], [16.868769, 50.473974], [17.554567, 50.362146], [17.649445, 50.049038], [18.392914, 49.988629], [18.853144, 49.49623], [18.554971, 49.495015], [18.399994, 49.315001], [18.170498, 49.271515], [18.104973, 49.043983], [17.913512, 48.996493], [17.886485, 48.903475], [17.545007, 48.800019], [17.101985, 48.816969], [16.960288, 48.596982]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Germany",
      TYPE: "Sovereign country",
      ADMIN: "Germany",
      GEOUNIT: "Germany",
      SUBUNIT: "Germany",
      NAME: "Germany",
      NAME_LONG: "Germany",
      ISO_A3: "DEU",
      ISO_A3_EH: "DEU"
    },
    bbox: [5.988658, 47.302488, 15.016996, 54.983104],
    geometry: {
      type: "Polygon",
      coordinates: [[[13.595946, 48.877172], [13.243357, 48.416115], [12.884103, 48.289146], [13.025851, 47.637584], [12.932627, 47.467646], [12.62076, 47.672388], [12.141357, 47.703083], [11.426414, 47.523766], [10.544504, 47.566399], [10.402084, 47.302488], [9.896068, 47.580197], [9.594226, 47.525058], [8.522612, 47.830828], [8.317301, 47.61358], [7.466759, 47.620582], [7.593676, 48.333019], [8.099279, 49.017784], [6.65823, 49.201958], [6.18632, 49.463803], [6.242751, 49.902226], [6.043073, 50.128052], [6.156658, 50.803721], [5.988658, 51.851616], [6.589397, 51.852029], [6.84287, 52.22844], [7.092053, 53.144043], [6.90514, 53.482162], [7.100425, 53.693932], [7.936239, 53.748296], [8.121706, 53.527792], [8.800734, 54.020786], [8.572118, 54.395646], [8.526229, 54.962744], [9.282049, 54.830865], [9.921906, 54.983104], [9.93958, 54.596642], [10.950112, 54.363607], [10.939467, 54.008693], [11.956252, 54.196486], [12.51844, 54.470371], [13.647467, 54.075511], [14.119686, 53.757029], [14.353315, 53.248171], [14.074521, 52.981263], [14.4376, 52.62485], [14.685026, 52.089947], [14.607098, 51.745188], [15.016996, 51.106674], [14.570718, 51.002339], [14.307013, 51.117268], [14.056228, 50.926918], [13.338132, 50.733234], [12.966837, 50.484076], [12.240111, 50.266338], [12.415191, 49.969121], [12.521024, 49.547415], [13.031329, 49.307068], [13.595946, 48.877172]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Djibouti",
      TYPE: "Sovereign country",
      ADMIN: "Djibouti",
      GEOUNIT: "Djibouti",
      SUBUNIT: "Djibouti",
      NAME: "Djibouti",
      NAME_LONG: "Djibouti",
      ISO_A3: "DJI",
      ISO_A3_EH: "DJI"
    },
    bbox: [41.66176, 10.926879, 43.317852, 12.699639],
    geometry: {
      type: "Polygon",
      coordinates: [[[43.081226, 12.699639], [43.317852, 12.390148], [43.286381, 11.974928], [42.715874, 11.735641], [43.145305, 11.46204], [42.776852, 10.926879], [42.55493, 11.10511], [42.31414, 11.0342], [41.75557, 11.05091], [41.73959, 11.35511], [41.66176, 11.6312], [42, 12.1], [42.35156, 12.54223], [42.779642, 12.455416], [43.081226, 12.699639]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Denmark",
      TYPE: "Country",
      ADMIN: "Denmark",
      GEOUNIT: "Denmark",
      SUBUNIT: "Denmark",
      NAME: "Denmark",
      NAME_LONG: "Denmark",
      ISO_A3: "DNK",
      ISO_A3_EH: "DNK"
    },
    bbox: [8.089977, 54.800015, 12.690006, 57.730017],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[9.921906, 54.983104], [9.282049, 54.830865], [8.526229, 54.962744], [8.120311, 55.517723], [8.089977, 56.540012], [8.256582, 56.809969], [8.543438, 57.110003], [9.424469, 57.172066], [9.775559, 57.447941], [10.580006, 57.730017], [10.546106, 57.215733], [10.25, 56.890016], [10.369993, 56.609982], [10.912182, 56.458621], [10.667804, 56.081383], [10.369993, 56.190007], [9.649985, 55.469999], [9.921906, 54.983104]]], [[[12.690006, 55.609991], [12.089991, 54.800015], [11.043543, 55.364864], [10.903914, 55.779955], [12.370904, 56.111407], [12.690006, 55.609991]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Dominican Republic",
      TYPE: "Sovereign country",
      ADMIN: "Dominican Republic",
      GEOUNIT: "Dominican Republic",
      SUBUNIT: "Dominican Republic",
      NAME: "Dominican Rep.",
      NAME_LONG: "Dominican Republic",
      ISO_A3: "DOM",
      ISO_A3_EH: "DOM"
    },
    bbox: [-71.945112, 17.598564, -68.317943, 19.884911],
    geometry: {
      type: "Polygon",
      coordinates: [[[-71.712361, 19.714456], [-71.587304, 19.884911], [-70.806706, 19.880286], [-70.214365, 19.622885], [-69.950815, 19.648], [-69.76925, 19.293267], [-69.222126, 19.313214], [-69.254346, 19.015196], [-68.809412, 18.979074], [-68.317943, 18.612198], [-68.689316, 18.205142], [-69.164946, 18.422648], [-69.623988, 18.380713], [-69.952934, 18.428307], [-70.133233, 18.245915], [-70.517137, 18.184291], [-70.669298, 18.426886], [-70.99995, 18.283329], [-71.40021, 17.598564], [-71.657662, 17.757573], [-71.708305, 18.044997], [-71.687738, 18.31666], [-71.945112, 18.6169], [-71.701303, 18.785417], [-71.624873, 19.169838], [-71.712361, 19.714456]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Algeria",
      TYPE: "Sovereign country",
      ADMIN: "Algeria",
      GEOUNIT: "Algeria",
      SUBUNIT: "Algeria",
      NAME: "Algeria",
      NAME_LONG: "Algeria",
      ISO_A3: "DZA",
      ISO_A3_EH: "DZA"
    },
    bbox: [-8.6844, 19.057364, 11.999506, 37.118381],
    geometry: {
      type: "Polygon",
      coordinates: [[[4.267419, 19.155265], [3.158133, 19.057364], [3.146661, 19.693579], [2.683588, 19.85623], [2.060991, 20.142233], [1.823228, 20.610809], [-1.550055, 22.792666], [-4.923337, 24.974574], [-8.6844, 27.395744], [-8.665124, 27.589479], [-8.66559, 27.656426], [-8.674116, 28.841289], [-7.059228, 29.579228], [-6.060632, 29.7317], [-5.242129, 30.000443], [-4.859646, 30.501188], [-3.690441, 30.896952], [-3.647498, 31.637294], [-3.06898, 31.724498], [-2.616605, 32.094346], [-1.307899, 32.262889], [-1.124551, 32.651522], [-1.388049, 32.864015], [-1.733455, 33.919713], [-1.792986, 34.527919], [-2.169914, 35.168396], [-1.208603, 35.714849], [-0.127454, 35.888662], [0.503877, 36.301273], [1.466919, 36.605647], [3.161699, 36.783905], [4.815758, 36.865037], [5.32012, 36.716519], [6.26182, 37.110655], [7.330385, 37.118381], [7.737078, 36.885708], [8.420964, 36.946427], [8.217824, 36.433177], [8.376368, 35.479876], [8.140981, 34.655146], [7.524482, 34.097376], [7.612642, 33.344115], [8.430473, 32.748337], [8.439103, 32.506285], [9.055603, 32.102692], [9.48214, 30.307556], [9.805634, 29.424638], [9.859998, 28.95999], [9.683885, 28.144174], [9.756128, 27.688259], [9.629056, 27.140953], [9.716286, 26.512206], [9.319411, 26.094325], [9.910693, 25.365455], [9.948261, 24.936954], [10.303847, 24.379313], [10.771364, 24.562532], [11.560669, 24.097909], [11.999506, 23.471668], [8.572893, 21.565661], [5.677566, 19.601207], [4.267419, 19.155265]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Ecuador",
      TYPE: "Sovereign country",
      ADMIN: "Ecuador",
      GEOUNIT: "Ecuador",
      SUBUNIT: "Ecuador",
      NAME: "Ecuador",
      NAME_LONG: "Ecuador",
      ISO_A3: "ECU",
      ISO_A3_EH: "ECU"
    },
    bbox: [-80.967765, -4.959129, -75.233723, 1.380924],
    geometry: {
      type: "Polygon",
      coordinates: [[[-78.855259, 1.380924], [-77.855061, 0.809925], [-77.668613, 0.825893], [-77.424984, 0.395687], [-76.57638, 0.256936], [-76.292314, 0.416047], [-75.801466, 0.084801], [-75.373223, -0.152032], [-75.233723, -0.911417], [-75.544996, -1.56161], [-76.635394, -2.608678], [-77.837905, -3.003021], [-78.450684, -3.873097], [-78.639897, -4.547784], [-79.205289, -4.959129], [-79.624979, -4.454198], [-80.028908, -4.346091], [-80.442242, -4.425724], [-80.469295, -4.059287], [-80.184015, -3.821162], [-80.302561, -3.404856], [-79.770293, -2.657512], [-79.986559, -2.220794], [-80.368784, -2.685159], [-80.967765, -2.246943], [-80.764806, -1.965048], [-80.933659, -1.057455], [-80.58337, -0.906663], [-80.399325, -0.283703], [-80.020898, 0.36034], [-80.09061, 0.768429], [-79.542762, 0.982938], [-78.855259, 1.380924]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Egypt",
      TYPE: "Sovereign country",
      ADMIN: "Egypt",
      GEOUNIT: "Egypt",
      SUBUNIT: "Egypt",
      NAME: "Egypt",
      NAME_LONG: "Egypt",
      ISO_A3: "EGY",
      ISO_A3_EH: "EGY"
    },
    bbox: [24.70007, 22, 36.86623, 31.58568],
    geometry: {
      type: "Polygon",
      coordinates: [[[36.86623, 22], [32.9, 22], [29.02, 22], [25, 22], [25, 25.6825], [25, 29.238655], [24.70007, 30.04419], [24.95762, 30.6616], [24.80287, 31.08929], [25.16482, 31.56915], [26.49533, 31.58568], [27.45762, 31.32126], [28.45048, 31.02577], [28.91353, 30.87005], [29.68342, 31.18686], [30.09503, 31.4734], [30.97693, 31.55586], [31.68796, 31.4296], [31.96041, 30.9336], [32.19247, 31.26034], [32.99392, 31.02407], [33.7734, 30.96746], [34.265435, 31.219357], [34.26544, 31.21936], [34.823243, 29.761081], [34.9226, 29.50133], [34.64174, 29.09942], [34.42655, 28.34399], [34.15451, 27.8233], [33.92136, 27.6487], [33.58811, 27.97136], [33.13676, 28.41765], [32.42323, 29.85108], [32.32046, 29.76043], [32.73482, 28.70523], [33.34876, 27.69989], [34.10455, 26.14227], [34.47387, 25.59856], [34.79507, 25.03375], [35.69241, 23.92671], [35.49372, 23.75237], [35.52598, 23.10244], [36.69069, 22.20485], [36.86623, 22]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Eritrea",
      TYPE: "Sovereign country",
      ADMIN: "Eritrea",
      GEOUNIT: "Eritrea",
      SUBUNIT: "Eritrea",
      NAME: "Eritrea",
      NAME_LONG: "Eritrea",
      ISO_A3: "ERI",
      ISO_A3_EH: "ERI"
    },
    bbox: [36.32322, 12.455416, 43.081226, 17.998307],
    geometry: {
      type: "Polygon",
      coordinates: [[[43.081226, 12.699639], [42.779642, 12.455416], [42.35156, 12.54223], [42.00975, 12.86582], [41.59856, 13.45209], [41.1552, 13.77333], [40.8966, 14.11864], [40.02625, 14.51959], [39.34061, 14.53155], [39.0994, 14.74064], [38.51295, 14.50547], [37.90607, 14.95943], [37.59377, 14.2131], [36.42951, 14.42211], [36.32322, 14.82249], [36.75389, 16.29186], [36.85253, 16.95655], [37.16747, 17.26314], [37.904, 17.42754], [38.41009, 17.998307], [38.990623, 16.840626], [39.26611, 15.922723], [39.814294, 15.435647], [41.179275, 14.49108], [41.734952, 13.921037], [42.276831, 13.343992], [42.589576, 13.000421], [43.081226, 12.699639]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Spain",
      TYPE: "Sovereign country",
      ADMIN: "Spain",
      GEOUNIT: "Spain",
      SUBUNIT: "Spain",
      NAME: "Spain",
      NAME_LONG: "Spain",
      ISO_A3: "ESP",
      ISO_A3_EH: "ESP"
    },
    bbox: [-9.392884, 35.94685, 3.039484, 43.748338],
    geometry: {
      type: "Polygon",
      coordinates: [[[-9.034818, 41.880571], [-8.984433, 42.592775], [-9.392884, 43.026625], [-7.97819, 43.748338], [-6.754492, 43.567909], [-5.411886, 43.57424], [-4.347843, 43.403449], [-3.517532, 43.455901], [-1.901351, 43.422802], [-1.502771, 43.034014], [0.338047, 42.579546], [0.701591, 42.795734], [1.826793, 42.343385], [2.985999, 42.473015], [3.039484, 41.89212], [2.091842, 41.226089], [0.810525, 41.014732], [0.721331, 40.678318], [0.106692, 40.123934], [-0.278711, 39.309978], [0.111291, 38.738514], [-0.467124, 38.292366], [-0.683389, 37.642354], [-1.438382, 37.443064], [-2.146453, 36.674144], [-3.415781, 36.6589], [-4.368901, 36.677839], [-4.995219, 36.324708], [-5.37716, 35.94685], [-5.866432, 36.029817], [-6.236694, 36.367677], [-6.520191, 36.942913], [-7.453726, 37.097788], [-7.537105, 37.428904], [-7.166508, 37.803894], [-7.029281, 38.075764], [-7.374092, 38.373059], [-7.098037, 39.030073], [-7.498632, 39.629571], [-7.066592, 39.711892], [-7.026413, 40.184524], [-6.86402, 40.330872], [-6.851127, 41.111083], [-6.389088, 41.381815], [-6.668606, 41.883387], [-7.251309, 41.918346], [-7.422513, 41.792075], [-8.013175, 41.790886], [-8.263857, 42.280469], [-8.671946, 42.134689], [-9.034818, 41.880571]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Estonia",
      TYPE: "Sovereign country",
      ADMIN: "Estonia",
      GEOUNIT: "Estonia",
      SUBUNIT: "Estonia",
      NAME: "Estonia",
      NAME_LONG: "Estonia",
      ISO_A3: "EST",
      ISO_A3_EH: "EST"
    },
    bbox: [23.339795, 57.474528, 28.131699, 59.61109],
    geometry: {
      type: "Polygon",
      coordinates: [[[24.312863, 57.793424], [24.428928, 58.383413], [24.061198, 58.257375], [23.42656, 58.612753], [23.339795, 59.18724], [24.604214, 59.465854], [25.864189, 59.61109], [26.949136, 59.445803], [27.981114, 59.475388], [27.981127, 59.475373], [27.98112, 59.47537], [28.131699, 59.300825], [27.42015, 58.72457], [27.716686, 57.791899], [27.288185, 57.474528], [26.463532, 57.476389], [25.60281, 57.847529], [25.164594, 57.970157], [24.312863, 57.793424]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Ethiopia",
      TYPE: "Sovereign country",
      ADMIN: "Ethiopia",
      GEOUNIT: "Ethiopia",
      SUBUNIT: "Ethiopia",
      NAME: "Ethiopia",
      NAME_LONG: "Ethiopia",
      ISO_A3: "ETH",
      ISO_A3_EH: "ETH"
    },
    bbox: [32.95418, 3.42206, 47.78942, 14.95943],
    geometry: {
      type: "Polygon",
      coordinates: [[[42.35156, 12.54223], [42, 12.1], [41.66176, 11.6312], [41.73959, 11.35511], [41.75557, 11.05091], [42.31414, 11.0342], [42.55493, 11.10511], [42.776852, 10.926879], [42.55876, 10.57258], [42.92812, 10.02194], [43.29699, 9.54048], [43.67875, 9.18358], [46.94834, 7.99688], [47.78942, 8.003], [44.9636, 5.00162], [43.66087, 4.95755], [42.76967, 4.25259], [42.12861, 4.23413], [41.855083, 3.918912], [41.1718, 3.91909], [40.76848, 4.25702], [39.85494, 3.83879], [39.559384, 3.42206], [38.89251, 3.50074], [38.67114, 3.61607], [38.43697, 3.58851], [38.120915, 3.598605], [36.855093, 4.447864], [36.159079, 4.447864], [35.817448, 4.776966], [35.817448, 5.338232], [35.298007, 5.506], [34.70702, 6.59422], [34.25032, 6.82607], [34.0751, 7.22595], [33.56829, 7.71334], [32.95418, 7.78497], [33.2948, 8.35458], [33.8255, 8.37916], [33.97498, 8.68456], [33.96162, 9.58358], [34.25745, 10.63009], [34.73115, 10.91017], [34.83163, 11.31896], [35.26049, 12.08286], [35.86363, 12.57828], [36.27022, 13.56333], [36.42951, 14.42211], [37.59377, 14.2131], [37.90607, 14.95943], [38.51295, 14.50547], [39.0994, 14.74064], [39.34061, 14.53155], [40.02625, 14.51959], [40.8966, 14.11864], [41.1552, 13.77333], [41.59856, 13.45209], [42.00975, 12.86582], [42.35156, 12.54223]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Finland",
      TYPE: "Country",
      ADMIN: "Finland",
      GEOUNIT: "Finland",
      SUBUNIT: "Finland",
      NAME: "Finland",
      NAME_LONG: "Finland",
      ISO_A3: "FIN",
      ISO_A3_EH: "FIN"
    },
    bbox: [20.645593, 59.846373, 31.516092, 70.164193],
    geometry: {
      type: "Polygon",
      coordinates: [[[23.903379, 66.006927], [23.56588, 66.396051], [23.539473, 67.936009], [21.978535, 68.616846], [20.645593, 69.106247], [21.244936, 69.370443], [22.356238, 68.841741], [23.66205, 68.891247], [24.735679, 68.649557], [25.689213, 69.092114], [26.179622, 69.825299], [27.732292, 70.164193], [29.015573, 69.766491], [28.59193, 69.064777], [28.445944, 68.364613], [29.977426, 67.698297], [29.054589, 66.944286], [30.21765, 65.80598], [29.54443, 64.948672], [30.444685, 64.204453], [30.035872, 63.552814], [31.516092, 62.867687], [31.139991, 62.357693], [30.211107, 61.780028], [28.07, 60.50352], [28.070002, 60.503519], [28.069998, 60.503517], [26.255173, 60.423961], [24.496624, 60.057316], [22.869695, 59.846373], [22.290764, 60.391921], [21.322244, 60.72017], [21.544866, 61.705329], [21.059211, 62.607393], [21.536029, 63.189735], [22.442744, 63.81781], [24.730512, 64.902344], [25.398068, 65.111427], [25.294043, 65.534346], [23.903379, 66.006927]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Fiji",
      TYPE: "Sovereign country",
      ADMIN: "Fiji",
      GEOUNIT: "Fiji",
      SUBUNIT: "Fiji",
      NAME: "Fiji",
      NAME_LONG: "Fiji",
      ISO_A3: "FJI",
      ISO_A3_EH: "FJI"
    },
    bbox: [-180, -18.28799, 180, -16.020882],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[178.3736, -17.33992], [178.71806, -17.62846], [178.55271, -18.15059], [177.93266, -18.28799], [177.38146, -18.16432], [177.28504, -17.72465], [177.67087, -17.38114], [178.12557, -17.50481], [178.3736, -17.33992]]], [[[179.364143, -16.801354], [178.725059, -17.012042], [178.596839, -16.63915], [179.096609, -16.433984], [179.413509, -16.379054], [180, -16.067133], [180, -16.555217], [179.364143, -16.801354]]], [[[-179.917369, -16.501783], [-180, -16.555217], [-180, -16.067133], [-179.79332, -16.020882], [-179.917369, -16.501783]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "United Kingdom",
      TYPE: "Dependency",
      ADMIN: "Falkland Islands",
      GEOUNIT: "Falkland Islands",
      SUBUNIT: "Falkland Islands",
      NAME: "Falkland Is.",
      NAME_LONG: "Falkland Islands",
      ISO_A3: "FLK",
      ISO_A3_EH: "FLK"
    },
    bbox: [-61.2, -52.3, -57.75, -51.1],
    geometry: {
      type: "Polygon",
      coordinates: [[[-61.2, -51.85], [-60, -51.25], [-59.15, -51.5], [-58.55, -51.1], [-57.75, -51.55], [-58.05, -51.9], [-59.4, -52.2], [-59.85, -51.85], [-60.7, -52.3], [-61.2, -51.85]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "French Guiana",
      TYPE: "Dependency",
      ADMIN: "French Guiana",
      GEOUNIT: "French Guiana",
      SUBUNIT: "French Guiana",
      NAME: "French Guiana",
      NAME_LONG: "French Guiana",
      ISO_A3: "FG",
      ISO_A3_EH: "FG"
    },
    bbox: [-61.2, -52.3, -57.75, -51.1],
    geometry: {
      type: "Polygon",
      coordinates: [[[-51.657797, 4.156232], [-52.249338, 3.241094], [-52.556425, 2.504705], [-52.939657, 2.124858], [-53.418465, 2.053389], [-53.554839, 2.334897], [-53.778521, 2.376703], [-54.088063, 2.105557], [-54.524754, 2.311849], [-54.27123, 2.738748], [-54.184284, 3.194172], [-54.011504, 3.62257], [-54.399542, 4.212611], [-54.478633, 4.896756], [-53.958045, 5.756548], [-53.618453, 5.646529], [-52.882141, 5.409851], [-51.823343, 4.565768], [-51.657797, 4.156232]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "France",
      ISO_A3: "FRA",
      TYPE: "Country",
      ADMIN: "France",
      GEOUNIT: "France",
      SUBUNIT: "France",
      NAME: "France",
      NAME_LONG: "France",
      ISO_A3_EH: "-99"
    },
    bbox: [-54.524754, 2.053389, 9.560016, 51.148506],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[2.513573, 51.148506], [2.658422, 50.796848], [3.123252, 50.780363], [3.588184, 50.378992], [4.286023, 49.907497], [4.799222, 49.985373], [5.674052, 49.529484], [5.897759, 49.442667], [6.18632, 49.463803], [6.65823, 49.201958], [8.099279, 49.017784], [7.593676, 48.333019], [7.466759, 47.620582], [7.192202, 47.449766], [6.736571, 47.541801], [6.768714, 47.287708], [6.037389, 46.725779], [6.022609, 46.27299], [6.5001, 46.429673], [6.843593, 45.991147], [6.802355, 45.70858], [7.096652, 45.333099], [6.749955, 45.028518], [7.007562, 44.254767], [7.549596, 44.127901], [7.435185, 43.693845], [6.529245, 43.128892], [4.556963, 43.399651], [3.100411, 43.075201], [2.985999, 42.473015], [1.826793, 42.343385], [0.701591, 42.795734], [0.338047, 42.579546], [-1.502771, 43.034014], [-1.901351, 43.422802], [-1.384225, 44.02261], [-1.193798, 46.014918], [-2.225724, 47.064363], [-2.963276, 47.570327], [-4.491555, 47.954954], [-4.59235, 48.68416], [-3.295814, 48.901692], [-1.616511, 48.644421], [-1.933494, 49.776342], [-0.989469, 49.347376], [1.338761, 50.127173], [1.639001, 50.946606], [2.513573, 51.148506]]], [[[9.560016, 42.152492], [9.229752, 41.380007], [8.775723, 41.583612], [8.544213, 42.256517], [8.746009, 42.628122], [9.390001, 43.009985], [9.560016, 42.152492]]]]
    },
    id: 55
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Gabon",
      TYPE: "Sovereign country",
      ADMIN: "Gabon",
      GEOUNIT: "Gabon",
      SUBUNIT: "Gabon",
      NAME: "Gabon",
      NAME_LONG: "Gabon",
      ISO_A3: "GAB",
      ISO_A3_EH: "GAB",
      TINY: 3
    },
    bbox: [8.797996, -3.978827, 14.425456, 2.326758],
    geometry: {
      type: "Polygon",
      coordinates: [[[11.276449, 2.261051], [11.751665, 2.326758], [12.35938, 2.192812], [12.951334, 2.321616], [13.075822, 2.267097], [13.003114, 1.830896], [13.282631, 1.314184], [14.026669, 1.395677], [14.276266, 1.19693], [13.843321, 0.038758], [14.316418, -0.552627], [14.425456, -1.333407], [14.29921, -1.998276], [13.992407, -2.470805], [13.109619, -2.42874], [12.575284, -1.948511], [12.495703, -2.391688], [11.820964, -2.514161], [11.478039, -2.765619], [11.855122, -3.426871], [11.093773, -3.978827], [10.066135, -2.969483], [9.405245, -2.144313], [8.797996, -1.111301], [8.830087, -0.779074], [9.04842, -0.459351], [9.291351, 0.268666], [9.492889, 1.01012], [9.830284, 1.067894], [11.285079, 1.057662], [11.276449, 2.261051]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "United Kingdom",
      TYPE: "Country",
      ADMIN: "United Kingdom",
      GEOUNIT: "United Kingdom",
      SUBUNIT: "United Kingdom",
      NAME: "United Kingdom",
      NAME_LONG: "United Kingdom",
      ISO_A3: "GBR",
      ISO_A3_EH: "GBR"
    },
    bbox: [-7.572168, 49.96, 1.681531, 58.635],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[-6.197885, 53.867565], [-6.95373, 54.073702], [-7.572168, 54.059956], [-7.366031, 54.595841], [-7.572168, 55.131622], [-6.733847, 55.17286], [-5.661949, 54.554603], [-6.197885, 53.867565]]], [[[-3.005005, 58.635], [-4.073828, 57.553025], [-3.055002, 57.690019], [-1.959281, 57.6848], [-2.219988, 56.870017], [-3.119003, 55.973793], [-2.085009, 55.909998], [-2.005676, 55.804903], [-1.114991, 54.624986], [-0.430485, 54.464376], [0.184981, 53.325014], [0.469977, 52.929999], [1.681531, 52.73952], [1.559988, 52.099998], [1.050562, 51.806761], [1.449865, 51.289428], [0.550334, 50.765739], [-0.787517, 50.774989], [-2.489998, 50.500019], [-2.956274, 50.69688], [-3.617448, 50.228356], [-4.542508, 50.341837], [-5.245023, 49.96], [-5.776567, 50.159678], [-4.30999, 51.210001], [-3.414851, 51.426009], [-3.422719, 51.426848], [-4.984367, 51.593466], [-5.267296, 51.9914], [-4.222347, 52.301356], [-4.770013, 52.840005], [-4.579999, 53.495004], [-3.093831, 53.404547], [-3.09208, 53.404441], [-2.945009, 53.985], [-3.614701, 54.600937], [-3.630005, 54.615013], [-4.844169, 54.790971], [-5.082527, 55.061601], [-4.719112, 55.508473], [-5.047981, 55.783986], [-5.586398, 55.311146], [-5.644999, 56.275015], [-6.149981, 56.78501], [-5.786825, 57.818848], [-5.009999, 58.630013], [-4.211495, 58.550845], [-3.005005, 58.635]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Georgia",
      TYPE: "Sovereign country",
      ADMIN: "Georgia",
      GEOUNIT: "Georgia",
      SUBUNIT: "Georgia",
      NAME: "Georgia",
      NAME_LONG: "Georgia",
      ISO_A3: "GEO",
      ISO_A3_EH: "GEO"
    },
    bbox: [39.955009, 41.064445, 46.637908, 43.553104],
    geometry: {
      type: "Polygon",
      coordinates: [[[44.97248, 41.248129], [43.582746, 41.092143], [42.619549, 41.583173], [41.554084, 41.535656], [41.703171, 41.962943], [41.45347, 42.645123], [40.875469, 43.013628], [40.321394, 43.128634], [39.955009, 43.434998], [40.076965, 43.553104], [40.92219, 43.38215], [42.3944, 43.2203], [43.75599, 42.74083], [43.93121, 42.55496], [44.537623, 42.711993], [45.470279, 42.502781], [45.7764, 42.09244], [46.404951, 41.860675], [46.145432, 41.722802], [46.637908, 41.181673], [46.501637, 41.064445], [45.962601, 41.123873], [45.217426, 41.411452], [44.97248, 41.248129]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Ghana",
      TYPE: "Sovereign country",
      ADMIN: "Ghana",
      GEOUNIT: "Ghana",
      SUBUNIT: "Ghana",
      NAME: "Ghana",
      NAME_LONG: "Ghana",
      ISO_A3: "GHA",
      ISO_A3_EH: "GHA"
    },
    bbox: [-3.24437, 4.710462, 1.060122, 11.098341],
    geometry: {
      type: "Polygon",
      coordinates: [[[-2.827496, 9.642461], [-2.963896, 10.395335], [-2.940409, 10.96269], [-1.203358, 11.009819], [-0.761576, 10.93693], [-0.438702, 11.098341], [0.023803, 11.018682], [-0.049785, 10.706918], [0.36758, 10.191213], [0.365901, 9.465004], [0.461192, 8.677223], [0.712029, 8.312465], [0.490957, 7.411744], [0.570384, 6.914359], [0.836931, 6.279979], [1.060122, 5.928837], [-0.507638, 5.343473], [-1.063625, 5.000548], [-1.964707, 4.710462], [-2.856125, 4.994476], [-2.810701, 5.389051], [-3.24437, 6.250472], [-2.983585, 7.379705], [-2.56219, 8.219628], [-2.827496, 9.642461]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Guinea",
      TYPE: "Sovereign country",
      ADMIN: "Guinea",
      GEOUNIT: "Guinea",
      SUBUNIT: "Guinea",
      NAME: "Guinea",
      NAME_LONG: "Guinea",
      ISO_A3: "GIN",
      ISO_A3_EH: "GIN"
    },
    bbox: [-15.130311, 7.309037, -7.8321, 12.586183],
    geometry: {
      type: "Polygon",
      coordinates: [[[-8.029944, 10.206535], [-8.229337, 10.12902], [-8.309616, 9.789532], [-8.079114, 9.376224], [-7.8321, 8.575704], [-8.203499, 8.455453], [-8.299049, 8.316444], [-8.221792, 8.123329], [-8.280703, 7.68718], [-8.439298, 7.686043], [-8.722124, 7.711674], [-8.926065, 7.309037], [-9.208786, 7.313921], [-9.403348, 7.526905], [-9.33728, 7.928534], [-9.755342, 8.541055], [-10.016567, 8.428504], [-10.230094, 8.406206], [-10.505477, 8.348896], [-10.494315, 8.715541], [-10.65477, 8.977178], [-10.622395, 9.26791], [-10.839152, 9.688246], [-11.117481, 10.045873], [-11.917277, 10.046984], [-12.150338, 9.858572], [-12.425929, 9.835834], [-12.596719, 9.620188], [-12.711958, 9.342712], [-13.24655, 8.903049], [-13.685154, 9.494744], [-14.074045, 9.886167], [-14.330076, 10.01572], [-14.579699, 10.214467], [-14.693232, 10.656301], [-14.839554, 10.876572], [-15.130311, 11.040412], [-14.685687, 11.527824], [-14.382192, 11.509272], [-14.121406, 11.677117], [-13.9008, 11.678719], [-13.743161, 11.811269], [-13.828272, 12.142644], [-13.718744, 12.247186], [-13.700476, 12.586183], [-13.217818, 12.575874], [-12.499051, 12.33209], [-12.278599, 12.35444], [-12.203565, 12.465648], [-11.658301, 12.386583], [-11.513943, 12.442988], [-11.456169, 12.076834], [-11.297574, 12.077971], [-11.036556, 12.211245], [-10.87083, 12.177887], [-10.593224, 11.923975], [-10.165214, 11.844084], [-9.890993, 12.060479], [-9.567912, 12.194243], [-9.327616, 12.334286], [-9.127474, 12.30806], [-8.905265, 12.088358], [-8.786099, 11.812561], [-8.376305, 11.393646], [-8.581305, 11.136246], [-8.620321, 10.810891], [-8.407311, 10.909257], [-8.282357, 10.792597], [-8.335377, 10.494812], [-8.029944, 10.206535]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Gambia",
      TYPE: "Sovereign country",
      ADMIN: "Gambia",
      GEOUNIT: "Gambia",
      SUBUNIT: "Gambia",
      NAME: "Gambia",
      NAME_LONG: "The Gambia",
      ISO_A3: "GMB",
      ISO_A3_EH: "GMB"
    },
    bbox: [-16.841525, 13.130284, -13.844963, 13.876492],
    geometry: {
      type: "Polygon",
      coordinates: [[[-16.841525, 13.151394], [-16.713729, 13.594959], [-15.624596, 13.623587], [-15.39877, 13.860369], [-15.081735, 13.876492], [-14.687031, 13.630357], [-14.376714, 13.62568], [-14.046992, 13.794068], [-13.844963, 13.505042], [-14.277702, 13.280585], [-14.712197, 13.298207], [-15.141163, 13.509512], [-15.511813, 13.27857], [-15.691001, 13.270353], [-15.931296, 13.130284], [-16.841525, 13.151394]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Guinea-Bissau",
      TYPE: "Sovereign country",
      ADMIN: "Guinea-Bissau",
      GEOUNIT: "Guinea-Bissau",
      SUBUNIT: "Guinea-Bissau",
      NAME: "Guinea-Bissau",
      NAME_LONG: "Guinea-Bissau",
      ISO_A3: "GNB",
      ISO_A3_EH: "GNB"
    },
    bbox: [-16.677452, 11.040412, -13.700476, 12.62817],
    geometry: {
      type: "Polygon",
      coordinates: [[[-13.700476, 12.586183], [-13.718744, 12.247186], [-13.828272, 12.142644], [-13.743161, 11.811269], [-13.9008, 11.678719], [-14.121406, 11.677117], [-14.382192, 11.509272], [-14.685687, 11.527824], [-15.130311, 11.040412], [-15.66418, 11.458474], [-16.085214, 11.524594], [-16.314787, 11.806515], [-16.308947, 11.958702], [-16.613838, 12.170911], [-16.677452, 12.384852], [-16.147717, 12.547762], [-15.816574, 12.515567], [-15.548477, 12.62817], [-13.700476, 12.586183]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Equatorial Guinea",
      TYPE: "Sovereign country",
      ADMIN: "Equatorial Guinea",
      GEOUNIT: "Equatorial Guinea",
      SUBUNIT: "Equatorial Guinea",
      NAME: "Eq. Guinea",
      NAME_LONG: "Equatorial Guinea",
      ISO_A3: "GNQ",
      ISO_A3_EH: "GNQ"
    },
    bbox: [9.305613, 1.01012, 11.285079, 2.283866],
    geometry: {
      type: "Polygon",
      coordinates: [[[9.649158, 2.283866], [11.276449, 2.261051], [11.285079, 1.057662], [9.830284, 1.067894], [9.492889, 1.01012], [9.305613, 1.160911], [9.649158, 2.283866]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Greece",
      TYPE: "Sovereign country",
      ADMIN: "Greece",
      GEOUNIT: "Greece",
      SUBUNIT: "Greece",
      NAME: "Greece",
      NAME_LONG: "Greece",
      ISO_A3: "GRC",
      ISO_A3_EH: "GRC"
    },
    bbox: [20.150016, 34.919988, 26.604196, 41.826905],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[20.150016, 39.624998], [20.615, 40.110007], [20.674997, 40.435], [20.99999, 40.580004], [21.02004, 40.842727], [21.674161, 40.931275], [22.055378, 41.149866], [22.597308, 41.130487], [22.76177, 41.3048], [22.952377, 41.337994], [23.692074, 41.309081], [24.492645, 41.583896], [25.197201, 41.234486], [26.106138, 41.328899], [26.117042, 41.826905], [26.604196, 41.562115], [26.294602, 40.936261], [26.056942, 40.824123], [25.447677, 40.852545], [24.925848, 40.947062], [23.714811, 40.687129], [24.407999, 40.124993], [23.899968, 39.962006], [23.342999, 39.960998], [22.813988, 40.476005], [22.626299, 40.256561], [22.849748, 39.659311], [23.350027, 39.190011], [22.973099, 38.970903], [23.530016, 38.510001], [24.025025, 38.219993], [24.040011, 37.655015], [23.115003, 37.920011], [23.409972, 37.409991], [22.774972, 37.30501], [23.154225, 36.422506], [22.490028, 36.41], [21.670026, 36.844986], [21.295011, 37.644989], [21.120034, 38.310323], [20.730032, 38.769985], [20.217712, 39.340235], [20.150016, 39.624998]]], [[[23.69998, 35.705004], [24.246665, 35.368022], [25.025015, 35.424996], [25.769208, 35.354018], [25.745023, 35.179998], [26.290003, 35.29999], [26.164998, 35.004995], [24.724982, 34.919988], [24.735007, 35.084991], [23.514978, 35.279992], [23.69998, 35.705004]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Denmark",
      TYPE: "Country",
      ADMIN: "Greenland",
      GEOUNIT: "Greenland",
      SUBUNIT: "Greenland",
      NAME: "Greenland",
      NAME_LONG: "Greenland",
      ISO_A3: "GRL",
      ISO_A3_EH: "GRL",
      PRECISION: 5
    },
    bbox: [-73.297, 60.03676, -12.20855, 83.64513],
    geometry: {
      type: "Polygon",
      coordinates: [[[-46.76379, 82.62796], [-43.40644, 83.22516], [-39.89753, 83.18018], [-38.62214, 83.54905], [-35.08787, 83.64513], [-27.10046, 83.51966], [-20.84539, 82.72669], [-22.69182, 82.34165], [-26.51753, 82.29765], [-31.9, 82.2], [-31.39646, 82.02154], [-27.85666, 82.13178], [-24.84448, 81.78697], [-22.90328, 82.09317], [-22.07175, 81.73449], [-23.16961, 81.15271], [-20.62363, 81.52462], [-15.76818, 81.91245], [-12.77018, 81.71885], [-12.20855, 81.29154], [-16.28533, 80.58004], [-16.85, 80.35], [-20.04624, 80.17708], [-17.73035, 80.12912], [-18.9, 79.4], [-19.70499, 78.75128], [-19.67353, 77.63859], [-18.47285, 76.98565], [-20.03503, 76.94434], [-21.67944, 76.62795], [-19.83407, 76.09808], [-19.59896, 75.24838], [-20.66818, 75.15585], [-19.37281, 74.29561], [-21.59422, 74.22382], [-20.43454, 73.81713], [-20.76234, 73.46436], [-22.17221, 73.30955], [-23.56593, 73.30663], [-22.31311, 72.62928], [-22.29954, 72.18409], [-24.27834, 72.59788], [-24.79296, 72.3302], [-23.44296, 72.08016], [-22.13281, 71.46898], [-21.75356, 70.66369], [-23.53603, 70.471], [-24.30702, 70.85649], [-25.54341, 71.43094], [-25.20135, 70.75226], [-26.36276, 70.22646], [-23.72742, 70.18401], [-22.34902, 70.12946], [-25.02927, 69.2588], [-27.74737, 68.47046], [-30.67371, 68.12503], [-31.77665, 68.12078], [-32.81105, 67.73547], [-34.20196, 66.67974], [-36.35284, 65.9789], [-37.04378, 65.93768], [-38.37505, 65.69213], [-39.81222, 65.45848], [-40.66899, 64.83997], [-40.68281, 64.13902], [-41.1887, 63.48246], [-42.81938, 62.68233], [-42.41666, 61.90093], [-42.86619, 61.07404], [-43.3784, 60.09772], [-44.7875, 60.03676], [-46.26364, 60.85328], [-48.26294, 60.85843], [-49.23308, 61.40681], [-49.90039, 62.38336], [-51.63325, 63.62691], [-52.14014, 64.27842], [-52.27659, 65.1767], [-53.66166, 66.09957], [-53.30161, 66.8365], [-53.96911, 67.18899], [-52.9804, 68.35759], [-51.47536, 68.72958], [-51.08041, 69.14781], [-50.87122, 69.9291], [-52.013585, 69.574925], [-52.55792, 69.42616], [-53.45629, 69.283625], [-54.68336, 69.61003], [-54.75001, 70.28932], [-54.35884, 70.821315], [-53.431315, 70.835755], [-51.39014, 70.56978], [-53.10937, 71.20485], [-54.00422, 71.54719], [-55, 71.406537], [-55.83468, 71.65444], [-54.71819, 72.58625], [-55.32634, 72.95861], [-56.12003, 73.64977], [-57.32363, 74.71026], [-58.59679, 75.09861], [-58.58516, 75.51727], [-61.26861, 76.10238], [-63.39165, 76.1752], [-66.06427, 76.13486], [-68.50438, 76.06141], [-69.66485, 76.37975], [-71.40257, 77.00857], [-68.77671, 77.32312], [-66.76397, 77.37595], [-71.04293, 77.63595], [-73.297, 78.04419], [-73.15938, 78.43271], [-69.37345, 78.91388], [-65.7107, 79.39436], [-65.3239, 79.75814], [-68.02298, 80.11721], [-67.15129, 80.51582], [-63.68925, 81.21396], [-62.23444, 81.3211], [-62.65116, 81.77042], [-60.28249, 82.03363], [-57.20744, 82.19074], [-54.13442, 82.19962], [-53.04328, 81.88833], [-50.39061, 82.43883], [-48.00386, 82.06481], [-46.59984, 81.985945], [-44.523, 81.6607], [-46.9007, 82.19979], [-46.76379, 82.62796]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Guatemala",
      TYPE: "Sovereign country",
      ADMIN: "Guatemala",
      GEOUNIT: "Guatemala",
      SUBUNIT: "Guatemala",
      NAME: "Guatemala",
      NAME_LONG: "Guatemala",
      ISO_A3: "GTM",
      ISO_A3_EH: "GTM",
      TINY: 4
    },
    bbox: [-92.229249, 13.735338, -88.225023, 17.819326],
    geometry: {
      type: "Polygon",
      coordinates: [[[-89.14308, 17.808319], [-89.150806, 17.015577], [-89.229122, 15.886938], [-88.930613, 15.887273], [-88.604586, 15.70638], [-88.518364, 15.855389], [-88.225023, 15.727722], [-88.68068, 15.346247], [-89.154811, 15.066419], [-89.22522, 14.874286], [-89.145535, 14.678019], [-89.353326, 14.424133], [-89.587343, 14.362586], [-89.534219, 14.244816], [-89.721934, 14.134228], [-90.064678, 13.88197], [-90.095555, 13.735338], [-90.608624, 13.909771], [-91.23241, 13.927832], [-91.689747, 14.126218], [-92.22775, 14.538829], [-92.20323, 14.830103], [-92.087216, 15.064585], [-92.229249, 15.251447], [-91.74796, 16.066565], [-90.464473, 16.069562], [-90.438867, 16.41011], [-90.600847, 16.470778], [-90.711822, 16.687483], [-91.08167, 16.918477], [-91.453921, 17.252177], [-91.002269, 17.254658], [-91.00152, 17.817595], [-90.067934, 17.819326], [-89.14308, 17.808319]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Guyana",
      TYPE: "Sovereign country",
      ADMIN: "Guyana",
      GEOUNIT: "Guyana",
      SUBUNIT: "Guyana",
      NAME: "Guyana",
      NAME_LONG: "Guyana",
      ISO_A3: "GUY",
      ISO_A3_EH: "GUY"
    },
    bbox: [-61.410303, 1.268088, -56.539386, 8.367035],
    geometry: {
      type: "Polygon",
      coordinates: [[[-56.539386, 1.899523], [-56.782704, 1.863711], [-57.335823, 1.948538], [-57.660971, 1.682585], [-58.11345, 1.507195], [-58.429477, 1.463942], [-58.540013, 1.268088], [-59.030862, 1.317698], [-59.646044, 1.786894], [-59.718546, 2.24963], [-59.974525, 2.755233], [-59.815413, 3.606499], [-59.53804, 3.958803], [-59.767406, 4.423503], [-60.111002, 4.574967], [-59.980959, 5.014061], [-60.213683, 5.244486], [-60.733574, 5.200277], [-61.410303, 5.959068], [-61.139415, 6.234297], [-61.159336, 6.696077], [-60.543999, 6.856584], [-60.295668, 7.043911], [-60.637973, 7.415], [-60.550588, 7.779603], [-59.758285, 8.367035], [-59.101684, 7.999202], [-58.482962, 7.347691], [-58.454876, 6.832787], [-58.078103, 6.809094], [-57.542219, 6.321268], [-57.147436, 5.97315], [-57.307246, 5.073567], [-57.914289, 4.812626], [-57.86021, 4.576801], [-58.044694, 4.060864], [-57.601569, 3.334655], [-57.281433, 3.333492], [-57.150098, 2.768927], [-56.539386, 1.899523]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Honduras",
      TYPE: "Sovereign country",
      ADMIN: "Honduras",
      GEOUNIT: "Honduras",
      SUBUNIT: "Honduras",
      NAME: "Honduras",
      NAME_LONG: "Honduras",
      ISO_A3: "HND",
      ISO_A3_EH: "HND"
    },
    bbox: [-89.353326, 12.984686, -83.147219, 16.005406],
    geometry: {
      type: "Polygon",
      coordinates: [[[-89.353326, 14.424133], [-89.145535, 14.678019], [-89.22522, 14.874286], [-89.154811, 15.066419], [-88.68068, 15.346247], [-88.225023, 15.727722], [-88.121153, 15.688655], [-87.901813, 15.864458], [-87.61568, 15.878799], [-87.522921, 15.797279], [-87.367762, 15.84694], [-86.903191, 15.756713], [-86.440946, 15.782835], [-86.119234, 15.893449], [-86.001954, 16.005406], [-85.683317, 15.953652], [-85.444004, 15.885749], [-85.182444, 15.909158], [-84.983722, 15.995923], [-84.52698, 15.857224], [-84.368256, 15.835158], [-84.063055, 15.648244], [-83.773977, 15.424072], [-83.410381, 15.270903], [-83.147219, 14.995829], [-83.489989, 15.016267], [-83.628585, 14.880074], [-83.975721, 14.749436], [-84.228342, 14.748764], [-84.449336, 14.621614], [-84.649582, 14.666805], [-84.820037, 14.819587], [-84.924501, 14.790493], [-85.052787, 14.551541], [-85.148751, 14.560197], [-85.165365, 14.35437], [-85.514413, 14.079012], [-85.698665, 13.960078], [-85.801295, 13.836055], [-86.096264, 14.038187], [-86.312142, 13.771356], [-86.520708, 13.778487], [-86.755087, 13.754845], [-86.733822, 13.263093], [-86.880557, 13.254204], [-87.005769, 13.025794], [-87.316654, 12.984686], [-87.489409, 13.297535], [-87.793111, 13.38448], [-87.723503, 13.78505], [-87.859515, 13.893312], [-88.065343, 13.964626], [-88.503998, 13.845486], [-88.541231, 13.980155], [-88.843073, 14.140507], [-89.058512, 14.340029], [-89.353326, 14.424133]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Croatia",
      TYPE: "Sovereign country",
      ADMIN: "Croatia",
      GEOUNIT: "Croatia",
      SUBUNIT: "Croatia",
      NAME: "Croatia",
      NAME_LONG: "Croatia",
      ISO_A3: "HRV",
      ISO_A3_EH: "HRV"
    },
    bbox: [13.656976, 42.479991, 19.390476, 46.503751],
    geometry: {
      type: "Polygon",
      coordinates: [[[19.005485, 44.860234], [18.553214, 45.08159], [17.861783, 45.06774], [17.002146, 45.233777], [16.534939, 45.211608], [16.318157, 45.004127], [15.959367, 45.233777], [15.750026, 44.818712], [16.23966, 44.351143], [16.456443, 44.04124], [16.916156, 43.667722], [17.297373, 43.446341], [17.674922, 43.028563], [18.56, 42.65], [18.450017, 42.479992], [18.450016, 42.479991], [17.50997, 42.849995], [16.930006, 43.209998], [16.015385, 43.507215], [15.174454, 44.243191], [15.37625, 44.317915], [14.920309, 44.738484], [14.901602, 45.07606], [14.258748, 45.233777], [13.952255, 44.802124], [13.656976, 45.136935], [13.679403, 45.484149], [13.71506, 45.500324], [14.411968, 45.466166], [14.595109, 45.634941], [14.935244, 45.471695], [15.327675, 45.452316], [15.323954, 45.731783], [15.67153, 45.834154], [15.768733, 46.238108], [16.564808, 46.503751], [16.882515, 46.380632], [17.630066, 45.951769], [18.456062, 45.759481], [18.829825, 45.908872], [19.072769, 45.521511], [19.390476, 45.236516], [19.005485, 44.860234]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Haiti",
      TYPE: "Sovereign country",
      ADMIN: "Haiti",
      GEOUNIT: "Haiti",
      SUBUNIT: "Haiti",
      NAME: "Haiti",
      NAME_LONG: "Haiti",
      ISO_A3: "HTI",
      ISO_A3_EH: "HTI"
    },
    bbox: [-74.458034, 18.030993, -71.624873, 19.915684],
    geometry: {
      type: "Polygon",
      coordinates: [[[-71.712361, 19.714456], [-71.624873, 19.169838], [-71.701303, 18.785417], [-71.945112, 18.6169], [-71.687738, 18.31666], [-71.708305, 18.044997], [-72.372476, 18.214961], [-72.844411, 18.145611], [-73.454555, 18.217906], [-73.922433, 18.030993], [-74.458034, 18.34255], [-74.369925, 18.664908], [-73.449542, 18.526053], [-72.694937, 18.445799], [-72.334882, 18.668422], [-72.79165, 19.101625], [-72.784105, 19.483591], [-73.415022, 19.639551], [-73.189791, 19.915684], [-72.579673, 19.871501], [-71.712361, 19.714456]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Hungary",
      TYPE: "Sovereign country",
      ADMIN: "Hungary",
      GEOUNIT: "Hungary",
      SUBUNIT: "Hungary",
      NAME: "Hungary",
      NAME_LONG: "Hungary",
      ISO_A3: "HUN",
      ISO_A3_EH: "HUN"
    },
    bbox: [16.202298, 45.759481, 22.710531, 48.623854],
    geometry: {
      type: "Polygon",
      coordinates: [[[16.202298, 46.852386], [16.534268, 47.496171], [16.340584, 47.712902], [16.903754, 47.714866], [16.979667, 48.123497], [17.488473, 47.867466], [17.857133, 47.758429], [18.696513, 47.880954], [18.777025, 48.081768], [19.174365, 48.111379], [19.661364, 48.266615], [19.769471, 48.202691], [20.239054, 48.327567], [20.473562, 48.56285], [20.801294, 48.623854], [21.872236, 48.319971], [22.085608, 48.422264], [22.64082, 48.15024], [22.710531, 47.882194], [22.099768, 47.672439], [21.626515, 46.994238], [21.021952, 46.316088], [20.220192, 46.127469], [19.596045, 46.17173], [18.829838, 45.908878], [18.829825, 45.908872], [18.456062, 45.759481], [17.630066, 45.951769], [16.882515, 46.380632], [16.564808, 46.503751], [16.370505, 46.841327], [16.202298, 46.852386]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Indonesia",
      TYPE: "Sovereign country",
      ADMIN: "Indonesia",
      GEOUNIT: "Indonesia",
      SUBUNIT: "Indonesia",
      NAME: "Indonesia",
      NAME_LONG: "Indonesia",
      ISO_A3: "IDN",
      ISO_A3_EH: "IDN"
    },
    bbox: [95.293026, -10.359987, 141.033852, 5.479821],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[120.715609, -10.239581], [120.295014, -10.25865], [118.967808, -9.557969], [119.90031, -9.36134], [120.425756, -9.665921], [120.775502, -9.969675], [120.715609, -10.239581]]], [[[124.968682, -8.89279], [125.07002, -9.089987], [125.08852, -9.393173], [124.43595, -10.140001], [123.579982, -10.359987], [123.459989, -10.239995], [123.550009, -9.900016], [123.980009, -9.290027], [124.968682, -8.89279]]], [[[117.900018, -8.095681], [118.260616, -8.362383], [118.87846, -8.280683], [119.126507, -8.705825], [117.970402, -8.906639], [117.277731, -9.040895], [116.740141, -9.032937], [117.083737, -8.457158], [117.632024, -8.449303], [117.900018, -8.095681]]], [[[122.903537, -8.094234], [122.756983, -8.649808], [121.254491, -8.933666], [119.924391, -8.810418], [119.920929, -8.444859], [120.715092, -8.236965], [121.341669, -8.53674], [122.007365, -8.46062], [122.903537, -8.094234]]], [[[108.623479, -6.777674], [110.539227, -6.877358], [110.759576, -6.465186], [112.614811, -6.946036], [112.978768, -7.594213], [114.478935, -7.776528], [115.705527, -8.370807], [114.564511, -8.751817], [113.464734, -8.348947], [112.559672, -8.376181], [111.522061, -8.302129], [110.58615, -8.122605], [109.427667, -7.740664], [108.693655, -7.6416], [108.277763, -7.766657], [106.454102, -7.3549], [106.280624, -6.9249], [105.365486, -6.851416], [106.051646, -5.895919], [107.265009, -5.954985], [108.072091, -6.345762], [108.486846, -6.421985], [108.623479, -6.777674]]], [[[134.724624, -6.214401], [134.210134, -6.895238], [134.112776, -6.142467], [134.290336, -5.783058], [134.499625, -5.445042], [134.727002, -5.737582], [134.724624, -6.214401]]], [[[127.249215, -3.459065], [126.874923, -3.790983], [126.183802, -3.607376], [125.989034, -3.177273], [127.000651, -3.129318], [127.249215, -3.459065]]], [[[130.471344, -3.093764], [130.834836, -3.858472], [129.990547, -3.446301], [129.155249, -3.362637], [128.590684, -3.428679], [127.898891, -3.393436], [128.135879, -2.84365], [129.370998, -2.802154], [130.471344, -3.093764]]], [[[141.00021, -2.600151], [141.017057, -5.859022], [141.033852, -9.117893], [140.143415, -8.297168], [139.127767, -8.096043], [138.881477, -8.380935], [137.614474, -8.411683], [138.039099, -7.597882], [138.668621, -7.320225], [138.407914, -6.232849], [137.92784, -5.393366], [135.98925, -4.546544], [135.164598, -4.462931], [133.66288, -3.538853], [133.367705, -4.024819], [132.983956, -4.112979], [132.756941, -3.746283], [132.753789, -3.311787], [131.989804, -2.820551], [133.066845, -2.460418], [133.780031, -2.479848], [133.696212, -2.214542], [132.232373, -2.212526], [131.836222, -1.617162], [130.94284, -1.432522], [130.519558, -0.93772], [131.867538, -0.695461], [132.380116, -0.369538], [133.985548, -0.78021], [134.143368, -1.151867], [134.422627, -2.769185], [135.457603, -3.367753], [136.293314, -2.307042], [137.440738, -1.703513], [138.329727, -1.702686], [139.184921, -2.051296], [139.926684, -2.409052], [141.00021, -2.600151]]], [[[125.240501, 1.419836], [124.437035, 0.427881], [123.685505, 0.235593], [122.723083, 0.431137], [121.056725, 0.381217], [120.183083, 0.237247], [120.04087, -0.519658], [120.935905, -1.408906], [121.475821, -0.955962], [123.340565, -0.615673], [123.258399, -1.076213], [122.822715, -0.930951], [122.38853, -1.516858], [121.508274, -1.904483], [122.454572, -3.186058], [122.271896, -3.5295], [123.170963, -4.683693], [123.162333, -5.340604], [122.628515, -5.634591], [122.236394, -5.282933], [122.719569, -4.464172], [121.738234, -4.851331], [121.489463, -4.574553], [121.619171, -4.188478], [120.898182, -3.602105], [120.972389, -2.627643], [120.305453, -2.931604], [120.390047, -4.097579], [120.430717, -5.528241], [119.796543, -5.6734], [119.366906, -5.379878], [119.653606, -4.459417], [119.498835, -3.494412], [119.078344, -3.487022], [118.767769, -2.801999], [119.180974, -2.147104], [119.323394, -1.353147], [119.825999, 0.154254], [120.035702, 0.566477], [120.885779, 1.309223], [121.666817, 1.013944], [122.927567, 0.875192], [124.077522, 0.917102], [125.065989, 1.643259], [125.240501, 1.419836]]], [[[128.688249, 1.132386], [128.635952, 0.258486], [128.12017, 0.356413], [127.968034, -0.252077], [128.379999, -0.780004], [128.100016, -0.899996], [127.696475, -0.266598], [127.39949, 1.011722], [127.600512, 1.810691], [127.932378, 2.174596], [128.004156, 1.628531], [128.594559, 1.540811], [128.688249, 1.132386]]], [[[109.66326, 2.006467], [109.830227, 1.338136], [110.514061, 0.773131], [111.159138, 0.976478], [111.797548, 0.904441], [112.380252, 1.410121], [112.859809, 1.49779], [113.80585, 1.217549], [114.621355, 1.430688], [115.134037, 2.821482], [115.519078, 3.169238], [115.865517, 4.306559], [117.015214, 4.306094], [117.882035, 4.137551], [117.313232, 3.234428], [118.04833, 2.28769], [117.875627, 1.827641], [118.996747, 0.902219], [117.811858, 0.784242], [117.478339, 0.102475], [117.521644, -0.803723], [116.560048, -1.487661], [116.533797, -2.483517], [116.148084, -4.012726], [116.000858, -3.657037], [114.864803, -4.106984], [114.468652, -3.495704], [113.755672, -3.43917], [113.256994, -3.118776], [112.068126, -3.478392], [111.703291, -2.994442], [111.04824, -3.049426], [110.223846, -2.934032], [110.070936, -1.592874], [109.571948, -1.314907], [109.091874, -0.459507], [108.952658, 0.415375], [109.069136, 1.341934], [109.66326, 2.006467]]], [[[105.817655, -5.852356], [104.710384, -5.873285], [103.868213, -5.037315], [102.584261, -4.220259], [102.156173, -3.614146], [101.399113, -2.799777], [100.902503, -2.050262], [100.141981, -0.650348], [99.26374, 0.183142], [98.970011, 1.042882], [98.601351, 1.823507], [97.699598, 2.453184], [97.176942, 3.308791], [96.424017, 3.86886], [95.380876, 4.970782], [95.293026, 5.479821], [95.936863, 5.439513], [97.484882, 5.246321], [98.369169, 4.26837], [99.142559, 3.59035], [99.693998, 3.174329], [100.641434, 2.099381], [101.658012, 2.083697], [102.498271, 1.3987], [103.07684, 0.561361], [103.838396, 0.104542], [103.437645, -0.711946], [104.010789, -1.059212], [104.369991, -1.084843], [104.53949, -1.782372], [104.887893, -2.340425], [105.622111, -2.428844], [106.108593, -3.061777], [105.857446, -4.305525], [105.817655, -5.852356]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "India",
      TYPE: "Sovereign country",
      ADMIN: "India",
      GEOUNIT: "India",
      SUBUNIT: "India",
      NAME: "India",
      NAME_LONG: "India",
      ISO_A3: "IND",
      ISO_A3_EH: "IND"
    },
    bbox: [68.176645, 7.965535, 97.402561, 35.49401],
    geometry: {
      type: "Polygon",
      coordinates: [[[92.672721, 22.041239], [92.146035, 23.627499], [91.869928, 23.624346], [91.706475, 22.985264], [91.158963, 23.503527], [91.46773, 24.072639], [91.915093, 24.130414], [92.376202, 24.976693], [91.799596, 25.147432], [90.872211, 25.132601], [89.920693, 25.26975], [89.832481, 25.965082], [89.355094, 26.014407], [88.563049, 26.446526], [88.209789, 25.768066], [88.931554, 25.238692], [88.306373, 24.866079], [88.084422, 24.501657], [88.69994, 24.233715], [88.52977, 23.631142], [88.876312, 22.879146], [89.031961, 22.055708], [88.888766, 21.690588], [88.208497, 21.703172], [86.975704, 21.495562], [87.033169, 20.743308], [86.499351, 20.151638], [85.060266, 19.478579], [83.941006, 18.30201], [83.189217, 17.671221], [82.192792, 17.016636], [82.191242, 16.556664], [81.692719, 16.310219], [80.791999, 15.951972], [80.324896, 15.899185], [80.025069, 15.136415], [80.233274, 13.835771], [80.286294, 13.006261], [79.862547, 12.056215], [79.857999, 10.357275], [79.340512, 10.308854], [78.885345, 9.546136], [79.18972, 9.216544], [78.277941, 8.933047], [77.941165, 8.252959], [77.539898, 7.965535], [76.592979, 8.899276], [76.130061, 10.29963], [75.746467, 11.308251], [75.396101, 11.781245], [74.864816, 12.741936], [74.616717, 13.992583], [74.443859, 14.617222], [73.534199, 15.990652], [73.119909, 17.92857], [72.820909, 19.208234], [72.824475, 20.419503], [72.630533, 21.356009], [71.175273, 20.757441], [70.470459, 20.877331], [69.16413, 22.089298], [69.644928, 22.450775], [69.349597, 22.84318], [68.176645, 23.691965], [68.842599, 24.359134], [71.04324, 24.356524], [70.844699, 25.215102], [70.282873, 25.722229], [70.168927, 26.491872], [69.514393, 26.940966], [70.616496, 27.989196], [71.777666, 27.91318], [72.823752, 28.961592], [73.450638, 29.976413], [74.42138, 30.979815], [74.405929, 31.692639], [75.258642, 32.271105], [74.451559, 32.7649], [74.104294, 33.441473], [73.749948, 34.317699], [74.240203, 34.748887], [75.757061, 34.504923], [76.871722, 34.653544], [77.837451, 35.49401], [78.912269, 34.321936], [78.811086, 33.506198], [79.208892, 32.994395], [79.176129, 32.48378], [78.458446, 32.618164], [78.738894, 31.515906], [79.721367, 30.882715], [81.111256, 30.183481], [80.476721, 29.729865], [80.088425, 28.79447], [81.057203, 28.416095], [81.999987, 27.925479], [83.304249, 27.364506], [84.675018, 27.234901], [85.251779, 26.726198], [86.024393, 26.630985], [87.227472, 26.397898], [88.060238, 26.414615], [88.174804, 26.810405], [88.043133, 27.445819], [88.120441, 27.876542], [88.730326, 28.086865], [88.814248, 27.299316], [88.835643, 27.098966], [89.744528, 26.719403], [90.373275, 26.875724], [91.217513, 26.808648], [92.033484, 26.83831], [92.103712, 27.452614], [91.696657, 27.771742], [92.503119, 27.896876], [93.413348, 28.640629], [94.56599, 29.277438], [95.404802, 29.031717], [96.117679, 29.452802], [96.586591, 28.83098], [96.248833, 28.411031], [97.327114, 28.261583], [97.402561, 27.882536], [97.051989, 27.699059], [97.133999, 27.083774], [96.419366, 27.264589], [95.124768, 26.573572], [95.155153, 26.001307], [94.603249, 25.162495], [94.552658, 24.675238], [94.106742, 23.850741], [93.325188, 24.078556], [93.286327, 23.043658], [93.060294, 22.703111], [93.166128, 22.27846], [92.672721, 22.041239]]]
    },
    id: 73
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Ireland",
      TYPE: "Sovereign country",
      ADMIN: "Ireland",
      GEOUNIT: "Ireland",
      SUBUNIT: "Ireland",
      NAME: "Ireland",
      NAME_LONG: "Ireland",
      ISO_A3: "IRL",
      ISO_A3_EH: "IRL"
    },
    bbox: [-9.977086, 51.669301, -6.032985, 55.131622],
    geometry: {
      type: "Polygon",
      coordinates: [[[-7.572168, 55.131622], [-7.366031, 54.595841], [-7.572168, 54.059956], [-6.95373, 54.073702], [-6.197885, 53.867565], [-6.032985, 53.153164], [-6.788857, 52.260118], [-8.561617, 51.669301], [-9.977086, 51.820455], [-9.166283, 52.864629], [-9.688525, 53.881363], [-8.327987, 54.664519], [-7.572168, 55.131622]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Iran",
      TYPE: "Sovereign country",
      ADMIN: "Iran",
      GEOUNIT: "Iran",
      SUBUNIT: "Iran",
      NAME: "Iran",
      NAME_LONG: "Iran",
      ISO_A3: "IRN",
      ISO_A3_EH: "IRN"
    },
    bbox: [44.109225, 25.078237, 63.316632, 39.713003],
    geometry: {
      type: "Polygon",
      coordinates: [[[61.210817, 35.650072], [60.803193, 34.404102], [60.52843, 33.676446], [60.9637, 33.528832], [60.536078, 32.981269], [60.863655, 32.18292], [60.941945, 31.548075], [61.699314, 31.379506], [61.781222, 30.73585], [60.874248, 29.829239], [61.369309, 29.303276], [61.771868, 28.699334], [62.72783, 28.259645], [62.755426, 27.378923], [63.233898, 27.217047], [63.316632, 26.756532], [61.874187, 26.239975], [61.497363, 25.078237], [59.616134, 25.380157], [58.525761, 25.609962], [57.397251, 25.739902], [56.970766, 26.966106], [56.492139, 27.143305], [55.72371, 26.964633], [54.71509, 26.480658], [53.493097, 26.812369], [52.483598, 27.580849], [51.520763, 27.86569], [50.852948, 28.814521], [50.115009, 30.147773], [49.57685, 29.985715], [48.941333, 30.31709], [48.567971, 29.926778], [48.014568, 30.452457], [48.004698, 30.985137], [47.685286, 30.984853], [47.849204, 31.709176], [47.334661, 32.469155], [46.109362, 33.017287], [45.416691, 33.967798], [45.64846, 34.748138], [46.151788, 35.093259], [46.07634, 35.677383], [45.420618, 35.977546], [44.772677, 37.170437], [44.77267, 37.17045], [44.225756, 37.971584], [44.421403, 38.281281], [44.109225, 39.428136], [44.79399, 39.713003], [44.952688, 39.335765], [45.457722, 38.874139], [46.143623, 38.741201], [46.50572, 38.770605], [47.685079, 39.508364], [48.060095, 39.582235], [48.355529, 39.288765], [48.010744, 38.794015], [48.634375, 38.270378], [48.883249, 38.320245], [49.199612, 37.582874], [50.147771, 37.374567], [50.842354, 36.872814], [52.264025, 36.700422], [53.82579, 36.965031], [53.921598, 37.198918], [54.800304, 37.392421], [55.511578, 37.964117], [56.180375, 37.935127], [56.619366, 38.121394], [57.330434, 38.029229], [58.436154, 37.522309], [59.234762, 37.412988], [60.377638, 36.527383], [61.123071, 36.491597], [61.210817, 35.650072]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Iraq",
      TYPE: "Sovereign country",
      ADMIN: "Iraq",
      GEOUNIT: "Iraq",
      SUBUNIT: "Iraq",
      NAME: "Iraq",
      NAME_LONG: "Iraq",
      ISO_A3: "IRQ",
      ISO_A3_EH: "IRQ"
    },
    bbox: [38.792341, 29.099025, 48.567971, 37.385264],
    geometry: {
      type: "Polygon",
      coordinates: [[[44.772677, 37.170437], [45.420618, 35.977546], [46.07634, 35.677383], [46.151788, 35.093259], [45.64846, 34.748138], [45.416691, 33.967798], [46.109362, 33.017287], [47.334661, 32.469155], [47.849204, 31.709176], [47.685286, 30.984853], [48.004698, 30.985137], [48.014568, 30.452457], [48.567971, 29.926778], [47.974519, 29.975819], [47.302622, 30.05907], [46.568713, 29.099025], [44.709499, 29.178891], [41.889981, 31.190009], [40.399994, 31.889992], [39.195468, 32.161009], [38.792341, 33.378686], [41.006159, 34.419372], [41.383965, 35.628317], [41.289707, 36.358815], [41.837064, 36.605854], [42.349591, 37.229873], [42.779126, 37.385264], [43.942259, 37.256228], [44.293452, 37.001514], [44.772677, 37.170437]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Iceland",
      TYPE: "Sovereign country",
      ADMIN: "Iceland",
      GEOUNIT: "Iceland",
      SUBUNIT: "Iceland",
      NAME: "Iceland",
      NAME_LONG: "Iceland",
      ISO_A3: "ISL",
      ISO_A3_EH: "ISL"
    },
    bbox: [-24.326184, 63.496383, -13.609732, 66.526792],
    geometry: {
      type: "Polygon",
      coordinates: [[[-14.508695, 66.455892], [-14.739637, 65.808748], [-13.609732, 65.126671], [-14.909834, 64.364082], [-17.794438, 63.678749], [-18.656246, 63.496383], [-19.972755, 63.643635], [-22.762972, 63.960179], [-21.778484, 64.402116], [-23.955044, 64.89113], [-22.184403, 65.084968], [-22.227423, 65.378594], [-24.326184, 65.611189], [-23.650515, 66.262519], [-22.134922, 66.410469], [-20.576284, 65.732112], [-19.056842, 66.276601], [-17.798624, 65.993853], [-16.167819, 66.526792], [-14.508695, 66.455892]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Israel",
      TYPE: "Country",
      ADMIN: "Israel",
      GEOUNIT: "Israel",
      SUBUNIT: "Israel",
      NAME: "Israel",
      NAME_LONG: "Israel",
      ISO_A3: "ISR",
      ISO_A3_EH: "ISR"
    },
    bbox: [34.265433, 29.501326, 35.836397, 33.277426],
    geometry: {
      type: "Polygon",
      coordinates: [[[34.823243, 29.761081], [34.26544, 31.21936], [34.265435, 31.219357], [34.265433, 31.219361], [34.556372, 31.548824], [34.488107, 31.605539], [34.752587, 32.072926], [34.955417, 32.827376], [35.098457, 33.080539], [35.126053, 33.0909], [35.460709, 33.08904], [35.552797, 33.264275], [35.821101, 33.277426], [35.836397, 32.868123], [35.700798, 32.716014], [35.719918, 32.709192], [35.545665, 32.393992], [35.18393, 32.532511], [34.974641, 31.866582], [35.225892, 31.754341], [34.970507, 31.616778], [34.927408, 31.353435], [35.397561, 31.489086], [35.420918, 31.100066], [34.922603, 29.501326], [34.823243, 29.761081]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Italy",
      TYPE: "Sovereign country",
      ADMIN: "Italy",
      GEOUNIT: "Italy",
      SUBUNIT: "Italy",
      NAME: "Italy",
      NAME_LONG: "Italy",
      ISO_A3: "ITA",
      ISO_A3_EH: "ITA"
    },
    bbox: [6.749955, 36.619987, 18.480247, 47.115393],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[10.442701, 46.893546], [11.048556, 46.751359], [11.164828, 46.941579], [12.153088, 47.115393], [12.376485, 46.767559], [13.806475, 46.509306], [13.69811, 46.016778], [13.93763, 45.591016], [13.141606, 45.736692], [12.328581, 45.381778], [12.383875, 44.885374], [12.261453, 44.600482], [12.589237, 44.091366], [13.526906, 43.587727], [14.029821, 42.761008], [15.14257, 41.95514], [15.926191, 41.961315], [16.169897, 41.740295], [15.889346, 41.541082], [16.785002, 41.179606], [17.519169, 40.877143], [18.376687, 40.355625], [18.480247, 40.168866], [18.293385, 39.810774], [17.73838, 40.277671], [16.869596, 40.442235], [16.448743, 39.795401], [17.17149, 39.4247], [17.052841, 38.902871], [16.635088, 38.843572], [16.100961, 37.985899], [15.684087, 37.908849], [15.687963, 38.214593], [15.891981, 38.750942], [16.109332, 38.964547], [15.718814, 39.544072], [15.413613, 40.048357], [14.998496, 40.172949], [14.703268, 40.60455], [14.060672, 40.786348], [13.627985, 41.188287], [12.888082, 41.25309], [12.106683, 41.704535], [11.191906, 42.355425], [10.511948, 42.931463], [10.200029, 43.920007], [9.702488, 44.036279], [8.888946, 44.366336], [8.428561, 44.231228], [7.850767, 43.767148], [7.435185, 43.693845], [7.549596, 44.127901], [7.007562, 44.254767], [6.749955, 45.028518], [7.096652, 45.333099], [6.802355, 45.70858], [6.843593, 45.991147], [7.273851, 45.776948], [7.755992, 45.82449], [8.31663, 46.163642], [8.489952, 46.005151], [8.966306, 46.036932], [9.182882, 46.440215], [9.922837, 46.314899], [10.363378, 46.483571], [10.442701, 46.893546]]], [[[15.520376, 38.231155], [15.160243, 37.444046], [15.309898, 37.134219], [15.099988, 36.619987], [14.335229, 36.996631], [13.826733, 37.104531], [12.431004, 37.61295], [12.570944, 38.126381], [13.741156, 38.034966], [14.761249, 38.143874], [15.520376, 38.231155]]], [[[9.210012, 41.209991], [9.809975, 40.500009], [9.669519, 39.177376], [9.214818, 39.240473], [8.806936, 38.906618], [8.428302, 39.171847], [8.388253, 40.378311], [8.159998, 40.950007], [8.709991, 40.899984], [9.210012, 41.209991]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Jamaica",
      TYPE: "Sovereign country",
      ADMIN: "Jamaica",
      GEOUNIT: "Jamaica",
      SUBUNIT: "Jamaica",
      NAME: "Jamaica",
      NAME_LONG: "Jamaica",
      ISO_A3: "JAM",
      ISO_A3_EH: "JAM"
    },
    bbox: [-78.337719, 17.701116, -76.199659, 18.524218],
    geometry: {
      type: "Polygon",
      coordinates: [[[-77.569601, 18.490525], [-76.896619, 18.400867], [-76.365359, 18.160701], [-76.199659, 17.886867], [-76.902561, 17.868238], [-77.206341, 17.701116], [-77.766023, 17.861597], [-78.337719, 18.225968], [-78.217727, 18.454533], [-77.797365, 18.524218], [-77.569601, 18.490525]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Jordan",
      TYPE: "Sovereign country",
      ADMIN: "Jordan",
      GEOUNIT: "Jordan",
      SUBUNIT: "Jordan",
      NAME: "Jordan",
      NAME_LONG: "Jordan",
      ISO_A3: "JOR",
      ISO_A3_EH: "JOR"
    },
    bbox: [34.922603, 29.197495, 39.195468, 33.378686],
    geometry: {
      type: "Polygon",
      coordinates: [[[38.792341, 33.378686], [39.195468, 32.161009], [39.004886, 32.010217], [37.002166, 31.508413], [37.998849, 30.5085], [37.66812, 30.338665], [37.503582, 30.003776], [36.740528, 29.865283], [36.501214, 29.505254], [36.068941, 29.197495], [34.956037, 29.356555], [34.922603, 29.501326], [35.420918, 31.100066], [35.397561, 31.489086], [35.545252, 31.782505], [35.545665, 32.393992], [35.719918, 32.709192], [36.834062, 32.312938], [38.792341, 33.378686]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Japan",
      TYPE: "Sovereign country",
      ADMIN: "Japan",
      GEOUNIT: "Japan",
      SUBUNIT: "Japan",
      NAME: "Japan",
      NAME_LONG: "Japan",
      ISO_A3: "JPN",
      ISO_A3_EH: "JPN"
    },
    bbox: [129.408463, 31.029579, 145.543137, 45.551483],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[134.638428, 34.149234], [134.766379, 33.806335], [134.203416, 33.201178], [133.79295, 33.521985], [133.280268, 33.28957], [133.014858, 32.704567], [132.363115, 32.989382], [132.371176, 33.463642], [132.924373, 34.060299], [133.492968, 33.944621], [133.904106, 34.364931], [134.638428, 34.149234]]], [[[140.976388, 37.142074], [140.59977, 36.343983], [140.774074, 35.842877], [140.253279, 35.138114], [138.975528, 34.6676], [137.217599, 34.606286], [135.792983, 33.464805], [135.120983, 33.849071], [135.079435, 34.596545], [133.340316, 34.375938], [132.156771, 33.904933], [130.986145, 33.885761], [132.000036, 33.149992], [131.33279, 31.450355], [130.686318, 31.029579], [130.20242, 31.418238], [130.447676, 32.319475], [129.814692, 32.61031], [129.408463, 33.296056], [130.353935, 33.604151], [130.878451, 34.232743], [131.884229, 34.749714], [132.617673, 35.433393], [134.608301, 35.731618], [135.677538, 35.527134], [136.723831, 37.304984], [137.390612, 36.827391], [138.857602, 37.827485], [139.426405, 38.215962], [140.05479, 39.438807], [139.883379, 40.563312], [140.305783, 41.195005], [141.368973, 41.37856], [141.914263, 39.991616], [141.884601, 39.180865], [140.959489, 38.174001], [140.976388, 37.142074]]], [[[143.910162, 44.1741], [144.613427, 43.960883], [145.320825, 44.384733], [145.543137, 43.262088], [144.059662, 42.988358], [143.18385, 41.995215], [141.611491, 42.678791], [141.067286, 41.584594], [139.955106, 41.569556], [139.817544, 42.563759], [140.312087, 43.333273], [141.380549, 43.388825], [141.671952, 44.772125], [141.967645, 45.551483], [143.14287, 44.510358], [143.910162, 44.1741]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Kazakhstan",
      TYPE: "Sovereign country",
      ADMIN: "Kazakhstan",
      GEOUNIT: "Kazakhstan",
      SUBUNIT: "Kazakhstan",
      NAME: "Kazakhstan",
      NAME_LONG: "Kazakhstan",
      ISO_A3: "KAZ",
      ISO_A3_EH: "KAZ"
    },
    bbox: [46.466446, 40.662325, 87.35997, 55.38525],
    geometry: {
      type: "Polygon",
      coordinates: [[[87.35997, 49.214981], [86.598776, 48.549182], [85.768233, 48.455751], [85.720484, 47.452969], [85.16429, 47.000956], [83.180484, 47.330031], [82.458926, 45.53965], [81.947071, 45.317027], [79.966106, 44.917517], [80.866206, 43.180362], [80.18015, 42.920068], [80.25999, 42.349999], [79.643645, 42.496683], [79.142177, 42.856092], [77.658392, 42.960686], [76.000354, 42.988022], [75.636965, 42.8779], [74.212866, 43.298339], [73.645304, 43.091272], [73.489758, 42.500894], [71.844638, 42.845395], [71.186281, 42.704293], [70.962315, 42.266154], [70.388965, 42.081308], [69.070027, 41.384244], [68.632483, 40.668681], [68.259896, 40.662325], [67.985856, 41.135991], [66.714047, 41.168444], [66.510649, 41.987644], [66.023392, 41.994646], [66.098012, 42.99766], [64.900824, 43.728081], [63.185787, 43.650075], [62.0133, 43.504477], [61.05832, 44.405817], [60.239972, 44.784037], [58.689989, 45.500014], [58.503127, 45.586804], [55.928917, 44.995858], [55.968191, 41.308642], [55.455251, 41.259859], [54.755345, 42.043971], [54.079418, 42.324109], [52.944293, 42.116034], [52.50246, 41.783316], [52.446339, 42.027151], [52.692112, 42.443895], [52.501426, 42.792298], [51.342427, 43.132975], [50.891292, 44.031034], [50.339129, 44.284016], [50.305643, 44.609836], [51.278503, 44.514854], [51.316899, 45.245998], [52.16739, 45.408391], [53.040876, 45.259047], [53.220866, 46.234646], [53.042737, 46.853006], [52.042023, 46.804637], [51.191945, 47.048705], [50.034083, 46.60899], [49.10116, 46.39933], [48.59325, 46.56104], [48.694734, 47.075628], [48.05725, 47.74377], [47.31524, 47.71585], [46.466446, 48.394152], [47.043672, 49.152039], [46.751596, 49.356006], [47.54948, 50.454698], [48.577841, 49.87476], [48.702382, 50.605128], [50.766648, 51.692762], [52.328724, 51.718652], [54.532878, 51.02624], [55.71694, 50.62171], [56.77798, 51.04355], [58.36332, 51.06364], [59.642282, 50.545442], [59.932807, 50.842194], [61.337424, 50.79907], [61.588003, 51.272659], [59.967534, 51.96042], [60.927269, 52.447548], [60.739993, 52.719986], [61.699986, 52.979996], [60.978066, 53.664993], [61.4366, 54.00625], [65.178534, 54.354228], [65.66687, 54.60125], [68.1691, 54.970392], [69.068167, 55.38525], [70.865267, 55.169734], [71.180131, 54.133285], [72.22415, 54.376655], [73.508516, 54.035617], [73.425679, 53.48981], [74.38482, 53.54685], [76.8911, 54.490524], [76.525179, 54.177003], [77.800916, 53.404415], [80.03556, 50.864751], [80.568447, 51.388336], [81.945986, 50.812196], [83.383004, 51.069183], [83.935115, 50.889246], [84.416377, 50.3114], [85.11556, 50.117303], [85.54127, 49.692859], [86.829357, 49.826675], [87.35997, 49.214981]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Kenya",
      TYPE: "Sovereign country",
      ADMIN: "Kenya",
      GEOUNIT: "Kenya",
      SUBUNIT: "Kenya",
      NAME: "Kenya",
      NAME_LONG: "Kenya",
      ISO_A3: "KEN",
      ISO_A3_EH: "KEN"
    },
    bbox: [33.893569, -4.67677, 41.855083, 5.506],
    geometry: {
      type: "Polygon",
      coordinates: [[[35.298007, 5.506], [35.817448, 5.338232], [35.817448, 4.776966], [36.159079, 4.447864], [36.855093, 4.447864], [38.120915, 3.598605], [38.43697, 3.58851], [38.67114, 3.61607], [38.89251, 3.50074], [39.559384, 3.42206], [39.85494, 3.83879], [40.76848, 4.25702], [41.1718, 3.91909], [41.855083, 3.918912], [40.98105, 2.78452], [40.993, -0.85829], [41.58513, -1.68325], [40.88477, -2.08255], [40.63785, -2.49979], [40.26304, -2.57309], [40.12119, -3.27768], [39.80006, -3.68116], [39.60489, -4.34653], [39.20222, -4.67677], [37.7669, -3.67712], [37.69869, -3.09699], [34.07262, -1.05982], [33.903711, -0.95], [33.893569, 0.109814], [34.18, 0.515], [34.6721, 1.17694], [35.03599, 1.90584], [34.59607, 3.05374], [34.47913, 3.5556], [34.005, 4.249885], [34.620196, 4.847123], [35.298007, 5.506]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Kyrgyzstan",
      TYPE: "Sovereign country",
      ADMIN: "Kyrgyzstan",
      GEOUNIT: "Kyrgyzstan",
      SUBUNIT: "Kyrgyzstan",
      NAME: "Kyrgyzstan",
      NAME_LONG: "Kyrgyzstan",
      ISO_A3: "KGZ",
      ISO_A3_EH: "KGZ"
    },
    bbox: [69.464887, 39.279463, 80.25999, 43.298339],
    geometry: {
      type: "Polygon",
      coordinates: [[[80.25999, 42.349999], [80.11943, 42.123941], [78.543661, 41.582243], [78.187197, 41.185316], [76.904484, 41.066486], [76.526368, 40.427946], [75.467828, 40.562072], [74.776862, 40.366425], [73.822244, 39.893973], [73.960013, 39.660008], [73.675379, 39.431237], [71.784694, 39.279463], [70.549162, 39.604198], [69.464887, 39.526683], [69.55961, 40.103211], [70.648019, 39.935754], [71.014198, 40.244366], [71.774875, 40.145844], [73.055417, 40.866033], [71.870115, 41.3929], [71.157859, 41.143587], [70.420022, 41.519998], [71.259248, 42.167711], [70.962315, 42.266154], [71.186281, 42.704293], [71.844638, 42.845395], [73.489758, 42.500894], [73.645304, 43.091272], [74.212866, 43.298339], [75.636965, 42.8779], [76.000354, 42.988022], [77.658392, 42.960686], [79.142177, 42.856092], [79.643645, 42.496683], [80.25999, 42.349999]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Cambodia",
      TYPE: "Sovereign country",
      ADMIN: "Cambodia",
      GEOUNIT: "Cambodia",
      SUBUNIT: "Cambodia",
      NAME: "Cambodia",
      NAME_LONG: "Cambodia",
      ISO_A3: "KHM",
      ISO_A3_EH: "KHM"
    },
    bbox: [102.348099, 10.486544, 107.614548, 14.570584],
    geometry: {
      type: "Polygon",
      coordinates: [[[102.584932, 12.186595], [102.348099, 13.394247], [102.988422, 14.225721], [104.281418, 14.416743], [105.218777, 14.273212], [106.043946, 13.881091], [106.496373, 14.570584], [107.382727, 14.202441], [107.614548, 13.535531], [107.491403, 12.337206], [105.810524, 11.567615], [106.24967, 10.961812], [105.199915, 10.88931], [104.334335, 10.486544], [103.49728, 10.632555], [103.09069, 11.153661], [102.584932, 12.186595]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "South Korea",
      TYPE: "Sovereign country",
      ADMIN: "South Korea",
      GEOUNIT: "South Korea",
      SUBUNIT: "South Korea",
      NAME: "South Korea",
      NAME_LONG: "Republic of Korea",
      ISO_A3: "KOR",
      ISO_A3_EH: "KOR"
    },
    bbox: [126.117398, 34.390046, 129.468304, 38.612243],
    geometry: {
      type: "Polygon",
      coordinates: [[[128.349716, 38.612243], [129.21292, 37.432392], [129.46045, 36.784189], [129.468304, 35.632141], [129.091377, 35.082484], [128.18585, 34.890377], [127.386519, 34.475674], [126.485748, 34.390046], [126.37392, 34.93456], [126.559231, 35.684541], [126.117398, 36.725485], [126.860143, 36.893924], [126.174759, 37.749686], [126.237339, 37.840378], [126.68372, 37.804773], [127.073309, 38.256115], [127.780035, 38.304536], [128.205746, 38.370397], [128.349716, 38.612243]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Kosovo",
      TYPE: "Sovereign country",
      ADMIN: "Kosovo",
      GEOUNIT: "Kosovo",
      SUBUNIT: "Kosovo",
      NAME: "Kosovo",
      NAME_LONG: "Kosovo",
      ISO_A3: "-99",
      ISO_A3_EH: "-99"
    },
    bbox: [20.0707, 41.84711, 21.77505, 43.27205],
    geometry: {
      type: "Polygon",
      coordinates: [[[20.590247, 41.855409], [20.52295, 42.21787], [20.283755, 42.32026], [20.0707, 42.58863], [20.25758, 42.81275], [20.49679, 42.88469], [20.63508, 43.21671], [20.81448, 43.27205], [20.95651, 43.13094], [21.143395, 43.068685], [21.27421, 42.90959], [21.43866, 42.86255], [21.63302, 42.67717], [21.77505, 42.6827], [21.66292, 42.43922], [21.54332, 42.32025], [21.576636, 42.245224], [21.3527, 42.2068], [20.76216, 42.05186], [20.71731, 41.84711], [20.590247, 41.855409]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Kuwait",
      TYPE: "Sovereign country",
      ADMIN: "Kuwait",
      GEOUNIT: "Kuwait",
      SUBUNIT: "Kuwait",
      NAME: "Kuwait",
      NAME_LONG: "Kuwait",
      ISO_A3: "KWT",
      ISO_A3_EH: "KWT"
    },
    bbox: [46.568713, 28.526063, 48.416094, 30.05907],
    geometry: {
      type: "Polygon",
      coordinates: [[[46.568713, 29.099025], [47.302622, 30.05907], [47.974519, 29.975819], [48.183189, 29.534477], [48.093943, 29.306299], [48.416094, 28.552004], [47.708851, 28.526063], [47.459822, 29.002519], [46.568713, 29.099025]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Laos",
      TYPE: "Sovereign country",
      ADMIN: "Laos",
      GEOUNIT: "Laos",
      SUBUNIT: "Laos",
      NAME: "Laos",
      NAME_LONG: "Lao PDR",
      ISO_A3: "LAO",
      ISO_A3_EH: "LAO"
    },
    bbox: [100.115988, 13.881091, 107.564525, 22.464753],
    geometry: {
      type: "Polygon",
      coordinates: [[[101.180005, 21.436573], [101.270026, 21.201652], [101.80312, 21.174367], [101.652018, 22.318199], [102.170436, 22.464753], [102.754896, 21.675137], [103.203861, 20.766562], [104.435, 20.758733], [104.822574, 19.886642], [104.183388, 19.624668], [103.896532, 19.265181], [105.094598, 18.666975], [105.925762, 17.485315], [106.556008, 16.604284], [107.312706, 15.908538], [107.564525, 15.202173], [107.382727, 14.202441], [106.496373, 14.570584], [106.043946, 13.881091], [105.218777, 14.273212], [105.544338, 14.723934], [105.589039, 15.570316], [104.779321, 16.441865], [104.716947, 17.428859], [103.956477, 18.240954], [103.200192, 18.309632], [102.998706, 17.961695], [102.413005, 17.932782], [102.113592, 18.109102], [101.059548, 17.512497], [101.035931, 18.408928], [101.282015, 19.462585], [100.606294, 19.508344], [100.548881, 20.109238], [100.115988, 20.41785], [100.329101, 20.786122], [101.180005, 21.436573]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Lebanon",
      TYPE: "Sovereign country",
      ADMIN: "Lebanon",
      GEOUNIT: "Lebanon",
      SUBUNIT: "Lebanon",
      NAME: "Lebanon",
      NAME_LONG: "Lebanon",
      ISO_A3: "LBN",
      ISO_A3_EH: "LBN",
      TINY: 4
    },
    bbox: [35.126053, 33.08904, 36.61175, 34.644914],
    geometry: {
      type: "Polygon",
      coordinates: [[[35.821101, 33.277426], [35.552797, 33.264275], [35.460709, 33.08904], [35.126053, 33.0909], [35.482207, 33.90545], [35.979592, 34.610058], [35.998403, 34.644914], [36.448194, 34.593935], [36.61175, 34.201789], [36.06646, 33.824912], [35.821101, 33.277426]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Liberia",
      TYPE: "Sovereign country",
      ADMIN: "Liberia",
      GEOUNIT: "Liberia",
      SUBUNIT: "Liberia",
      NAME: "Liberia",
      NAME_LONG: "Liberia",
      ISO_A3: "LBR",
      ISO_A3_EH: "LBR"
    },
    bbox: [-11.438779, 4.355755, -7.539715, 8.541055],
    geometry: {
      type: "Polygon",
      coordinates: [[[-8.439298, 7.686043], [-8.485446, 7.395208], [-8.385452, 6.911801], [-8.60288, 6.467564], [-8.311348, 6.193033], [-7.993693, 6.12619], [-7.570153, 5.707352], [-7.539715, 5.313345], [-7.635368, 5.188159], [-7.712159, 4.364566], [-7.974107, 4.355755], [-9.004794, 4.832419], [-9.91342, 5.593561], [-10.765384, 6.140711], [-11.438779, 6.785917], [-11.199802, 7.105846], [-11.146704, 7.396706], [-10.695595, 7.939464], [-10.230094, 8.406206], [-10.016567, 8.428504], [-9.755342, 8.541055], [-9.33728, 7.928534], [-9.403348, 7.526905], [-9.208786, 7.313921], [-8.926065, 7.309037], [-8.722124, 7.711674], [-8.439298, 7.686043]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Libya",
      TYPE: "Sovereign country",
      ADMIN: "Libya",
      GEOUNIT: "Libya",
      SUBUNIT: "Libya",
      NAME: "Libya",
      NAME_LONG: "Libya",
      ISO_A3: "LBY",
      ISO_A3_EH: "LBY"
    },
    bbox: [9.319411, 19.58047, 25.16482, 33.136996],
    geometry: {
      type: "Polygon",
      coordinates: [[[11.999506, 23.471668], [11.560669, 24.097909], [10.771364, 24.562532], [10.303847, 24.379313], [9.948261, 24.936954], [9.910693, 25.365455], [9.319411, 26.094325], [9.716286, 26.512206], [9.629056, 27.140953], [9.756128, 27.688259], [9.683885, 28.144174], [9.859998, 28.95999], [9.805634, 29.424638], [9.48214, 30.307556], [9.970017, 30.539325], [10.056575, 30.961831], [9.950225, 31.37607], [10.636901, 31.761421], [10.94479, 32.081815], [11.432253, 32.368903], [11.488787, 33.136996], [12.66331, 32.79278], [13.08326, 32.87882], [13.91868, 32.71196], [15.24563, 32.26508], [15.71394, 31.37626], [16.61162, 31.18218], [18.02109, 30.76357], [19.08641, 30.26639], [19.57404, 30.52582], [20.05335, 30.98576], [19.82033, 31.75179], [20.13397, 32.2382], [20.85452, 32.7068], [21.54298, 32.8432], [22.89576, 32.63858], [23.2368, 32.19149], [23.60913, 32.18726], [23.9275, 32.01667], [24.92114, 31.89936], [25.16482, 31.56915], [24.80287, 31.08929], [24.95762, 30.6616], [24.70007, 30.04419], [25, 29.238655], [25, 25.6825], [25, 22], [25, 20.00304], [23.85, 20], [23.83766, 19.58047], [19.84926, 21.49509], [15.86085, 23.40972], [14.8513, 22.86295], [14.143871, 22.491289], [13.581425, 23.040506], [11.999506, 23.471668]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Sri Lanka",
      TYPE: "Sovereign country",
      ADMIN: "Sri Lanka",
      GEOUNIT: "Sri Lanka",
      SUBUNIT: "Sri Lanka",
      NAME: "Sri Lanka",
      NAME_LONG: "Sri Lanka",
      ISO_A3: "LKA",
      ISO_A3_EH: "LKA"
    },
    bbox: [79.695167, 5.96837, 81.787959, 9.824078],
    geometry: {
      type: "Polygon",
      coordinates: [[[81.787959, 7.523055], [81.637322, 6.481775], [81.21802, 6.197141], [80.348357, 5.96837], [79.872469, 6.763463], [79.695167, 8.200843], [80.147801, 9.824078], [80.838818, 9.268427], [81.304319, 8.564206], [81.787959, 7.523055]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Lesotho",
      TYPE: "Sovereign country",
      ADMIN: "Lesotho",
      GEOUNIT: "Lesotho",
      SUBUNIT: "Lesotho",
      NAME: "Lesotho",
      NAME_LONG: "Lesotho",
      ISO_A3: "LSO",
      ISO_A3_EH: "LSO"
    },
    bbox: [26.999262, -30.645106, 29.325166, -28.647502],
    geometry: {
      type: "Polygon",
      coordinates: [[[28.978263, -28.955597], [29.325166, -29.257387], [29.018415, -29.743766], [28.8484, -30.070051], [28.291069, -30.226217], [28.107205, -30.545732], [27.749397, -30.645106], [26.999262, -29.875954], [27.532511, -29.242711], [28.074338, -28.851469], [28.5417, -28.647502], [28.978263, -28.955597]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Lithuania",
      TYPE: "Sovereign country",
      ADMIN: "Lithuania",
      GEOUNIT: "Lithuania",
      SUBUNIT: "Lithuania",
      NAME: "Lithuania",
      NAME_LONG: "Lithuania",
      ISO_A3: "LTU",
      ISO_A3_EH: "LTU"
    },
    bbox: [21.0558, 53.905702, 26.588279, 56.372528],
    geometry: {
      type: "Polygon",
      coordinates: [[[26.494331, 55.615107], [26.588279, 55.167176], [25.768433, 54.846963], [25.536354, 54.282423], [24.450684, 53.905702], [23.484128, 53.912498], [23.243987, 54.220567], [22.731099, 54.327537], [22.651052, 54.582741], [22.757764, 54.856574], [22.315724, 55.015299], [21.268449, 55.190482], [21.0558, 56.031076], [22.201157, 56.337802], [23.878264, 56.273671], [24.860684, 56.372528], [25.000934, 56.164531], [25.533047, 56.100297], [26.494331, 55.615107]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Luxembourg",
      TYPE: "Sovereign country",
      ADMIN: "Luxembourg",
      GEOUNIT: "Luxembourg",
      SUBUNIT: "Luxembourg",
      NAME: "Luxembourg",
      NAME_LONG: "Luxembourg",
      ISO_A3: "LUX",
      ISO_A3_EH: "LUX",
      TINY: 5
    },
    bbox: [5.674052, 49.442667, 6.242751, 50.128052],
    geometry: {
      type: "Polygon",
      coordinates: [[[5.674052, 49.529484], [5.782417, 50.090328], [6.043073, 50.128052], [6.242751, 49.902226], [6.18632, 49.463803], [5.897759, 49.442667], [5.674052, 49.529484]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Latvia",
      TYPE: "Sovereign country",
      ADMIN: "Latvia",
      GEOUNIT: "Latvia",
      SUBUNIT: "Latvia",
      NAME: "Latvia",
      NAME_LONG: "Latvia",
      ISO_A3: "LVA",
      ISO_A3_EH: "LVA"
    },
    bbox: [21.0558, 55.615107, 28.176709, 57.970157],
    geometry: {
      type: "Polygon",
      coordinates: [[[28.176709, 56.16913], [27.10246, 55.783314], [26.494331, 55.615107], [25.533047, 56.100297], [25.000934, 56.164531], [24.860684, 56.372528], [23.878264, 56.273671], [22.201157, 56.337802], [21.0558, 56.031076], [21.090424, 56.783873], [21.581866, 57.411871], [22.524341, 57.753374], [23.318453, 57.006236], [24.12073, 57.025693], [24.312863, 57.793424], [25.164594, 57.970157], [25.60281, 57.847529], [26.463532, 57.476389], [27.288185, 57.474528], [27.770016, 57.244258], [27.855282, 56.759326], [28.176709, 56.16913]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Morocco",
      TYPE: "Sovereign country",
      ADMIN: "Morocco",
      GEOUNIT: "Morocco",
      SUBUNIT: "Morocco",
      NAME: "Morocco",
      NAME_LONG: "Morocco",
      ISO_A3: "MAR",
      ISO_A3_EH: "MAR"
    },
    bbox: [-17.020428, 21.420734, -1.124551, 35.759988],
    geometry: {
      type: "Polygon",
      coordinates: [[[-2.169914, 35.168396], [-1.792986, 34.527919], [-1.733455, 33.919713], [-1.388049, 32.864015], [-1.124551, 32.651522], [-1.307899, 32.262889], [-2.616605, 32.094346], [-3.06898, 31.724498], [-3.647498, 31.637294], [-3.690441, 30.896952], [-4.859646, 30.501188], [-5.242129, 30.000443], [-6.060632, 29.7317], [-7.059228, 29.579228], [-8.674116, 28.841289], [-8.66559, 27.656426], [-8.817828, 27.656426], [-8.794884, 27.120696], [-9.413037, 27.088476], [-9.735343, 26.860945], [-10.189424, 26.860945], [-10.551263, 26.990808], [-11.392555, 26.883424], [-11.71822, 26.104092], [-12.030759, 26.030866], [-12.500963, 24.770116], [-13.89111, 23.691009], [-14.221168, 22.310163], [-14.630833, 21.86094], [-14.750955, 21.5006], [-17.002962, 21.420734], [-17.020428, 21.42231], [-16.973248, 21.885745], [-16.589137, 22.158234], [-16.261922, 22.67934], [-16.326414, 23.017768], [-15.982611, 23.723358], [-15.426004, 24.359134], [-15.089332, 24.520261], [-14.824645, 25.103533], [-14.800926, 25.636265], [-14.43994, 26.254418], [-13.773805, 26.618892], [-13.139942, 27.640148], [-13.121613, 27.654148], [-12.618837, 28.038186], [-11.688919, 28.148644], [-10.900957, 28.832142], [-10.399592, 29.098586], [-9.564811, 29.933574], [-9.814718, 31.177736], [-9.434793, 32.038096], [-9.300693, 32.564679], [-8.657476, 33.240245], [-7.654178, 33.697065], [-6.912544, 34.110476], [-6.244342, 35.145865], [-5.929994, 35.759988], [-5.193863, 35.755182], [-4.591006, 35.330712], [-3.640057, 35.399855], [-2.604306, 35.179093], [-2.169914, 35.168396]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Moldova",
      TYPE: "Sovereign country",
      ADMIN: "Moldova",
      GEOUNIT: "Moldova",
      SUBUNIT: "Moldova",
      NAME: "Moldova",
      NAME_LONG: "Moldova",
      ISO_A3: "MDA",
      ISO_A3_EH: "MDA"
    },
    bbox: [26.619337, 45.488283, 30.024659, 48.467119],
    geometry: {
      type: "Polygon",
      coordinates: [[[26.619337, 48.220726], [26.857824, 48.368211], [27.522537, 48.467119], [28.259547, 48.155562], [28.670891, 48.118149], [29.122698, 47.849095], [29.050868, 47.510227], [29.415135, 47.346645], [29.559674, 46.928583], [29.908852, 46.674361], [29.83821, 46.525326], [30.024659, 46.423937], [29.759972, 46.349988], [29.170654, 46.379262], [29.072107, 46.517678], [28.862972, 46.437889], [28.933717, 46.25883], [28.659987, 45.939987], [28.485269, 45.596907], [28.233554, 45.488283], [28.054443, 45.944586], [28.160018, 46.371563], [28.12803, 46.810476], [27.551166, 47.405117], [27.233873, 47.826771], [26.924176, 48.123264], [26.619337, 48.220726]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Madagascar",
      TYPE: "Sovereign country",
      ADMIN: "Madagascar",
      GEOUNIT: "Madagascar",
      SUBUNIT: "Madagascar",
      NAME: "Madagascar",
      NAME_LONG: "Madagascar",
      ISO_A3: "MDG",
      ISO_A3_EH: "MDG"
    },
    bbox: [43.254187, -25.601434, 50.476537, -12.040557],
    geometry: {
      type: "Polygon",
      coordinates: [[[49.543519, -12.469833], [49.808981, -12.895285], [50.056511, -13.555761], [50.217431, -14.758789], [50.476537, -15.226512], [50.377111, -15.706069], [50.200275, -16.000263], [49.860606, -15.414253], [49.672607, -15.710204], [49.863344, -16.451037], [49.774564, -16.875042], [49.498612, -17.106036], [49.435619, -17.953064], [49.041792, -19.118781], [48.548541, -20.496888], [47.930749, -22.391501], [47.547723, -23.781959], [47.095761, -24.94163], [46.282478, -25.178463], [45.409508, -25.601434], [44.833574, -25.346101], [44.03972, -24.988345], [43.763768, -24.460677], [43.697778, -23.574116], [43.345654, -22.776904], [43.254187, -22.057413], [43.433298, -21.336475], [43.893683, -21.163307], [43.89637, -20.830459], [44.374325, -20.072366], [44.464397, -19.435454], [44.232422, -18.961995], [44.042976, -18.331387], [43.963084, -17.409945], [44.312469, -16.850496], [44.446517, -16.216219], [44.944937, -16.179374], [45.502732, -15.974373], [45.872994, -15.793454], [46.312243, -15.780018], [46.882183, -15.210182], [47.70513, -14.594303], [48.005215, -14.091233], [47.869047, -13.663869], [48.293828, -13.784068], [48.84506, -13.089175], [48.863509, -12.487868], [49.194651, -12.040557], [49.543519, -12.469833]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Mexico",
      TYPE: "Sovereign country",
      ADMIN: "Mexico",
      GEOUNIT: "Mexico",
      SUBUNIT: "Mexico",
      NAME: "Mexico",
      NAME_LONG: "Mexico",
      ISO_A3: "MEX",
      ISO_A3_EH: "MEX"
    },
    bbox: [-117.12776, 14.538829, -86.811982, 32.72083],
    geometry: {
      type: "Polygon",
      coordinates: [[[-88.300031, 18.499982], [-88.490123, 18.486831], [-88.848344, 17.883198], [-89.029857, 18.001511], [-89.150909, 17.955468], [-89.14308, 17.808319], [-90.067934, 17.819326], [-91.00152, 17.817595], [-91.002269, 17.254658], [-91.453921, 17.252177], [-91.08167, 16.918477], [-90.711822, 16.687483], [-90.600847, 16.470778], [-90.438867, 16.41011], [-90.464473, 16.069562], [-91.74796, 16.066565], [-92.229249, 15.251447], [-92.087216, 15.064585], [-92.20323, 14.830103], [-92.22775, 14.538829], [-93.359464, 15.61543], [-93.875169, 15.940164], [-94.691656, 16.200975], [-95.250227, 16.128318], [-96.053382, 15.752088], [-96.557434, 15.653515], [-97.263592, 15.917065], [-98.01303, 16.107312], [-98.947676, 16.566043], [-99.697397, 16.706164], [-100.829499, 17.171071], [-101.666089, 17.649026], [-101.918528, 17.91609], [-102.478132, 17.975751], [-103.50099, 18.292295], [-103.917527, 18.748572], [-104.99201, 19.316134], [-105.493038, 19.946767], [-105.731396, 20.434102], [-105.397773, 20.531719], [-105.500661, 20.816895], [-105.270752, 21.076285], [-105.265817, 21.422104], [-105.603161, 21.871146], [-105.693414, 22.26908], [-106.028716, 22.773752], [-106.90998, 23.767774], [-107.915449, 24.548915], [-108.401905, 25.172314], [-109.260199, 25.580609], [-109.444089, 25.824884], [-109.291644, 26.442934], [-109.801458, 26.676176], [-110.391732, 27.162115], [-110.641019, 27.859876], [-111.178919, 27.941241], [-111.759607, 28.467953], [-112.228235, 28.954409], [-112.271824, 29.266844], [-112.809594, 30.021114], [-113.163811, 30.786881], [-113.148669, 31.170966], [-113.871881, 31.567608], [-114.205737, 31.524045], [-114.776451, 31.799532], [-114.9367, 31.393485], [-114.771232, 30.913617], [-114.673899, 30.162681], [-114.330974, 29.750432], [-113.588875, 29.061611], [-113.424053, 28.826174], [-113.271969, 28.754783], [-113.140039, 28.411289], [-112.962298, 28.42519], [-112.761587, 27.780217], [-112.457911, 27.525814], [-112.244952, 27.171727], [-111.616489, 26.662817], [-111.284675, 25.73259], [-110.987819, 25.294606], [-110.710007, 24.826004], [-110.655049, 24.298595], [-110.172856, 24.265548], [-109.771847, 23.811183], [-109.409104, 23.364672], [-109.433392, 23.185588], [-109.854219, 22.818272], [-110.031392, 22.823078], [-110.295071, 23.430973], [-110.949501, 24.000964], [-111.670568, 24.484423], [-112.182036, 24.738413], [-112.148989, 25.470125], [-112.300711, 26.012004], [-112.777297, 26.32196], [-113.464671, 26.768186], [-113.59673, 26.63946], [-113.848937, 26.900064], [-114.465747, 27.14209], [-115.055142, 27.722727], [-114.982253, 27.7982], [-114.570366, 27.741485], [-114.199329, 28.115003], [-114.162018, 28.566112], [-114.931842, 29.279479], [-115.518654, 29.556362], [-115.887365, 30.180794], [-116.25835, 30.836464], [-116.721526, 31.635744], [-117.12776, 32.53534], [-115.99135, 32.61239], [-114.72139, 32.72083], [-114.815, 32.52528], [-113.30498, 32.03914], [-111.02361, 31.33472], [-109.035, 31.34194], [-108.24194, 31.34222], [-108.24, 31.754854], [-106.50759, 31.75452], [-106.1429, 31.39995], [-105.63159, 31.08383], [-105.03737, 30.64402], [-104.70575, 30.12173], [-104.45697, 29.57196], [-103.94, 29.27], [-103.11, 28.97], [-102.48, 29.76], [-101.6624, 29.7793], [-100.9576, 29.38071], [-100.45584, 28.69612], [-100.11, 28.11], [-99.52, 27.54], [-99.3, 26.84], [-99.02, 26.37], [-98.24, 26.06], [-97.53, 25.84], [-97.140008, 25.869997], [-97.528072, 24.992144], [-97.702946, 24.272343], [-97.776042, 22.93258], [-97.872367, 22.444212], [-97.699044, 21.898689], [-97.38896, 21.411019], [-97.189333, 20.635433], [-96.525576, 19.890931], [-96.292127, 19.320371], [-95.900885, 18.828024], [-94.839063, 18.562717], [-94.42573, 18.144371], [-93.548651, 18.423837], [-92.786114, 18.524839], [-92.037348, 18.704569], [-91.407903, 18.876083], [-90.77187, 19.28412], [-90.53359, 19.867418], [-90.451476, 20.707522], [-90.278618, 20.999855], [-89.601321, 21.261726], [-88.543866, 21.493675], [-87.658417, 21.458846], [-87.05189, 21.543543], [-86.811982, 21.331515], [-86.845908, 20.849865], [-87.383291, 20.255405], [-87.621054, 19.646553], [-87.43675, 19.472403], [-87.58656, 19.04013], [-87.837191, 18.259816], [-88.090664, 18.516648], [-88.300031, 18.499982]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Macedonia",
      TYPE: "Sovereign country",
      ADMIN: "Macedonia",
      GEOUNIT: "Macedonia",
      SUBUNIT: "Macedonia",
      NAME: "Macedonia",
      NAME_LONG: "Macedonia",
      ISO_A3: "MKD",
      ISO_A3_EH: "MKD"
    },
    bbox: [20.463175, 40.842727, 22.952377, 42.32026],
    geometry: {
      type: "Polygon",
      coordinates: [[[21.02004, 40.842727], [20.605182, 41.086226], [20.463175, 41.515089], [20.590247, 41.855404], [20.590247, 41.855409], [20.71731, 41.84711], [20.76216, 42.05186], [21.3527, 42.2068], [21.576636, 42.245224], [21.91708, 42.30364], [22.380526, 42.32026], [22.881374, 41.999297], [22.952377, 41.337994], [22.76177, 41.3048], [22.597308, 41.130487], [22.055378, 41.149866], [21.674161, 40.931275], [21.02004, 40.842727]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Mali",
      TYPE: "Sovereign country",
      ADMIN: "Mali",
      GEOUNIT: "Mali",
      SUBUNIT: "Mali",
      NAME: "Mali",
      NAME_LONG: "Mali",
      ISO_A3: "MLI",
      ISO_A3_EH: "MLI"
    },
    bbox: [-12.17075, 10.096361, 4.27021, 24.974574],
    geometry: {
      type: "Polygon",
      coordinates: [[[0.374892, 14.928908], [-0.266257, 14.924309], [-0.515854, 15.116158], [-1.066363, 14.973815], [-2.001035, 14.559008], [-2.191825, 14.246418], [-2.967694, 13.79815], [-3.103707, 13.541267], [-3.522803, 13.337662], [-4.006391, 13.472485], [-4.280405, 13.228444], [-4.427166, 12.542646], [-5.220942, 11.713859], [-5.197843, 11.375146], [-5.470565, 10.95127], [-5.404342, 10.370737], [-5.816926, 10.222555], [-6.050452, 10.096361], [-6.205223, 10.524061], [-6.493965, 10.411303], [-6.666461, 10.430811], [-6.850507, 10.138994], [-7.622759, 10.147236], [-7.89959, 10.297382], [-8.029944, 10.206535], [-8.335377, 10.494812], [-8.282357, 10.792597], [-8.407311, 10.909257], [-8.620321, 10.810891], [-8.581305, 11.136246], [-8.376305, 11.393646], [-8.786099, 11.812561], [-8.905265, 12.088358], [-9.127474, 12.30806], [-9.327616, 12.334286], [-9.567912, 12.194243], [-9.890993, 12.060479], [-10.165214, 11.844084], [-10.593224, 11.923975], [-10.87083, 12.177887], [-11.036556, 12.211245], [-11.297574, 12.077971], [-11.456169, 12.076834], [-11.513943, 12.442988], [-11.467899, 12.754519], [-11.553398, 13.141214], [-11.927716, 13.422075], [-12.124887, 13.994727], [-12.17075, 14.616834], [-11.834208, 14.799097], [-11.666078, 15.388208], [-11.349095, 15.411256], [-10.650791, 15.132746], [-10.086846, 15.330486], [-9.700255, 15.264107], [-9.550238, 15.486497], [-5.537744, 15.50169], [-5.315277, 16.201854], [-5.488523, 16.325102], [-5.971129, 20.640833], [-6.453787, 24.956591], [-4.923337, 24.974574], [-1.550055, 22.792666], [1.823228, 20.610809], [2.060991, 20.142233], [2.683588, 19.85623], [3.146661, 19.693579], [3.158133, 19.057364], [4.267419, 19.155265], [4.27021, 16.852227], [3.723422, 16.184284], [3.638259, 15.56812], [2.749993, 15.409525], [1.385528, 15.323561], [1.015783, 14.968182], [0.374892, 14.928908]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Myanmar",
      TYPE: "Sovereign country",
      ADMIN: "Myanmar",
      GEOUNIT: "Myanmar",
      SUBUNIT: "Myanmar",
      NAME: "Myanmar",
      NAME_LONG: "Myanmar",
      ISO_A3: "MMR",
      ISO_A3_EH: "MMR"
    },
    bbox: [92.303234, 9.93296, 101.180005, 28.335945],
    geometry: {
      type: "Polygon",
      coordinates: [[[92.368554, 20.670883], [92.303234, 21.475485], [92.652257, 21.324048], [92.672721, 22.041239], [93.166128, 22.27846], [93.060294, 22.703111], [93.286327, 23.043658], [93.325188, 24.078556], [94.106742, 23.850741], [94.552658, 24.675238], [94.603249, 25.162495], [95.155153, 26.001307], [95.124768, 26.573572], [96.419366, 27.264589], [97.133999, 27.083774], [97.051989, 27.699059], [97.402561, 27.882536], [97.327114, 28.261583], [97.911988, 28.335945], [98.246231, 27.747221], [98.68269, 27.508812], [98.712094, 26.743536], [98.671838, 25.918703], [97.724609, 25.083637], [97.60472, 23.897405], [98.660262, 24.063286], [98.898749, 23.142722], [99.531992, 22.949039], [99.240899, 22.118314], [99.983489, 21.742937], [100.416538, 21.558839], [101.150033, 21.849984], [101.180005, 21.436573], [100.329101, 20.786122], [100.115988, 20.41785], [99.543309, 20.186598], [98.959676, 19.752981], [98.253724, 19.708203], [97.797783, 18.62708], [97.375896, 18.445438], [97.859123, 17.567946], [98.493761, 16.837836], [98.903348, 16.177824], [98.537376, 15.308497], [98.192074, 15.123703], [98.430819, 14.622028], [99.097755, 13.827503], [99.212012, 13.269294], [99.196354, 12.804748], [99.587286, 11.892763], [99.038121, 10.960546], [98.553551, 9.93296], [98.457174, 10.675266], [98.764546, 11.441292], [98.428339, 12.032987], [98.509574, 13.122378], [98.103604, 13.64046], [97.777732, 14.837286], [97.597072, 16.100568], [97.16454, 16.928734], [96.505769, 16.427241], [95.369352, 15.71439], [94.808405, 15.803454], [94.188804, 16.037936], [94.533486, 17.27724], [94.324817, 18.213514], [93.540988, 19.366493], [93.663255, 19.726962], [93.078278, 19.855145], [92.368554, 20.670883]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Montenegro",
      TYPE: "Sovereign country",
      ADMIN: "Montenegro",
      GEOUNIT: "Montenegro",
      SUBUNIT: "Montenegro",
      NAME: "Montenegro",
      NAME_LONG: "Montenegro",
      ISO_A3: "MNE",
      ISO_A3_EH: "MNE"
    },
    bbox: [18.450017, 41.877551, 20.3398, 43.52384],
    geometry: {
      type: "Polygon",
      coordinates: [[[20.0707, 42.58863], [19.801613, 42.500093], [19.738051, 42.688247], [19.304486, 42.195745], [19.371768, 41.877551], [19.16246, 41.95502], [18.88214, 42.28151], [18.450017, 42.479992], [18.56, 42.65], [18.70648, 43.20011], [19.03165, 43.43253], [19.21852, 43.52384], [19.48389, 43.35229], [19.63, 43.21378], [19.95857, 43.10604], [20.3398, 42.89852], [20.25758, 42.81275], [20.0707, 42.58863]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Mongolia",
      TYPE: "Sovereign country",
      ADMIN: "Mongolia",
      GEOUNIT: "Mongolia",
      SUBUNIT: "Mongolia",
      NAME: "Mongolia",
      NAME_LONG: "Mongolia",
      ISO_A3: "MNG",
      ISO_A3_EH: "MNG"
    },
    bbox: [87.751264, 41.59741, 119.772824, 52.047366],
    geometry: {
      type: "Polygon",
      coordinates: [[[116.678801, 49.888531], [116.191802, 49.134598], [115.485282, 48.135383], [115.742837, 47.726545], [116.308953, 47.85341], [117.295507, 47.697709], [118.064143, 48.06673], [118.866574, 47.74706], [119.772824, 47.048059], [119.66327, 46.69268], [118.874326, 46.805412], [117.421701, 46.672733], [116.717868, 46.388202], [115.985096, 45.727235], [114.460332, 45.339817], [113.463907, 44.808893], [112.436062, 45.011646], [111.873306, 45.102079], [111.348377, 44.457442], [111.667737, 44.073176], [111.829588, 43.743118], [111.129682, 43.406834], [110.412103, 42.871234], [109.243596, 42.519446], [107.744773, 42.481516], [106.129316, 42.134328], [104.964994, 41.59741], [104.522282, 41.908347], [103.312278, 41.907468], [101.83304, 42.514873], [100.845866, 42.663804], [99.515817, 42.524691], [97.451757, 42.74889], [96.349396, 42.725635], [95.762455, 43.319449], [95.306875, 44.241331], [94.688929, 44.352332], [93.480734, 44.975472], [92.133891, 45.115076], [90.94554, 45.286073], [90.585768, 45.719716], [90.970809, 46.888146], [90.280826, 47.693549], [88.854298, 48.069082], [88.013832, 48.599463], [87.751264, 49.297198], [88.805567, 49.470521], [90.713667, 50.331812], [92.234712, 50.802171], [93.10421, 50.49529], [94.147566, 50.480537], [94.815949, 50.013433], [95.81402, 49.97746], [97.25976, 49.72605], [98.231762, 50.422401], [97.82574, 51.010995], [98.861491, 52.047366], [99.981732, 51.634006], [100.88948, 51.516856], [102.06521, 51.25991], [102.25589, 50.51056], [103.676545, 50.089966], [104.62158, 50.27532], [105.886591, 50.406019], [106.888804, 50.274296], [107.868176, 49.793705], [108.475167, 49.282548], [109.402449, 49.292961], [110.662011, 49.130128], [111.581231, 49.377968], [112.89774, 49.543565], [114.362456, 50.248303], [114.96211, 50.140247], [115.485695, 49.805177], [116.678801, 49.888531]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Mozambique",
      TYPE: "Sovereign country",
      ADMIN: "Mozambique",
      GEOUNIT: "Mozambique",
      SUBUNIT: "Mozambique",
      NAME: "Mozambique",
      NAME_LONG: "Mozambique",
      ISO_A3: "MOZ",
      ISO_A3_EH: "MOZ"
    },
    bbox: [30.179481, -26.742192, 40.775475, -10.317096],
    geometry: {
      type: "Polygon",
      coordinates: [[[34.559989, -11.52002], [35.312398, -11.439146], [36.514082, -11.720938], [36.775151, -11.594537], [37.47129, -11.56876], [37.82764, -11.26879], [38.427557, -11.285202], [39.521, -10.89688], [40.31659, -10.3171], [40.316586, -10.317098], [40.316589, -10.317096], [40.478387, -10.765441], [40.437253, -11.761711], [40.560811, -12.639177], [40.59962, -14.201975], [40.775475, -14.691764], [40.477251, -15.406294], [40.089264, -16.100774], [39.452559, -16.720891], [38.538351, -17.101023], [37.411133, -17.586368], [36.281279, -18.659688], [35.896497, -18.84226], [35.1984, -19.552811], [34.786383, -19.784012], [34.701893, -20.497043], [35.176127, -21.254361], [35.373428, -21.840837], [35.385848, -22.14], [35.562546, -22.09], [35.533935, -23.070788], [35.371774, -23.535359], [35.60747, -23.706563], [35.458746, -24.12261], [35.040735, -24.478351], [34.215824, -24.816314], [33.01321, -25.357573], [32.574632, -25.727318], [32.660363, -26.148584], [32.915955, -26.215867], [32.83012, -26.742192], [32.071665, -26.73382], [31.985779, -26.29178], [31.837778, -25.843332], [31.752408, -25.484284], [31.930589, -24.369417], [31.670398, -23.658969], [31.191409, -22.25151], [32.244988, -21.116489], [32.508693, -20.395292], [32.659743, -20.30429], [32.772708, -19.715592], [32.611994, -19.419383], [32.654886, -18.67209], [32.849861, -17.979057], [32.847639, -16.713398], [32.328239, -16.392074], [31.852041, -16.319417], [31.636498, -16.07199], [31.173064, -15.860944], [30.338955, -15.880839], [30.274256, -15.507787], [30.179481, -14.796099], [33.214025, -13.97186], [33.7897, -14.451831], [34.064825, -14.35995], [34.459633, -14.61301], [34.517666, -15.013709], [34.307291, -15.478641], [34.381292, -16.18356], [35.03381, -16.8013], [35.339063, -16.10744], [35.771905, -15.896859], [35.686845, -14.611046], [35.267956, -13.887834], [34.907151, -13.565425], [34.559989, -13.579998], [34.280006, -12.280025], [34.559989, -11.52002]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Mauritania",
      TYPE: "Sovereign country",
      ADMIN: "Mauritania",
      GEOUNIT: "Mauritania",
      SUBUNIT: "Mauritania",
      NAME: "Mauritania",
      NAME_LONG: "Mauritania",
      ISO_A3: "MRT",
      ISO_A3_EH: "MRT"
    },
    bbox: [-17.063423, 14.616834, -4.923337, 27.395744],
    geometry: {
      type: "Polygon",
      coordinates: [[[-8.6844, 27.395744], [-4.923337, 24.974574], [-6.453787, 24.956591], [-5.971129, 20.640833], [-5.488523, 16.325102], [-5.315277, 16.201854], [-5.537744, 15.50169], [-9.550238, 15.486497], [-9.700255, 15.264107], [-10.086846, 15.330486], [-10.650791, 15.132746], [-11.349095, 15.411256], [-11.666078, 15.388208], [-11.834208, 14.799097], [-12.17075, 14.616834], [-12.830658, 15.303692], [-13.435738, 16.039383], [-14.099521, 16.304302], [-14.577348, 16.598264], [-15.135737, 16.587282], [-15.623666, 16.369337], [-16.12069, 16.455663], [-16.463098, 16.135036], [-16.549708, 16.673892], [-16.270552, 17.166963], [-16.146347, 18.108482], [-16.256883, 19.096716], [-16.377651, 19.593817], [-16.277838, 20.092521], [-16.536324, 20.567866], [-17.063423, 20.999752], [-16.845194, 21.333323], [-12.929102, 21.327071], [-13.118754, 22.77122], [-12.874222, 23.284832], [-11.937224, 23.374594], [-11.969419, 25.933353], [-8.687294, 25.881056], [-8.6844, 27.395744]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Malawi",
      TYPE: "Sovereign country",
      ADMIN: "Malawi",
      GEOUNIT: "Malawi",
      SUBUNIT: "Malawi",
      NAME: "Malawi",
      NAME_LONG: "Malawi",
      ISO_A3: "MWI",
      ISO_A3_EH: "MWI"
    },
    bbox: [32.688165, -16.8013, 35.771905, -9.230599],
    geometry: {
      type: "Polygon",
      coordinates: [[[34.559989, -11.52002], [34.280006, -12.280025], [34.559989, -13.579998], [34.907151, -13.565425], [35.267956, -13.887834], [35.686845, -14.611046], [35.771905, -15.896859], [35.339063, -16.10744], [35.03381, -16.8013], [34.381292, -16.18356], [34.307291, -15.478641], [34.517666, -15.013709], [34.459633, -14.61301], [34.064825, -14.35995], [33.7897, -14.451831], [33.214025, -13.97186], [32.688165, -13.712858], [32.991764, -12.783871], [33.306422, -12.435778], [33.114289, -11.607198], [33.31531, -10.79655], [33.485688, -10.525559], [33.231388, -9.676722], [32.759375, -9.230599], [33.73972, -9.41715], [33.940838, -9.693674], [34.28, -10.16], [34.559989, -11.52002]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Malaysia",
      TYPE: "Sovereign country",
      ADMIN: "Malaysia",
      GEOUNIT: "Malaysia",
      SUBUNIT: "Malaysia",
      NAME: "Malaysia",
      NAME_LONG: "Malaysia",
      ISO_A3: "MYS",
      ISO_A3_EH: "MYS"
    },
    bbox: [100.085757, 0.773131, 119.181904, 6.928053],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[114.204017, 4.525874], [114.659596, 4.007637], [114.869557, 4.348314], [115.347461, 4.316636], [115.4057, 4.955228], [115.45071, 5.44773], [116.220741, 6.143191], [116.725103, 6.924771], [117.129626, 6.928053], [117.643393, 6.422166], [117.689075, 5.98749], [118.347691, 5.708696], [119.181904, 5.407836], [119.110694, 5.016128], [118.439727, 4.966519], [118.618321, 4.478202], [117.882035, 4.137551], [117.015214, 4.306094], [115.865517, 4.306559], [115.519078, 3.169238], [115.134037, 2.821482], [114.621355, 1.430688], [113.80585, 1.217549], [112.859809, 1.49779], [112.380252, 1.410121], [111.797548, 0.904441], [111.159138, 0.976478], [110.514061, 0.773131], [109.830227, 1.338136], [109.66326, 2.006467], [110.396135, 1.663775], [111.168853, 1.850637], [111.370081, 2.697303], [111.796928, 2.885897], [112.995615, 3.102395], [113.712935, 3.893509], [114.204017, 4.525874]]], [[[102.141187, 6.221636], [102.371147, 6.128205], [102.961705, 5.524495], [103.381215, 4.855001], [103.438575, 4.181606], [103.332122, 3.726698], [103.429429, 3.382869], [103.502448, 2.791019], [103.854674, 2.515454], [104.247932, 1.631141], [104.228811, 1.293048], [103.519707, 1.226334], [102.573615, 1.967115], [101.390638, 2.760814], [101.27354, 3.270292], [100.695435, 3.93914], [100.557408, 4.76728], [100.196706, 5.312493], [100.30626, 6.040562], [100.085757, 6.464489], [100.259596, 6.642825], [101.075516, 6.204867], [101.154219, 5.691384], [101.814282, 5.810808], [102.141187, 6.221636]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Namibia",
      TYPE: "Sovereign country",
      ADMIN: "Namibia",
      GEOUNIT: "Namibia",
      SUBUNIT: "Namibia",
      NAME: "Namibia",
      NAME_LONG: "Namibia",
      ISO_A3: "NAM",
      ISO_A3_EH: "NAM"
    },
    bbox: [11.734199, -29.045462, 25.084443, -16.941343],
    geometry: {
      type: "Polygon",
      coordinates: [[[11.734199, -17.301889], [12.215461, -17.111668], [12.814081, -16.941343], [13.462362, -16.971212], [14.058501, -17.423381], [14.209707, -17.353101], [18.263309, -17.309951], [18.956187, -17.789095], [21.377176, -17.930636], [23.215048, -17.523116], [24.033862, -17.295843], [24.682349, -17.353411], [25.07695, -17.578823], [25.084443, -17.661816], [24.520705, -17.887125], [24.217365, -17.889347], [23.579006, -18.281261], [23.196858, -17.869038], [21.65504, -18.219146], [20.910641, -18.252219], [20.881134, -21.814327], [19.895458, -21.849157], [19.895768, -24.76779], [19.894734, -28.461105], [19.002127, -28.972443], [18.464899, -29.045462], [17.836152, -28.856378], [17.387497, -28.783514], [17.218929, -28.355943], [16.824017, -28.082162], [16.344977, -28.576705], [15.601818, -27.821247], [15.210472, -27.090956], [14.989711, -26.117372], [14.743214, -25.39292], [14.408144, -23.853014], [14.385717, -22.656653], [14.257714, -22.111208], [13.868642, -21.699037], [13.352498, -20.872834], [12.826845, -19.673166], [12.608564, -19.045349], [11.794919, -18.069129], [11.734199, -17.301889]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "France",
      ISO_A3: "FRA",
      TYPE: "Dependency",
      ADMIN: "New Caledonia",
      GEOUNIT: "New Caledonia",
      SUBUNIT: "New Caledonia",
      NAME: "New Caledonia",
      NAME_LONG: "New Caledonia",
      ISO_A3_EH: "NCL"
    },
    bbox: [164.029606, -22.399976, 167.120011, -20.105646],
    geometry: {
      type: "Polygon",
      coordinates: [[[165.77999, -21.080005], [166.599991, -21.700019], [167.120011, -22.159991], [166.740035, -22.399976], [166.189732, -22.129708], [165.474375, -21.679607], [164.829815, -21.14982], [164.167995, -20.444747], [164.029606, -20.105646], [164.459967, -20.120012], [165.020036, -20.459991], [165.460009, -20.800022], [165.77999, -21.080005]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Niger",
      TYPE: "Sovereign country",
      ADMIN: "Niger",
      GEOUNIT: "Niger",
      SUBUNIT: "Niger",
      NAME: "Niger",
      NAME_LONG: "Niger",
      ISO_A3: "NER",
      ISO_A3_EH: "NER"
    },
    bbox: [0.295646, 11.660167, 15.903247, 23.471668],
    geometry: {
      type: "Polygon",
      coordinates: [[[3.61118, 11.660167], [2.848643, 12.235636], [2.490164, 12.233052], [2.154474, 11.94015], [2.177108, 12.625018], [1.024103, 12.851826], [0.993046, 13.33575], [0.429928, 13.988733], [0.295646, 14.444235], [0.374892, 14.928908], [1.015783, 14.968182], [1.385528, 15.323561], [2.749993, 15.409525], [3.638259, 15.56812], [3.723422, 16.184284], [4.27021, 16.852227], [4.267419, 19.155265], [5.677566, 19.601207], [8.572893, 21.565661], [11.999506, 23.471668], [13.581425, 23.040506], [14.143871, 22.491289], [14.8513, 22.86295], [15.096888, 21.308519], [15.47106, 21.04845], [15.487148, 20.730415], [15.903247, 20.387619], [15.685741, 19.95718], [15.300441, 17.92795], [15.247731, 16.627306], [13.97217, 15.68437], [13.540394, 14.367134], [13.956699, 13.996691], [13.954477, 13.353449], [14.595781, 13.330427], [14.495787, 12.859396], [14.213531, 12.802035], [14.181336, 12.483657], [13.995353, 12.461565], [13.318702, 13.556356], [13.083987, 13.596147], [12.302071, 13.037189], [11.527803, 13.32898], [10.989593, 13.387323], [10.701032, 13.246918], [10.114814, 13.277252], [9.524928, 12.851102], [9.014933, 12.826659], [7.804671, 13.343527], [7.330747, 13.098038], [6.820442, 13.115091], [6.445426, 13.492768], [5.443058, 13.865924], [4.368344, 13.747482], [4.107946, 13.531216], [3.967283, 12.956109], [3.680634, 12.552903], [3.61118, 11.660167]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Nigeria",
      TYPE: "Sovereign country",
      ADMIN: "Nigeria",
      GEOUNIT: "Nigeria",
      SUBUNIT: "Nigeria",
      NAME: "Nigeria",
      NAME_LONG: "Nigeria",
      ISO_A3: "NGA",
      ISO_A3_EH: "NGA"
    },
    bbox: [2.691702, 4.240594, 14.577178, 13.865924],
    geometry: {
      type: "Polygon",
      coordinates: [[[2.691702, 6.258817], [2.749063, 7.870734], [2.723793, 8.506845], [2.912308, 9.137608], [3.220352, 9.444153], [3.705438, 10.06321], [3.60007, 10.332186], [3.797112, 10.734746], [3.572216, 11.327939], [3.61118, 11.660167], [3.680634, 12.552903], [3.967283, 12.956109], [4.107946, 13.531216], [4.368344, 13.747482], [5.443058, 13.865924], [6.445426, 13.492768], [6.820442, 13.115091], [7.330747, 13.098038], [7.804671, 13.343527], [9.014933, 12.826659], [9.524928, 12.851102], [10.114814, 13.277252], [10.701032, 13.246918], [10.989593, 13.387323], [11.527803, 13.32898], [12.302071, 13.037189], [13.083987, 13.596147], [13.318702, 13.556356], [13.995353, 12.461565], [14.181336, 12.483657], [14.577178, 12.085361], [14.468192, 11.904752], [14.415379, 11.572369], [13.57295, 10.798566], [13.308676, 10.160362], [13.1676, 9.640626], [12.955468, 9.417772], [12.753672, 8.717763], [12.218872, 8.305824], [12.063946, 7.799808], [11.839309, 7.397042], [11.745774, 6.981383], [11.058788, 6.644427], [10.497375, 7.055358], [10.118277, 7.03877], [9.522706, 6.453482], [9.233163, 6.444491], [8.757533, 5.479666], [8.500288, 4.771983], [7.462108, 4.412108], [7.082596, 4.464689], [6.698072, 4.240594], [5.898173, 4.262453], [5.362805, 4.887971], [5.033574, 5.611802], [4.325607, 6.270651], [3.57418, 6.2583], [2.691702, 6.258817]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Nicaragua",
      TYPE: "Sovereign country",
      ADMIN: "Nicaragua",
      GEOUNIT: "Nicaragua",
      SUBUNIT: "Nicaragua",
      NAME: "Nicaragua",
      NAME_LONG: "Nicaragua",
      ISO_A3: "NIC",
      ISO_A3_EH: "NIC"
    },
    bbox: [-87.668493, 10.726839, -83.147219, 15.016267],
    geometry: {
      type: "Polygon",
      coordinates: [[[-83.655612, 10.938764], [-83.895054, 10.726839], [-84.190179, 10.79345], [-84.355931, 10.999226], [-84.673069, 11.082657], [-84.903003, 10.952303], [-85.561852, 11.217119], [-85.71254, 11.088445], [-86.058488, 11.403439], [-86.52585, 11.806877], [-86.745992, 12.143962], [-87.167516, 12.458258], [-87.668493, 12.90991], [-87.557467, 13.064552], [-87.392386, 12.914018], [-87.316654, 12.984686], [-87.005769, 13.025794], [-86.880557, 13.254204], [-86.733822, 13.263093], [-86.755087, 13.754845], [-86.520708, 13.778487], [-86.312142, 13.771356], [-86.096264, 14.038187], [-85.801295, 13.836055], [-85.698665, 13.960078], [-85.514413, 14.079012], [-85.165365, 14.35437], [-85.148751, 14.560197], [-85.052787, 14.551541], [-84.924501, 14.790493], [-84.820037, 14.819587], [-84.649582, 14.666805], [-84.449336, 14.621614], [-84.228342, 14.748764], [-83.975721, 14.749436], [-83.628585, 14.880074], [-83.489989, 15.016267], [-83.147219, 14.995829], [-83.233234, 14.899866], [-83.284162, 14.676624], [-83.182126, 14.310703], [-83.4125, 13.970078], [-83.519832, 13.567699], [-83.552207, 13.127054], [-83.498515, 12.869292], [-83.473323, 12.419087], [-83.626104, 12.32085], [-83.719613, 11.893124], [-83.650858, 11.629032], [-83.85547, 11.373311], [-83.808936, 11.103044], [-83.655612, 10.938764]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Netherlands",
      TYPE: "Country",
      ADMIN: "Netherlands",
      GEOUNIT: "Netherlands",
      SUBUNIT: "Netherlands",
      NAME: "Netherlands",
      NAME_LONG: "Netherlands",
      ISO_A3: "NLD",
      ISO_A3_EH: "NLD"
    },
    bbox: [3.314971, 50.803721, 7.092053, 53.510403],
    geometry: {
      type: "Polygon",
      coordinates: [[[6.156658, 50.803721], [5.606976, 51.037298], [4.973991, 51.475024], [4.047071, 51.267259], [3.314971, 51.345755], [3.315011, 51.345777], [3.830289, 51.620545], [4.705997, 53.091798], [6.074183, 53.510403], [6.90514, 53.482162], [7.092053, 53.144043], [6.84287, 52.22844], [6.589397, 51.852029], [5.988658, 51.851616], [6.156658, 50.803721]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Norway",
      TYPE: "Sovereign country",
      ADMIN: "Norway",
      GEOUNIT: "Norway",
      SUBUNIT: "Norway",
      NAME: "Norway",
      NAME_LONG: "Norway",
      ISO_A3: "-99",
      ISO_A3_EH: "-99"
    },
    bbox: [4.992078, 58.078884, 31.293418, 80.657144],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[28.59193, 69.064777], [29.015573, 69.766491], [27.732292, 70.164193], [26.179622, 69.825299], [25.689213, 69.092114], [24.735679, 68.649557], [23.66205, 68.891247], [22.356238, 68.841741], [21.244936, 69.370443], [20.645593, 69.106247], [20.025269, 69.065139], [19.87856, 68.407194], [17.993868, 68.567391], [17.729182, 68.010552], [16.768879, 68.013937], [16.108712, 67.302456], [15.108411, 66.193867], [13.55569, 64.787028], [13.919905, 64.445421], [13.571916, 64.049114], [12.579935, 64.066219], [11.930569, 63.128318], [11.992064, 61.800362], [12.631147, 61.293572], [12.300366, 60.117933], [11.468272, 59.432393], [11.027369, 58.856149], [10.356557, 59.469807], [8.382, 58.313288], [7.048748, 58.078884], [5.665835, 58.588155], [5.308234, 59.663232], [4.992078, 61.970998], [5.9129, 62.614473], [8.553411, 63.454008], [10.527709, 64.486038], [12.358347, 65.879726], [14.761146, 67.810642], [16.435927, 68.563205], [19.184028, 69.817444], [21.378416, 70.255169], [23.023742, 70.202072], [24.546543, 71.030497], [26.37005, 70.986262], [28.165547, 71.185474], [31.293418, 70.453788], [30.005435, 70.186259], [31.101042, 69.558101], [29.39955, 69.15692], [28.59193, 69.064777]]], [[[24.72412, 77.85385], [22.49032, 77.44493], [20.72601, 77.67704], [21.41611, 77.93504], [20.8119, 78.25463], [22.88426, 78.45494], [23.28134, 78.07954], [24.72412, 77.85385]]], [[[18.25183, 79.70175], [21.54383, 78.95611], [19.02737, 78.5626], [18.47172, 77.82669], [17.59441, 77.63796], [17.1182, 76.80941], [15.91315, 76.77045], [13.76259, 77.38035], [14.66956, 77.73565], [13.1706, 78.02493], [11.22231, 78.8693], [10.44453, 79.65239], [13.17077, 80.01046], [13.71852, 79.66039], [15.14282, 79.67431], [15.52255, 80.01608], [16.99085, 80.05086], [18.25183, 79.70175]]], [[[25.447625, 80.40734], [27.407506, 80.056406], [25.924651, 79.517834], [23.024466, 79.400012], [20.075188, 79.566823], [19.897266, 79.842362], [18.462264, 79.85988], [17.368015, 80.318896], [20.455992, 80.598156], [21.907945, 80.357679], [22.919253, 80.657144], [25.447625, 80.40734]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Nepal",
      TYPE: "Sovereign country",
      ADMIN: "Nepal",
      GEOUNIT: "Nepal",
      SUBUNIT: "Nepal",
      NAME: "Nepal",
      NAME_LONG: "Nepal",
      ISO_A3: "NPL",
      ISO_A3_EH: "NPL"
    },
    bbox: [80.088425, 26.397898, 88.174804, 30.422717],
    geometry: {
      type: "Polygon",
      coordinates: [[[81.111256, 30.183481], [81.525804, 30.422717], [82.327513, 30.115268], [83.337115, 29.463732], [83.898993, 29.320226], [84.23458, 28.839894], [85.011638, 28.642774], [85.82332, 28.203576], [86.954517, 27.974262], [88.120441, 27.876542], [88.043133, 27.445819], [88.174804, 26.810405], [88.060238, 26.414615], [87.227472, 26.397898], [86.024393, 26.630985], [85.251779, 26.726198], [84.675018, 27.234901], [83.304249, 27.364506], [81.999987, 27.925479], [81.057203, 28.416095], [80.088425, 28.79447], [80.476721, 29.729865], [81.111256, 30.183481]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "New Zealand",
      TYPE: "Country",
      ADMIN: "New Zealand",
      GEOUNIT: "New Zealand",
      SUBUNIT: "New Zealand",
      NAME: "New Zealand",
      NAME_LONG: "New Zealand",
      ISO_A3: "NZL",
      ISO_A3_EH: "NZL"
    },
    bbox: [166.509144, -46.641235, 178.517094, -34.450662],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[173.020375, -40.919052], [173.247234, -41.331999], [173.958405, -40.926701], [174.247587, -41.349155], [174.248517, -41.770008], [173.876447, -42.233184], [173.22274, -42.970038], [172.711246, -43.372288], [173.080113, -43.853344], [172.308584, -43.865694], [171.452925, -44.242519], [171.185138, -44.897104], [170.616697, -45.908929], [169.831422, -46.355775], [169.332331, -46.641235], [168.411354, -46.619945], [167.763745, -46.290197], [166.676886, -46.219917], [166.509144, -45.852705], [167.046424, -45.110941], [168.303763, -44.123973], [168.949409, -43.935819], [169.667815, -43.555326], [170.52492, -43.031688], [171.12509, -42.512754], [171.569714, -41.767424], [171.948709, -41.514417], [172.097227, -40.956104], [172.79858, -40.493962], [173.020375, -40.919052]]], [[[174.612009, -36.156397], [175.336616, -37.209098], [175.357596, -36.526194], [175.808887, -36.798942], [175.95849, -37.555382], [176.763195, -37.881253], [177.438813, -37.961248], [178.010354, -37.579825], [178.517094, -37.695373], [178.274731, -38.582813], [177.97046, -39.166343], [177.206993, -39.145776], [176.939981, -39.449736], [177.032946, -39.879943], [176.885824, -40.065978], [176.508017, -40.604808], [176.01244, -41.289624], [175.239567, -41.688308], [175.067898, -41.425895], [174.650973, -41.281821], [175.22763, -40.459236], [174.900157, -39.908933], [173.824047, -39.508854], [173.852262, -39.146602], [174.574802, -38.797683], [174.743474, -38.027808], [174.697017, -37.381129], [174.292028, -36.711092], [174.319004, -36.534824], [173.840997, -36.121981], [173.054171, -35.237125], [172.636005, -34.529107], [173.007042, -34.450662], [173.551298, -35.006183], [174.32939, -35.265496], [174.612009, -36.156397]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Oman",
      TYPE: "Sovereign country",
      ADMIN: "Oman",
      GEOUNIT: "Oman",
      SUBUNIT: "Oman",
      NAME: "Oman",
      NAME_LONG: "Oman",
      ISO_A3: "OMN",
      ISO_A3_EH: "OMN"
    },
    bbox: [52.00001, 16.651051, 59.80806, 26.395934],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[56.261042, 25.714606], [56.070821, 26.055464], [56.362017, 26.395934], [56.485679, 26.309118], [56.391421, 25.895991], [56.261042, 25.714606]]], [[[55.208341, 22.70833], [55.234489, 23.110993], [55.525841, 23.524869], [55.528632, 23.933604], [55.981214, 24.130543], [55.804119, 24.269604], [55.886233, 24.920831], [56.396847, 24.924732], [56.84514, 24.241673], [57.403453, 23.878594], [58.136948, 23.747931], [58.729211, 23.565668], [59.180502, 22.992395], [59.450098, 22.660271], [59.80806, 22.533612], [59.806148, 22.310525], [59.442191, 21.714541], [59.282408, 21.433886], [58.861141, 21.114035], [58.487986, 20.428986], [58.034318, 20.481437], [57.826373, 20.243002], [57.665762, 19.736005], [57.7887, 19.06757], [57.694391, 18.94471], [57.234264, 18.947991], [56.609651, 18.574267], [56.512189, 18.087113], [56.283521, 17.876067], [55.661492, 17.884128], [55.269939, 17.632309], [55.2749, 17.228354], [54.791002, 16.950697], [54.239253, 17.044981], [53.570508, 16.707663], [53.108573, 16.651051], [52.782184, 17.349742], [52.00001, 19.000003], [54.999982, 19.999994], [55.666659, 22.000001], [55.208341, 22.70833]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Pakistan",
      TYPE: "Sovereign country",
      ADMIN: "Pakistan",
      GEOUNIT: "Pakistan",
      SUBUNIT: "Pakistan",
      NAME: "Pakistan",
      NAME_LONG: "Pakistan",
      ISO_A3: "PAK",
      ISO_A3_EH: "PAK"
    },
    bbox: [60.874248, 23.691965, 77.837451, 37.133031],
    geometry: {
      type: "Polygon",
      coordinates: [[[60.874248, 29.829239], [62.549857, 29.318572], [63.550261, 29.468331], [64.148002, 29.340819], [64.350419, 29.560031], [65.046862, 29.472181], [66.346473, 29.887943], [66.381458, 30.738899], [66.938891, 31.304911], [67.683394, 31.303154], [67.792689, 31.58293], [68.556932, 31.71331], [68.926677, 31.620189], [69.317764, 31.901412], [69.262522, 32.501944], [69.687147, 33.105499], [70.323594, 33.358533], [69.930543, 34.02012], [70.881803, 33.988856], [71.156773, 34.348911], [71.115019, 34.733126], [71.613076, 35.153203], [71.498768, 35.650563], [71.262348, 36.074388], [71.846292, 36.509942], [72.920025, 36.720007], [74.067552, 36.836176], [74.575893, 37.020841], [75.158028, 37.133031], [75.896897, 36.666806], [76.192848, 35.898403], [77.837451, 35.49401], [76.871722, 34.653544], [75.757061, 34.504923], [74.240203, 34.748887], [73.749948, 34.317699], [74.104294, 33.441473], [74.451559, 32.7649], [75.258642, 32.271105], [74.405929, 31.692639], [74.42138, 30.979815], [73.450638, 29.976413], [72.823752, 28.961592], [71.777666, 27.91318], [70.616496, 27.989196], [69.514393, 26.940966], [70.168927, 26.491872], [70.282873, 25.722229], [70.844699, 25.215102], [71.04324, 24.356524], [68.842599, 24.359134], [68.176645, 23.691965], [67.443667, 23.944844], [67.145442, 24.663611], [66.372828, 25.425141], [64.530408, 25.237039], [62.905701, 25.218409], [61.497363, 25.078237], [61.874187, 26.239975], [63.316632, 26.756532], [63.233898, 27.217047], [62.755426, 27.378923], [62.72783, 28.259645], [61.771868, 28.699334], [61.369309, 29.303276], [60.874248, 29.829239]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Panama",
      TYPE: "Sovereign country",
      ADMIN: "Panama",
      GEOUNIT: "Panama",
      SUBUNIT: "Panama",
      NAME: "Panama",
      NAME_LONG: "Panama",
      ISO_A3: "PAN",
      ISO_A3_EH: "PAN"
    },
    bbox: [-82.965783, 7.220541, -77.242566, 9.61161],
    geometry: {
      type: "Polygon",
      coordinates: [[[-77.353361, 8.670505], [-77.474723, 8.524286], [-77.242566, 7.935278], [-77.431108, 7.638061], [-77.753414, 7.70984], [-77.881571, 7.223771], [-78.214936, 7.512255], [-78.429161, 8.052041], [-78.182096, 8.319182], [-78.435465, 8.387705], [-78.622121, 8.718124], [-79.120307, 8.996092], [-79.557877, 8.932375], [-79.760578, 8.584515], [-80.164481, 8.333316], [-80.382659, 8.298409], [-80.480689, 8.090308], [-80.00369, 7.547524], [-80.276671, 7.419754], [-80.421158, 7.271572], [-80.886401, 7.220541], [-81.059543, 7.817921], [-81.189716, 7.647906], [-81.519515, 7.70661], [-81.721311, 8.108963], [-82.131441, 8.175393], [-82.390934, 8.292362], [-82.820081, 8.290864], [-82.850958, 8.073823], [-82.965783, 8.225028], [-82.913176, 8.423517], [-82.829771, 8.626295], [-82.868657, 8.807266], [-82.719183, 8.925709], [-82.927155, 9.07433], [-82.932891, 9.476812], [-82.546196, 9.566135], [-82.187123, 9.207449], [-82.207586, 8.995575], [-81.808567, 8.950617], [-81.714154, 9.031955], [-81.439287, 8.786234], [-80.947302, 8.858504], [-80.521901, 9.111072], [-79.9146, 9.312765], [-79.573303, 9.61161], [-79.021192, 9.552931], [-79.05845, 9.454565], [-78.500888, 9.420459], [-78.055928, 9.24773], [-77.729514, 8.946844], [-77.353361, 8.670505]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Peru",
      TYPE: "Sovereign country",
      ADMIN: "Peru",
      GEOUNIT: "Peru",
      SUBUNIT: "Peru",
      NAME: "Peru",
      NAME_LONG: "Peru",
      ISO_A3: "PER",
      ISO_A3_EH: "PER"
    },
    bbox: [-81.410943, -18.347975, -68.66508, -0.057205],
    geometry: {
      type: "Polygon",
      coordinates: [[[-69.529678, -10.951734], [-68.66508, -12.5613], [-68.88008, -12.899729], [-68.929224, -13.602684], [-68.948887, -14.453639], [-69.339535, -14.953195], [-69.160347, -15.323974], [-69.389764, -15.660129], [-68.959635, -16.500698], [-69.590424, -17.580012], [-69.858444, -18.092694], [-70.372572, -18.347975], [-71.37525, -17.773799], [-71.462041, -17.363488], [-73.44453, -16.359363], [-75.237883, -15.265683], [-76.009205, -14.649286], [-76.423469, -13.823187], [-76.259242, -13.535039], [-77.106192, -12.222716], [-78.092153, -10.377712], [-79.036953, -8.386568], [-79.44592, -7.930833], [-79.760578, -7.194341], [-80.537482, -6.541668], [-81.249996, -6.136834], [-80.926347, -5.690557], [-81.410943, -4.736765], [-81.09967, -4.036394], [-80.302561, -3.404856], [-80.184015, -3.821162], [-80.469295, -4.059287], [-80.442242, -4.425724], [-80.028908, -4.346091], [-79.624979, -4.454198], [-79.205289, -4.959129], [-78.639897, -4.547784], [-78.450684, -3.873097], [-77.837905, -3.003021], [-76.635394, -2.608678], [-75.544996, -1.56161], [-75.233723, -0.911417], [-75.373223, -0.152032], [-75.106625, -0.057205], [-74.441601, -0.53082], [-74.122395, -1.002833], [-73.659504, -1.260491], [-73.070392, -2.308954], [-72.325787, -2.434218], [-71.774761, -2.16979], [-71.413646, -2.342802], [-70.813476, -2.256865], [-70.047709, -2.725156], [-70.692682, -3.742872], [-70.394044, -3.766591], [-69.893635, -4.298187], [-70.794769, -4.251265], [-70.928843, -4.401591], [-71.748406, -4.593983], [-72.891928, -5.274561], [-72.964507, -5.741251], [-73.219711, -6.089189], [-73.120027, -6.629931], [-73.724487, -6.918595], [-73.723401, -7.340999], [-73.987235, -7.52383], [-73.571059, -8.424447], [-73.015383, -9.032833], [-73.226713, -9.462213], [-72.563033, -9.520194], [-72.184891, -10.053598], [-71.302412, -10.079436], [-70.481894, -9.490118], [-70.548686, -11.009147], [-70.093752, -11.123972], [-69.529678, -10.951734]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Philippines",
      TYPE: "Sovereign country",
      ADMIN: "Philippines",
      GEOUNIT: "Philippines",
      SUBUNIT: "Philippines",
      NAME: "Philippines",
      NAME_LONG: "Philippines",
      ISO_A3: "PHL",
      ISO_A3_EH: "PHL"
    },
    bbox: [117.174275, 5.581003, 126.537424, 18.505227],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[126.376814, 8.414706], [126.478513, 7.750354], [126.537424, 7.189381], [126.196773, 6.274294], [125.831421, 7.293715], [125.363852, 6.786485], [125.683161, 6.049657], [125.396512, 5.581003], [124.219788, 6.161355], [123.93872, 6.885136], [124.243662, 7.36061], [123.610212, 7.833527], [123.296071, 7.418876], [122.825506, 7.457375], [122.085499, 6.899424], [121.919928, 7.192119], [122.312359, 8.034962], [122.942398, 8.316237], [123.487688, 8.69301], [123.841154, 8.240324], [124.60147, 8.514158], [124.764612, 8.960409], [125.471391, 8.986997], [125.412118, 9.760335], [126.222714, 9.286074], [126.306637, 8.782487], [126.376814, 8.414706]]], [[[123.982438, 10.278779], [123.623183, 9.950091], [123.309921, 9.318269], [122.995883, 9.022189], [122.380055, 9.713361], [122.586089, 9.981045], [122.837081, 10.261157], [122.947411, 10.881868], [123.49885, 10.940624], [123.337774, 10.267384], [124.077936, 11.232726], [123.982438, 10.278779]]], [[[118.504581, 9.316383], [117.174275, 8.3675], [117.664477, 9.066889], [118.386914, 9.6845], [118.987342, 10.376292], [119.511496, 11.369668], [119.689677, 10.554291], [119.029458, 10.003653], [118.504581, 9.316383]]], [[[121.883548, 11.891755], [122.483821, 11.582187], [123.120217, 11.58366], [123.100838, 11.165934], [122.637714, 10.741308], [122.00261, 10.441017], [121.967367, 10.905691], [122.03837, 11.415841], [121.883548, 11.891755]]], [[[125.502552, 12.162695], [125.783465, 11.046122], [125.011884, 11.311455], [125.032761, 10.975816], [125.277449, 10.358722], [124.801819, 10.134679], [124.760168, 10.837995], [124.459101, 10.88993], [124.302522, 11.495371], [124.891013, 11.415583], [124.87799, 11.79419], [124.266762, 12.557761], [125.227116, 12.535721], [125.502552, 12.162695]]], [[[121.527394, 13.06959], [121.26219, 12.20556], [120.833896, 12.704496], [120.323436, 13.466413], [121.180128, 13.429697], [121.527394, 13.06959]]], [[[121.321308, 18.504065], [121.937601, 18.218552], [122.246006, 18.47895], [122.336957, 18.224883], [122.174279, 17.810283], [122.515654, 17.093505], [122.252311, 16.262444], [121.662786, 15.931018], [121.50507, 15.124814], [121.728829, 14.328376], [122.258925, 14.218202], [122.701276, 14.336541], [123.950295, 13.782131], [123.855107, 13.237771], [124.181289, 12.997527], [124.077419, 12.536677], [123.298035, 13.027526], [122.928652, 13.55292], [122.671355, 13.185836], [122.03465, 13.784482], [121.126385, 13.636687], [120.628637, 13.857656], [120.679384, 14.271016], [120.991819, 14.525393], [120.693336, 14.756671], [120.564145, 14.396279], [120.070429, 14.970869], [119.920929, 15.406347], [119.883773, 16.363704], [120.286488, 16.034629], [120.390047, 17.599081], [120.715867, 18.505227], [121.321308, 18.504065]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Papua New Guinea",
      TYPE: "Sovereign country",
      ADMIN: "Papua New Guinea",
      GEOUNIT: "Papua New Guinea",
      SUBUNIT: "Papua New Guinea",
      NAME: "Papua New Guinea",
      NAME_LONG: "Papua New Guinea",
      ISO_A3: "PNG",
      ISO_A3_EH: "PNG"
    },
    bbox: [141.00021, -10.652476, 156.019965, -2.500002],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[141.033852, -9.117893], [141.017057, -5.859022], [141.00021, -2.600151], [142.735247, -3.289153], [144.583971, -3.861418], [145.27318, -4.373738], [145.829786, -4.876498], [145.981922, -5.465609], [147.648073, -6.083659], [147.891108, -6.614015], [146.970905, -6.721657], [147.191874, -7.388024], [148.084636, -8.044108], [148.734105, -9.104664], [149.306835, -9.071436], [149.266631, -9.514406], [150.038728, -9.684318], [149.738798, -9.872937], [150.801628, -10.293687], [150.690575, -10.582713], [150.028393, -10.652476], [149.78231, -10.393267], [148.923138, -10.280923], [147.913018, -10.130441], [147.135443, -9.492444], [146.567881, -8.942555], [146.048481, -8.067414], [144.744168, -7.630128], [143.897088, -7.91533], [143.286376, -8.245491], [143.413913, -8.983069], [142.628431, -9.326821], [142.068259, -9.159596], [141.033852, -9.117893]]], [[[155.880026, -6.819997], [155.599991, -6.919991], [155.166994, -6.535931], [154.729192, -5.900828], [154.514114, -5.139118], [154.652504, -5.042431], [154.759991, -5.339984], [155.062918, -5.566792], [155.547746, -6.200655], [156.019965, -6.540014], [155.880026, -6.819997]]], [[[151.982796, -5.478063], [151.459107, -5.56028], [151.30139, -5.840728], [150.754447, -6.083763], [150.241197, -6.317754], [149.709963, -6.316513], [148.890065, -6.02604], [148.318937, -5.747142], [148.401826, -5.437756], [149.298412, -5.583742], [149.845562, -5.505503], [149.99625, -5.026101], [150.139756, -5.001348], [150.236908, -5.53222], [150.807467, -5.455842], [151.089672, -5.113693], [151.647881, -4.757074], [151.537862, -4.167807], [152.136792, -4.14879], [152.338743, -4.312966], [152.318693, -4.867661], [151.982796, -5.478063]]], [[[153.140038, -4.499983], [152.827292, -4.766427], [152.638673, -4.176127], [152.406026, -3.789743], [151.953237, -3.462062], [151.384279, -3.035422], [150.66205, -2.741486], [150.939965, -2.500002], [151.479984, -2.779985], [151.820015, -2.999972], [152.239989, -3.240009], [152.640017, -3.659983], [153.019994, -3.980015], [153.140038, -4.499983]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Poland",
      TYPE: "Sovereign country",
      ADMIN: "Poland",
      GEOUNIT: "Poland",
      SUBUNIT: "Poland",
      NAME: "Poland",
      NAME_LONG: "Poland",
      ISO_A3: "POL",
      ISO_A3_EH: "POL"
    },
    bbox: [14.074521, 49.027395, 24.029986, 54.851536],
    geometry: {
      type: "Polygon",
      coordinates: [[[23.484128, 53.912498], [23.527536, 53.470122], [23.804935, 53.089731], [23.799199, 52.691099], [23.199494, 52.486977], [23.508002, 52.023647], [23.527071, 51.578454], [24.029986, 50.705407], [23.922757, 50.424881], [23.426508, 50.308506], [22.51845, 49.476774], [22.776419, 49.027395], [22.558138, 49.085738], [21.607808, 49.470107], [20.887955, 49.328772], [20.415839, 49.431453], [19.825023, 49.217125], [19.320713, 49.571574], [18.909575, 49.435846], [18.853144, 49.49623], [18.392914, 49.988629], [17.649445, 50.049038], [17.554567, 50.362146], [16.868769, 50.473974], [16.719476, 50.215747], [16.176253, 50.422607], [16.238627, 50.697733], [15.490972, 50.78473], [15.016996, 51.106674], [14.607098, 51.745188], [14.685026, 52.089947], [14.4376, 52.62485], [14.074521, 52.981263], [14.353315, 53.248171], [14.119686, 53.757029], [14.8029, 54.050706], [16.363477, 54.513159], [17.622832, 54.851536], [18.620859, 54.682606], [18.696255, 54.438719], [19.66064, 54.426084], [20.892245, 54.312525], [22.731099, 54.327537], [23.243987, 54.220567], [23.484128, 53.912498]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "United States",
      TYPE: "Dependency",
      ADMIN: "Puerto Rico",
      GEOUNIT: "Puerto Rico",
      SUBUNIT: "Puerto Rico",
      NAME: "Puerto Rico",
      NAME_LONG: "Puerto Rico",
      ISO_A3: "PRI",
      ISO_A3_EH: "PRI"
    },
    bbox: [-67.242428, 17.946553, -65.591004, 18.520601],
    geometry: {
      type: "Polygon",
      coordinates: [[[-66.282434, 18.514762], [-65.771303, 18.426679], [-65.591004, 18.228035], [-65.847164, 17.975906], [-66.599934, 17.981823], [-67.184162, 17.946553], [-67.242428, 18.37446], [-67.100679, 18.520601], [-66.282434, 18.514762]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "North Korea",
      TYPE: "Sovereign country",
      ADMIN: "North Korea",
      GEOUNIT: "North Korea",
      SUBUNIT: "North Korea",
      NAME: "North Korea",
      NAME_LONG: "Dem. Rep. Korea",
      ISO_A3: "PRK",
      ISO_A3_EH: "PRK"
    },
    bbox: [124.265625, 37.669071, 130.780007, 42.985387],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[124.265625, 39.928493], [125.079942, 40.569824], [126.182045, 41.107336], [126.869083, 41.816569], [127.343783, 41.503152], [128.208433, 41.466772], [128.052215, 41.994285], [129.596669, 42.424982], [129.994267, 42.985387], [130.64, 42.395024], [130.64, 42.395], [130.779992, 42.22001], [130.400031, 42.280004], [129.965949, 41.941368], [129.667362, 41.601104], [129.705189, 40.882828], [129.188115, 40.661808], [129.0104, 40.485436], [128.633368, 40.189847], [127.967414, 40.025413], [127.533436, 39.75685], [127.50212, 39.323931], [127.385434, 39.213472], [127.783343, 39.050898], [128.349716, 38.612243], [128.205746, 38.370397], [127.780035, 38.304536], [127.073309, 38.256115], [126.68372, 37.804773], [126.237339, 37.840378], [126.174759, 37.749686], [125.689104, 37.94001], [125.568439, 37.752089], [125.27533, 37.669071], [125.240087, 37.857224], [124.981033, 37.948821], [124.712161, 38.108346], [124.985994, 38.548474], [125.221949, 38.665857], [125.132859, 38.848559], [125.38659, 39.387958], [125.321116, 39.551385], [124.737482, 39.660344], [124.265625, 39.928493]]], [[[130.780005, 42.22001], [130.780007, 42.220007], [130.780004, 42.220008], [130.780005, 42.22001]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Portugal",
      TYPE: "Sovereign country",
      ADMIN: "Portugal",
      GEOUNIT: "Portugal",
      SUBUNIT: "Portugal",
      NAME: "Portugal",
      NAME_LONG: "Portugal",
      ISO_A3: "PRT",
      ISO_A3_EH: "PRT"
    },
    bbox: [-9.526571, 36.838269, -6.389088, 42.280469],
    geometry: {
      type: "Polygon",
      coordinates: [[[-9.034818, 41.880571], [-8.671946, 42.134689], [-8.263857, 42.280469], [-8.013175, 41.790886], [-7.422513, 41.792075], [-7.251309, 41.918346], [-6.668606, 41.883387], [-6.389088, 41.381815], [-6.851127, 41.111083], [-6.86402, 40.330872], [-7.026413, 40.184524], [-7.066592, 39.711892], [-7.498632, 39.629571], [-7.098037, 39.030073], [-7.374092, 38.373059], [-7.029281, 38.075764], [-7.166508, 37.803894], [-7.537105, 37.428904], [-7.453726, 37.097788], [-7.855613, 36.838269], [-8.382816, 36.97888], [-8.898857, 36.868809], [-8.746101, 37.651346], [-8.839998, 38.266243], [-9.287464, 38.358486], [-9.526571, 38.737429], [-9.446989, 39.392066], [-9.048305, 39.755093], [-8.977353, 40.159306], [-8.768684, 40.760639], [-8.790853, 41.184334], [-8.990789, 41.543459], [-9.034818, 41.880571]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Paraguay",
      TYPE: "Sovereign country",
      ADMIN: "Paraguay",
      GEOUNIT: "Paraguay",
      SUBUNIT: "Paraguay",
      NAME: "Paraguay",
      NAME_LONG: "Paraguay",
      ISO_A3: "PRY",
      ISO_A3_EH: "PRY"
    },
    bbox: [-62.685057, -27.548499, -54.29296, -19.342747],
    geometry: {
      type: "Polygon",
      coordinates: [[[-54.625291, -25.739255], [-54.788795, -26.621786], [-55.695846, -27.387837], [-56.486702, -27.548499], [-57.60976, -27.395899], [-58.618174, -27.123719], [-57.63366, -25.603657], [-57.777217, -25.16234], [-58.807128, -24.771459], [-60.028966, -24.032796], [-60.846565, -23.880713], [-62.685057, -22.249029], [-62.291179, -21.051635], [-62.265961, -20.513735], [-61.786326, -19.633737], [-60.043565, -19.342747], [-59.115042, -19.356906], [-58.183471, -19.868399], [-58.166392, -20.176701], [-57.870674, -20.732688], [-57.937156, -22.090176], [-56.88151, -22.282154], [-56.473317, -22.0863], [-55.797958, -22.35693], [-55.610683, -22.655619], [-55.517639, -23.571998], [-55.400747, -23.956935], [-55.027902, -24.001274], [-54.652834, -23.839578], [-54.29296, -24.021014], [-54.293476, -24.5708], [-54.428946, -25.162185], [-54.625291, -25.739255]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Israel",
      TYPE: "Disputed",
      ADMIN: "Palestine",
      GEOUNIT: "Palestine",
      SUBUNIT: "Palestine",
      NAME: "Palestine",
      NAME_LONG: "Palestine",
      ISO_A3: "PSE",
      ISO_A3_EH: "PSE"
    },
    bbox: [34.927408, 31.353435, 35.545665, 32.532511],
    geometry: {
      type: "Polygon",
      coordinates: [[[35.397561, 31.489086], [34.927408, 31.353435], [34.970507, 31.616778], [35.225892, 31.754341], [34.974641, 31.866582], [35.18393, 32.532511], [35.545665, 32.393992], [35.545252, 31.782505], [35.397561, 31.489086]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Qatar",
      TYPE: "Sovereign country",
      ADMIN: "Qatar",
      GEOUNIT: "Qatar",
      SUBUNIT: "Qatar",
      NAME: "Qatar",
      NAME_LONG: "Qatar",
      ISO_A3: "QAT",
      ISO_A3_EH: "QAT"
    },
    bbox: [50.743911, 24.556331, 51.6067, 26.114582],
    geometry: {
      type: "Polygon",
      coordinates: [[[50.810108, 24.754743], [50.743911, 25.482424], [51.013352, 26.006992], [51.286462, 26.114582], [51.589079, 25.801113], [51.6067, 25.21567], [51.389608, 24.627386], [51.112415, 24.556331], [50.810108, 24.754743]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Romania",
      TYPE: "Sovereign country",
      ADMIN: "Romania",
      GEOUNIT: "Romania",
      SUBUNIT: "Romania",
      NAME: "Romania",
      NAME_LONG: "Romania",
      ISO_A3: "ROU",
      ISO_A3_EH: "ROU"
    },
    bbox: [20.220192, 43.688445, 29.626543, 48.220881],
    geometry: {
      type: "Polygon",
      coordinates: [[[28.558081, 43.707462], [27.970107, 43.812468], [27.2424, 44.175986], [26.065159, 43.943494], [25.569272, 43.688445], [24.100679, 43.741051], [23.332302, 43.897011], [22.944832, 43.823785], [22.65715, 44.234923], [22.474008, 44.409228], [22.705726, 44.578003], [22.459022, 44.702517], [22.145088, 44.478422], [21.562023, 44.768947], [21.483526, 45.18117], [20.874313, 45.416375], [20.762175, 45.734573], [20.220192, 46.127469], [21.021952, 46.316088], [21.626515, 46.994238], [22.099768, 47.672439], [22.710531, 47.882194], [23.142236, 48.096341], [23.760958, 47.985598], [24.402056, 47.981878], [24.866317, 47.737526], [25.207743, 47.891056], [25.945941, 47.987149], [26.19745, 48.220881], [26.619337, 48.220726], [26.924176, 48.123264], [27.233873, 47.826771], [27.551166, 47.405117], [28.12803, 46.810476], [28.160018, 46.371563], [28.054443, 45.944586], [28.233554, 45.488283], [28.679779, 45.304031], [29.149725, 45.464925], [29.603289, 45.293308], [29.626543, 45.035391], [29.141612, 44.82021], [28.837858, 44.913874], [28.558081, 43.707462]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Russia",
      TYPE: "Sovereign country",
      ADMIN: "Russia",
      GEOUNIT: "Russia",
      SUBUNIT: "Russia",
      NAME: "Russia",
      NAME_LONG: "Russian Federation",
      ISO_A3: "RUS",
      ISO_A3_EH: "RUS"
    },
    bbox: [-180, 41.151416, 180, 81.2504],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[48.584353, 41.808869], [47.987283, 41.405819], [47.815666, 41.151416], [47.373315, 41.219732], [46.686071, 41.827137], [46.404951, 41.860675], [45.7764, 42.09244], [45.470279, 42.502781], [44.537623, 42.711993], [43.93121, 42.55496], [43.75599, 42.74083], [42.3944, 43.2203], [40.92219, 43.38215], [40.076965, 43.553104], [39.955009, 43.434998], [38.68, 44.28], [37.53912, 44.65721], [36.67546, 45.24469], [37.40317, 45.40451], [38.23295, 46.24087], [37.67372, 46.63657], [39.14767, 47.04475], [39.1212, 47.26336], [38.223538, 47.10219], [38.255112, 47.5464], [38.77057, 47.82562], [39.738278, 47.898937], [39.89562, 48.23241], [39.67465, 48.78382], [40.080789, 49.30743], [40.06904, 49.60105], [38.594988, 49.926462], [38.010631, 49.915662], [37.39346, 50.383953], [36.626168, 50.225591], [35.356116, 50.577197], [35.37791, 50.77394], [35.022183, 51.207572], [34.224816, 51.255993], [34.141978, 51.566413], [34.391731, 51.768882], [33.7527, 52.335075], [32.715761, 52.238465], [32.412058, 52.288695], [32.15944, 52.06125], [31.785992, 52.101678], [31.78597, 52.10168], [31.540018, 52.742052], [31.305201, 53.073996], [31.49764, 53.16743], [32.304519, 53.132726], [32.693643, 53.351421], [32.405599, 53.618045], [31.731273, 53.794029], [31.791424, 53.974639], [31.384472, 54.157056], [30.757534, 54.811771], [30.971836, 55.081548], [30.873909, 55.550976], [29.896294, 55.789463], [29.371572, 55.670091], [29.229513, 55.918344], [28.176709, 56.16913], [27.855282, 56.759326], [27.770016, 57.244258], [27.288185, 57.474528], [27.716686, 57.791899], [27.42015, 58.72457], [28.131699, 59.300825], [27.98112, 59.47537], [27.981127, 59.475373], [29.1177, 60.02805], [28.070002, 60.503519], [28.07, 60.50352], [30.211107, 61.780028], [31.139991, 62.357693], [31.516092, 62.867687], [30.035872, 63.552814], [30.444685, 64.204453], [29.54443, 64.948672], [30.21765, 65.80598], [29.054589, 66.944286], [29.977426, 67.698297], [28.445944, 68.364613], [28.59193, 69.064777], [29.39955, 69.15692], [31.101042, 69.558101], [31.10108, 69.55811], [32.13272, 69.90595], [33.77547, 69.30142], [36.51396, 69.06342], [40.29234, 67.9324], [41.05987, 67.45713], [41.12595, 66.79158], [40.01583, 66.26618], [38.38295, 65.99953], [33.91871, 66.75961], [33.18444, 66.63253], [34.81477, 65.90015], [34.878574, 65.436213], [34.94391, 64.41437], [36.23129, 64.10945], [37.01273, 63.84983], [37.14197, 64.33471], [36.539579, 64.76446], [37.17604, 65.14322], [39.59345, 64.52079], [40.4356, 64.76446], [39.7626, 65.49682], [42.09309, 66.47623], [43.01604, 66.41858], [43.94975, 66.06908], [44.53226, 66.75634], [43.69839, 67.35245], [44.18795, 67.95051], [43.45282, 68.57079], [46.25, 68.25], [46.82134, 67.68997], [45.55517, 67.56652], [45.56202, 67.01005], [46.34915, 66.66767], [47.89416, 66.88455], [48.13876, 67.52238], [50.22766, 67.99867], [53.71743, 68.85738], [54.47171, 68.80815], [53.48582, 68.20131], [54.72628, 68.09702], [55.44268, 68.43866], [57.31702, 68.46628], [58.802, 68.88082], [59.94142, 68.27844], [61.07784, 68.94069], [60.03, 69.52], [60.55, 69.85], [63.504, 69.54739], [64.888115, 69.234835], [68.51216, 68.09233], [69.18068, 68.61563], [68.16444, 69.14436], [68.13522, 69.35649], [66.93008, 69.45461], [67.25976, 69.92873], [66.72492, 70.70889], [66.69466, 71.02897], [68.54006, 71.9345], [69.19636, 72.84336], [69.94, 73.04], [72.58754, 72.77629], [72.79603, 72.22006], [71.84811, 71.40898], [72.47011, 71.09019], [72.79188, 70.39114], [72.5647, 69.02085], [73.66787, 68.4079], [73.2387, 67.7404], [71.28, 66.32], [72.42301, 66.17267], [72.82077, 66.53267], [73.92099, 66.78946], [74.18651, 67.28429], [75.052, 67.76047], [74.46926, 68.32899], [74.93584, 68.98918], [73.84236, 69.07146], [73.60187, 69.62763], [74.3998, 70.63175], [73.1011, 71.44717], [74.89082, 72.12119], [74.65926, 72.83227], [75.15801, 72.85497], [75.68351, 72.30056], [75.28898, 71.33556], [76.35911, 71.15287], [75.90313, 71.87401], [77.57665, 72.26717], [79.65202, 72.32011], [81.5, 71.75], [80.61071, 72.58285], [80.51109, 73.6482], [82.25, 73.85], [84.65526, 73.80591], [86.8223, 73.93688], [86.00956, 74.45967], [87.16682, 75.11643], [88.31571, 75.14393], [90.26, 75.64], [92.90058, 75.77333], [93.23421, 76.0472], [95.86, 76.14], [96.67821, 75.91548], [98.92254, 76.44689], [100.75967, 76.43028], [101.03532, 76.86189], [101.99084, 77.28754], [104.3516, 77.69792], [106.06664, 77.37389], [104.705, 77.1274], [106.97013, 76.97419], [107.24, 76.48], [108.1538, 76.72335], [111.07726, 76.71], [113.33151, 76.22224], [114.13417, 75.84764], [113.88539, 75.32779], [112.77918, 75.03186], [110.15125, 74.47673], [109.4, 74.18], [110.64, 74.04], [112.11919, 73.78774], [113.01954, 73.97693], [113.52958, 73.33505], [113.96881, 73.59488], [115.56782, 73.75285], [118.77633, 73.58772], [119.02, 73.12], [123.20066, 72.97122], [123.25777, 73.73503], [125.38, 73.56], [126.97644, 73.56549], [128.59126, 73.03871], [129.05157, 72.39872], [128.46, 71.98], [129.71599, 71.19304], [131.28858, 70.78699], [132.2535, 71.8363], [133.85766, 71.38642], [135.56193, 71.65525], [137.49755, 71.34763], [138.23409, 71.62803], [139.86983, 71.48783], [139.14791, 72.41619], [140.46817, 72.84941], [149.5, 72.2], [150.35118, 71.60643], [152.9689, 70.84222], [157.00688, 71.03141], [158.99779, 70.86672], [159.83031, 70.45324], [159.70866, 69.72198], [160.94053, 69.43728], [162.27907, 69.64204], [164.05248, 69.66823], [165.94037, 69.47199], [167.83567, 69.58269], [169.57763, 68.6938], [170.81688, 69.01363], [170.0082, 69.65276], [170.45345, 70.09703], [173.64391, 69.81743], [175.72403, 69.87725], [178.6, 69.4], [180, 68.963636], [180, 64.979709], [179.99281, 64.97433], [178.7072, 64.53493], [177.41128, 64.60821], [178.313, 64.07593], [178.90825, 63.25197], [179.37034, 62.98262], [179.48636, 62.56894], [179.22825, 62.3041], [177.3643, 62.5219], [174.56929, 61.76915], [173.68013, 61.65261], [172.15, 60.95], [170.6985, 60.33618], [170.33085, 59.88177], [168.90046, 60.57355], [166.29498, 59.78855], [165.84, 60.16], [164.87674, 59.7316], [163.53929, 59.86871], [163.21711, 59.21101], [162.01733, 58.24328], [162.05297, 57.83912], [163.19191, 57.61503], [163.05794, 56.15924], [162.12958, 56.12219], [161.70146, 55.28568], [162.11749, 54.85514], [160.36877, 54.34433], [160.02173, 53.20257], [158.53094, 52.95868], [158.23118, 51.94269], [156.78979, 51.01105], [156.42, 51.7], [155.99182, 53.15895], [155.43366, 55.38103], [155.91442, 56.76792], [156.75815, 57.3647], [156.81035, 57.83204], [158.36433, 58.05575], [160.15064, 59.31477], [161.87204, 60.343], [163.66969, 61.1409], [164.47355, 62.55061], [163.25842, 62.46627], [162.65791, 61.6425], [160.12148, 60.54423], [159.30232, 61.77396], [156.72068, 61.43442], [154.21806, 59.75818], [155.04375, 59.14495], [152.81185, 58.88385], [151.26573, 58.78089], [151.33815, 59.50396], [149.78371, 59.65573], [148.54481, 59.16448], [145.48722, 59.33637], [142.19782, 59.03998], [138.95848, 57.08805], [135.12619, 54.72959], [136.70171, 54.60355], [137.19342, 53.97732], [138.1647, 53.75501], [138.80463, 54.25455], [139.90151, 54.18968], [141.34531, 53.08957], [141.37923, 52.23877], [140.59742, 51.23967], [140.51308, 50.04553], [140.06193, 48.44671], [138.55472, 46.99965], [138.21971, 46.30795], [136.86232, 45.1435], [135.51535, 43.989], [134.86939, 43.39821], [133.53687, 42.81147], [132.90627, 42.79849], [132.27807, 43.28456], [130.93587, 42.55274], [130.780005, 42.22001], [130.780004, 42.220008], [130.78, 42.22], [130.779992, 42.22001], [130.64, 42.395], [130.64, 42.395024], [130.633866, 42.903015], [131.144688, 42.92999], [131.288555, 44.11152], [131.02519, 44.96796], [131.883454, 45.321162], [133.09712, 45.14409], [133.769644, 46.116927], [134.11235, 47.21248], [134.50081, 47.57845], [135.026311, 48.47823], [133.373596, 48.183442], [132.50669, 47.78896], [130.98726, 47.79013], [130.582293, 48.729687], [129.397818, 49.4406], [127.6574, 49.76027], [127.287456, 50.739797], [126.939157, 51.353894], [126.564399, 51.784255], [125.946349, 52.792799], [125.068211, 53.161045], [123.57147, 53.4588], [122.245748, 53.431726], [121.003085, 53.251401], [120.177089, 52.753886], [120.725789, 52.516226], [120.7382, 51.96411], [120.18208, 51.64355], [119.27939, 50.58292], [119.288461, 50.142883], [117.879244, 49.510983], [116.678801, 49.888531], [115.485695, 49.805177], [114.96211, 50.140247], [114.362456, 50.248303], [112.89774, 49.543565], [111.581231, 49.377968], [110.662011, 49.130128], [109.402449, 49.292961], [108.475167, 49.282548], [107.868176, 49.793705], [106.888804, 50.274296], [105.886591, 50.406019], [104.62158, 50.27532], [103.676545, 50.089966], [102.25589, 50.51056], [102.06521, 51.25991], [100.88948, 51.516856], [99.981732, 51.634006], [98.861491, 52.047366], [97.82574, 51.010995], [98.231762, 50.422401], [97.25976, 49.72605], [95.81402, 49.97746], [94.815949, 50.013433], [94.147566, 50.480537], [93.10421, 50.49529], [92.234712, 50.802171], [90.713667, 50.331812], [88.805567, 49.470521], [87.751264, 49.297198], [87.35997, 49.214981], [86.829357, 49.826675], [85.54127, 49.692859], [85.11556, 50.117303], [84.416377, 50.3114], [83.935115, 50.889246], [83.383004, 51.069183], [81.945986, 50.812196], [80.568447, 51.388336], [80.03556, 50.864751], [77.800916, 53.404415], [76.525179, 54.177003], [76.8911, 54.490524], [74.38482, 53.54685], [73.425679, 53.48981], [73.508516, 54.035617], [72.22415, 54.376655], [71.180131, 54.133285], [70.865267, 55.169734], [69.068167, 55.38525], [68.1691, 54.970392], [65.66687, 54.60125], [65.178534, 54.354228], [61.4366, 54.00625], [60.978066, 53.664993], [61.699986, 52.979996], [60.739993, 52.719986], [60.927269, 52.447548], [59.967534, 51.96042], [61.588003, 51.272659], [61.337424, 50.79907], [59.932807, 50.842194], [59.642282, 50.545442], [58.36332, 51.06364], [56.77798, 51.04355], [55.71694, 50.62171], [54.532878, 51.02624], [52.328724, 51.718652], [50.766648, 51.692762], [48.702382, 50.605128], [48.577841, 49.87476], [47.54948, 50.454698], [46.751596, 49.356006], [47.043672, 49.152039], [46.466446, 48.394152], [47.31524, 47.71585], [48.05725, 47.74377], [48.694734, 47.075628], [48.59325, 46.56104], [49.10116, 46.39933], [48.64541, 45.80629], [47.67591, 45.64149], [46.68201, 44.6092], [47.59094, 43.66016], [47.49252, 42.98658], [48.58437, 41.80888], [48.584353, 41.808869]]], [[[21.268449, 55.190482], [22.315724, 55.015299], [22.757764, 54.856574], [22.651052, 54.582741], [22.731099, 54.327537], [20.892245, 54.312525], [19.66064, 54.426084], [19.888481, 54.86616], [21.268449, 55.190482]]], [[[143.648007, 50.7476], [144.654148, 48.976391], [143.173928, 49.306551], [142.558668, 47.861575], [143.533492, 46.836728], [143.505277, 46.137908], [142.747701, 46.740765], [142.09203, 45.966755], [141.906925, 46.805929], [142.018443, 47.780133], [141.904445, 48.859189], [142.1358, 49.615163], [142.179983, 50.952342], [141.594076, 51.935435], [141.682546, 53.301966], [142.606934, 53.762145], [142.209749, 54.225476], [142.654786, 54.365881], [142.914616, 53.704578], [143.260848, 52.74076], [143.235268, 51.75666], [143.648007, 50.7476]]], [[[-175.01425, 66.58435], [-174.33983, 66.33556], [-174.57182, 67.06219], [-171.85731, 66.91308], [-169.89958, 65.97724], [-170.89107, 65.54139], [-172.53025, 65.43791], [-172.555, 64.46079], [-172.95533, 64.25269], [-173.89184, 64.2826], [-174.65392, 64.63125], [-175.98353, 64.92288], [-176.20716, 65.35667], [-177.22266, 65.52024], [-178.35993, 65.39052], [-178.90332, 65.74044], [-178.68611, 66.11211], [-179.88377, 65.87456], [-179.43268, 65.40411], [-180, 64.979709], [-180, 68.963636], [-177.55, 68.2], [-174.92825, 67.20589], [-175.01425, 66.58435]]], [[[180, 70.832199], [178.903425, 70.78114], [178.7253, 71.0988], [180, 71.515714], [180, 70.832199]]], [[[-178.69378, 70.89302], [-180, 70.832199], [-180, 71.515714], [-179.871875, 71.55762], [-179.02433, 71.55553], [-177.577945, 71.26948], [-177.663575, 71.13277], [-178.69378, 70.89302]]], [[[143.60385, 73.21244], [142.08763, 73.20544], [140.038155, 73.31692], [139.86312, 73.36983], [140.81171, 73.76506], [142.06207, 73.85758], [143.48283, 73.47525], [143.60385, 73.21244]]], [[[150.73167, 75.08406], [149.575925, 74.68892], [147.977465, 74.778355], [146.11919, 75.17298], [146.358485, 75.49682], [148.22223, 75.345845], [150.73167, 75.08406]]], [[[145.086285, 75.562625], [144.3, 74.82], [140.61381, 74.84768], [138.95544, 74.61148], [136.97439, 75.26167], [137.51176, 75.94917], [138.831075, 76.13676], [141.471615, 76.09289], [145.086285, 75.562625]]], [[[57.535693, 70.720464], [56.944979, 70.632743], [53.677375, 70.762658], [53.412017, 71.206662], [51.601895, 71.474759], [51.455754, 72.014881], [52.478275, 72.229442], [52.444169, 72.774731], [54.427614, 73.627548], [53.50829, 73.749814], [55.902459, 74.627486], [55.631933, 75.081412], [57.868644, 75.60939], [61.170044, 76.251883], [64.498368, 76.439055], [66.210977, 76.809782], [68.15706, 76.939697], [68.852211, 76.544811], [68.180573, 76.233642], [64.637326, 75.737755], [61.583508, 75.260885], [58.477082, 74.309056], [56.986786, 73.333044], [55.419336, 72.371268], [55.622838, 71.540595], [57.535693, 70.720464]]], [[[105.07547, 78.30689], [99.43814, 77.921], [101.2649, 79.23399], [102.08635, 79.34641], [102.837815, 79.28129], [105.37243, 78.71334], [105.07547, 78.30689]]], [[[51.136187, 80.54728], [49.793685, 80.415428], [48.894411, 80.339567], [48.754937, 80.175468], [47.586119, 80.010181], [46.502826, 80.247247], [47.072455, 80.559424], [44.846958, 80.58981], [46.799139, 80.771918], [48.318477, 80.78401], [48.522806, 80.514569], [49.09719, 80.753986], [50.039768, 80.918885], [51.522933, 80.699726], [51.136187, 80.54728]]], [[[99.93976, 78.88094], [97.75794, 78.7562], [94.97259, 79.044745], [93.31288, 79.4265], [92.5454, 80.14379], [91.18107, 80.34146], [93.77766, 81.0246], [95.940895, 81.2504], [97.88385, 80.746975], [100.186655, 79.780135], [99.93976, 78.88094]]]]
    },
    id: 135
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Rwanda",
      TYPE: "Sovereign country",
      ADMIN: "Rwanda",
      GEOUNIT: "Rwanda",
      SUBUNIT: "Rwanda",
      NAME: "Rwanda",
      NAME_LONG: "Rwanda",
      ISO_A3: "RWA",
      ISO_A3_EH: "RWA"
    },
    bbox: [29.024926, -2.917858, 30.816135, -1.134659],
    geometry: {
      type: "Polygon",
      coordinates: [[[30.469674, -2.413855], [29.938359, -2.348487], [29.632176, -2.917858], [29.024926, -2.839258], [29.117479, -2.292211], [29.254835, -2.21511], [29.291887, -1.620056], [29.579466, -1.341313], [29.821519, -1.443322], [30.419105, -1.134659], [30.816135, -1.698914], [30.758309, -2.28725], [30.46967, -2.41383], [30.469674, -2.413855]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Western Sahara",
      TYPE: "Indeterminate",
      ADMIN: "Western Sahara",
      GEOUNIT: "Western Sahara",
      SUBUNIT: "Western Sahara",
      NAME: "W. Sahara",
      NAME_LONG: "Western Sahara",
      ISO_A3: "ESH",
      ISO_A3_EH: "ESH"
    },
    bbox: [-17.063423, 20.999752, -8.665124, 27.656426],
    geometry: {
      type: "Polygon",
      coordinates: [[[-8.66559, 27.656426], [-8.665124, 27.589479], [-8.6844, 27.395744], [-8.687294, 25.881056], [-11.969419, 25.933353], [-11.937224, 23.374594], [-12.874222, 23.284832], [-13.118754, 22.77122], [-12.929102, 21.327071], [-16.845194, 21.333323], [-17.063423, 20.999752], [-17.020428, 21.42231], [-17.002962, 21.420734], [-14.750955, 21.5006], [-14.630833, 21.86094], [-14.221168, 22.310163], [-13.89111, 23.691009], [-12.500963, 24.770116], [-12.030759, 26.030866], [-11.71822, 26.104092], [-11.392555, 26.883424], [-10.551263, 26.990808], [-10.189424, 26.860945], [-9.735343, 26.860945], [-9.413037, 27.088476], [-8.794884, 27.120696], [-8.817828, 27.656426], [-8.66559, 27.656426]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Saudi Arabia",
      TYPE: "Sovereign country",
      ADMIN: "Saudi Arabia",
      GEOUNIT: "Saudi Arabia",
      SUBUNIT: "Saudi Arabia",
      NAME: "Saudi Arabia",
      NAME_LONG: "Saudi Arabia",
      ISO_A3: "SAU",
      ISO_A3_EH: "SAU"
    },
    bbox: [34.632336, 16.347891, 55.666659, 32.161009],
    geometry: {
      type: "Polygon",
      coordinates: [[[51.579519, 24.245497], [51.617708, 24.014219], [52.000733, 23.001154], [55.006803, 22.496948], [55.208341, 22.70833], [55.666659, 22.000001], [54.999982, 19.999994], [52.00001, 19.000003], [49.116672, 18.616668], [48.183344, 18.166669], [47.466695, 17.116682], [47.000005, 16.949999], [46.749994, 17.283338], [46.366659, 17.233315], [45.399999, 17.333335], [45.216651, 17.433329], [44.062613, 17.410359], [43.791519, 17.319977], [43.380794, 17.579987], [43.115798, 17.08844], [43.218375, 16.66689], [42.779332, 16.347891], [42.649573, 16.774635], [42.347989, 17.075806], [42.270888, 17.474722], [41.754382, 17.833046], [41.221391, 18.6716], [40.939341, 19.486485], [40.247652, 20.174635], [39.801685, 20.338862], [39.139399, 21.291905], [39.023696, 21.986875], [39.066329, 22.579656], [38.492772, 23.688451], [38.02386, 24.078686], [37.483635, 24.285495], [37.154818, 24.858483], [37.209491, 25.084542], [36.931627, 25.602959], [36.639604, 25.826228], [36.249137, 26.570136], [35.640182, 27.37652], [35.130187, 28.063352], [34.632336, 28.058546], [34.787779, 28.607427], [34.83222, 28.957483], [34.956037, 29.356555], [36.068941, 29.197495], [36.501214, 29.505254], [36.740528, 29.865283], [37.503582, 30.003776], [37.66812, 30.338665], [37.998849, 30.5085], [37.002166, 31.508413], [39.004886, 32.010217], [39.195468, 32.161009], [40.399994, 31.889992], [41.889981, 31.190009], [44.709499, 29.178891], [46.568713, 29.099025], [47.459822, 29.002519], [47.708851, 28.526063], [48.416094, 28.552004], [48.807595, 27.689628], [49.299554, 27.461218], [49.470914, 27.109999], [50.152422, 26.689663], [50.212935, 26.277027], [50.113303, 25.943972], [50.239859, 25.60805], [50.527387, 25.327808], [50.660557, 24.999896], [50.810108, 24.754743], [51.112415, 24.556331], [51.389608, 24.627386], [51.579519, 24.245497]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Sudan",
      TYPE: "Sovereign country",
      ADMIN: "Sudan",
      GEOUNIT: "Sudan",
      SUBUNIT: "Sudan",
      NAME: "Sudan",
      NAME_LONG: "Sudan",
      ISO_A3: "SDN",
      ISO_A3_EH: "SDN"
    },
    bbox: [21.93681, 8.229188, 38.41009, 22],
    geometry: {
      type: "Polygon",
      coordinates: [[[24.567369, 8.229188], [23.805813, 8.666319], [23.459013, 8.954286], [23.394779, 9.265068], [23.55725, 9.681218], [23.554304, 10.089255], [22.977544, 10.714463], [22.864165, 11.142395], [22.87622, 11.38461], [22.50869, 11.67936], [22.49762, 12.26024], [22.28801, 12.64605], [21.93681, 12.58818], [22.03759, 12.95546], [22.29658, 13.37232], [22.18329, 13.78648], [22.51202, 14.09318], [22.30351, 14.32682], [22.56795, 14.94429], [23.02459, 15.68072], [23.88689, 15.61084], [23.83766, 19.58047], [23.85, 20], [25, 20.00304], [25, 22], [29.02, 22], [32.9, 22], [36.86623, 22], [37.18872, 21.01885], [36.96941, 20.83744], [37.1147, 19.80796], [37.48179, 18.61409], [37.86276, 18.36786], [38.41009, 17.998307], [37.904, 17.42754], [37.16747, 17.26314], [36.85253, 16.95655], [36.75389, 16.29186], [36.32322, 14.82249], [36.42951, 14.42211], [36.27022, 13.56333], [35.86363, 12.57828], [35.26049, 12.08286], [34.83163, 11.31896], [34.73115, 10.91017], [34.25745, 10.63009], [33.96162, 9.58358], [33.97498, 8.68456], [33.963393, 9.464285], [33.824963, 9.484061], [33.842131, 9.981915], [33.721959, 10.325262], [33.206938, 10.720112], [33.086766, 11.441141], [33.206938, 12.179338], [32.743419, 12.248008], [32.67475, 12.024832], [32.073892, 11.97333], [32.314235, 11.681484], [32.400072, 11.080626], [31.850716, 10.531271], [31.352862, 9.810241], [30.837841, 9.707237], [29.996639, 10.290927], [29.618957, 10.084919], [29.515953, 9.793074], [29.000932, 9.604232], [28.966597, 9.398224], [27.97089, 9.398224], [27.833551, 9.604232], [27.112521, 9.638567], [26.752006, 9.466893], [26.477328, 9.55273], [25.962307, 10.136421], [25.790633, 10.411099], [25.069604, 10.27376], [24.794926, 9.810241], [24.537415, 8.917538], [24.194068, 8.728696], [23.88698, 8.61973], [24.567369, 8.229188]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "South Sudan",
      TYPE: "Sovereign country",
      ADMIN: "South Sudan",
      GEOUNIT: "South Sudan",
      SUBUNIT: "South Sudan",
      NAME: "S. Sudan",
      NAME_LONG: "South Sudan",
      ISO_A3: "SSD",
      ISO_A3_EH: "SSD"
    },
    bbox: [23.88698, 3.509172, 35.298007, 12.248008],
    geometry: {
      type: "Polygon",
      coordinates: [[[27.374226, 5.233944], [27.213409, 5.550953], [26.465909, 5.946717], [26.213418, 6.546603], [25.796648, 6.979316], [25.124131, 7.500085], [25.114932, 7.825104], [24.567369, 8.229188], [23.88698, 8.61973], [24.194068, 8.728696], [24.537415, 8.917538], [24.794926, 9.810241], [25.069604, 10.27376], [25.790633, 10.411099], [25.962307, 10.136421], [26.477328, 9.55273], [26.752006, 9.466893], [27.112521, 9.638567], [27.833551, 9.604232], [27.97089, 9.398224], [28.966597, 9.398224], [29.000932, 9.604232], [29.515953, 9.793074], [29.618957, 10.084919], [29.996639, 10.290927], [30.837841, 9.707237], [31.352862, 9.810241], [31.850716, 10.531271], [32.400072, 11.080626], [32.314235, 11.681484], [32.073892, 11.97333], [32.67475, 12.024832], [32.743419, 12.248008], [33.206938, 12.179338], [33.086766, 11.441141], [33.206938, 10.720112], [33.721959, 10.325262], [33.842131, 9.981915], [33.824963, 9.484061], [33.963393, 9.464285], [33.97498, 8.68456], [33.8255, 8.37916], [33.2948, 8.35458], [32.95418, 7.78497], [33.56829, 7.71334], [34.0751, 7.22595], [34.25032, 6.82607], [34.70702, 6.59422], [35.298007, 5.506], [34.620196, 4.847123], [34.005, 4.249885], [33.39, 3.79], [32.68642, 3.79232], [31.88145, 3.55827], [31.24556, 3.7819], [30.833852, 3.509172], [29.9535, 4.173699], [29.715995, 4.600805], [29.159078, 4.389267], [28.696678, 4.455077], [28.428994, 4.287155], [27.979977, 4.408413], [27.374226, 5.233944]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Senegal",
      TYPE: "Sovereign country",
      ADMIN: "Senegal",
      GEOUNIT: "Senegal",
      SUBUNIT: "Senegal",
      NAME: "Senegal",
      NAME_LONG: "Senegal",
      ISO_A3: "SEN",
      ISO_A3_EH: "SEN"
    },
    bbox: [-17.625043, 12.33209, -11.467899, 16.598264],
    geometry: {
      type: "Polygon",
      coordinates: [[[-11.513943, 12.442988], [-11.658301, 12.386583], [-12.203565, 12.465648], [-12.278599, 12.35444], [-12.499051, 12.33209], [-13.217818, 12.575874], [-13.700476, 12.586183], [-15.548477, 12.62817], [-15.816574, 12.515567], [-16.147717, 12.547762], [-16.677452, 12.384852], [-16.841525, 13.151394], [-15.931296, 13.130284], [-15.691001, 13.270353], [-15.511813, 13.27857], [-15.141163, 13.509512], [-14.712197, 13.298207], [-14.277702, 13.280585], [-13.844963, 13.505042], [-14.046992, 13.794068], [-14.376714, 13.62568], [-14.687031, 13.630357], [-15.081735, 13.876492], [-15.39877, 13.860369], [-15.624596, 13.623587], [-16.713729, 13.594959], [-17.126107, 14.373516], [-17.625043, 14.729541], [-17.185173, 14.919477], [-16.700706, 15.621527], [-16.463098, 16.135036], [-16.12069, 16.455663], [-15.623666, 16.369337], [-15.135737, 16.587282], [-14.577348, 16.598264], [-14.099521, 16.304302], [-13.435738, 16.039383], [-12.830658, 15.303692], [-12.17075, 14.616834], [-12.124887, 13.994727], [-11.927716, 13.422075], [-11.553398, 13.141214], [-11.467899, 12.754519], [-11.513943, 12.442988]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Solomon Islands",
      TYPE: "Sovereign country",
      ADMIN: "Solomon Islands",
      GEOUNIT: "Solomon Islands",
      SUBUNIT: "Solomon Islands",
      NAME: "Solomon Is.",
      NAME_LONG: "Solomon Islands",
      ISO_A3: "SLB",
      ISO_A3_EH: "SLB"
    },
    bbox: [156.491358, -10.826367, 162.398646, -6.599338],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[162.119025, -10.482719], [162.398646, -10.826367], [161.700032, -10.820011], [161.319797, -10.204751], [161.917383, -10.446701], [162.119025, -10.482719]]], [[[160.852229, -9.872937], [160.462588, -9.89521], [159.849447, -9.794027], [159.640003, -9.63998], [159.702945, -9.24295], [160.362956, -9.400304], [160.688518, -9.610162], [160.852229, -9.872937]]], [[[161.679982, -9.599982], [161.529397, -9.784312], [160.788253, -8.917543], [160.579997, -8.320009], [160.920028, -8.320009], [161.280006, -9.120011], [161.679982, -9.599982]]], [[[159.875027, -8.33732], [159.917402, -8.53829], [159.133677, -8.114181], [158.586114, -7.754824], [158.21115, -7.421872], [158.359978, -7.320018], [158.820001, -7.560003], [159.640003, -8.020027], [159.875027, -8.33732]]], [[[157.538426, -7.34782], [157.33942, -7.404767], [156.90203, -7.176874], [156.491358, -6.765943], [156.542828, -6.599338], [157.14, -7.021638], [157.538426, -7.34782]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Sierra Leone",
      TYPE: "Sovereign country",
      ADMIN: "Sierra Leone",
      GEOUNIT: "Sierra Leone",
      SUBUNIT: "Sierra Leone",
      NAME: "Sierra Leone",
      NAME_LONG: "Sierra Leone",
      ISO_A3: "SLE",
      ISO_A3_EH: "SLE"
    },
    bbox: [-13.24655, 6.785917, -10.230094, 10.046984],
    geometry: {
      type: "Polygon",
      coordinates: [[[-13.24655, 8.903049], [-12.711958, 9.342712], [-12.596719, 9.620188], [-12.425929, 9.835834], [-12.150338, 9.858572], [-11.917277, 10.046984], [-11.117481, 10.045873], [-10.839152, 9.688246], [-10.622395, 9.26791], [-10.65477, 8.977178], [-10.494315, 8.715541], [-10.505477, 8.348896], [-10.230094, 8.406206], [-10.695595, 7.939464], [-11.146704, 7.396706], [-11.199802, 7.105846], [-11.438779, 6.785917], [-11.708195, 6.860098], [-12.428099, 7.262942], [-12.949049, 7.798646], [-13.124025, 8.163946], [-13.24655, 8.903049]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "El Salvador",
      TYPE: "Sovereign country",
      ADMIN: "El Salvador",
      GEOUNIT: "El Salvador",
      SUBUNIT: "El Salvador",
      NAME: "El Salvador",
      NAME_LONG: "El Salvador",
      ISO_A3: "SLV",
      ISO_A3_EH: "SLV"
    },
    bbox: [-90.095555, 13.149017, -87.723503, 14.424133],
    geometry: {
      type: "Polygon",
      coordinates: [[[-90.095555, 13.735338], [-90.064678, 13.88197], [-89.721934, 14.134228], [-89.534219, 14.244816], [-89.587343, 14.362586], [-89.353326, 14.424133], [-89.058512, 14.340029], [-88.843073, 14.140507], [-88.541231, 13.980155], [-88.503998, 13.845486], [-88.065343, 13.964626], [-87.859515, 13.893312], [-87.723503, 13.78505], [-87.793111, 13.38448], [-87.904112, 13.149017], [-88.483302, 13.163951], [-88.843228, 13.259734], [-89.256743, 13.458533], [-89.812394, 13.520622], [-90.095555, 13.735338]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Somaliland",
      TYPE: "Indeterminate",
      ADMIN: "Somaliland",
      GEOUNIT: "Somaliland",
      SUBUNIT: "Somaliland",
      NAME: "Somaliland",
      NAME_LONG: "Somaliland",
      ISO_A3: "-99",
      ISO_A3_EH: "-99"
    },
    bbox: [42.55876, 7.99688, 48.948206, 11.46204],
    geometry: {
      type: "Polygon",
      coordinates: [[[42.776852, 10.926879], [43.145305, 11.46204], [43.47066, 11.27771], [43.666668, 10.864169], [44.117804, 10.445538], [44.614259, 10.442205], [45.556941, 10.698029], [46.645401, 10.816549], [47.525658, 11.127228], [48.021596, 11.193064], [48.378784, 11.375482], [48.948206, 11.410622], [48.948205, 11.410617], [48.948205, 11.410617], [48.942005, 11.394266], [48.938491, 10.982327], [48.938233, 9.9735], [48.93813, 9.451749], [48.486736, 8.837626], [47.78942, 8.003], [46.94834, 7.99688], [43.67875, 9.18358], [43.29699, 9.54048], [42.92812, 10.02194], [42.55876, 10.57258], [42.776852, 10.926879]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Somalia",
      TYPE: "Sovereign country",
      ADMIN: "Somalia",
      GEOUNIT: "Somalia",
      SUBUNIT: "Somalia",
      NAME: "Somalia",
      NAME_LONG: "Somalia",
      ISO_A3: "SOM",
      ISO_A3_EH: "SOM"
    },
    bbox: [40.98105, -1.68325, 51.13387, 12.02464],
    geometry: {
      type: "Polygon",
      coordinates: [[[41.855083, 3.918912], [42.12861, 4.23413], [42.76967, 4.25259], [43.66087, 4.95755], [44.9636, 5.00162], [47.78942, 8.003], [48.486736, 8.837626], [48.93813, 9.451749], [48.938233, 9.9735], [48.938491, 10.982327], [48.942005, 11.394266], [48.948205, 11.410617], [48.948205, 11.410617], [49.26776, 11.43033], [49.72862, 11.5789], [50.25878, 11.67957], [50.73202, 12.0219], [51.1112, 12.02464], [51.13387, 11.74815], [51.04153, 11.16651], [51.04531, 10.6409], [50.83418, 10.27972], [50.55239, 9.19874], [50.07092, 8.08173], [49.4527, 6.80466], [48.59455, 5.33911], [47.74079, 4.2194], [46.56476, 2.85529], [45.56399, 2.04576], [44.06815, 1.05283], [43.13597, 0.2922], [42.04157, -0.91916], [41.81095, -1.44647], [41.58513, -1.68325], [40.993, -0.85829], [40.98105, 2.78452], [41.855083, 3.918912]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Republic of Serbia",
      TYPE: "Sovereign country",
      ADMIN: "Republic of Serbia",
      GEOUNIT: "Republic of Serbia",
      SUBUNIT: "Republic of Serbia",
      NAME: "Serbia",
      NAME_LONG: "Serbia",
      ISO_A3: "SRB",
      ISO_A3_EH: "SRB"
    },
    bbox: [18.829825, 42.245224, 22.986019, 46.17173],
    geometry: {
      type: "Polygon",
      coordinates: [[[22.65715, 44.234923], [22.410446, 44.008063], [22.500157, 43.642814], [22.986019, 43.211161], [22.604801, 42.898519], [22.436595, 42.580321], [22.545012, 42.461362], [22.380526, 42.32026], [21.91708, 42.30364], [21.576636, 42.245224], [21.54332, 42.32025], [21.66292, 42.43922], [21.77505, 42.6827], [21.63302, 42.67717], [21.43866, 42.86255], [21.27421, 42.90959], [21.143395, 43.068685], [20.95651, 43.13094], [20.81448, 43.27205], [20.63508, 43.21671], [20.49679, 42.88469], [20.25758, 42.81275], [20.3398, 42.89852], [19.95857, 43.10604], [19.63, 43.21378], [19.48389, 43.35229], [19.21852, 43.52384], [19.454, 43.5681], [19.59976, 44.03847], [19.11761, 44.42307], [19.36803, 44.863], [19.00548, 44.86023], [19.005485, 44.860234], [19.390476, 45.236516], [19.072769, 45.521511], [18.829825, 45.908872], [18.829838, 45.908878], [19.596045, 46.17173], [20.220192, 46.127469], [20.762175, 45.734573], [20.874313, 45.416375], [21.483526, 45.18117], [21.562023, 44.768947], [22.145088, 44.478422], [22.459022, 44.702517], [22.705726, 44.578003], [22.474008, 44.409228], [22.65715, 44.234923]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Suriname",
      TYPE: "Sovereign country",
      ADMIN: "Suriname",
      GEOUNIT: "Suriname",
      SUBUNIT: "Suriname",
      NAME: "Suriname",
      NAME_LONG: "Suriname",
      ISO_A3: "SUR",
      ISO_A3_EH: "SUR"
    },
    bbox: [-58.044694, 1.817667, -53.958045, 6.025291],
    geometry: {
      type: "Polygon",
      coordinates: [[[-54.524754, 2.311849], [-55.097587, 2.523748], [-55.569755, 2.421506], [-55.973322, 2.510364], [-56.073342, 2.220795], [-55.9056, 2.021996], [-55.995698, 1.817667], [-56.539386, 1.899523], [-57.150098, 2.768927], [-57.281433, 3.333492], [-57.601569, 3.334655], [-58.044694, 4.060864], [-57.86021, 4.576801], [-57.914289, 4.812626], [-57.307246, 5.073567], [-57.147436, 5.97315], [-55.949318, 5.772878], [-55.84178, 5.953125], [-55.03325, 6.025291], [-53.958045, 5.756548], [-54.478633, 4.896756], [-54.399542, 4.212611], [-54.011504, 3.62257], [-54.184284, 3.194172], [-54.27123, 2.738748], [-54.524754, 2.311849]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Slovakia",
      TYPE: "Sovereign country",
      ADMIN: "Slovakia",
      GEOUNIT: "Slovakia",
      SUBUNIT: "Slovakia",
      NAME: "Slovakia",
      NAME_LONG: "Slovakia",
      ISO_A3: "SVK",
      ISO_A3_EH: "SVK"
    },
    bbox: [16.879983, 47.758429, 22.558138, 49.571574],
    geometry: {
      type: "Polygon",
      coordinates: [[[16.979667, 48.123497], [16.879983, 48.470013], [16.960288, 48.596982], [17.101985, 48.816969], [17.545007, 48.800019], [17.886485, 48.903475], [17.913512, 48.996493], [18.104973, 49.043983], [18.170498, 49.271515], [18.399994, 49.315001], [18.554971, 49.495015], [18.853144, 49.49623], [18.909575, 49.435846], [19.320713, 49.571574], [19.825023, 49.217125], [20.415839, 49.431453], [20.887955, 49.328772], [21.607808, 49.470107], [22.558138, 49.085738], [22.280842, 48.825392], [22.085608, 48.422264], [21.872236, 48.319971], [20.801294, 48.623854], [20.473562, 48.56285], [20.239054, 48.327567], [19.769471, 48.202691], [19.661364, 48.266615], [19.174365, 48.111379], [18.777025, 48.081768], [18.696513, 47.880954], [17.857133, 47.758429], [17.488473, 47.867466], [16.979667, 48.123497]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Slovenia",
      TYPE: "Sovereign country",
      ADMIN: "Slovenia",
      GEOUNIT: "Slovenia",
      SUBUNIT: "Slovenia",
      NAME: "Slovenia",
      NAME_LONG: "Slovenia",
      ISO_A3: "SVN",
      ISO_A3_EH: "SVN"
    },
    bbox: [13.69811, 45.452316, 16.564808, 46.852386],
    geometry: {
      type: "Polygon",
      coordinates: [[[13.806475, 46.509306], [14.632472, 46.431817], [15.137092, 46.658703], [16.011664, 46.683611], [16.202298, 46.852386], [16.370505, 46.841327], [16.564808, 46.503751], [15.768733, 46.238108], [15.67153, 45.834154], [15.323954, 45.731783], [15.327675, 45.452316], [14.935244, 45.471695], [14.595109, 45.634941], [14.411968, 45.466166], [13.71506, 45.500324], [13.93763, 45.591016], [13.69811, 46.016778], [13.806475, 46.509306]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Sweden",
      TYPE: "Sovereign country",
      ADMIN: "Sweden",
      GEOUNIT: "Sweden",
      SUBUNIT: "Sweden",
      NAME: "Sweden",
      NAME_LONG: "Sweden",
      ISO_A3: "SWE",
      ISO_A3_EH: "SWE"
    },
    bbox: [11.027369, 55.361737, 23.903379, 69.106247],
    geometry: {
      type: "Polygon",
      coordinates: [[[20.645593, 69.106247], [21.978535, 68.616846], [23.539473, 67.936009], [23.56588, 66.396051], [23.903379, 66.006927], [22.183173, 65.723741], [21.213517, 65.026005], [21.369631, 64.413588], [19.778876, 63.609554], [17.847779, 62.7494], [17.119555, 61.341166], [17.831346, 60.636583], [18.787722, 60.081914], [17.869225, 58.953766], [16.829185, 58.719827], [16.44771, 57.041118], [15.879786, 56.104302], [14.666681, 56.200885], [14.100721, 55.407781], [12.942911, 55.361737], [12.625101, 56.30708], [11.787942, 57.441817], [11.027369, 58.856149], [11.468272, 59.432393], [12.300366, 60.117933], [12.631147, 61.293572], [11.992064, 61.800362], [11.930569, 63.128318], [12.579935, 64.066219], [13.571916, 64.049114], [13.919905, 64.445421], [13.55569, 64.787028], [15.108411, 66.193867], [16.108712, 67.302456], [16.768879, 68.013937], [17.729182, 68.010552], [17.993868, 68.567391], [19.87856, 68.407194], [20.025269, 69.065139], [20.645593, 69.106247]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Swaziland",
      TYPE: "Sovereign country",
      ADMIN: "Swaziland",
      GEOUNIT: "Swaziland",
      SUBUNIT: "Swaziland",
      NAME: "Swaziland",
      NAME_LONG: "Swaziland",
      ISO_A3: "SWZ",
      ISO_A3_EH: "SWZ"
    },
    bbox: [30.676609, -27.285879, 32.071665, -25.660191],
    geometry: {
      type: "Polygon",
      coordinates: [[[31.837778, -25.843332], [31.985779, -26.29178], [32.071665, -26.73382], [31.86806, -27.177927], [31.282773, -27.285879], [30.685962, -26.743845], [30.676609, -26.398078], [30.949667, -26.022649], [31.04408, -25.731452], [31.333158, -25.660191], [31.837778, -25.843332]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Syria",
      TYPE: "Sovereign country",
      ADMIN: "Syria",
      GEOUNIT: "Syria",
      SUBUNIT: "Syria",
      NAME: "Syria",
      NAME_LONG: "Syria",
      ISO_A3: "SYR",
      ISO_A3_EH: "SYR"
    },
    bbox: [35.700798, 32.312938, 42.349591, 37.229873],
    geometry: {
      type: "Polygon",
      coordinates: [[[42.349591, 37.229873], [41.837064, 36.605854], [41.289707, 36.358815], [41.383965, 35.628317], [41.006159, 34.419372], [38.792341, 33.378686], [36.834062, 32.312938], [35.719918, 32.709192], [35.700798, 32.716014], [35.836397, 32.868123], [35.821101, 33.277426], [36.06646, 33.824912], [36.61175, 34.201789], [36.448194, 34.593935], [35.998403, 34.644914], [35.905023, 35.410009], [36.149763, 35.821535], [36.41755, 36.040617], [36.685389, 36.259699], [36.739494, 36.81752], [37.066761, 36.623036], [38.167727, 36.90121], [38.699891, 36.712927], [39.52258, 36.716054], [40.673259, 37.091276], [41.212089, 37.074352], [42.349591, 37.229873]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Chad",
      TYPE: "Sovereign country",
      ADMIN: "Chad",
      GEOUNIT: "Chad",
      SUBUNIT: "Chad",
      NAME: "Chad",
      NAME_LONG: "Chad",
      ISO_A3: "TCD",
      ISO_A3_EH: "TCD"
    },
    bbox: [13.540394, 7.421925, 23.88689, 23.40972],
    geometry: {
      type: "Polygon",
      coordinates: [[[22.864165, 11.142395], [22.231129, 10.971889], [21.723822, 10.567056], [21.000868, 9.475985], [20.059685, 9.012706], [19.094008, 9.074847], [18.81201, 8.982915], [18.911022, 8.630895], [18.389555, 8.281304], [17.96493, 7.890914], [16.705988, 7.508328], [16.456185, 7.734774], [16.290562, 7.754307], [16.106232, 7.497088], [15.27946, 7.421925], [15.436092, 7.692812], [15.120866, 8.38215], [14.979996, 8.796104], [14.544467, 8.965861], [13.954218, 9.549495], [14.171466, 10.021378], [14.627201, 9.920919], [14.909354, 9.992129], [15.467873, 9.982337], [14.923565, 10.891325], [14.960152, 11.555574], [14.89336, 12.21905], [14.495787, 12.859396], [14.595781, 13.330427], [13.954477, 13.353449], [13.956699, 13.996691], [13.540394, 14.367134], [13.97217, 15.68437], [15.247731, 16.627306], [15.300441, 17.92795], [15.685741, 19.95718], [15.903247, 20.387619], [15.487148, 20.730415], [15.47106, 21.04845], [15.096888, 21.308519], [14.8513, 22.86295], [15.86085, 23.40972], [19.84926, 21.49509], [23.83766, 19.58047], [23.88689, 15.61084], [23.02459, 15.68072], [22.56795, 14.94429], [22.30351, 14.32682], [22.51202, 14.09318], [22.18329, 13.78648], [22.29658, 13.37232], [22.03759, 12.95546], [21.93681, 12.58818], [22.28801, 12.64605], [22.49762, 12.26024], [22.50869, 11.67936], [22.87622, 11.38461], [22.864165, 11.142395]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Togo",
      TYPE: "Sovereign country",
      ADMIN: "Togo",
      GEOUNIT: "Togo",
      SUBUNIT: "Togo",
      NAME: "Togo",
      NAME_LONG: "Togo",
      ISO_A3: "TGO",
      ISO_A3_EH: "TGO"
    },
    bbox: [-0.049785, 5.928837, 1.865241, 11.018682],
    geometry: {
      type: "Polygon",
      coordinates: [[[0.899563, 10.997339], [0.772336, 10.470808], [1.077795, 10.175607], [1.425061, 9.825395], [1.463043, 9.334624], [1.664478, 9.12859], [1.618951, 6.832038], [1.865241, 6.142158], [1.060122, 5.928837], [0.836931, 6.279979], [0.570384, 6.914359], [0.490957, 7.411744], [0.712029, 8.312465], [0.461192, 8.677223], [0.365901, 9.465004], [0.36758, 10.191213], [-0.049785, 10.706918], [0.023803, 11.018682], [0.899563, 10.997339]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Thailand",
      TYPE: "Sovereign country",
      ADMIN: "Thailand",
      GEOUNIT: "Thailand",
      SUBUNIT: "Thailand",
      NAME: "Thailand",
      NAME_LONG: "Thailand",
      ISO_A3: "THA",
      ISO_A3_EH: "THA"
    },
    bbox: [97.375896, 5.691384, 105.589039, 20.41785],
    geometry: {
      type: "Polygon",
      coordinates: [[[105.218777, 14.273212], [104.281418, 14.416743], [102.988422, 14.225721], [102.348099, 13.394247], [102.584932, 12.186595], [101.687158, 12.64574], [100.83181, 12.627085], [100.978467, 13.412722], [100.097797, 13.406856], [100.018733, 12.307001], [99.478921, 10.846367], [99.153772, 9.963061], [99.222399, 9.239255], [99.873832, 9.207862], [100.279647, 8.295153], [100.459274, 7.429573], [101.017328, 6.856869], [101.623079, 6.740622], [102.141187, 6.221636], [101.814282, 5.810808], [101.154219, 5.691384], [101.075516, 6.204867], [100.259596, 6.642825], [100.085757, 6.464489], [99.690691, 6.848213], [99.519642, 7.343454], [98.988253, 7.907993], [98.503786, 8.382305], [98.339662, 7.794512], [98.150009, 8.350007], [98.25915, 8.973923], [98.553551, 9.93296], [99.038121, 10.960546], [99.587286, 11.892763], [99.196354, 12.804748], [99.212012, 13.269294], [99.097755, 13.827503], [98.430819, 14.622028], [98.192074, 15.123703], [98.537376, 15.308497], [98.903348, 16.177824], [98.493761, 16.837836], [97.859123, 17.567946], [97.375896, 18.445438], [97.797783, 18.62708], [98.253724, 19.708203], [98.959676, 19.752981], [99.543309, 20.186598], [100.115988, 20.41785], [100.548881, 20.109238], [100.606294, 19.508344], [101.282015, 19.462585], [101.035931, 18.408928], [101.059548, 17.512497], [102.113592, 18.109102], [102.413005, 17.932782], [102.998706, 17.961695], [103.200192, 18.309632], [103.956477, 18.240954], [104.716947, 17.428859], [104.779321, 16.441865], [105.589039, 15.570316], [105.544338, 14.723934], [105.218777, 14.273212]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Tajikistan",
      TYPE: "Sovereign country",
      ADMIN: "Tajikistan",
      GEOUNIT: "Tajikistan",
      SUBUNIT: "Tajikistan",
      NAME: "Tajikistan",
      NAME_LONG: "Tajikistan",
      ISO_A3: "TJK",
      ISO_A3_EH: "TJK"
    },
    bbox: [67.44222, 36.738171, 74.980002, 40.960213],
    geometry: {
      type: "Polygon",
      coordinates: [[[74.980002, 37.41999], [73.948696, 37.421566], [73.260056, 37.495257], [72.63689, 37.047558], [72.193041, 36.948288], [71.844638, 36.738171], [71.448693, 37.065645], [71.541918, 37.905774], [71.239404, 37.953265], [71.348131, 38.258905], [70.806821, 38.486282], [70.376304, 38.138396], [70.270574, 37.735165], [70.116578, 37.588223], [69.518785, 37.608997], [69.196273, 37.151144], [68.859446, 37.344336], [68.135562, 37.023115], [67.83, 37.144994], [68.392033, 38.157025], [68.176025, 38.901553], [67.44222, 39.140144], [67.701429, 39.580478], [68.536416, 39.533453], [69.011633, 40.086158], [69.329495, 40.727824], [70.666622, 40.960213], [70.45816, 40.496495], [70.601407, 40.218527], [71.014198, 40.244366], [70.648019, 39.935754], [69.55961, 40.103211], [69.464887, 39.526683], [70.549162, 39.604198], [71.784694, 39.279463], [73.675379, 39.431237], [73.928852, 38.505815], [74.257514, 38.606507], [74.864816, 38.378846], [74.829986, 37.990007], [74.980002, 37.41999]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Turkmenistan",
      TYPE: "Sovereign country",
      ADMIN: "Turkmenistan",
      GEOUNIT: "Turkmenistan",
      SUBUNIT: "Turkmenistan",
      NAME: "Turkmenistan",
      NAME_LONG: "Turkmenistan",
      ISO_A3: "TKM",
      ISO_A3_EH: "TKM"
    },
    bbox: [52.50246, 35.270664, 66.54615, 42.751551],
    geometry: {
      type: "Polygon",
      coordinates: [[[66.518607, 37.362784], [66.217385, 37.39379], [65.745631, 37.661164], [65.588948, 37.305217], [64.746105, 37.111818], [64.546479, 36.312073], [63.982896, 36.007957], [63.193538, 35.857166], [62.984662, 35.404041], [62.230651, 35.270664], [61.210817, 35.650072], [61.123071, 36.491597], [60.377638, 36.527383], [59.234762, 37.412988], [58.436154, 37.522309], [57.330434, 38.029229], [56.619366, 38.121394], [56.180375, 37.935127], [55.511578, 37.964117], [54.800304, 37.392421], [53.921598, 37.198918], [53.735511, 37.906136], [53.880929, 38.952093], [53.101028, 39.290574], [53.357808, 39.975286], [52.693973, 40.033629], [52.915251, 40.876523], [53.858139, 40.631034], [54.736845, 40.951015], [54.008311, 41.551211], [53.721713, 42.123191], [52.91675, 41.868117], [52.814689, 41.135371], [52.50246, 41.783316], [52.944293, 42.116034], [54.079418, 42.324109], [54.755345, 42.043971], [55.455251, 41.259859], [55.968191, 41.308642], [57.096391, 41.32231], [56.932215, 41.826026], [57.78653, 42.170553], [58.629011, 42.751551], [59.976422, 42.223082], [60.083341, 41.425146], [60.465953, 41.220327], [61.547179, 41.26637], [61.882714, 41.084857], [62.37426, 40.053886], [63.518015, 39.363257], [64.170223, 38.892407], [65.215999, 38.402695], [66.54615, 37.974685], [66.518607, 37.362784]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "East Timor",
      TYPE: "Sovereign country",
      ADMIN: "East Timor",
      GEOUNIT: "East Timor",
      SUBUNIT: "East Timor",
      NAME: "Timor-Leste",
      NAME_LONG: "Timor-Leste",
      ISO_A3: "TLS",
      ISO_A3_EH: "TLS"
    },
    bbox: [124.968682, -9.393173, 127.335928, -8.273345],
    geometry: {
      type: "Polygon",
      coordinates: [[[125.08852, -9.393173], [125.07002, -9.089987], [124.968682, -8.89279], [125.086246, -8.656887], [125.947072, -8.432095], [126.644704, -8.398247], [126.957243, -8.273345], [127.335928, -8.397317], [126.967992, -8.668256], [125.925885, -9.106007], [125.08852, -9.393173]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Trinidad and Tobago",
      TYPE: "Sovereign country",
      ADMIN: "Trinidad and Tobago",
      GEOUNIT: "Trinidad and Tobago",
      SUBUNIT: "Trinidad and Tobago",
      NAME: "Trinidad and Tobago",
      NAME_LONG: "Trinidad and Tobago",
      ISO_A3: "TTO",
      ISO_A3_EH: "TTO",
      TINY: 2
    },
    bbox: [-61.95, 10, -60.895, 10.89],
    geometry: {
      type: "Polygon",
      coordinates: [[[-61.68, 10.76], [-61.105, 10.89], [-60.895, 10.855], [-60.935, 10.11], [-61.77, 10], [-61.95, 10.09], [-61.66, 10.365], [-61.68, 10.76]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Tunisia",
      TYPE: "Sovereign country",
      ADMIN: "Tunisia",
      GEOUNIT: "Tunisia",
      SUBUNIT: "Tunisia",
      NAME: "Tunisia",
      NAME_LONG: "Tunisia",
      ISO_A3: "TUN",
      ISO_A3_EH: "TUN"
    },
    bbox: [7.524482, 30.307556, 11.488787, 37.349994],
    geometry: {
      type: "Polygon",
      coordinates: [[[9.48214, 30.307556], [9.055603, 32.102692], [8.439103, 32.506285], [8.430473, 32.748337], [7.612642, 33.344115], [7.524482, 34.097376], [8.140981, 34.655146], [8.376368, 35.479876], [8.217824, 36.433177], [8.420964, 36.946427], [9.509994, 37.349994], [10.210002, 37.230002], [10.18065, 36.724038], [11.028867, 37.092103], [11.100026, 36.899996], [10.600005, 36.41], [10.593287, 35.947444], [10.939519, 35.698984], [10.807847, 34.833507], [10.149593, 34.330773], [10.339659, 33.785742], [10.856836, 33.76874], [11.108501, 33.293343], [11.488787, 33.136996], [11.432253, 32.368903], [10.94479, 32.081815], [10.636901, 31.761421], [9.950225, 31.37607], [10.056575, 30.961831], [9.970017, 30.539325], [9.48214, 30.307556]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Turkey",
      TYPE: "Sovereign country",
      ADMIN: "Turkey",
      GEOUNIT: "Turkey",
      SUBUNIT: "Turkey",
      NAME: "Turkey",
      NAME_LONG: "Turkey",
      ISO_A3: "TUR",
      ISO_A3_EH: "TUR"
    },
    bbox: [26.043351, 35.821535, 44.79399, 42.141485],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[43.582746, 41.092143], [43.752658, 40.740201], [43.656436, 40.253564], [44.400009, 40.005], [44.79399, 39.713003], [44.109225, 39.428136], [44.421403, 38.281281], [44.225756, 37.971584], [44.77267, 37.17045], [44.772677, 37.170437], [44.293452, 37.001514], [43.942259, 37.256228], [42.779126, 37.385264], [42.349591, 37.229873], [41.212089, 37.074352], [40.673259, 37.091276], [39.52258, 36.716054], [38.699891, 36.712927], [38.167727, 36.90121], [37.066761, 36.623036], [36.739494, 36.81752], [36.685389, 36.259699], [36.41755, 36.040617], [36.149763, 35.821535], [35.782085, 36.274995], [36.160822, 36.650606], [35.550936, 36.565443], [34.714553, 36.795532], [34.026895, 36.21996], [32.509158, 36.107564], [31.699595, 36.644275], [30.621625, 36.677865], [30.391096, 36.262981], [29.699976, 36.144357], [28.732903, 36.676831], [27.641187, 36.658822], [27.048768, 37.653361], [26.318218, 38.208133], [26.8047, 38.98576], [26.170785, 39.463612], [27.28002, 40.420014], [28.819978, 40.460011], [29.240004, 41.219991], [31.145934, 41.087622], [32.347979, 41.736264], [33.513283, 42.01896], [35.167704, 42.040225], [36.913127, 41.335358], [38.347665, 40.948586], [39.512607, 41.102763], [40.373433, 41.013673], [41.554084, 41.535656], [42.619549, 41.583173], [43.582746, 41.092143]]], [[[26.117042, 41.826905], [27.135739, 42.141485], [27.99672, 42.007359], [28.115525, 41.622886], [28.988443, 41.299934], [28.806438, 41.054962], [27.619017, 40.999823], [27.192377, 40.690566], [26.358009, 40.151994], [26.043351, 40.617754], [26.056942, 40.824123], [26.294602, 40.936261], [26.604196, 41.562115], [26.117042, 41.826905]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Taiwan",
      TYPE: "Sovereign country",
      ADMIN: "Taiwan",
      GEOUNIT: "Taiwan",
      SUBUNIT: "Taiwan",
      NAME: "Taiwan",
      NAME_LONG: "Taiwan",
      ISO_A3: "TWN",
      ISO_A3_EH: "TWN"
    },
    bbox: [120.106189, 21.970571, 121.951244, 25.295459],
    geometry: {
      type: "Polygon",
      coordinates: [[[121.777818, 24.394274], [121.175632, 22.790857], [120.74708, 21.970571], [120.220083, 22.814861], [120.106189, 23.556263], [120.69468, 24.538451], [121.495044, 25.295459], [121.951244, 24.997596], [121.777818, 24.394274]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "United Republic of Tanzania",
      TYPE: "Sovereign country",
      ADMIN: "United Republic of Tanzania",
      GEOUNIT: "Tanzania",
      SUBUNIT: "Tanzania",
      NAME: "Tanzania",
      NAME_LONG: "Tanzania",
      ISO_A3: "TZA",
      ISO_A3_EH: "TZA"
    },
    bbox: [29.339998, -11.720938, 40.31659, -0.95],
    geometry: {
      type: "Polygon",
      coordinates: [[[29.339998, -4.499983], [29.753512, -4.452389], [30.11632, -4.09012], [30.50554, -3.56858], [30.75224, -3.35931], [30.74301, -3.03431], [30.52766, -2.80762], [30.469674, -2.413855], [30.46967, -2.41383], [30.758309, -2.28725], [30.816135, -1.698914], [30.419105, -1.134659], [30.76986, -1.01455], [31.86617, -1.02736], [33.903711, -0.95], [34.07262, -1.05982], [37.69869, -3.09699], [37.7669, -3.67712], [39.20222, -4.67677], [38.74054, -5.90895], [38.79977, -6.47566], [39.44, -6.84], [39.47, -7.1], [39.19469, -7.7039], [39.25203, -8.00781], [39.18652, -8.48551], [39.53574, -9.11237], [39.9496, -10.0984], [40.316586, -10.317098], [40.31659, -10.3171], [39.521, -10.89688], [38.427557, -11.285202], [37.82764, -11.26879], [37.47129, -11.56876], [36.775151, -11.594537], [36.514082, -11.720938], [35.312398, -11.439146], [34.559989, -11.52002], [34.28, -10.16], [33.940838, -9.693674], [33.73972, -9.41715], [32.759375, -9.230599], [32.191865, -8.930359], [31.556348, -8.762049], [31.157751, -8.594579], [30.74001, -8.340006], [30.740015, -8.340007], [30.199997, -7.079981], [29.620032, -6.520015], [29.419993, -5.939999], [29.519987, -5.419979], [29.339998, -4.499983]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Uganda",
      TYPE: "Sovereign country",
      ADMIN: "Uganda",
      GEOUNIT: "Uganda",
      SUBUNIT: "Uganda",
      NAME: "Uganda",
      NAME_LONG: "Uganda",
      ISO_A3: "UGA",
      ISO_A3_EH: "UGA"
    },
    bbox: [29.579466, -1.443322, 35.03599, 4.249885],
    geometry: {
      type: "Polygon",
      coordinates: [[[29.579466, -1.341313], [29.587838, -0.587406], [29.819503, -0.20531], [29.875779, 0.59738], [30.086154, 1.062313], [30.468508, 1.583805], [30.85267, 1.849396], [31.174149, 2.204465], [30.773347, 2.339883], [30.83386, 3.509166], [30.833852, 3.509172], [31.24556, 3.7819], [31.88145, 3.55827], [32.68642, 3.79232], [33.39, 3.79], [34.005, 4.249885], [34.47913, 3.5556], [34.59607, 3.05374], [35.03599, 1.90584], [34.6721, 1.17694], [34.18, 0.515], [33.893569, 0.109814], [33.903711, -0.95], [31.86617, -1.02736], [30.76986, -1.01455], [30.419105, -1.134659], [29.821519, -1.443322], [29.579466, -1.341313]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Ukraine",
      TYPE: "Sovereign country",
      ADMIN: "Ukraine",
      GEOUNIT: "Ukraine",
      SUBUNIT: "Ukraine",
      NAME: "Ukraine",
      NAME_LONG: "Ukraine",
      ISO_A3: "UKR",
      ISO_A3_EH: "UKR"
    },
    bbox: [22.085608, 45.293308, 40.080789, 52.335075],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[23.527071, 51.578454], [24.005078, 51.617444], [24.553106, 51.888461], [25.327788, 51.910656], [26.337959, 51.832289], [27.454066, 51.592303], [28.241615, 51.572227], [28.617613, 51.427714], [28.992835, 51.602044], [29.254938, 51.368234], [30.157364, 51.416138], [30.555117, 51.319503], [30.619454, 51.822806], [30.927549, 52.042353], [31.785992, 52.101678], [32.15944, 52.06125], [32.412058, 52.288695], [32.715761, 52.238465], [33.7527, 52.335075], [34.391731, 51.768882], [34.141978, 51.566413], [34.224816, 51.255993], [35.022183, 51.207572], [35.37791, 50.77394], [35.356116, 50.577197], [36.626168, 50.225591], [37.39346, 50.383953], [38.010631, 49.915662], [38.594988, 49.926462], [40.06904, 49.60105], [40.080789, 49.30743], [39.67465, 48.78382], [39.89562, 48.23241], [39.738278, 47.898937], [38.77057, 47.82562], [38.255112, 47.5464], [38.223538, 47.10219], [37.425137, 47.022221], [36.759855, 46.6987], [35.823685, 46.645964], [34.962342, 46.273197], [35.012659, 45.737725], [34.861792, 45.768182], [34.732017, 45.965666], [34.410402, 46.005162], [33.699462, 46.219573], [33.435988, 45.971917], [33.298567, 46.080598], [31.74414, 46.333348], [31.675307, 46.706245], [30.748749, 46.5831], [30.377609, 46.03241], [29.603289, 45.293308], [29.149725, 45.464925], [28.679779, 45.304031], [28.233554, 45.488283], [28.485269, 45.596907], [28.659987, 45.939987], [28.933717, 46.25883], [28.862972, 46.437889], [29.072107, 46.517678], [29.170654, 46.379262], [29.759972, 46.349988], [30.024659, 46.423937], [29.83821, 46.525326], [29.908852, 46.674361], [29.559674, 46.928583], [29.415135, 47.346645], [29.050868, 47.510227], [29.122698, 47.849095], [28.670891, 48.118149], [28.259547, 48.155562], [27.522537, 48.467119], [26.857824, 48.368211], [26.619337, 48.220726], [26.19745, 48.220881], [25.945941, 47.987149], [25.207743, 47.891056], [24.866317, 47.737526], [24.402056, 47.981878], [23.760958, 47.985598], [23.142236, 48.096341], [22.710531, 47.882194], [22.64082, 48.15024], [22.085608, 48.422264], [22.280842, 48.825392], [22.558138, 49.085738], [22.776419, 49.027395], [22.51845, 49.476774], [23.426508, 50.308506], [23.922757, 50.424881], [24.029986, 50.705407], [23.527071, 51.578454]]], [[[33.435988, 45.971917], [33.699462, 46.219573], [34.410402, 46.005162], [34.732017, 45.965666], [34.861792, 45.768182], [35.012659, 45.737725], [35.020788, 45.651219], [35.510009, 45.409993], [36.529998, 45.46999], [36.334713, 45.113216], [35.239999, 44.939996], [33.882511, 44.361479], [33.326421, 44.564877], [33.546924, 45.034771], [32.454174, 45.327466], [32.630804, 45.519186], [33.588162, 45.851569], [33.435988, 45.971917]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Uruguay",
      TYPE: "Sovereign country",
      ADMIN: "Uruguay",
      GEOUNIT: "Uruguay",
      SUBUNIT: "Uruguay",
      NAME: "Uruguay",
      NAME_LONG: "Uruguay",
      ISO_A3: "URY",
      ISO_A3_EH: "URY"
    },
    bbox: [-58.427074, -34.952647, -53.209589, -30.109686],
    geometry: {
      type: "Polygon",
      coordinates: [[[-58.427074, -33.909454], [-58.349611, -33.263189], [-58.132648, -33.040567], [-58.14244, -32.044504], [-57.874937, -31.016556], [-57.625133, -30.216295], [-56.976026, -30.109686], [-55.973245, -30.883076], [-55.60151, -30.853879], [-54.572452, -31.494511], [-53.787952, -32.047243], [-53.209589, -32.727666], [-53.650544, -33.202004], [-53.373662, -33.768378], [-53.806426, -34.396815], [-54.935866, -34.952647], [-55.67409, -34.752659], [-56.215297, -34.859836], [-57.139685, -34.430456], [-57.817861, -34.462547], [-58.427074, -33.909454]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "United States",
      TYPE: "Country",
      ADMIN: "United States",
      GEOUNIT: "United States",
      SUBUNIT: "United States",
      NAME: "United States",
      NAME_LONG: "United States",
      ISO_A3: "USA",
      ISO_A3_EH: "USA"
    },
    bbox: [-171.791111, 18.91619, -66.96466, 71.357764],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[-122.84, 49], [-120, 49], [-117.03121, 49], [-116.04818, 49], [-113, 49], [-110.05, 49], [-107.05, 49], [-104.04826, 48.99986], [-100.65, 49], [-97.22872, 49.0007], [-95.15907, 49], [-95.15609, 49.38425], [-94.81758, 49.38905], [-94.64, 48.84], [-94.32914, 48.67074], [-93.63087, 48.60926], [-92.61, 48.45], [-91.64, 48.14], [-90.83, 48.27], [-89.6, 48.01], [-89.272917, 48.019808], [-88.378114, 48.302918], [-87.439793, 47.94], [-86.461991, 47.553338], [-85.652363, 47.220219], [-84.87608, 46.900083], [-84.779238, 46.637102], [-84.543749, 46.538684], [-84.6049, 46.4396], [-84.3367, 46.40877], [-84.14212, 46.512226], [-84.091851, 46.275419], [-83.890765, 46.116927], [-83.616131, 46.116927], [-83.469551, 45.994686], [-83.592851, 45.816894], [-82.550925, 45.347517], [-82.337763, 44.44], [-82.137642, 43.571088], [-82.43, 42.98], [-82.9, 42.43], [-83.12, 42.08], [-83.142, 41.975681], [-83.02981, 41.832796], [-82.690089, 41.675105], [-82.439278, 41.675105], [-81.277747, 42.209026], [-80.247448, 42.3662], [-78.939362, 42.863611], [-78.92, 42.965], [-79.01, 43.27], [-79.171674, 43.466339], [-78.72028, 43.625089], [-77.737885, 43.629056], [-76.820034, 43.628784], [-76.5, 44.018459], [-76.375, 44.09631], [-75.31821, 44.81645], [-74.867, 45.00048], [-73.34783, 45.00738], [-71.50506, 45.0082], [-71.405, 45.255], [-71.08482, 45.30524], [-70.66, 45.46], [-70.305, 45.915], [-69.99997, 46.69307], [-69.237216, 47.447781], [-68.905, 47.185], [-68.23444, 47.35486], [-67.79046, 47.06636], [-67.79134, 45.70281], [-67.13741, 45.13753], [-66.96466, 44.8097], [-68.03252, 44.3252], [-69.06, 43.98], [-70.11617, 43.68405], [-70.645476, 43.090238], [-70.81489, 42.8653], [-70.825, 42.335], [-70.495, 41.805], [-70.08, 41.78], [-70.185, 42.145], [-69.88497, 41.92283], [-69.96503, 41.63717], [-70.64, 41.475], [-71.12039, 41.49445], [-71.86, 41.32], [-72.295, 41.27], [-72.87643, 41.22065], [-73.71, 40.931102], [-72.24126, 41.11948], [-71.945, 40.93], [-73.345, 40.63], [-73.982, 40.628], [-73.952325, 40.75075], [-74.25671, 40.47351], [-73.96244, 40.42763], [-74.17838, 39.70926], [-74.90604, 38.93954], [-74.98041, 39.1964], [-75.20002, 39.24845], [-75.52805, 39.4985], [-75.32, 38.96], [-75.071835, 38.782032], [-75.05673, 38.40412], [-75.37747, 38.01551], [-75.94023, 37.21689], [-76.03127, 37.2566], [-75.72205, 37.93705], [-76.23287, 38.319215], [-76.35, 39.15], [-76.542725, 38.717615], [-76.32933, 38.08326], [-76.989998, 38.239992], [-76.30162, 37.917945], [-76.25874, 36.9664], [-75.9718, 36.89726], [-75.86804, 36.55125], [-75.72749, 35.55074], [-76.36318, 34.80854], [-77.397635, 34.51201], [-78.05496, 33.92547], [-78.55435, 33.86133], [-79.06067, 33.49395], [-79.20357, 33.15839], [-80.301325, 32.509355], [-80.86498, 32.0333], [-81.33629, 31.44049], [-81.49042, 30.72999], [-81.31371, 30.03552], [-80.98, 29.18], [-80.535585, 28.47213], [-80.53, 28.04], [-80.056539, 26.88], [-80.088015, 26.205765], [-80.13156, 25.816775], [-80.38103, 25.20616], [-80.68, 25.08], [-81.17213, 25.20126], [-81.33, 25.64], [-81.71, 25.87], [-82.24, 26.73], [-82.70515, 27.49504], [-82.85526, 27.88624], [-82.65, 28.55], [-82.93, 29.1], [-83.70959, 29.93656], [-84.1, 30.09], [-85.10882, 29.63615], [-85.28784, 29.68612], [-85.7731, 30.15261], [-86.4, 30.4], [-87.53036, 30.27433], [-88.41782, 30.3849], [-89.18049, 30.31598], [-89.593831, 30.159994], [-89.413735, 29.89419], [-89.43, 29.48864], [-89.21767, 29.29108], [-89.40823, 29.15961], [-89.77928, 29.30714], [-90.15463, 29.11743], [-90.880225, 29.148535], [-91.626785, 29.677], [-92.49906, 29.5523], [-93.22637, 29.78375], [-93.84842, 29.71363], [-94.69, 29.48], [-95.60026, 28.73863], [-96.59404, 28.30748], [-97.14, 27.83], [-97.37, 27.38], [-97.38, 26.69], [-97.33, 26.21], [-97.14, 25.87], [-97.53, 25.84], [-98.24, 26.06], [-99.02, 26.37], [-99.3, 26.84], [-99.52, 27.54], [-100.11, 28.11], [-100.45584, 28.69612], [-100.9576, 29.38071], [-101.6624, 29.7793], [-102.48, 29.76], [-103.11, 28.97], [-103.94, 29.27], [-104.45697, 29.57196], [-104.70575, 30.12173], [-105.03737, 30.64402], [-105.63159, 31.08383], [-106.1429, 31.39995], [-106.50759, 31.75452], [-108.24, 31.754854], [-108.24194, 31.34222], [-109.035, 31.34194], [-111.02361, 31.33472], [-113.30498, 32.03914], [-114.815, 32.52528], [-114.72139, 32.72083], [-115.99135, 32.61239], [-117.12776, 32.53534], [-117.295938, 33.046225], [-117.944, 33.621236], [-118.410602, 33.740909], [-118.519895, 34.027782], [-119.081, 34.078], [-119.438841, 34.348477], [-120.36778, 34.44711], [-120.62286, 34.60855], [-120.74433, 35.15686], [-121.71457, 36.16153], [-122.54747, 37.55176], [-122.51201, 37.78339], [-122.95319, 38.11371], [-123.7272, 38.95166], [-123.86517, 39.76699], [-124.39807, 40.3132], [-124.17886, 41.14202], [-124.2137, 41.99964], [-124.53284, 42.76599], [-124.14214, 43.70838], [-124.020535, 44.615895], [-123.89893, 45.52341], [-124.079635, 46.86475], [-124.39567, 47.72017], [-124.68721, 48.184433], [-124.566101, 48.379715], [-123.12, 48.04], [-122.58736, 47.096], [-122.34, 47.36], [-122.5, 48.18], [-122.84, 49]]], [[[-140.985988, 69.711998], [-140.986, 69.712], [-140.9925, 66.00003], [-140.99778, 60.30639], [-140.013, 60.27682], [-139.039, 60], [-138.34089, 59.56211], [-137.4525, 58.905], [-136.47972, 59.46389], [-135.47583, 59.78778], [-134.945, 59.27056], [-134.27111, 58.86111], [-133.35556, 58.41028], [-132.73042, 57.69289], [-131.70781, 56.55212], [-130.00778, 55.91583], [-129.98, 55.285], [-130.53611, 54.80278], [-130.536109, 54.802754], [-130.53611, 54.802753], [-131.085818, 55.178906], [-131.967211, 55.497776], [-132.250011, 56.369996], [-133.539181, 57.178887], [-134.078063, 58.123068], [-135.038211, 58.187715], [-136.628062, 58.212209], [-137.800006, 58.499995], [-139.867787, 59.537762], [-140.825274, 59.727517], [-142.574444, 60.084447], [-143.958881, 59.99918], [-145.925557, 60.45861], [-147.114374, 60.884656], [-148.224306, 60.672989], [-148.018066, 59.978329], [-148.570823, 59.914173], [-149.727858, 59.705658], [-150.608243, 59.368211], [-151.716393, 59.155821], [-151.859433, 59.744984], [-151.409719, 60.725803], [-150.346941, 61.033588], [-150.621111, 61.284425], [-151.895839, 60.727198], [-152.57833, 60.061657], [-154.019172, 59.350279], [-153.287511, 58.864728], [-154.232492, 58.146374], [-155.307491, 57.727795], [-156.308335, 57.422774], [-156.556097, 56.979985], [-158.117217, 56.463608], [-158.433321, 55.994154], [-159.603327, 55.566686], [-160.28972, 55.643581], [-161.223048, 55.364735], [-162.237766, 55.024187], [-163.069447, 54.689737], [-164.785569, 54.404173], [-164.942226, 54.572225], [-163.84834, 55.039431], [-162.870001, 55.348043], [-161.804175, 55.894986], [-160.563605, 56.008055], [-160.07056, 56.418055], [-158.684443, 57.016675], [-158.461097, 57.216921], [-157.72277, 57.570001], [-157.550274, 58.328326], [-157.041675, 58.918885], [-158.194731, 58.615802], [-158.517218, 58.787781], [-159.058606, 58.424186], [-159.711667, 58.93139], [-159.981289, 58.572549], [-160.355271, 59.071123], [-161.355003, 58.670838], [-161.968894, 58.671665], [-162.054987, 59.266925], [-161.874171, 59.633621], [-162.518059, 59.989724], [-163.818341, 59.798056], [-164.662218, 60.267484], [-165.346388, 60.507496], [-165.350832, 61.073895], [-166.121379, 61.500019], [-165.734452, 62.074997], [-164.919179, 62.633076], [-164.562508, 63.146378], [-163.753332, 63.219449], [-163.067224, 63.059459], [-162.260555, 63.541936], [-161.53445, 63.455817], [-160.772507, 63.766108], [-160.958335, 64.222799], [-161.518068, 64.402788], [-160.777778, 64.788604], [-161.391926, 64.777235], [-162.45305, 64.559445], [-162.757786, 64.338605], [-163.546394, 64.55916], [-164.96083, 64.446945], [-166.425288, 64.686672], [-166.845004, 65.088896], [-168.11056, 65.669997], [-166.705271, 66.088318], [-164.47471, 66.57666], [-163.652512, 66.57666], [-163.788602, 66.077207], [-161.677774, 66.11612], [-162.489715, 66.735565], [-163.719717, 67.116395], [-164.430991, 67.616338], [-165.390287, 68.042772], [-166.764441, 68.358877], [-166.204707, 68.883031], [-164.430811, 68.915535], [-163.168614, 69.371115], [-162.930566, 69.858062], [-161.908897, 70.33333], [-160.934797, 70.44769], [-159.039176, 70.891642], [-158.119723, 70.824721], [-156.580825, 71.357764], [-155.06779, 71.147776], [-154.344165, 70.696409], [-153.900006, 70.889989], [-152.210006, 70.829992], [-152.270002, 70.600006], [-150.739992, 70.430017], [-149.720003, 70.53001], [-147.613362, 70.214035], [-145.68999, 70.12001], [-144.920011, 69.989992], [-143.589446, 70.152514], [-142.07251, 69.851938], [-140.985988, 69.711998], [-140.985988, 69.711998]]], [[[-155.54211, 19.08348], [-155.68817, 18.91619], [-155.93665, 19.05939], [-155.90806, 19.33888], [-156.07347, 19.70294], [-156.02368, 19.81422], [-155.85008, 19.97729], [-155.91907, 20.17395], [-155.86108, 20.26721], [-155.78505, 20.2487], [-155.40214, 20.07975], [-155.22452, 19.99302], [-155.06226, 19.8591], [-154.80741, 19.50871], [-154.83147, 19.45328], [-155.22217, 19.23972], [-155.54211, 19.08348]]], [[[-156.07926, 20.64397], [-156.41445, 20.57241], [-156.58673, 20.783], [-156.70167, 20.8643], [-156.71055, 20.92676], [-156.61258, 21.01249], [-156.25711, 20.91745], [-155.99566, 20.76404], [-156.07926, 20.64397]]], [[[-156.75824, 21.17684], [-156.78933, 21.06873], [-157.32521, 21.09777], [-157.25027, 21.21958], [-156.75824, 21.17684]]], [[[-157.65283, 21.32217], [-157.70703, 21.26442], [-157.7786, 21.27729], [-158.12667, 21.31244], [-158.2538, 21.53919], [-158.29265, 21.57912], [-158.0252, 21.71696], [-157.94161, 21.65272], [-157.65283, 21.32217]]], [[[-159.34512, 21.982], [-159.46372, 21.88299], [-159.80051, 22.06533], [-159.74877, 22.1382], [-159.5962, 22.23618], [-159.36569, 22.21494], [-159.34512, 21.982]]], [[[-153.006314, 57.115842], [-154.00509, 56.734677], [-154.516403, 56.992749], [-154.670993, 57.461196], [-153.76278, 57.816575], [-153.228729, 57.968968], [-152.564791, 57.901427], [-152.141147, 57.591059], [-153.006314, 57.115842]]], [[[-165.579164, 59.909987], [-166.19277, 59.754441], [-166.848337, 59.941406], [-167.455277, 60.213069], [-166.467792, 60.38417], [-165.67443, 60.293607], [-165.579164, 59.909987]]], [[[-171.731657, 63.782515], [-171.114434, 63.592191], [-170.491112, 63.694975], [-169.682505, 63.431116], [-168.689439, 63.297506], [-168.771941, 63.188598], [-169.52944, 62.976931], [-170.290556, 63.194438], [-170.671386, 63.375822], [-171.553063, 63.317789], [-171.791111, 63.405846], [-171.731657, 63.782515]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Uzbekistan",
      TYPE: "Sovereign country",
      ADMIN: "Uzbekistan",
      GEOUNIT: "Uzbekistan",
      SUBUNIT: "Uzbekistan",
      NAME: "Uzbekistan",
      NAME_LONG: "Uzbekistan",
      ISO_A3: "UZB",
      ISO_A3_EH: "UZB",
      TINY: 5
    },
    bbox: [55.928917, 37.144994, 73.055417, 45.586804],
    geometry: {
      type: "Polygon",
      coordinates: [[[67.83, 37.144994], [67.075782, 37.356144], [66.518607, 37.362784], [66.54615, 37.974685], [65.215999, 38.402695], [64.170223, 38.892407], [63.518015, 39.363257], [62.37426, 40.053886], [61.882714, 41.084857], [61.547179, 41.26637], [60.465953, 41.220327], [60.083341, 41.425146], [59.976422, 42.223082], [58.629011, 42.751551], [57.78653, 42.170553], [56.932215, 41.826026], [57.096391, 41.32231], [55.968191, 41.308642], [55.928917, 44.995858], [58.503127, 45.586804], [58.689989, 45.500014], [60.239972, 44.784037], [61.05832, 44.405817], [62.0133, 43.504477], [63.185787, 43.650075], [64.900824, 43.728081], [66.098012, 42.99766], [66.023392, 41.994646], [66.510649, 41.987644], [66.714047, 41.168444], [67.985856, 41.135991], [68.259896, 40.662325], [68.632483, 40.668681], [69.070027, 41.384244], [70.388965, 42.081308], [70.962315, 42.266154], [71.259248, 42.167711], [70.420022, 41.519998], [71.157859, 41.143587], [71.870115, 41.3929], [73.055417, 40.866033], [71.774875, 40.145844], [71.014198, 40.244366], [70.601407, 40.218527], [70.45816, 40.496495], [70.666622, 40.960213], [69.329495, 40.727824], [69.011633, 40.086158], [68.536416, 39.533453], [67.701429, 39.580478], [67.44222, 39.140144], [68.176025, 38.901553], [68.392033, 38.157025], [67.83, 37.144994]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Venezuela",
      TYPE: "Sovereign country",
      ADMIN: "Venezuela",
      GEOUNIT: "Venezuela",
      SUBUNIT: "Venezuela",
      NAME: "Venezuela",
      NAME_LONG: "Venezuela",
      ISO_A3: "VEN",
      ISO_A3_EH: "VEN"
    },
    bbox: [-73.304952, 0.724452, -59.758285, 12.162307],
    geometry: {
      type: "Polygon",
      coordinates: [[[-60.733574, 5.200277], [-60.601179, 4.918098], [-60.966893, 4.536468], [-62.08543, 4.162124], [-62.804533, 4.006965], [-63.093198, 3.770571], [-63.888343, 4.02053], [-64.628659, 4.148481], [-64.816064, 4.056445], [-64.368494, 3.79721], [-64.408828, 3.126786], [-64.269999, 2.497006], [-63.422867, 2.411068], [-63.368788, 2.2009], [-64.083085, 1.916369], [-64.199306, 1.492855], [-64.611012, 1.328731], [-65.354713, 1.095282], [-65.548267, 0.789254], [-66.325765, 0.724452], [-66.876326, 1.253361], [-67.181294, 2.250638], [-67.447092, 2.600281], [-67.809938, 2.820655], [-67.303173, 3.318454], [-67.337564, 3.542342], [-67.621836, 3.839482], [-67.823012, 4.503937], [-67.744697, 5.221129], [-67.521532, 5.55687], [-67.34144, 6.095468], [-67.695087, 6.267318], [-68.265052, 6.153268], [-68.985319, 6.206805], [-69.38948, 6.099861], [-70.093313, 6.960376], [-70.674234, 7.087785], [-71.960176, 6.991615], [-72.198352, 7.340431], [-72.444487, 7.423785], [-72.479679, 7.632506], [-72.360901, 8.002638], [-72.439862, 8.405275], [-72.660495, 8.625288], [-72.78873, 9.085027], [-73.304952, 9.152], [-73.027604, 9.73677], [-72.905286, 10.450344], [-72.614658, 10.821975], [-72.227575, 11.108702], [-71.973922, 11.608672], [-71.331584, 11.776284], [-71.360006, 11.539994], [-71.94705, 11.423282], [-71.620868, 10.96946], [-71.633064, 10.446494], [-72.074174, 9.865651], [-71.695644, 9.072263], [-71.264559, 9.137195], [-71.039999, 9.859993], [-71.350084, 10.211935], [-71.400623, 10.968969], [-70.155299, 11.375482], [-70.293843, 11.846822], [-69.943245, 12.162307], [-69.5843, 11.459611], [-68.882999, 11.443385], [-68.233271, 10.885744], [-68.194127, 10.554653], [-67.296249, 10.545868], [-66.227864, 10.648627], [-65.655238, 10.200799], [-64.890452, 10.077215], [-64.329479, 10.389599], [-64.318007, 10.641418], [-63.079322, 10.701724], [-61.880946, 10.715625], [-62.730119, 10.420269], [-62.388512, 9.948204], [-61.588767, 9.873067], [-60.830597, 9.38134], [-60.671252, 8.580174], [-60.150096, 8.602757], [-59.758285, 8.367035], [-60.550588, 7.779603], [-60.637973, 7.415], [-60.295668, 7.043911], [-60.543999, 6.856584], [-61.159336, 6.696077], [-61.139415, 6.234297], [-61.410303, 5.959068], [-60.733574, 5.200277]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Vietnam",
      TYPE: "Sovereign country",
      ADMIN: "Vietnam",
      GEOUNIT: "Vietnam",
      SUBUNIT: "Vietnam",
      NAME: "Vietnam",
      NAME_LONG: "Vietnam",
      ISO_A3: "VNM",
      ISO_A3_EH: "VNM",
      TINY: 2
    },
    bbox: [102.170436, 8.59976, 109.33527, 23.352063],
    geometry: {
      type: "Polygon",
      coordinates: [[[102.170436, 22.464753], [102.706992, 22.708795], [103.504515, 22.703757], [104.476858, 22.81915], [105.329209, 23.352063], [105.811247, 22.976892], [106.725403, 22.794268], [106.567273, 22.218205], [107.04342, 21.811899], [108.05018, 21.55238], [106.715068, 20.696851], [105.881682, 19.75205], [105.662006, 19.058165], [106.426817, 18.004121], [107.361954, 16.697457], [108.269495, 16.079742], [108.877107, 15.276691], [109.33527, 13.426028], [109.200136, 11.666859], [108.36613, 11.008321], [107.220929, 10.364484], [106.405113, 9.53084], [105.158264, 8.59976], [104.795185, 9.241038], [105.076202, 9.918491], [104.334335, 10.486544], [105.199915, 10.88931], [106.24967, 10.961812], [105.810524, 11.567615], [107.491403, 12.337206], [107.614548, 13.535531], [107.382727, 14.202441], [107.564525, 15.202173], [107.312706, 15.908538], [106.556008, 16.604284], [105.925762, 17.485315], [105.094598, 18.666975], [103.896532, 19.265181], [104.183388, 19.624668], [104.822574, 19.886642], [104.435, 20.758733], [103.203861, 20.766562], [102.754896, 21.675137], [102.170436, 22.464753]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Vanuatu",
      TYPE: "Sovereign country",
      ADMIN: "Vanuatu",
      GEOUNIT: "Vanuatu",
      SUBUNIT: "Vanuatu",
      NAME: "Vanuatu",
      NAME_LONG: "Vanuatu",
      ISO_A3: "VUT",
      ISO_A3_EH: "VUT",
      TINY: 2
    },
    bbox: [166.629137, -16.59785, 167.844877, -14.626497],
    geometry: {
      type: "MultiPolygon",
      coordinates: [[[[167.844877, -16.466333], [167.515181, -16.59785], [167.180008, -16.159995], [167.216801, -15.891846], [167.844877, -16.466333]]], [[[167.107712, -14.93392], [167.270028, -15.740021], [167.001207, -15.614602], [166.793158, -15.668811], [166.649859, -15.392704], [166.629137, -14.626497], [167.107712, -14.93392]]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Yemen",
      TYPE: "Sovereign country",
      ADMIN: "Yemen",
      GEOUNIT: "Yemen",
      SUBUNIT: "Yemen",
      NAME: "Yemen",
      NAME_LONG: "Yemen",
      ISO_A3: "YEM",
      ISO_A3_EH: "YEM"
    },
    bbox: [42.604873, 12.58595, 53.108573, 19.000003],
    geometry: {
      type: "Polygon",
      coordinates: [[[52.00001, 19.000003], [52.782184, 17.349742], [53.108573, 16.651051], [52.385206, 16.382411], [52.191729, 15.938433], [52.168165, 15.59742], [51.172515, 15.17525], [49.574576, 14.708767], [48.679231, 14.003202], [48.238947, 13.94809], [47.938914, 14.007233], [47.354454, 13.59222], [46.717076, 13.399699], [45.877593, 13.347764], [45.62505, 13.290946], [45.406459, 13.026905], [45.144356, 12.953938], [44.989533, 12.699587], [44.494576, 12.721653], [44.175113, 12.58595], [43.482959, 12.6368], [43.222871, 13.22095], [43.251448, 13.767584], [43.087944, 14.06263], [42.892245, 14.802249], [42.604873, 15.213335], [42.805015, 15.261963], [42.702438, 15.718886], [42.823671, 15.911742], [42.779332, 16.347891], [43.218375, 16.66689], [43.115798, 17.08844], [43.380794, 17.579987], [43.791519, 17.319977], [44.062613, 17.410359], [45.216651, 17.433329], [45.399999, 17.333335], [46.366659, 17.233315], [46.749994, 17.283338], [47.000005, 16.949999], [47.466695, 17.116682], [48.183344, 18.166669], [49.116672, 18.616668], [52.00001, 19.000003]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "South Africa",
      TYPE: "Sovereign country",
      ADMIN: "South Africa",
      GEOUNIT: "South Africa",
      SUBUNIT: "South Africa",
      NAME: "South Africa",
      NAME_LONG: "South Africa",
      ISO_A3: "ZAF",
      ISO_A3_EH: "ZAF",
      PRECISION: 50
    },
    bbox: [16.344977, -34.819166, 32.83012, -22.091313],
    geometry: {
      type: "Polygon",
      coordinates: [[[19.895768, -24.76779], [20.165726, -24.917962], [20.758609, -25.868136], [20.66647, -26.477453], [20.889609, -26.828543], [21.605896, -26.726534], [22.105969, -26.280256], [22.579532, -25.979448], [22.824271, -25.500459], [23.312097, -25.26869], [23.73357, -25.390129], [24.211267, -25.670216], [25.025171, -25.71967], [25.664666, -25.486816], [25.765849, -25.174845], [25.941652, -24.696373], [26.485753, -24.616327], [26.786407, -24.240691], [27.11941, -23.574323], [28.017236, -22.827754], [29.432188, -22.091313], [29.839037, -22.102216], [30.322883, -22.271612], [30.659865, -22.151567], [31.191409, -22.25151], [31.670398, -23.658969], [31.930589, -24.369417], [31.752408, -25.484284], [31.837778, -25.843332], [31.333158, -25.660191], [31.04408, -25.731452], [30.949667, -26.022649], [30.676609, -26.398078], [30.685962, -26.743845], [31.282773, -27.285879], [31.86806, -27.177927], [32.071665, -26.73382], [32.83012, -26.742192], [32.580265, -27.470158], [32.462133, -28.301011], [32.203389, -28.752405], [31.521001, -29.257387], [31.325561, -29.401978], [30.901763, -29.909957], [30.622813, -30.423776], [30.055716, -31.140269], [28.925553, -32.172041], [28.219756, -32.771953], [27.464608, -33.226964], [26.419452, -33.61495], [25.909664, -33.66704], [25.780628, -33.944646], [25.172862, -33.796851], [24.677853, -33.987176], [23.594043, -33.794474], [22.988189, -33.916431], [22.574157, -33.864083], [21.542799, -34.258839], [20.689053, -34.417175], [20.071261, -34.795137], [19.616405, -34.819166], [19.193278, -34.462599], [18.855315, -34.444306], [18.424643, -33.997873], [18.377411, -34.136521], [18.244499, -33.867752], [18.25008, -33.281431], [17.92519, -32.611291], [18.24791, -32.429131], [18.221762, -31.661633], [17.566918, -30.725721], [17.064416, -29.878641], [17.062918, -29.875954], [16.344977, -28.576705], [16.824017, -28.082162], [17.218929, -28.355943], [17.387497, -28.783514], [17.836152, -28.856378], [18.464899, -29.045462], [19.002127, -28.972443], [19.894734, -28.461105], [19.895768, -24.76779]], [[28.978263, -28.955597], [28.5417, -28.647502], [28.074338, -28.851469], [27.532511, -29.242711], [26.999262, -29.875954], [27.749397, -30.645106], [28.107205, -30.545732], [28.291069, -30.226217], [28.8484, -30.070051], [29.018415, -29.743766], [29.325166, -29.257387], [28.978263, -28.955597]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Zambia",
      TYPE: "Sovereign country",
      ADMIN: "Zambia",
      GEOUNIT: "Zambia",
      SUBUNIT: "Zambia",
      NAME: "Zambia",
      NAME_LONG: "Zambia",
      ISO_A3: "ZMB",
      ISO_A3_EH: "ZMB"
    },
    bbox: [21.887843, -17.961229, 33.485688, -8.238257],
    geometry: {
      type: "Polygon",
      coordinates: [[[23.215048, -17.523116], [22.562478, -16.898451], [21.887843, -16.08031], [21.933886, -12.898437], [24.016137, -12.911046], [23.930922, -12.565848], [24.079905, -12.191297], [23.904154, -11.722282], [24.017894, -11.237298], [23.912215, -10.926826], [24.257155, -10.951993], [24.314516, -11.262826], [24.78317, -11.238694], [25.418118, -11.330936], [25.75231, -11.784965], [26.553088, -11.92444], [27.16442, -11.608748], [27.388799, -12.132747], [28.155109, -12.272481], [28.523562, -12.698604], [28.934286, -13.248958], [29.699614, -13.257227], [29.616001, -12.178895], [29.341548, -12.360744], [28.642417, -11.971569], [28.372253, -11.793647], [28.49607, -10.789884], [28.673682, -9.605925], [28.449871, -9.164918], [28.734867, -8.526559], [29.002912, -8.407032], [30.346086, -8.238257], [30.74001, -8.340006], [31.157751, -8.594579], [31.556348, -8.762049], [32.191865, -8.930359], [32.759375, -9.230599], [33.231388, -9.676722], [33.485688, -10.525559], [33.31531, -10.79655], [33.114289, -11.607198], [33.306422, -12.435778], [32.991764, -12.783871], [32.688165, -13.712858], [33.214025, -13.97186], [30.179481, -14.796099], [30.274256, -15.507787], [29.516834, -15.644678], [28.947463, -16.043051], [28.825869, -16.389749], [28.467906, -16.4684], [27.598243, -17.290831], [27.044427, -17.938026], [26.706773, -17.961229], [26.381935, -17.846042], [25.264226, -17.73654], [25.084443, -17.661816], [25.07695, -17.578823], [24.682349, -17.353411], [24.033862, -17.295843], [23.215048, -17.523116]]]
    }
  }, {
    type: "Feature",
    properties: {
      SOVEREIGNT: "Zimbabwe",
      TYPE: "Sovereign country",
      ADMIN: "Zimbabwe",
      GEOUNIT: "Zimbabwe",
      SUBUNIT: "Zimbabwe",
      NAME: "Zimbabwe",
      NAME_LONG: "Zimbabwe",
      ISO_A3: "ZWE",
      ISO_A3_EH: "ZWE"
    },
    bbox: [25.264226, -22.271612, 32.849861, -15.507787],
    geometry: {
      type: "Polygon",
      coordinates: [[[29.432188, -22.091313], [28.794656, -21.639454], [28.02137, -21.485975], [27.727228, -20.851802], [27.724747, -20.499059], [27.296505, -20.39152], [26.164791, -19.293086], [25.850391, -18.714413], [25.649163, -18.536026], [25.264226, -17.73654], [26.381935, -17.846042], [26.706773, -17.961229], [27.044427, -17.938026], [27.598243, -17.290831], [28.467906, -16.4684], [28.825869, -16.389749], [28.947463, -16.043051], [29.516834, -15.644678], [30.274256, -15.507787], [30.338955, -15.880839], [31.173064, -15.860944], [31.636498, -16.07199], [31.852041, -16.319417], [32.328239, -16.392074], [32.847639, -16.713398], [32.849861, -17.979057], [32.654886, -18.67209], [32.611994, -19.419383], [32.772708, -19.715592], [32.659743, -20.30429], [32.508693, -20.395292], [32.244988, -21.116489], [31.191409, -22.25151], [30.659865, -22.151567], [30.322883, -22.271612], [29.839037, -22.102216], [29.432188, -22.091313]]]
    }
  }],
  bbox = [-180, -90, 180, 83.64513],
  countries = {
    type,
    features,
    bbox
  };
function flattenMultiLineStringCoordinates(e) {
  return e.type === "MultiPolygon" ? e.coordinates.flatMap(t => t) : e.coordinates;
}
function CountryOutlines(_ref6) {
  let {
    countries: e,
    radius: t,
    precision: r = 7,
    countryStrokes: i,
    countryStrokeOpacity: a
  } = _ref6;
  const {
      strokes: n,
      strokeOpacity: u
    } = useControls("Countries", {
      strokes: {
        label: "Strokes",
        value: i
      },
      strokeOpacity: {
        label: "Strokes Opacity",
        value: a,
        min: 0,
        max: 1,
        step: 0.01
      }
    }, {
      collapsed: !0
    }),
    f = useMemo(() => ({
      type: "MultiLineString",
      coordinates: e.features.flatMap(v => flattenMultiLineStringCoordinates(v.geometry))
    }), [e]),
    p = useMemo(() => new GeoJsonGeometry(f, t, r), [f, t, r]);
  return /* @__PURE__ */jsx("lineSegments", {
    visible: n,
    geometry: p,
    children: /* @__PURE__ */jsx("lineBasicMaterial", {
      attach: "material",
      color: "white",
      opacity: u,
      transparent: !0
    })
  });
}
const countriesData = [{
  country: "India",
  ISO_A3: "IND",
  api_collections_created: 18.3,
  api_requests_created: 256.2
}, {
  country: "United States",
  ISO_A3: "USA",
  api_collections_created: 21.6,
  api_requests_created: 216.3
}, {
  country: "China",
  ISO_A3: "CHN",
  api_collections_created: 10.7,
  api_requests_created: 50.3
}, {
  country: "Brazil",
  ISO_A3: "BRA",
  api_collections_created: 5.45,
  api_requests_created: 52.4
}, {
  country: "United Kingdom",
  ISO_A3: "GBR",
  api_collections_created: 4,
  api_requests_created: 44.1
}, {
  country: "Russia",
  ISO_A3: "RUS",
  api_collections_created: 2.94,
  api_requests_created: 21.4
}, {
  country: "France",
  ISO_A3: "FRA",
  api_collections_created: 3,
  api_requests_created: 33.5
}, {
  country: "Germany",
  ISO_A3: "DEU",
  api_collections_created: 2.92,
  api_requests_created: 30.4
}, {
  country: "Indonesia",
  ISO_A3: "IDN",
  api_collections_created: 2.48,
  api_requests_created: 35.3
}, {
  country: "Vietnam",
  ISO_A3: "VNM",
  api_collections_created: 2.24,
  api_requests_created: 25.8
}, {
  country: "Canada",
  ISO_A3: "CAN",
  api_collections_created: 2.48,
  api_requests_created: 29.6
}, {
  country: "Spain",
  ISO_A3: "ESP",
  api_collections_created: 2.35,
  api_requests_created: 26.8
}, {
  country: "South Korea",
  ISO_A3: "KOR",
  api_collections_created: 1.08,
  api_requests_created: 17.6
}, {
  country: "Australia",
  ISO_A3: "AUS",
  api_collections_created: 1.8,
  api_requests_created: 17.4
}, {
  country: "Hong Kong",
  ISO_A3: "HKG",
  api_collections_created: 1.5,
  api_requests_created: 12.4
}, {
  country: "Poland",
  ISO_A3: "POL",
  api_collections_created: 1.48,
  api_requests_created: 19.3
}, {
  country: "Mexico",
  ISO_A3: "MEX",
  api_collections_created: 1.46,
  api_requests_created: 12.5
}, {
  country: "Ukraine",
  ISO_A3: "UKR",
  api_collections_created: 1.71,
  api_requests_created: 20.7
}, {
  country: "Netherlands",
  ISO_A3: "NLD",
  api_collections_created: 1.57,
  api_requests_created: 18.5
}, {
  country: "Italy",
  ISO_A3: "ITA",
  api_collections_created: 1.41,
  api_requests_created: 12.7
}, {
  country: "Colombia",
  ISO_A3: "COL",
  api_collections_created: 1.24,
  api_requests_created: 10.7
}, {
  country: "Turkey",
  ISO_A3: "TUR",
  api_collections_created: 1.21,
  api_requests_created: 15.2
}, {
  country: "Argentina",
  ISO_A3: "ARG",
  api_collections_created: 1.29,
  api_requests_created: 10.7
}, {
  country: "Japan",
  ISO_A3: "JPN",
  api_collections_created: 1.33,
  api_requests_created: 15.8
}, {
  country: "Singapore",
  ISO_A3: "SGP",
  api_collections_created: 1.25,
  api_requests_created: 12.6
}, {
  country: "Thailand",
  ISO_A3: "THA",
  api_collections_created: 1.29,
  api_requests_created: 12.1
}, {
  country: "Pakistan",
  ISO_A3: "PAK",
  api_collections_created: 998783,
  api_requests_created: 15.1
}, {
  country: "Philippines",
  ISO_A3: "PHL",
  api_collections_created: 838610,
  api_requests_created: 12
}, {
  country: "Egypt",
  ISO_A3: "EGY",
  api_collections_created: 727575,
  api_requests_created: 11
}, {
  country: "Taiwan",
  ISO_A3: "TWN",
  api_collections_created: 902232,
  api_requests_created: 7.91
}, {
  country: "Israel",
  ISO_A3: "ISR",
  api_collections_created: 794402,
  api_requests_created: 10
}, {
  country: "Chile",
  ISO_A3: "CHL",
  api_collections_created: 723008,
  api_requests_created: 4.57
}, {
  country: "South Africa",
  ISO_A3: "ZAF",
  api_collections_created: 687031,
  api_requests_created: 7.09
}, {
  country: "Romania",
  ISO_A3: "ROU",
  api_collections_created: 688967,
  api_requests_created: 9.42
}, {
  country: "Sweden",
  ISO_A3: "SWE",
  api_collections_created: 728716,
  api_requests_created: 5.44
}, {
  country: "Portugal",
  ISO_A3: "PRT",
  api_collections_created: 620597,
  api_requests_created: 6.69
}, {
  country: "Peru",
  ISO_A3: "PER",
  api_collections_created: 541162,
  api_requests_created: 4.4
}, {
  country: "Belgium",
  ISO_A3: "BEL",
  api_collections_created: 608890,
  api_requests_created: 5.72
}, {
  country: "Nigeria",
  ISO_A3: "NGA",
  api_collections_created: 447724,
  api_requests_created: 6.77
}, {
  country: "Malaysia",
  ISO_A3: "MYS",
  api_collections_created: 529480,
  api_requests_created: 6.1
}, {
  country: "Ireland",
  ISO_A3: "IRL",
  api_collections_created: 572542,
  api_requests_created: 7.73
}, {
  country: "Switzerland",
  ISO_A3: "CHE",
  api_collections_created: 522068,
  api_requests_created: 5.07
}, {
  country: "Belarus",
  ISO_A3: "BLR",
  api_collections_created: 565949,
  api_requests_created: 5.27
}, {
  country: "Bangladesh",
  ISO_A3: "BGD",
  api_collections_created: 370852,
  api_requests_created: 4.82
}, {
  country: "Sri Lanka",
  ISO_A3: "LKA",
  api_collections_created: 391246,
  api_requests_created: 4.14
}, {
  country: "Czechia",
  ISO_A3: "CZE",
  api_collections_created: 406441,
  api_requests_created: 4.47
}, {
  country: "Denmark",
  ISO_A3: "DNK",
  api_collections_created: 408705,
  api_requests_created: 3.66
}, {
  country: "United Arab Emirates",
  ISO_A3: "ARE",
  api_collections_created: 340670,
  api_requests_created: 3.84
}, {
  country: "Austria",
  ISO_A3: "AUT",
  api_collections_created: 355687,
  api_requests_created: 3.67
}, {
  country: "Iran",
  ISO_A3: "IRN",
  api_collections_created: 411622,
  api_requests_created: 3.59
}, {
  country: "Norway",
  ISO_A3: "NOR",
  api_collections_created: 351527,
  api_requests_created: 3.47
}, {
  country: "Serbia",
  ISO_A3: "SRB",
  api_collections_created: 316433,
  api_requests_created: 3.79
}, {
  country: "Finland",
  ISO_A3: "FIN",
  api_collections_created: 303134,
  api_requests_created: 4.63
}, {
  country: "New Zealand",
  ISO_A3: "NZL",
  api_collections_created: 391246,
  api_requests_created: 3.69
}, {
  country: "Bulgaria",
  ISO_A3: "BGR",
  api_collections_created: 305364,
  api_requests_created: 3.9
}, {
  country: "Hungary",
  ISO_A3: "HUN",
  api_collections_created: 287860,
  api_requests_created: 2.84
}, {
  country: "Nepal",
  ISO_A3: "NPL",
  api_collections_created: 225973,
  api_requests_created: 2.58
}, {
  country: "Greece",
  ISO_A3: "GRC",
  api_collections_created: 264943,
  api_requests_created: 2.73
}, {
  country: "Kazakhstan",
  ISO_A3: "KAZ",
  api_collections_created: 197921,
  api_requests_created: 2.31
}, {
  country: "Saudi Arabia",
  ISO_A3: "SAU",
  api_collections_created: 224546,
  api_requests_created: 2.32
}, {
  country: "Kenya",
  ISO_A3: "KEN",
  api_collections_created: 217006,
  api_requests_created: 2.369
}, {
  country: "Morocco",
  ISO_A3: "MAR",
  api_collections_created: 174458,
  api_requests_created: 2.1
}, {
  country: "Tunisia",
  ISO_A3: "TUN",
  api_collections_created: 174934,
  api_requests_created: 1.67
}, {
  country: "Ecuador",
  ISO_A3: "ECU",
  api_collections_created: 177154,
  api_requests_created: 1.46
}, {
  country: "Uzbekistan",
  ISO_A3: "UZB",
  api_collections_created: 130926,
  api_requests_created: 1.89
}, {
  country: "Uruguay",
  ISO_A3: "URY",
  api_collections_created: 187272,
  api_requests_created: 1.73
}, {
  country: "Slovakia",
  ISO_A3: "SVK",
  api_collections_created: 175817,
  api_requests_created: 2.47
}, {
  country: "Armenia",
  ISO_A3: "ARM",
  api_collections_created: 139850,
  api_requests_created: 1.865
}, {
  country: "Georgia",
  ISO_A3: "GEO",
  api_collections_created: 94015,
  api_requests_created: 1.54
}, {
  country: "Costa Rica",
  ISO_A3: "CRI",
  api_collections_created: 166282,
  api_requests_created: 1.25
}, {
  country: "Croatia",
  ISO_A3: "HRV",
  api_collections_created: 148300,
  api_requests_created: 1.55
}, {
  country: "Venezuela",
  ISO_A3: "VEN",
  api_collections_created: 118396,
  api_requests_created: 1.36
}, {
  country: "Cambodia",
  ISO_A3: "KHM",
  api_collections_created: 111585,
  api_requests_created: 2.1
}, {
  country: "Bolivia",
  ISO_A3: "BOL",
  api_collections_created: 111286,
  api_requests_created: 1
}, {
  country: "Guatemala",
  ISO_A3: "GTM",
  api_collections_created: 104345,
  api_requests_created: 959417
}, {
  country: "Cyprus",
  ISO_A3: "CYP",
  api_collections_created: 61311,
  api_requests_created: 1.4
}, {
  country: "Latvia",
  ISO_A3: "LVA",
  api_collections_created: 107894,
  api_requests_created: 1.53
}, {
  country: "Estonia",
  ISO_A3: "EST",
  api_collections_created: 108469,
  api_requests_created: 1.41
}, {
  country: "Lithuania",
  ISO_A3: "LTU",
  api_collections_created: 54816,
  api_requests_created: 1.09
}, {
  country: "Jordan",
  ISO_A3: "JOR",
  api_collections_created: 55550,
  api_requests_created: 1.24
}, {
  country: "Azerbaijan",
  ISO_A3: "AZE",
  api_collections_created: 71577,
  api_requests_created: 702376
}, {
  country: "Palestine",
  ISO_A3: "PSE",
  api_collections_created: 83327,
  api_requests_created: 1.34
}, {
  country: "Lebanon",
  ISO_A3: "LBN",
  api_collections_created: 91272,
  api_requests_created: 1.18
}, {
  country: "Slovenia",
  ISO_A3: "SVN",
  api_collections_created: 100059,
  api_requests_created: 1.02
}, {
  country: "Myanmar",
  ISO_A3: "MMR",
  api_collections_created: 59886,
  api_requests_created: 891240
}, {
  country: "Ghana",
  ISO_A3: "GHA",
  api_collections_created: 71329,
  api_requests_created: 840719
}, {
  country: "Hashemite Kingdom of Jordan",
  ISO_A3: "JOR",
  api_collections_created: 55550,
  api_requests_created: 850037
}, {
  country: "Republic of Lithuania",
  ISO_A3: "LTU",
  api_collections_created: 54816,
  api_requests_created: 985901
}, {
  country: "Dominican Republic",
  ISO_A3: "DOM",
  api_collections_created: 75403,
  api_requests_created: 679872
}, {
  country: "Bosnia and Herzegovina",
  ISO_A3: "BIH",
  api_collections_created: 77597,
  api_requests_created: 793671
}, {
  country: "North Macedonia",
  ISO_A3: "MKD",
  api_collections_created: 55517,
  api_requests_created: 928126
}, {
  country: "Mongolia",
  ISO_A3: "MNG",
  api_collections_created: 65880,
  api_requests_created: 631086
}, {
  country: "El Salvador",
  ISO_A3: "SLV",
  api_collections_created: 59032,
  api_requests_created: 733183
}, {
  country: "Cyprus",
  ISO_A3: "CYP",
  api_collections_created: 61311,
  api_requests_created: 1.401
}, {
  country: "Ethiopia",
  ISO_A3: "ETH",
  api_collections_created: 40253,
  api_requests_created: 502324
}, {
  country: "Albania",
  ISO_A3: "ALB",
  api_collections_created: 56274,
  api_requests_created: 563558
}, {
  country: "Luxembourg",
  ISO_A3: "LUX",
  api_collections_created: 71138,
  api_requests_created: 550752
}, {
  country: "Algeria",
  ISO_A3: "DZA",
  api_collections_created: 40645,
  api_requests_created: 468847
}, {
  country: "Syria",
  ISO_A3: "SYR",
  api_collections_created: 41321,
  api_requests_created: 618995
}, {
  country: "Rest of the world",
  ISO_A3: null,
  api_collections_created: 44.1,
  api_requests_created: 509.5
}];
function mergeBufferGeometries(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  const r = e[0].index !== null,
    i = new Set(Object.keys(e[0].attributes)),
    a = new Set(Object.keys(e[0].morphAttributes)),
    n = {},
    u = {},
    f = e[0].morphTargetsRelative,
    p = new BufferGeometry();
  let y = 0;
  for (let v = 0; v < e.length; ++v) {
    const A = e[v];
    let c = 0;
    if (r !== (A.index !== null)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + v + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them."), null;
    for (const E in A.attributes) {
      if (!i.has(E)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + v + '. All geometries must have compatible attributes; make sure "' + E + '" attribute exists among all geometries, or in none of them.'), null;
      n[E] === void 0 && (n[E] = []), n[E].push(A.attributes[E]), c++;
    }
    if (c !== i.size) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + v + ". Make sure all geometries have the same number of attributes."), null;
    if (f !== A.morphTargetsRelative) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + v + ". .morphTargetsRelative must be consistent throughout all geometries."), null;
    for (const E in A.morphAttributes) {
      if (!a.has(E)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + v + ".  .morphAttributes must be consistent throughout all geometries."), null;
      u[E] === void 0 && (u[E] = []), u[E].push(A.morphAttributes[E]);
    }
    if (t) {
      let E;
      if (r) E = A.index.count;else if (A.attributes.position !== void 0) E = A.attributes.position.count;else return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + v + ". The geometry must have either an index or a position attribute"), null;
      p.addGroup(y, E, v), y += E;
    }
  }
  if (r) {
    let v = 0;
    const A = [];
    for (let c = 0; c < e.length; ++c) {
      const E = e[c].index;
      for (let d = 0; d < E.count; ++d) A.push(E.getX(d) + v);
      v += e[c].attributes.position.count;
    }
    p.setIndex(A);
  }
  for (const v in n) {
    const A = mergeBufferAttributes(n[v]);
    if (!A) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + v + " attribute."), null;
    p.setAttribute(v, A);
  }
  for (const v in u) {
    const A = u[v][0].length;
    if (A === 0) break;
    p.morphAttributes = p.morphAttributes || {}, p.morphAttributes[v] = [];
    for (let c = 0; c < A; ++c) {
      const E = [];
      for (let g = 0; g < u[v].length; ++g) E.push(u[v][g][c]);
      const d = mergeBufferAttributes(E);
      if (!d) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + v + " morphAttribute."), null;
      p.morphAttributes[v].push(d);
    }
  }
  return p;
}
function mergeBufferAttributes(e) {
  let t,
    r,
    i,
    a = 0;
  for (let f = 0; f < e.length; ++f) {
    const p = e[f];
    if (p.isInterleavedBufferAttribute) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. InterleavedBufferAttributes are not supported."), null;
    if (t === void 0 && (t = p.array.constructor), t !== p.array.constructor) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes."), null;
    if (r === void 0 && (r = p.itemSize), r !== p.itemSize) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes."), null;
    if (i === void 0 && (i = p.normalized), i !== p.normalized) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes."), null;
    a += p.array.length;
  }
  const n = new t(a);
  let u = 0;
  for (let f = 0; f < e.length; ++f) n.set(e[f].array, u), u += e[f].array.length;
  return new BufferAttribute(n, r, i);
}
const InfoPopup = forwardRef((_ref7, r) => {
  let {
    children: e,
    ...t
  } = _ref7;
  const i = useRef(),
    a = useRef(new Vector3()),
    [n, u] = useState(!1),
    {
      headerColor: f,
      shadowOpacity: p,
      shadowDistance: y,
      heightControl: v,
      widthControl: A,
      scaleControl: c
    } = useControls("Info Box", {
      headerColor: {
        label: "header color",
        value: t.infoBoxHeaderColor
      },
      shadowOpacity: {
        label: "shadow",
        value: t.infoBoxShadowOpacity,
        min: 0,
        max: 1
      },
      shadowDistance: {
        label: "shadow distance",
        value: t.infoBoxShadowDistance,
        min: 0,
        max: 20
      },
      heightControl: {
        value: t.infoBoxHeight,
        min: 0,
        max: 500
      },
      widthControl: {
        value: t.infoBoxWidth,
        min: 0,
        max: 500
      },
      scaleControl: {
        value: t.infoBoxScale,
        min: 0.5,
        max: 1
      }
    }, {
      collapsed: !0
    });
  useFrame(I => {
    const o = I.camera.position.distanceTo(i.current.getWorldPosition(a.current)) <= 12.5;
    o !== n && u(o);
  }), useEffect(() => {
    n || t.updateRange(n);
  }, [n]), useImperativeHandle(r, () => ({
    getRange: () => n
  }));
  const E = useSpring$1({
      opacity: `${t.infoVisible ? 1 : 0}`,
      scale: `${c}`,
      to: {
        opacity: `${t.infoVisible ? 1 : 0}`,
        scale: `${c}`
      }
    }),
    d = useSpring$1({
      height: `${t.infoVisible ? v : 0}px`,
      width: `${A}px`,
      y: `${t.infoVisible ? 0 : v / 2}px`,
      boxShadow: `-${y}px ${y}px rgba(33, 33, 33, ${p})`
    }),
    g = useSpring$1({
      y: `${t.infoVisible ? 0 : -v / 2}px`
    });
  return /* @__PURE__ */jsx("group", {
    ref: i,
    ...t,
    children: t.infoVisible && /* @__PURE__ */jsx(Html, {
      className: "postman-globe-info-popups",
      children: /* @__PURE__ */jsx(animated$1.div, {
        className: "postman-globe-info-popup",
        style: E,
        children: /* @__PURE__ */jsx(animated$1.div, {
          className: "postman-globe-info-popup__outer",
          style: d,
          children: /* @__PURE__ */jsxs(animated$1.div, {
            className: "postman-globe-info-popup__inner",
            style: g,
            children: [/* @__PURE__ */jsx("div", {
              className: "postman-globe-info-popup__header",
              style: {
                background: f
              },
              children: t.countryData.country
            }), /* @__PURE__ */jsxs("div", {
              className: "postman-globe-info-popup__content",
              children: [t.countryData.api_collections_created && /* @__PURE__ */jsxs("div", {
                className: "postman-globe-info-popup__content__section",
                children: [/* @__PURE__ */jsxs("div", {
                  className: "title",
                  children: [/* @__PURE__ */jsx("h4", {
                    children: "Collections created"
                  }), /* @__PURE__ */jsx("span", {
                    children: " (all time)"
                  })]
                }), t.countryData.api_collections_created >= 1 && t.countryData.api_collections_created <= 75.5 ? /* @__PURE__ */jsxs("p", {
                  children: [t.countryData.api_collections_created, " million"]
                }) : /* @__PURE__ */jsx("p", {
                  children: Number(t.countryData.api_collections_created.toFixed(0)).toLocaleString().split(/\s/).join(",")
                })]
              }), t.countryData.api_requests_created && /* @__PURE__ */jsxs("div", {
                className: "postman-globe-info-popup__content__section",
                children: [/* @__PURE__ */jsxs("div", {
                  className: "title",
                  children: [/* @__PURE__ */jsx("h4", {
                    children: "Requests created"
                  }), /* @__PURE__ */jsx("span", {
                    children: " (past year)"
                  })]
                }), t.countryData.api_requests_created >= 1 && t.countryData.api_requests_created <= 600.5 ? /* @__PURE__ */jsxs("p", {
                  children: [t.countryData.api_requests_created, " million"]
                }) : /* @__PURE__ */jsx("p", {
                  children: Number(t.countryData.api_requests_created.toFixed(0)).toLocaleString().split(/\s/).join(",")
                })]
              })]
            })]
          })
        })
      })
    })
  });
});
function Country(_ref8) {
  let {
    coords: e,
    geometry: t,
    isoA3: r,
    precision: i = 7,
    radius: a,
    hasData: n,
    countryData: u,
    defaultColor: f,
    defaultHoverColor: p,
    infoBoxHeaderColor: y,
    infoBoxShadowOpacity: v,
    infoBoxShadowDistance: A,
    infoBoxWidth: c,
    infoBoxHeight: E,
    infoBoxScale: d
  } = _ref8;
  const g = useRef(),
    [I, o] = useState(!1),
    s = p,
    [l, h] = useState(new Vector3()),
    [m, S] = useState(!1),
    {
      color: b
    } = useSpring({
      color: I || m ? s : f
    }),
    T = useCallback(B => {
      n && (B.stopPropagation(), o(!0));
    }, [e, r]),
    C = useCallback(B => {
      n && (B.stopPropagation(), o(!1));
    }, [e, r]),
    F = useMemo(() => {
      const B = new BufferGeometry(),
        x = t.type === "MultiPolygon" ? e.map(P => new ConicPolygonGeometry(P, a, a, !0, !0, !0, i)) : [new ConicPolygonGeometry(e, a, a, !0, !0, !0, i)],
        N = mergeBufferGeometries(x, !1);
      return N.computeBoundingSphere(), B.copy(N), h(N.boundingSphere.center), B;
    }, [e, a]),
    w = useCallback(B => {
      if (!n) return;
      B.stopPropagation();
      const x = !m && g.current.getRange();
      if (S(x), x) {
        const N = new Vector3();
        B.object.parent.worldToLocal(N.copy(B.point)), N.x += 0.1, N.y -= 0.1, h(N);
      }
    }, [m]),
    k = B => {
      S(B);
    },
    L = useCallback(B => {
      n && (B.stopPropagation(), S(!1));
    }, []);
  return /* @__PURE__ */jsxs("group", {
    children: [/* @__PURE__ */jsx(animated.mesh, {
      geometry: F,
      onPointerOver: T,
      onPointerOut: C,
      onClick: w,
      onPointerMissed: L,
      children: /* @__PURE__ */jsx(animated.meshBasicMaterial, {
        attach: "material",
        depthWrite: !1,
        color: b,
        blending: MultiplyBlending
      })
    }), n && /* @__PURE__ */jsx(InfoPopup, {
      ref: g,
      position: l,
      countryData: u,
      infoVisible: m,
      updateRange: k,
      infoBoxHeaderColor: y,
      infoBoxShadowOpacity: v,
      infoBoxShadowDistance: A,
      infoBoxWidth: c,
      infoBoxHeight: E,
      infoBoxScale: d
    })]
  });
}
function RestOfTheWorld(_ref9) {
  let {
    countries: e,
    radius: t,
    nameList: r,
    defaultColor: i,
    defaultHoverColor: a,
    infoBoxHeaderColor: n,
    infoBoxShadowOpacity: u,
    infoBoxShadowDistance: f,
    infoBoxWidth: p,
    infoBoxHeight: y,
    infoBoxScale: v
  } = _ref9;
  return /* @__PURE__ */jsx(Fragment, {
    children: e && e.features.map((_ref10, E) => {
      let {
        properties: A,
        geometry: c
      } = _ref10;
      return /* @__PURE__ */jsx(require$$0.Fragment, {
        children: !r.includes(A.NAME) && /* @__PURE__ */jsx(Country, {
          defaultColor: i,
          defaultHoverColor: a,
          radius: t,
          hasData: !0,
          infoPopupesVisible: !0,
          precision: A.PRECISION,
          admin: A.ADMIN,
          name: A.NAME,
          countryData: countriesData.find(d => d.country === "Rest of the world"),
          isoA3: A.ISO_A3,
          coords: c.coordinates,
          geometry: c,
          infoBoxHeaderColor: n,
          infoBoxShadowOpacity: u,
          infoBoxShadowDistance: f,
          infoBoxWidth: p,
          infoBoxHeight: y,
          infoBoxScale: v
        })
      }, `${A.NAME}-${E}`);
    })
  });
}
const Countries = forwardRef((_ref11, c) => {
  let {
    countries: e,
    radius: t,
    infoPopupesVisible: r,
    countryFillNoData: i,
    countryFillHasData: a,
    countryFillHover: n,
    infoBoxHeaderColor: u,
    infoBoxShadowOpacity: f,
    infoBoxShadowDistance: p,
    infoBoxWidth: y,
    infoBoxHeight: v,
    infoBoxScale: A
  } = _ref11;
  const E = countriesData.map(o => o.country),
    {
      defaultColorNoData: d,
      defaultColorData: g,
      defaultHoverColor: I
    } = useControls("Countries", {
      defaultColorNoData: {
        label: "no data",
        value: i
      },
      defaultColorData: {
        label: "has data",
        value: a
      },
      defaultHoverColor: {
        label: "is hovered",
        value: n
      }
    }, {
      collapsed: !0
    });
  return /* @__PURE__ */jsxs("group", {
    ref: c,
    children: [e && /* @__PURE__ */jsx(RestOfTheWorld, {
      defaultColor: d,
      defaultHoverColor: d,
      radius: t + 0.01,
      countries: e,
      nameList: E,
      infoBoxHeaderColor: u,
      infoBoxShadowOpacity: f,
      infoBoxShadowDistance: p,
      infoBoxWidth: y,
      infoBoxHeight: v,
      infoBoxScale: A
    }), e && e.features.map((_ref12, l) => {
      let {
        properties: o,
        geometry: s
      } = _ref12;
      return /* @__PURE__ */jsx(require$$0.Fragment, {
        children: E.includes(o.NAME) && /* @__PURE__ */jsx(Country, {
          defaultColor: g,
          defaultHoverColor: I,
          radius: t + 0.01,
          hasData: E.includes(o.NAME),
          infoPopupesVisible: r,
          precision: o.PRECISION,
          admin: o.ADMIN,
          name: o.NAME,
          countryData: countriesData.find(h => h.country === o.NAME),
          isoA3: o.ISO_A3,
          coords: s.coordinates,
          geometry: s,
          infoBoxHeaderColor: u,
          infoBoxShadowOpacity: f,
          infoBoxShadowDistance: p,
          infoBoxWidth: y,
          infoBoxHeight: v,
          infoBoxScale: A
        })
      }, `${o.NAME}-${l}`);
    })]
  });
});
function GlobeOutline(_ref13) {
  let {
    radius: e,
    outlineThickness: t
  } = _ref13;
  const r = useRef(),
    i = useRef(),
    {
      thickness: a
    } = useControls("Globe", {
      thickness: {
        label: "Outline Thickness",
        value: t,
        min: 0,
        max: 10,
        step: 0.01
      }
    }, {
      collapsed: !0
    });
  return useFrame(n => {
    r.current && r.current.lookAt(n.camera.position);
  }), /* @__PURE__ */jsxs("mesh", {
    ref: r,
    children: [/* @__PURE__ */jsx("planeGeometry", {
      attach: "geometry",
      args: [e * 2, e * 2]
    }), /* @__PURE__ */jsx("portalMaterial", {
      ref: i,
      uColorStart: "black",
      uColorEnd: "white",
      uThickness: a,
      transparent: !0,
      depthTest: !1
    })]
  });
}
const PortalMaterial = shaderMaterial({
  uColorStart: new Color("black"),
  uColorEnd: new Color("white"),
  uThickness: 1
}, /* glsl */
`
  varying vec2 vUv;
  void main() {
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectionPosition = projectionMatrix * viewPosition;
    gl_Position = projectionPosition;
    vUv = uv;
  }`, /* glsl */
`
  uniform vec3 uColorStart;
  uniform vec3 uColorEnd;
  uniform float uThickness;
  varying vec2 vUv;
  void main() {
    float strength = 1.;
    float outerGlow = distance(vUv, vec2(0.5));
    float hardness = .001;
    float thickness = uThickness * .0025;
    float edge = .5 - thickness;
    float edge2 = edge + thickness;
    float circle1 = smoothstep(edge, edge + hardness, outerGlow);
    float circle2 = smoothstep(edge2, edge2 + hardness, outerGlow);

    float circle = circle1 - circle2;

    vec3 alpha = mix(uColorStart, uColorEnd, circle);

    gl_FragColor = vec4(vec3(0.0), alpha);

    #include <tonemapping_fragment>
    #include <encodings_fragment>
  }`);
extend({
  PortalMaterial
});
const Globe = forwardRef((e, t) => {
    const {
        radius: r
      } = useControls("Globe", {
        radius: {
          label: "Radius",
          value: e.radius,
          min: 0,
          max: 2,
          step: 1e-3
        }
      }, {
        collapsed: !0
      }),
      i = useRef(),
      [a, n] = useState(!1);
    return /* @__PURE__ */jsxs("group", {
      ref: t,
      ...e,
      children: [/* @__PURE__ */jsxs("mesh", {
        ref: i,
        onClick: f => {
          n(!1);
        },
        children: [/* @__PURE__ */jsx("sphereGeometry", {
          args: [r, 75, 75]
        }), /* @__PURE__ */jsx("meshStandardMaterial", {
          color: "white"
        })]
      }), /* @__PURE__ */jsx(Countries, {
        countryFillNoData: e.countryFillNoData,
        countryFillHasData: e.countryFillHasData,
        countryFillHover: e.countryFillHover,
        countries,
        radius: r,
        infoPopupesVisible: a,
        infoBoxHeaderColor: e.infoBoxHeaderColor,
        infoBoxShadowOpacity: e.infoBoxShadowOpacity,
        infoBoxShadowDistance: e.infoBoxShadowDistance,
        infoBoxWidth: e.infoBoxWidth,
        infoBoxHeight: e.infoBoxHeight,
        infoBoxScale: e.infoBoxScale
      }), countries && /* @__PURE__ */jsx(CountryOutlines, {
        radius: r + 0.01,
        countries,
        countryStrokes: e.countryStrokes,
        countryStrokeOpacity: e.countryStrokeOpacity
      }), /* @__PURE__ */jsx(GlobeOutline, {
        outlineThickness: e.outlineThickness,
        radius: r * 1.01
      })]
    });
  }),
  svgNS = "http://www.w3.org/2000/svg";
let locationHref = "",
  _useWebWorker = !1;
const initialDefaultFrame = -999999,
  setWebWorker = e => {
    _useWebWorker = !!e;
  },
  getWebWorker = () => _useWebWorker,
  setLocationHref = e => {
    locationHref = e;
  },
  getLocationHref = () => locationHref;
function createTag(e) {
  return document.createElement(e);
}
function extendPrototype(e, t) {
  var r,
    i = e.length,
    a;
  for (r = 0; r < i; r += 1) {
    a = e[r].prototype;
    for (var n in a) Object.prototype.hasOwnProperty.call(a, n) && (t.prototype[n] = a[n]);
  }
}
function getDescriptor(e, t) {
  return Object.getOwnPropertyDescriptor(e, t);
}
function createProxyFunction(e) {
  function t() {}
  return t.prototype = e, t;
}
const audioControllerFactory = function () {
    function e(t) {
      this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1;
    }
    return e.prototype = {
      addAudio: function (t) {
        this.audios.push(t);
      },
      pause: function () {
        var t,
          r = this.audios.length;
        for (t = 0; t < r; t += 1) this.audios[t].pause();
      },
      resume: function () {
        var t,
          r = this.audios.length;
        for (t = 0; t < r; t += 1) this.audios[t].resume();
      },
      setRate: function (t) {
        var r,
          i = this.audios.length;
        for (r = 0; r < i; r += 1) this.audios[r].setRate(t);
      },
      createAudio: function (t) {
        return this.audioFactory ? this.audioFactory(t) : window.Howl ? new window.Howl({
          src: [t]
        }) : {
          isPlaying: !1,
          play: function () {
            this.isPlaying = !0;
          },
          seek: function () {
            this.isPlaying = !1;
          },
          playing: function () {},
          rate: function () {},
          setVolume: function () {}
        };
      },
      setAudioFactory: function (t) {
        this.audioFactory = t;
      },
      setVolume: function (t) {
        this._volume = t, this._updateVolume();
      },
      mute: function () {
        this._isMuted = !0, this._updateVolume();
      },
      unmute: function () {
        this._isMuted = !1, this._updateVolume();
      },
      getVolume: function () {
        return this._volume;
      },
      _updateVolume: function () {
        var t,
          r = this.audios.length;
        for (t = 0; t < r; t += 1) this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1));
      }
    }, function () {
      return new e();
    };
  }(),
  createTypedArray = function () {
    function e(r, i) {
      var a = 0,
        n = [],
        u;
      switch (r) {
        case "int16":
        case "uint8c":
          u = 1;
          break;
        default:
          u = 1.1;
          break;
      }
      for (a = 0; a < i; a += 1) n.push(u);
      return n;
    }
    function t(r, i) {
      return r === "float32" ? new Float32Array(i) : r === "int16" ? new Int16Array(i) : r === "uint8c" ? new Uint8ClampedArray(i) : e(r, i);
    }
    return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? t : e;
  }();
function createSizedArray(e) {
  return Array.apply(null, {
    length: e
  });
}
let subframeEnabled = !0,
  expressionsPlugin = null,
  idPrefix$1 = "";
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
  bmPow = Math.pow,
  bmSqrt = Math.sqrt,
  bmFloor = Math.floor,
  bmMin = Math.min,
  BMMath = {};
(function () {
  var e = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"],
    t,
    r = e.length;
  for (t = 0; t < r; t += 1) BMMath[e[t]] = Math[e[t]];
})();
BMMath.random = Math.random;
BMMath.abs = function (e) {
  var t = typeof e;
  if (t === "object" && e.length) {
    var r = createSizedArray(e.length),
      i,
      a = e.length;
    for (i = 0; i < a; i += 1) r[i] = Math.abs(e[i]);
    return r;
  }
  return Math.abs(e);
};
let defaultCurveSegments = 150;
const degToRads = Math.PI / 180,
  roundCorner = 0.5519;
function BMEnterFrameEvent(e, t, r, i) {
  this.type = e, this.currentTime = t, this.totalTime = r, this.direction = i < 0 ? -1 : 1;
}
function BMCompleteEvent(e, t) {
  this.type = e, this.direction = t < 0 ? -1 : 1;
}
function BMCompleteLoopEvent(e, t, r, i) {
  this.type = e, this.currentLoop = r, this.totalLoops = t, this.direction = i < 0 ? -1 : 1;
}
function BMSegmentStartEvent(e, t, r) {
  this.type = e, this.firstFrame = t, this.totalFrames = r;
}
function BMDestroyEvent(e, t) {
  this.type = e, this.target = t;
}
function BMRenderFrameErrorEvent(e, t) {
  this.type = "renderFrameError", this.nativeError = e, this.currentTime = t;
}
function BMConfigErrorEvent(e) {
  this.type = "configError", this.nativeError = e;
}
const createElementID = function () {
  var e = 0;
  return function () {
    return e += 1, idPrefix$1 + "__lottie_element_" + e;
  };
}();
function HSVtoRGB(e, t, r) {
  var i, a, n, u, f, p, y, v;
  switch (u = Math.floor(e * 6), f = e * 6 - u, p = r * (1 - t), y = r * (1 - f * t), v = r * (1 - (1 - f) * t), u % 6) {
    case 0:
      i = r, a = v, n = p;
      break;
    case 1:
      i = y, a = r, n = p;
      break;
    case 2:
      i = p, a = r, n = v;
      break;
    case 3:
      i = p, a = y, n = r;
      break;
    case 4:
      i = v, a = p, n = r;
      break;
    case 5:
      i = r, a = p, n = y;
      break;
  }
  return [i, a, n];
}
function RGBtoHSV(e, t, r) {
  var i = Math.max(e, t, r),
    a = Math.min(e, t, r),
    n = i - a,
    u,
    f = i === 0 ? 0 : n / i,
    p = i / 255;
  switch (i) {
    case a:
      u = 0;
      break;
    case e:
      u = t - r + n * (t < r ? 6 : 0), u /= 6 * n;
      break;
    case t:
      u = r - e + n * 2, u /= 6 * n;
      break;
    case r:
      u = e - t + n * 4, u /= 6 * n;
      break;
  }
  return [u, f, p];
}
function addSaturationToRGB(e, t) {
  var r = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
  return r[1] += t, r[1] > 1 ? r[1] = 1 : r[1] <= 0 && (r[1] = 0), HSVtoRGB(r[0], r[1], r[2]);
}
function addBrightnessToRGB(e, t) {
  var r = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
  return r[2] += t, r[2] > 1 ? r[2] = 1 : r[2] < 0 && (r[2] = 0), HSVtoRGB(r[0], r[1], r[2]);
}
function addHueToRGB(e, t) {
  var r = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
  return r[0] += t / 360, r[0] > 1 ? r[0] -= 1 : r[0] < 0 && (r[0] += 1), HSVtoRGB(r[0], r[1], r[2]);
}
(function () {
  var e = [],
    t,
    r;
  for (t = 0; t < 256; t += 1) r = t.toString(16), e[t] = r.length === 1 ? "0" + r : r;
  return function (i, a, n) {
    return i < 0 && (i = 0), a < 0 && (a = 0), n < 0 && (n = 0), "#" + e[i] + e[a] + e[n];
  };
})();
const setSubframeEnabled = e => {
    subframeEnabled = !!e;
  },
  getSubframeEnabled = () => subframeEnabled,
  setExpressionsPlugin = e => {
    expressionsPlugin = e;
  },
  getExpressionsPlugin = () => expressionsPlugin,
  setDefaultCurveSegments = e => {
    defaultCurveSegments = e;
  },
  getDefaultCurveSegments = () => defaultCurveSegments,
  setIdPrefix = e => {
    idPrefix$1 = e;
  };
function createNS(e) {
  return document.createElementNS(svgNS, e);
}
const dataManager = function () {
    var e = 1,
      t = [],
      r,
      i,
      a = {
        onmessage: function () {},
        postMessage: function (c) {
          r({
            data: c
          });
        }
      },
      n = {
        postMessage: function (c) {
          a.onmessage({
            data: c
          });
        }
      };
    function u(c) {
      if (window.Worker && window.Blob && getWebWorker()) {
        var E = new Blob(["var _workerSelf = self; self.onmessage = ", c.toString()], {
            type: "text/javascript"
          }),
          d = URL.createObjectURL(E);
        return new Worker(d);
      }
      return r = c, a;
    }
    function f() {
      i || (i = u(function (E) {
        function d() {
          function I(x, N) {
            var P,
              _,
              M = x.length,
              R,
              G,
              D,
              z;
            for (_ = 0; _ < M; _ += 1) if (P = x[_], "ks" in P && !P.completed) {
              if (P.completed = !0, P.tt && (x[_ - 1].td = P.tt), P.hasMask) {
                var Y = P.masksProperties;
                for (G = Y.length, R = 0; R < G; R += 1) if (Y[R].pt.k.i) m(Y[R].pt.k);else for (z = Y[R].pt.k.length, D = 0; D < z; D += 1) Y[R].pt.k[D].s && m(Y[R].pt.k[D].s[0]), Y[R].pt.k[D].e && m(Y[R].pt.k[D].e[0]);
              }
              P.ty === 0 ? (P.layers = l(P.refId, N), I(P.layers, N)) : P.ty === 4 ? h(P.shapes) : P.ty === 5 && L(P);
            }
          }
          function o(x, N) {
            if (x) {
              var P = 0,
                _ = x.length;
              for (P = 0; P < _; P += 1) x[P].t === 1 && (x[P].data.layers = l(x[P].data.refId, N), I(x[P].data.layers, N));
            }
          }
          function s(x, N) {
            for (var P = 0, _ = N.length; P < _;) {
              if (N[P].id === x) return N[P];
              P += 1;
            }
            return null;
          }
          function l(x, N) {
            var P = s(x, N);
            return P ? P.layers.__used ? JSON.parse(JSON.stringify(P.layers)) : (P.layers.__used = !0, P.layers) : null;
          }
          function h(x) {
            var N,
              P = x.length,
              _,
              M;
            for (N = P - 1; N >= 0; N -= 1) if (x[N].ty === "sh") {
              if (x[N].ks.k.i) m(x[N].ks.k);else for (M = x[N].ks.k.length, _ = 0; _ < M; _ += 1) x[N].ks.k[_].s && m(x[N].ks.k[_].s[0]), x[N].ks.k[_].e && m(x[N].ks.k[_].e[0]);
            } else x[N].ty === "gr" && h(x[N].it);
          }
          function m(x) {
            var N,
              P = x.i.length;
            for (N = 0; N < P; N += 1) x.i[N][0] += x.v[N][0], x.i[N][1] += x.v[N][1], x.o[N][0] += x.v[N][0], x.o[N][1] += x.v[N][1];
          }
          function S(x, N) {
            var P = N ? N.split(".") : [100, 100, 100];
            return x[0] > P[0] ? !0 : P[0] > x[0] ? !1 : x[1] > P[1] ? !0 : P[1] > x[1] ? !1 : x[2] > P[2] ? !0 : P[2] > x[2] ? !1 : null;
          }
          var b = function () {
              var x = [4, 4, 14];
              function N(_) {
                var M = _.t.d;
                _.t.d = {
                  k: [{
                    s: M,
                    t: 0
                  }]
                };
              }
              function P(_) {
                var M,
                  R = _.length;
                for (M = 0; M < R; M += 1) _[M].ty === 5 && N(_[M]);
              }
              return function (_) {
                if (S(x, _.v) && (P(_.layers), _.assets)) {
                  var M,
                    R = _.assets.length;
                  for (M = 0; M < R; M += 1) _.assets[M].layers && P(_.assets[M].layers);
                }
              };
            }(),
            T = function () {
              var x = [4, 7, 99];
              return function (N) {
                if (N.chars && !S(x, N.v)) {
                  var P,
                    _ = N.chars.length;
                  for (P = 0; P < _; P += 1) {
                    var M = N.chars[P];
                    M.data && M.data.shapes && (h(M.data.shapes), M.data.ip = 0, M.data.op = 99999, M.data.st = 0, M.data.sr = 1, M.data.ks = {
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      }
                    }, N.chars[P].t || (M.data.shapes.push({
                      ty: "no"
                    }), M.data.shapes[0].it.push({
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      },
                      sk: {
                        k: 0,
                        a: 0
                      },
                      sa: {
                        k: 0,
                        a: 0
                      },
                      ty: "tr"
                    })));
                  }
                }
              };
            }(),
            C = function () {
              var x = [5, 7, 15];
              function N(_) {
                var M = _.t.p;
                typeof M.a == "number" && (M.a = {
                  a: 0,
                  k: M.a
                }), typeof M.p == "number" && (M.p = {
                  a: 0,
                  k: M.p
                }), typeof M.r == "number" && (M.r = {
                  a: 0,
                  k: M.r
                });
              }
              function P(_) {
                var M,
                  R = _.length;
                for (M = 0; M < R; M += 1) _[M].ty === 5 && N(_[M]);
              }
              return function (_) {
                if (S(x, _.v) && (P(_.layers), _.assets)) {
                  var M,
                    R = _.assets.length;
                  for (M = 0; M < R; M += 1) _.assets[M].layers && P(_.assets[M].layers);
                }
              };
            }(),
            F = function () {
              var x = [4, 1, 9];
              function N(_) {
                var M,
                  R = _.length,
                  G,
                  D;
                for (M = 0; M < R; M += 1) if (_[M].ty === "gr") N(_[M].it);else if (_[M].ty === "fl" || _[M].ty === "st") if (_[M].c.k && _[M].c.k[0].i) for (D = _[M].c.k.length, G = 0; G < D; G += 1) _[M].c.k[G].s && (_[M].c.k[G].s[0] /= 255, _[M].c.k[G].s[1] /= 255, _[M].c.k[G].s[2] /= 255, _[M].c.k[G].s[3] /= 255), _[M].c.k[G].e && (_[M].c.k[G].e[0] /= 255, _[M].c.k[G].e[1] /= 255, _[M].c.k[G].e[2] /= 255, _[M].c.k[G].e[3] /= 255);else _[M].c.k[0] /= 255, _[M].c.k[1] /= 255, _[M].c.k[2] /= 255, _[M].c.k[3] /= 255;
              }
              function P(_) {
                var M,
                  R = _.length;
                for (M = 0; M < R; M += 1) _[M].ty === 4 && N(_[M].shapes);
              }
              return function (_) {
                if (S(x, _.v) && (P(_.layers), _.assets)) {
                  var M,
                    R = _.assets.length;
                  for (M = 0; M < R; M += 1) _.assets[M].layers && P(_.assets[M].layers);
                }
              };
            }(),
            w = function () {
              var x = [4, 4, 18];
              function N(_) {
                var M,
                  R = _.length,
                  G,
                  D;
                for (M = R - 1; M >= 0; M -= 1) if (_[M].ty === "sh") {
                  if (_[M].ks.k.i) _[M].ks.k.c = _[M].closed;else for (D = _[M].ks.k.length, G = 0; G < D; G += 1) _[M].ks.k[G].s && (_[M].ks.k[G].s[0].c = _[M].closed), _[M].ks.k[G].e && (_[M].ks.k[G].e[0].c = _[M].closed);
                } else _[M].ty === "gr" && N(_[M].it);
              }
              function P(_) {
                var M,
                  R,
                  G = _.length,
                  D,
                  z,
                  Y,
                  Z;
                for (R = 0; R < G; R += 1) {
                  if (M = _[R], M.hasMask) {
                    var q = M.masksProperties;
                    for (z = q.length, D = 0; D < z; D += 1) if (q[D].pt.k.i) q[D].pt.k.c = q[D].cl;else for (Z = q[D].pt.k.length, Y = 0; Y < Z; Y += 1) q[D].pt.k[Y].s && (q[D].pt.k[Y].s[0].c = q[D].cl), q[D].pt.k[Y].e && (q[D].pt.k[Y].e[0].c = q[D].cl);
                  }
                  M.ty === 4 && N(M.shapes);
                }
              }
              return function (_) {
                if (S(x, _.v) && (P(_.layers), _.assets)) {
                  var M,
                    R = _.assets.length;
                  for (M = 0; M < R; M += 1) _.assets[M].layers && P(_.assets[M].layers);
                }
              };
            }();
          function k(x) {
            x.__complete || (F(x), b(x), T(x), C(x), w(x), I(x.layers, x.assets), o(x.chars, x.assets), x.__complete = !0);
          }
          function L(x) {
            x.t.a.length === 0 && "m" in x.t.p;
          }
          var B = {};
          return B.completeData = k, B.checkColors = F, B.checkChars = T, B.checkPathProperties = C, B.checkShapes = w, B.completeLayers = I, B;
        }
        if (n.dataManager || (n.dataManager = d()), n.assetLoader || (n.assetLoader = function () {
          function I(s) {
            var l = s.getResponseHeader("content-type");
            return l && s.responseType === "json" && l.indexOf("json") !== -1 || s.response && typeof s.response == "object" ? s.response : s.response && typeof s.response == "string" ? JSON.parse(s.response) : s.responseText ? JSON.parse(s.responseText) : null;
          }
          function o(s, l, h, m) {
            var S,
              b = new XMLHttpRequest();
            try {
              b.responseType = "json";
            } catch {}
            b.onreadystatechange = function () {
              if (b.readyState === 4) if (b.status === 200) S = I(b), h(S);else try {
                S = I(b), h(S);
              } catch (T) {
                m && m(T);
              }
            };
            try {
              b.open("GET", s, !0);
            } catch {
              b.open("GET", l + "/" + s, !0);
            }
            b.send();
          }
          return {
            load: o
          };
        }()), E.data.type === "loadAnimation") n.assetLoader.load(E.data.path, E.data.fullPath, function (I) {
          n.dataManager.completeData(I), n.postMessage({
            id: E.data.id,
            payload: I,
            status: "success"
          });
        }, function () {
          n.postMessage({
            id: E.data.id,
            status: "error"
          });
        });else if (E.data.type === "complete") {
          var g = E.data.animation;
          n.dataManager.completeData(g), n.postMessage({
            id: E.data.id,
            payload: g,
            status: "success"
          });
        } else E.data.type === "loadData" && n.assetLoader.load(E.data.path, E.data.fullPath, function (I) {
          n.postMessage({
            id: E.data.id,
            payload: I,
            status: "success"
          });
        }, function () {
          n.postMessage({
            id: E.data.id,
            status: "error"
          });
        });
      }), i.onmessage = function (c) {
        var E = c.data,
          d = E.id,
          g = t[d];
        t[d] = null, E.status === "success" ? g.onComplete(E.payload) : g.onError && g.onError();
      });
    }
    function p(c, E) {
      e += 1;
      var d = "processId_" + e;
      return t[d] = {
        onComplete: c,
        onError: E
      }, d;
    }
    function y(c, E, d) {
      f();
      var g = p(E, d);
      i.postMessage({
        type: "loadAnimation",
        path: c,
        fullPath: window.location.origin + window.location.pathname,
        id: g
      });
    }
    function v(c, E, d) {
      f();
      var g = p(E, d);
      i.postMessage({
        type: "loadData",
        path: c,
        fullPath: window.location.origin + window.location.pathname,
        id: g
      });
    }
    function A(c, E, d) {
      f();
      var g = p(E, d);
      i.postMessage({
        type: "complete",
        animation: c,
        id: g
      });
    }
    return {
      loadAnimation: y,
      loadData: v,
      completeAnimation: A
    };
  }(),
  ImagePreloader = function () {
    var e = function () {
      var o = createTag("canvas");
      o.width = 1, o.height = 1;
      var s = o.getContext("2d");
      return s.fillStyle = "rgba(0,0,0,0)", s.fillRect(0, 0, 1, 1), o;
    }();
    function t() {
      this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
    }
    function r() {
      this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
    }
    function i(o, s, l) {
      var h = "";
      if (o.e) h = o.p;else if (s) {
        var m = o.p;
        m.indexOf("images/") !== -1 && (m = m.split("/")[1]), h = s + m;
      } else h = l, h += o.u ? o.u : "", h += o.p;
      return h;
    }
    function a(o) {
      var s = 0,
        l = setInterval(function () {
          var h = o.getBBox();
          (h.width || s > 500) && (this._imageLoaded(), clearInterval(l)), s += 1;
        }.bind(this), 50);
    }
    function n(o) {
      var s = i(o, this.assetsPath, this.path),
        l = createNS("image");
      isSafari ? this.testImageLoaded(l) : l.addEventListener("load", this._imageLoaded, !1), l.addEventListener("error", function () {
        h.img = e, this._imageLoaded();
      }.bind(this), !1), l.setAttributeNS("http://www.w3.org/1999/xlink", "href", s), this._elementHelper.append ? this._elementHelper.append(l) : this._elementHelper.appendChild(l);
      var h = {
        img: l,
        assetData: o
      };
      return h;
    }
    function u(o) {
      var s = i(o, this.assetsPath, this.path),
        l = createTag("img");
      l.crossOrigin = "anonymous", l.addEventListener("load", this._imageLoaded, !1), l.addEventListener("error", function () {
        h.img = e, this._imageLoaded();
      }.bind(this), !1), l.src = s;
      var h = {
        img: l,
        assetData: o
      };
      return h;
    }
    function f(o) {
      var s = {
          assetData: o
        },
        l = i(o, this.assetsPath, this.path);
      return dataManager.loadData(l, function (h) {
        s.img = h, this._footageLoaded();
      }.bind(this), function () {
        s.img = {}, this._footageLoaded();
      }.bind(this)), s;
    }
    function p(o, s) {
      this.imagesLoadedCb = s;
      var l,
        h = o.length;
      for (l = 0; l < h; l += 1) o[l].layers || (!o[l].t || o[l].t === "seq" ? (this.totalImages += 1, this.images.push(this._createImageData(o[l]))) : o[l].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(o[l]))));
    }
    function y(o) {
      this.path = o || "";
    }
    function v(o) {
      this.assetsPath = o || "";
    }
    function A(o) {
      for (var s = 0, l = this.images.length; s < l;) {
        if (this.images[s].assetData === o) return this.images[s].img;
        s += 1;
      }
      return null;
    }
    function c() {
      this.imagesLoadedCb = null, this.images.length = 0;
    }
    function E() {
      return this.totalImages === this.loadedAssets;
    }
    function d() {
      return this.totalFootages === this.loadedFootagesCount;
    }
    function g(o, s) {
      o === "svg" ? (this._elementHelper = s, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
    }
    function I() {
      this._imageLoaded = t.bind(this), this._footageLoaded = r.bind(this), this.testImageLoaded = a.bind(this), this.createFootageData = f.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
    }
    return I.prototype = {
      loadAssets: p,
      setAssetsPath: v,
      setPath: y,
      loadedImages: E,
      loadedFootages: d,
      destroy: c,
      getAsset: A,
      createImgData: u,
      createImageData: n,
      imageLoaded: t,
      footageLoaded: r,
      setCacheType: g
    }, I;
  }();
function BaseEvent() {}
BaseEvent.prototype = {
  triggerEvent: function (e, t) {
    if (this._cbs[e]) for (var r = this._cbs[e], i = 0; i < r.length; i += 1) r[i](t);
  },
  addEventListener: function (e, t) {
    return this._cbs[e] || (this._cbs[e] = []), this._cbs[e].push(t), function () {
      this.removeEventListener(e, t);
    }.bind(this);
  },
  removeEventListener: function (e, t) {
    if (!t) this._cbs[e] = null;else if (this._cbs[e]) {
      for (var r = 0, i = this._cbs[e].length; r < i;) this._cbs[e][r] === t && (this._cbs[e].splice(r, 1), r -= 1, i -= 1), r += 1;
      this._cbs[e].length || (this._cbs[e] = null);
    }
  }
};
const markerParser = function () {
    function e(t) {
      for (var r = t.split(`\r
`), i = {}, a, n = 0, u = 0; u < r.length; u += 1) a = r[u].split(":"), a.length === 2 && (i[a[0]] = a[1].trim(), n += 1);
      if (n === 0) throw new Error();
      return i;
    }
    return function (t) {
      for (var r = [], i = 0; i < t.length; i += 1) {
        var a = t[i],
          n = {
            time: a.tm,
            duration: a.dr
          };
        try {
          n.payload = JSON.parse(t[i].cm);
        } catch {
          try {
            n.payload = e(t[i].cm);
          } catch {
            n.payload = {
              name: t[i].cm
            };
          }
        }
        r.push(n);
      }
      return r;
    };
  }(),
  ProjectInterface = function () {
    function e(t) {
      this.compositions.push(t);
    }
    return function () {
      function t(r) {
        for (var i = 0, a = this.compositions.length; i < a;) {
          if (this.compositions[i].data && this.compositions[i].data.nm === r) return this.compositions[i].prepareFrame && this.compositions[i].data.xt && this.compositions[i].prepareFrame(this.currentFrame), this.compositions[i].compInterface;
          i += 1;
        }
        return null;
      }
      return t.compositions = [], t.currentFrame = 0, t.registerComposition = e, t;
    };
  }(),
  renderers = {},
  registerRenderer = (e, t) => {
    renderers[e] = t;
  };
function getRenderer(e) {
  return renderers[e];
}
const AnimationItem = function () {
  this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader(), this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0);
};
extendPrototype([BaseEvent], AnimationItem);
AnimationItem.prototype.setParams = function (e) {
  (e.wrapper || e.container) && (this.wrapper = e.wrapper || e.container);
  var t = "svg";
  e.animType ? t = e.animType : e.renderer && (t = e.renderer);
  const r = getRenderer(t);
  this.renderer = new r(this, e.rendererSettings), this.imagePreloader.setCacheType(t, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = t, e.loop === "" || e.loop === null || e.loop === void 0 || e.loop === !0 ? this.loop = !0 : e.loop === !1 ? this.loop = !1 : this.loop = parseInt(e.loop, 10), this.autoplay = "autoplay" in e ? e.autoplay : !0, this.name = e.name ? e.name : "", this.autoloadSegments = Object.prototype.hasOwnProperty.call(e, "autoloadSegments") ? e.autoloadSegments : !0, this.assetsPath = e.assetsPath, this.initialSegment = e.initialSegment, e.audioFactory && this.audioController.setAudioFactory(e.audioFactory), e.animationData ? this.setupAnimation(e.animationData) : e.path && (e.path.lastIndexOf("\\") !== -1 ? this.path = e.path.substr(0, e.path.lastIndexOf("\\") + 1) : this.path = e.path.substr(0, e.path.lastIndexOf("/") + 1), this.fileName = e.path.substr(e.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(e.path, this.configAnimation, this.onSetupError));
};
AnimationItem.prototype.onSetupError = function () {
  this.trigger("data_failed");
};
AnimationItem.prototype.setupAnimation = function (e) {
  dataManager.completeAnimation(e, this.configAnimation);
};
AnimationItem.prototype.setData = function (e, t) {
  t && typeof t != "object" && (t = JSON.parse(t));
  var r = {
      wrapper: e,
      animationData: t
    },
    i = e.attributes;
  r.path = i.getNamedItem("data-animation-path") ? i.getNamedItem("data-animation-path").value : i.getNamedItem("data-bm-path") ? i.getNamedItem("data-bm-path").value : i.getNamedItem("bm-path") ? i.getNamedItem("bm-path").value : "", r.animType = i.getNamedItem("data-anim-type") ? i.getNamedItem("data-anim-type").value : i.getNamedItem("data-bm-type") ? i.getNamedItem("data-bm-type").value : i.getNamedItem("bm-type") ? i.getNamedItem("bm-type").value : i.getNamedItem("data-bm-renderer") ? i.getNamedItem("data-bm-renderer").value : i.getNamedItem("bm-renderer") ? i.getNamedItem("bm-renderer").value : "canvas";
  var a = i.getNamedItem("data-anim-loop") ? i.getNamedItem("data-anim-loop").value : i.getNamedItem("data-bm-loop") ? i.getNamedItem("data-bm-loop").value : i.getNamedItem("bm-loop") ? i.getNamedItem("bm-loop").value : "";
  a === "false" ? r.loop = !1 : a === "true" ? r.loop = !0 : a !== "" && (r.loop = parseInt(a, 10));
  var n = i.getNamedItem("data-anim-autoplay") ? i.getNamedItem("data-anim-autoplay").value : i.getNamedItem("data-bm-autoplay") ? i.getNamedItem("data-bm-autoplay").value : i.getNamedItem("bm-autoplay") ? i.getNamedItem("bm-autoplay").value : !0;
  r.autoplay = n !== "false", r.name = i.getNamedItem("data-name") ? i.getNamedItem("data-name").value : i.getNamedItem("data-bm-name") ? i.getNamedItem("data-bm-name").value : i.getNamedItem("bm-name") ? i.getNamedItem("bm-name").value : "";
  var u = i.getNamedItem("data-anim-prerender") ? i.getNamedItem("data-anim-prerender").value : i.getNamedItem("data-bm-prerender") ? i.getNamedItem("data-bm-prerender").value : i.getNamedItem("bm-prerender") ? i.getNamedItem("bm-prerender").value : "";
  u === "false" && (r.prerender = !1), this.setParams(r);
};
AnimationItem.prototype.includeLayers = function (e) {
  e.op > this.animationData.op && (this.animationData.op = e.op, this.totalFrames = Math.floor(e.op - this.animationData.ip));
  var t = this.animationData.layers,
    r,
    i = t.length,
    a = e.layers,
    n,
    u = a.length;
  for (n = 0; n < u; n += 1) for (r = 0; r < i;) {
    if (t[r].id === a[n].id) {
      t[r] = a[n];
      break;
    }
    r += 1;
  }
  if ((e.chars || e.fonts) && (this.renderer.globalData.fontManager.addChars(e.chars), this.renderer.globalData.fontManager.addFonts(e.fonts, this.renderer.globalData.defs)), e.assets) for (i = e.assets.length, r = 0; r < i; r += 1) this.animationData.assets.push(e.assets[r]);
  this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
};
AnimationItem.prototype.onSegmentComplete = function (e) {
  this.animationData = e;
  var t = getExpressionsPlugin();
  t && t.initExpressions(this), this.loadNextSegment();
};
AnimationItem.prototype.loadNextSegment = function () {
  var e = this.animationData.segments;
  if (!e || e.length === 0 || !this.autoloadSegments) {
    this.trigger("data_ready"), this.timeCompleted = this.totalFrames;
    return;
  }
  var t = e.shift();
  this.timeCompleted = t.time * this.frameRate;
  var r = this.path + this.fileName + "_" + this.segmentPos + ".json";
  this.segmentPos += 1, dataManager.loadData(r, this.includeLayers.bind(this), function () {
    this.trigger("data_failed");
  }.bind(this));
};
AnimationItem.prototype.loadSegments = function () {
  var e = this.animationData.segments;
  e || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
};
AnimationItem.prototype.imagesLoaded = function () {
  this.trigger("loaded_images"), this.checkLoaded();
};
AnimationItem.prototype.preloadImages = function () {
  this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
};
AnimationItem.prototype.configAnimation = function (e) {
  if (this.renderer) try {
    this.animationData = e, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(e), e.assets || (e.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(e.assets), this.markers = markerParser(e.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
  } catch (t) {
    this.triggerConfigError(t);
  }
};
AnimationItem.prototype.waitForFontsLoaded = function () {
  this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
};
AnimationItem.prototype.checkLoaded = function () {
  if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
    this.isLoaded = !0;
    var e = getExpressionsPlugin();
    e && e.initExpressions(this), this.renderer.initItems(), setTimeout(function () {
      this.trigger("DOMLoaded");
    }.bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
  }
};
AnimationItem.prototype.resize = function () {
  this.renderer.updateContainerSize();
};
AnimationItem.prototype.setSubframe = function (e) {
  this.isSubframeEnabled = !!e;
};
AnimationItem.prototype.gotoFrame = function () {
  this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
};
AnimationItem.prototype.renderFrame = function () {
  if (!(this.isLoaded === !1 || !this.renderer)) try {
    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
  } catch (e) {
    this.triggerRenderFrameError(e);
  }
};
AnimationItem.prototype.play = function (e) {
  e && this.name !== e || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_pause"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
};
AnimationItem.prototype.pause = function (e) {
  e && this.name !== e || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_play"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
};
AnimationItem.prototype.togglePause = function (e) {
  e && this.name !== e || (this.isPaused === !0 ? this.play() : this.pause());
};
AnimationItem.prototype.stop = function (e) {
  e && this.name !== e || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
};
AnimationItem.prototype.getMarkerData = function (e) {
  for (var t, r = 0; r < this.markers.length; r += 1) if (t = this.markers[r], t.payload && t.payload.name === e) return t;
  return null;
};
AnimationItem.prototype.goToAndStop = function (e, t, r) {
  if (!(r && this.name !== r)) {
    var i = Number(e);
    if (isNaN(i)) {
      var a = this.getMarkerData(e);
      a && this.goToAndStop(a.time, !0);
    } else t ? this.setCurrentRawFrameValue(e) : this.setCurrentRawFrameValue(e * this.frameModifier);
    this.pause();
  }
};
AnimationItem.prototype.goToAndPlay = function (e, t, r) {
  if (!(r && this.name !== r)) {
    var i = Number(e);
    if (isNaN(i)) {
      var a = this.getMarkerData(e);
      a && (a.duration ? this.playSegments([a.time, a.time + a.duration], !0) : this.goToAndStop(a.time, !0));
    } else this.goToAndStop(i, t, r);
    this.play();
  }
};
AnimationItem.prototype.advanceTime = function (e) {
  if (!(this.isPaused === !0 || this.isLoaded === !1)) {
    var t = this.currentRawFrame + e * this.frameModifier,
      r = !1;
    t >= this.totalFrames - 1 && this.frameModifier > 0 ? !this.loop || this.playCount === this.loop ? this.checkSegments(t > this.totalFrames ? t % this.totalFrames : 0) || (r = !0, t = this.totalFrames - 1) : t >= this.totalFrames ? (this.playCount += 1, this.checkSegments(t % this.totalFrames) || (this.setCurrentRawFrameValue(t % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(t) : t < 0 ? this.checkSegments(t % this.totalFrames) || (this.loop && !(this.playCount-- <= 0 && this.loop !== !0) ? (this.setCurrentRawFrameValue(this.totalFrames + t % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0) : (r = !0, t = 0)) : this.setCurrentRawFrameValue(t), r && (this.setCurrentRawFrameValue(t), this.pause(), this.trigger("complete"));
  }
};
AnimationItem.prototype.adjustSegment = function (e, t) {
  this.playCount = 0, e[1] < e[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = e[0] - e[1], this.timeCompleted = this.totalFrames, this.firstFrame = e[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - t)) : e[1] > e[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = e[1] - e[0], this.timeCompleted = this.totalFrames, this.firstFrame = e[0], this.setCurrentRawFrameValue(1e-3 + t)), this.trigger("segmentStart");
};
AnimationItem.prototype.setSegment = function (e, t) {
  var r = -1;
  this.isPaused && (this.currentRawFrame + this.firstFrame < e ? r = e : this.currentRawFrame + this.firstFrame > t && (r = t - e)), this.firstFrame = e, this.totalFrames = t - e, this.timeCompleted = this.totalFrames, r !== -1 && this.goToAndStop(r, !0);
};
AnimationItem.prototype.playSegments = function (e, t) {
  if (t && (this.segments.length = 0), typeof e[0] == "object") {
    var r,
      i = e.length;
    for (r = 0; r < i; r += 1) this.segments.push(e[r]);
  } else this.segments.push(e);
  this.segments.length && t && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
};
AnimationItem.prototype.resetSegments = function (e) {
  this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), e && this.checkSegments(0);
};
AnimationItem.prototype.checkSegments = function (e) {
  return this.segments.length ? (this.adjustSegment(this.segments.shift(), e), !0) : !1;
};
AnimationItem.prototype.destroy = function (e) {
  e && this.name !== e || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.renderer = null, this.imagePreloader = null, this.projectInterface = null);
};
AnimationItem.prototype.setCurrentRawFrameValue = function (e) {
  this.currentRawFrame = e, this.gotoFrame();
};
AnimationItem.prototype.setSpeed = function (e) {
  this.playSpeed = e, this.updaFrameModifier();
};
AnimationItem.prototype.setDirection = function (e) {
  this.playDirection = e < 0 ? -1 : 1, this.updaFrameModifier();
};
AnimationItem.prototype.setVolume = function (e, t) {
  t && this.name !== t || this.audioController.setVolume(e);
};
AnimationItem.prototype.getVolume = function () {
  return this.audioController.getVolume();
};
AnimationItem.prototype.mute = function (e) {
  e && this.name !== e || this.audioController.mute();
};
AnimationItem.prototype.unmute = function (e) {
  e && this.name !== e || this.audioController.unmute();
};
AnimationItem.prototype.updaFrameModifier = function () {
  this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
};
AnimationItem.prototype.getPath = function () {
  return this.path;
};
AnimationItem.prototype.getAssetsPath = function (e) {
  var t = "";
  if (e.e) t = e.p;else if (this.assetsPath) {
    var r = e.p;
    r.indexOf("images/") !== -1 && (r = r.split("/")[1]), t = this.assetsPath + r;
  } else t = this.path, t += e.u ? e.u : "", t += e.p;
  return t;
};
AnimationItem.prototype.getAssetData = function (e) {
  for (var t = 0, r = this.assets.length; t < r;) {
    if (e === this.assets[t].id) return this.assets[t];
    t += 1;
  }
  return null;
};
AnimationItem.prototype.hide = function () {
  this.renderer.hide();
};
AnimationItem.prototype.show = function () {
  this.renderer.show();
};
AnimationItem.prototype.getDuration = function (e) {
  return e ? this.totalFrames : this.totalFrames / this.frameRate;
};
AnimationItem.prototype.updateDocumentData = function (e, t, r) {
  try {
    var i = this.renderer.getElementByPath(e);
    i.updateDocumentData(t, r);
  } catch {}
};
AnimationItem.prototype.trigger = function (e) {
  if (this._cbs && this._cbs[e]) switch (e) {
    case "enterFrame":
      this.triggerEvent(e, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameModifier));
      break;
    case "drawnFrame":
      this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(e, this.drawnFrameEvent);
      break;
    case "loopComplete":
      this.triggerEvent(e, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult));
      break;
    case "complete":
      this.triggerEvent(e, new BMCompleteEvent(e, this.frameMult));
      break;
    case "segmentStart":
      this.triggerEvent(e, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames));
      break;
    case "destroy":
      this.triggerEvent(e, new BMDestroyEvent(e, this));
      break;
    default:
      this.triggerEvent(e);
  }
  e === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameMult)), e === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult)), e === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(e, this.frameMult)), e === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames)), e === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(e, this));
};
AnimationItem.prototype.triggerRenderFrameError = function (e) {
  var t = new BMRenderFrameErrorEvent(e, this.currentFrame);
  this.triggerEvent("error", t), this.onError && this.onError.call(this, t);
};
AnimationItem.prototype.triggerConfigError = function (e) {
  var t = new BMConfigErrorEvent(e, this.currentFrame);
  this.triggerEvent("error", t), this.onError && this.onError.call(this, t);
};
const animationManager = function () {
    var e = {},
      t = [],
      r = 0,
      i = 0,
      a = 0,
      n = !0,
      u = !1;
    function f(N) {
      for (var P = 0, _ = N.target; P < i;) t[P].animation === _ && (t.splice(P, 1), P -= 1, i -= 1, _.isPaused || A()), P += 1;
    }
    function p(N, P) {
      if (!N) return null;
      for (var _ = 0; _ < i;) {
        if (t[_].elem === N && t[_].elem !== null) return t[_].animation;
        _ += 1;
      }
      var M = new AnimationItem();
      return c(M, N), M.setData(N, P), M;
    }
    function y() {
      var N,
        P = t.length,
        _ = [];
      for (N = 0; N < P; N += 1) _.push(t[N].animation);
      return _;
    }
    function v() {
      a += 1, F();
    }
    function A() {
      a -= 1;
    }
    function c(N, P) {
      N.addEventListener("destroy", f), N.addEventListener("_active", v), N.addEventListener("_idle", A), t.push({
        elem: P,
        animation: N
      }), i += 1;
    }
    function E(N) {
      var P = new AnimationItem();
      return c(P, null), P.setParams(N), P;
    }
    function d(N, P) {
      var _;
      for (_ = 0; _ < i; _ += 1) t[_].animation.setSpeed(N, P);
    }
    function g(N, P) {
      var _;
      for (_ = 0; _ < i; _ += 1) t[_].animation.setDirection(N, P);
    }
    function I(N) {
      var P;
      for (P = 0; P < i; P += 1) t[P].animation.play(N);
    }
    function o(N) {
      var P = N - r,
        _;
      for (_ = 0; _ < i; _ += 1) t[_].animation.advanceTime(P);
      r = N, a && !u ? window.requestAnimationFrame(o) : n = !0;
    }
    function s(N) {
      r = N, window.requestAnimationFrame(o);
    }
    function l(N) {
      var P;
      for (P = 0; P < i; P += 1) t[P].animation.pause(N);
    }
    function h(N, P, _) {
      var M;
      for (M = 0; M < i; M += 1) t[M].animation.goToAndStop(N, P, _);
    }
    function m(N) {
      var P;
      for (P = 0; P < i; P += 1) t[P].animation.stop(N);
    }
    function S(N) {
      var P;
      for (P = 0; P < i; P += 1) t[P].animation.togglePause(N);
    }
    function b(N) {
      var P;
      for (P = i - 1; P >= 0; P -= 1) t[P].animation.destroy(N);
    }
    function T(N, P, _) {
      var M = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))),
        R,
        G = M.length;
      for (R = 0; R < G; R += 1) _ && M[R].setAttribute("data-bm-type", _), p(M[R], N);
      if (P && G === 0) {
        _ || (_ = "svg");
        var D = document.getElementsByTagName("body")[0];
        D.innerText = "";
        var z = createTag("div");
        z.style.width = "100%", z.style.height = "100%", z.setAttribute("data-bm-type", _), D.appendChild(z), p(z, N);
      }
    }
    function C() {
      var N;
      for (N = 0; N < i; N += 1) t[N].animation.resize();
    }
    function F() {
      !u && a && n && (window.requestAnimationFrame(s), n = !1);
    }
    function w() {
      u = !0;
    }
    function k() {
      u = !1, F();
    }
    function L(N, P) {
      var _;
      for (_ = 0; _ < i; _ += 1) t[_].animation.setVolume(N, P);
    }
    function B(N) {
      var P;
      for (P = 0; P < i; P += 1) t[P].animation.mute(N);
    }
    function x(N) {
      var P;
      for (P = 0; P < i; P += 1) t[P].animation.unmute(N);
    }
    return e.registerAnimation = p, e.loadAnimation = E, e.setSpeed = d, e.setDirection = g, e.play = I, e.pause = l, e.stop = m, e.togglePause = S, e.searchAnimations = T, e.resize = C, e.goToAndStop = h, e.destroy = b, e.freeze = w, e.unfreeze = k, e.setVolume = L, e.mute = B, e.unmute = x, e.getRegisteredAnimations = y, e;
  }(),
  BezierFactory = function () {
    var e = {};
    e.getBezierEasing = r;
    var t = {};
    function r(s, l, h, m, S) {
      var b = S || ("bez_" + s + "_" + l + "_" + h + "_" + m).replace(/\./g, "p");
      if (t[b]) return t[b];
      var T = new o([s, l, h, m]);
      return t[b] = T, T;
    }
    var i = 4,
      a = 1e-3,
      n = 1e-7,
      u = 10,
      f = 11,
      p = 1 / (f - 1),
      y = typeof Float32Array == "function";
    function v(s, l) {
      return 1 - 3 * l + 3 * s;
    }
    function A(s, l) {
      return 3 * l - 6 * s;
    }
    function c(s) {
      return 3 * s;
    }
    function E(s, l, h) {
      return ((v(l, h) * s + A(l, h)) * s + c(l)) * s;
    }
    function d(s, l, h) {
      return 3 * v(l, h) * s * s + 2 * A(l, h) * s + c(l);
    }
    function g(s, l, h, m, S) {
      var b,
        T,
        C = 0;
      do T = l + (h - l) / 2, b = E(T, m, S) - s, b > 0 ? h = T : l = T; while (Math.abs(b) > n && ++C < u);
      return T;
    }
    function I(s, l, h, m) {
      for (var S = 0; S < i; ++S) {
        var b = d(l, h, m);
        if (b === 0) return l;
        var T = E(l, h, m) - s;
        l -= T / b;
      }
      return l;
    }
    function o(s) {
      this._p = s, this._mSampleValues = y ? new Float32Array(f) : new Array(f), this._precomputed = !1, this.get = this.get.bind(this);
    }
    return o.prototype = {
      get: function (s) {
        var l = this._p[0],
          h = this._p[1],
          m = this._p[2],
          S = this._p[3];
        return this._precomputed || this._precompute(), l === h && m === S ? s : s === 0 ? 0 : s === 1 ? 1 : E(this._getTForX(s), h, S);
      },
      // Private part
      _precompute: function () {
        var s = this._p[0],
          l = this._p[1],
          h = this._p[2],
          m = this._p[3];
        this._precomputed = !0, (s !== l || h !== m) && this._calcSampleValues();
      },
      _calcSampleValues: function () {
        for (var s = this._p[0], l = this._p[2], h = 0; h < f; ++h) this._mSampleValues[h] = E(h * p, s, l);
      },
      /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */
      _getTForX: function (s) {
        for (var l = this._p[0], h = this._p[2], m = this._mSampleValues, S = 0, b = 1, T = f - 1; b !== T && m[b] <= s; ++b) S += p;
        --b;
        var C = (s - m[b]) / (m[b + 1] - m[b]),
          F = S + C * p,
          w = d(F, l, h);
        return w >= a ? I(s, F, l, h) : w === 0 ? F : g(s, S, S + p, l, h);
      }
    }, e;
  }(),
  pooling = function () {
    function e(t) {
      return t.concat(createSizedArray(t.length));
    }
    return {
      double: e
    };
  }(),
  poolFactory = function () {
    return function (e, t, r) {
      var i = 0,
        a = e,
        n = createSizedArray(a),
        u = {
          newElement: f,
          release: p
        };
      function f() {
        var y;
        return i ? (i -= 1, y = n[i]) : y = t(), y;
      }
      function p(y) {
        i === a && (n = pooling.double(n), a *= 2), r && r(y), n[i] = y, i += 1;
      }
      return u;
    };
  }(),
  bezierLengthPool = function () {
    function e() {
      return {
        addedLength: 0,
        percents: createTypedArray("float32", getDefaultCurveSegments()),
        lengths: createTypedArray("float32", getDefaultCurveSegments())
      };
    }
    return poolFactory(8, e);
  }(),
  segmentsLengthPool = function () {
    function e() {
      return {
        lengths: [],
        totalLength: 0
      };
    }
    function t(r) {
      var i,
        a = r.lengths.length;
      for (i = 0; i < a; i += 1) bezierLengthPool.release(r.lengths[i]);
      r.lengths.length = 0;
    }
    return poolFactory(8, e, t);
  }();
function bezFunction() {
  var e = Math;
  function t(c, E, d, g, I, o) {
    var s = c * g + E * I + d * o - I * g - o * c - d * E;
    return s > -1e-3 && s < 1e-3;
  }
  function r(c, E, d, g, I, o, s, l, h) {
    if (d === 0 && o === 0 && h === 0) return t(c, E, g, I, s, l);
    var m = e.sqrt(e.pow(g - c, 2) + e.pow(I - E, 2) + e.pow(o - d, 2)),
      S = e.sqrt(e.pow(s - c, 2) + e.pow(l - E, 2) + e.pow(h - d, 2)),
      b = e.sqrt(e.pow(s - g, 2) + e.pow(l - I, 2) + e.pow(h - o, 2)),
      T;
    return m > S ? m > b ? T = m - S - b : T = b - S - m : b > S ? T = b - S - m : T = S - m - b, T > -1e-4 && T < 1e-4;
  }
  var i = function () {
    return function (c, E, d, g) {
      var I = getDefaultCurveSegments(),
        o,
        s,
        l,
        h,
        m,
        S = 0,
        b,
        T = [],
        C = [],
        F = bezierLengthPool.newElement();
      for (l = d.length, o = 0; o < I; o += 1) {
        for (m = o / (I - 1), b = 0, s = 0; s < l; s += 1) h = bmPow(1 - m, 3) * c[s] + 3 * bmPow(1 - m, 2) * m * d[s] + 3 * (1 - m) * bmPow(m, 2) * g[s] + bmPow(m, 3) * E[s], T[s] = h, C[s] !== null && (b += bmPow(T[s] - C[s], 2)), C[s] = T[s];
        b && (b = bmSqrt(b), S += b), F.percents[o] = m, F.lengths[o] = S;
      }
      return F.addedLength = S, F;
    };
  }();
  function a(c) {
    var E = segmentsLengthPool.newElement(),
      d = c.c,
      g = c.v,
      I = c.o,
      o = c.i,
      s,
      l = c._length,
      h = E.lengths,
      m = 0;
    for (s = 0; s < l - 1; s += 1) h[s] = i(g[s], g[s + 1], I[s], o[s + 1]), m += h[s].addedLength;
    return d && l && (h[s] = i(g[s], g[0], I[s], o[0]), m += h[s].addedLength), E.totalLength = m, E;
  }
  function n(c) {
    this.segmentLength = 0, this.points = new Array(c);
  }
  function u(c, E) {
    this.partialLength = c, this.point = E;
  }
  var f = function () {
    var c = {};
    return function (E, d, g, I) {
      var o = (E[0] + "_" + E[1] + "_" + d[0] + "_" + d[1] + "_" + g[0] + "_" + g[1] + "_" + I[0] + "_" + I[1]).replace(/\./g, "p");
      if (!c[o]) {
        var s = getDefaultCurveSegments(),
          l,
          h,
          m,
          S,
          b,
          T = 0,
          C,
          F,
          w = null;
        E.length === 2 && (E[0] !== d[0] || E[1] !== d[1]) && t(E[0], E[1], d[0], d[1], E[0] + g[0], E[1] + g[1]) && t(E[0], E[1], d[0], d[1], d[0] + I[0], d[1] + I[1]) && (s = 2);
        var k = new n(s);
        for (m = g.length, l = 0; l < s; l += 1) {
          for (F = createSizedArray(m), b = l / (s - 1), C = 0, h = 0; h < m; h += 1) S = bmPow(1 - b, 3) * E[h] + 3 * bmPow(1 - b, 2) * b * (E[h] + g[h]) + 3 * (1 - b) * bmPow(b, 2) * (d[h] + I[h]) + bmPow(b, 3) * d[h], F[h] = S, w !== null && (C += bmPow(F[h] - w[h], 2));
          C = bmSqrt(C), T += C, k.points[l] = new u(C, F), w = F;
        }
        k.segmentLength = T, c[o] = k;
      }
      return c[o];
    };
  }();
  function p(c, E) {
    var d = E.percents,
      g = E.lengths,
      I = d.length,
      o = bmFloor((I - 1) * c),
      s = c * E.addedLength,
      l = 0;
    if (o === I - 1 || o === 0 || s === g[o]) return d[o];
    for (var h = g[o] > s ? -1 : 1, m = !0; m;) if (g[o] <= s && g[o + 1] > s ? (l = (s - g[o]) / (g[o + 1] - g[o]), m = !1) : o += h, o < 0 || o >= I - 1) {
      if (o === I - 1) return d[o];
      m = !1;
    }
    return d[o] + (d[o + 1] - d[o]) * l;
  }
  function y(c, E, d, g, I, o) {
    var s = p(I, o),
      l = 1 - s,
      h = e.round((l * l * l * c[0] + (s * l * l + l * s * l + l * l * s) * d[0] + (s * s * l + l * s * s + s * l * s) * g[0] + s * s * s * E[0]) * 1e3) / 1e3,
      m = e.round((l * l * l * c[1] + (s * l * l + l * s * l + l * l * s) * d[1] + (s * s * l + l * s * s + s * l * s) * g[1] + s * s * s * E[1]) * 1e3) / 1e3;
    return [h, m];
  }
  var v = createTypedArray("float32", 8);
  function A(c, E, d, g, I, o, s) {
    I < 0 ? I = 0 : I > 1 && (I = 1);
    var l = p(I, s);
    o = o > 1 ? 1 : o;
    var h = p(o, s),
      m,
      S = c.length,
      b = 1 - l,
      T = 1 - h,
      C = b * b * b,
      F = l * b * b * 3,
      w = l * l * b * 3,
      k = l * l * l,
      L = b * b * T,
      B = l * b * T + b * l * T + b * b * h,
      x = l * l * T + b * l * h + l * b * h,
      N = l * l * h,
      P = b * T * T,
      _ = l * T * T + b * h * T + b * T * h,
      M = l * h * T + b * h * h + l * T * h,
      R = l * h * h,
      G = T * T * T,
      D = h * T * T + T * h * T + T * T * h,
      z = h * h * T + T * h * h + h * T * h,
      Y = h * h * h;
    for (m = 0; m < S; m += 1) v[m * 4] = e.round((C * c[m] + F * d[m] + w * g[m] + k * E[m]) * 1e3) / 1e3, v[m * 4 + 1] = e.round((L * c[m] + B * d[m] + x * g[m] + N * E[m]) * 1e3) / 1e3, v[m * 4 + 2] = e.round((P * c[m] + _ * d[m] + M * g[m] + R * E[m]) * 1e3) / 1e3, v[m * 4 + 3] = e.round((G * c[m] + D * d[m] + z * g[m] + Y * E[m]) * 1e3) / 1e3;
    return v;
  }
  return {
    getSegmentsLength: a,
    getNewSegment: A,
    getPointInSegment: y,
    buildBezierData: f,
    pointOnLine2D: t,
    pointOnLine3D: r
  };
}
const bez = bezFunction(),
  PropertyFactory = function () {
    var e = initialDefaultFrame,
      t = Math.abs;
    function r(I, o) {
      var s = this.offsetTime,
        l;
      this.propType === "multidimensional" && (l = createTypedArray("float32", this.pv.length));
      for (var h = o.lastIndex, m = h, S = this.keyframes.length - 1, b = !0, T, C, F; b;) {
        if (T = this.keyframes[m], C = this.keyframes[m + 1], m === S - 1 && I >= C.t - s) {
          T.h && (T = C), h = 0;
          break;
        }
        if (C.t - s > I) {
          h = m;
          break;
        }
        m < S - 1 ? m += 1 : (h = 0, b = !1);
      }
      F = this.keyframesMetadata[m] || {};
      var w,
        k,
        L,
        B,
        x,
        N,
        P = C.t - s,
        _ = T.t - s,
        M;
      if (T.to) {
        F.bezierData || (F.bezierData = bez.buildBezierData(T.s, C.s || T.e, T.to, T.ti));
        var R = F.bezierData;
        if (I >= P || I < _) {
          var G = I >= P ? R.points.length - 1 : 0;
          for (k = R.points[G].point.length, w = 0; w < k; w += 1) l[w] = R.points[G].point[w];
        } else {
          F.__fnct ? N = F.__fnct : (N = BezierFactory.getBezierEasing(T.o.x, T.o.y, T.i.x, T.i.y, T.n).get, F.__fnct = N), L = N((I - _) / (P - _));
          var D = R.segmentLength * L,
            z,
            Y = o.lastFrame < I && o._lastKeyframeIndex === m ? o._lastAddedLength : 0;
          for (x = o.lastFrame < I && o._lastKeyframeIndex === m ? o._lastPoint : 0, b = !0, B = R.points.length; b;) {
            if (Y += R.points[x].partialLength, D === 0 || L === 0 || x === R.points.length - 1) {
              for (k = R.points[x].point.length, w = 0; w < k; w += 1) l[w] = R.points[x].point[w];
              break;
            } else if (D >= Y && D < Y + R.points[x + 1].partialLength) {
              for (z = (D - Y) / R.points[x + 1].partialLength, k = R.points[x].point.length, w = 0; w < k; w += 1) l[w] = R.points[x].point[w] + (R.points[x + 1].point[w] - R.points[x].point[w]) * z;
              break;
            }
            x < B - 1 ? x += 1 : b = !1;
          }
          o._lastPoint = x, o._lastAddedLength = Y - R.points[x].partialLength, o._lastKeyframeIndex = m;
        }
      } else {
        var Z, q, t1, r1, a1;
        if (S = T.s.length, M = C.s || T.e, this.sh && T.h !== 1) {
          if (I >= P) l[0] = M[0], l[1] = M[1], l[2] = M[2];else if (I <= _) l[0] = T.s[0], l[1] = T.s[1], l[2] = T.s[2];else {
            var e1 = n(T.s),
              X = n(M),
              s1 = (I - _) / (P - _);
            a(l, i(e1, X, s1));
          }
        } else for (m = 0; m < S; m += 1) T.h !== 1 && (I >= P ? L = 1 : I < _ ? L = 0 : (T.o.x.constructor === Array ? (F.__fnct || (F.__fnct = []), F.__fnct[m] ? N = F.__fnct[m] : (Z = T.o.x[m] === void 0 ? T.o.x[0] : T.o.x[m], q = T.o.y[m] === void 0 ? T.o.y[0] : T.o.y[m], t1 = T.i.x[m] === void 0 ? T.i.x[0] : T.i.x[m], r1 = T.i.y[m] === void 0 ? T.i.y[0] : T.i.y[m], N = BezierFactory.getBezierEasing(Z, q, t1, r1).get, F.__fnct[m] = N)) : F.__fnct ? N = F.__fnct : (Z = T.o.x, q = T.o.y, t1 = T.i.x, r1 = T.i.y, N = BezierFactory.getBezierEasing(Z, q, t1, r1).get, T.keyframeMetadata = N), L = N((I - _) / (P - _)))), M = C.s || T.e, a1 = T.h === 1 ? T.s[m] : T.s[m] + (M[m] - T.s[m]) * L, this.propType === "multidimensional" ? l[m] = a1 : l = a1;
      }
      return o.lastIndex = h, l;
    }
    function i(I, o, s) {
      var l = [],
        h = I[0],
        m = I[1],
        S = I[2],
        b = I[3],
        T = o[0],
        C = o[1],
        F = o[2],
        w = o[3],
        k,
        L,
        B,
        x,
        N;
      return L = h * T + m * C + S * F + b * w, L < 0 && (L = -L, T = -T, C = -C, F = -F, w = -w), 1 - L > 1e-6 ? (k = Math.acos(L), B = Math.sin(k), x = Math.sin((1 - s) * k) / B, N = Math.sin(s * k) / B) : (x = 1 - s, N = s), l[0] = x * h + N * T, l[1] = x * m + N * C, l[2] = x * S + N * F, l[3] = x * b + N * w, l;
    }
    function a(I, o) {
      var s = o[0],
        l = o[1],
        h = o[2],
        m = o[3],
        S = Math.atan2(2 * l * m - 2 * s * h, 1 - 2 * l * l - 2 * h * h),
        b = Math.asin(2 * s * l + 2 * h * m),
        T = Math.atan2(2 * s * m - 2 * l * h, 1 - 2 * s * s - 2 * h * h);
      I[0] = S / degToRads, I[1] = b / degToRads, I[2] = T / degToRads;
    }
    function n(I) {
      var o = I[0] * degToRads,
        s = I[1] * degToRads,
        l = I[2] * degToRads,
        h = Math.cos(o / 2),
        m = Math.cos(s / 2),
        S = Math.cos(l / 2),
        b = Math.sin(o / 2),
        T = Math.sin(s / 2),
        C = Math.sin(l / 2),
        F = h * m * S - b * T * C,
        w = b * T * S + h * m * C,
        k = b * m * S + h * T * C,
        L = h * T * S - b * m * C;
      return [w, k, L, F];
    }
    function u() {
      var I = this.comp.renderedFrame - this.offsetTime,
        o = this.keyframes[0].t - this.offsetTime,
        s = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      if (!(I === this._caching.lastFrame || this._caching.lastFrame !== e && (this._caching.lastFrame >= s && I >= s || this._caching.lastFrame < o && I < o))) {
        this._caching.lastFrame >= I && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
        var l = this.interpolateValue(I, this._caching);
        this.pv = l;
      }
      return this._caching.lastFrame = I, this.pv;
    }
    function f(I) {
      var o;
      if (this.propType === "unidimensional") o = I * this.mult, t(this.v - o) > 1e-5 && (this.v = o, this._mdf = !0);else for (var s = 0, l = this.v.length; s < l;) o = I[s] * this.mult, t(this.v[s] - o) > 1e-5 && (this.v[s] = o, this._mdf = !0), s += 1;
    }
    function p() {
      if (!(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length)) {
        if (this.lock) {
          this.setVValue(this.pv);
          return;
        }
        this.lock = !0, this._mdf = this._isFirstFrame;
        var I,
          o = this.effectsSequence.length,
          s = this.kf ? this.pv : this.data.k;
        for (I = 0; I < o; I += 1) s = this.effectsSequence[I](s);
        this.setVValue(s), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
    function y(I) {
      this.effectsSequence.push(I), this.container.addDynamicProperty(this);
    }
    function v(I, o, s, l) {
      this.propType = "unidimensional", this.mult = s || 1, this.data = o, this.v = s ? o.k * s : o.k, this.pv = o.k, this._mdf = !1, this.elem = I, this.container = l, this.comp = I.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = p, this.setVValue = f, this.addEffect = y;
    }
    function A(I, o, s, l) {
      this.propType = "multidimensional", this.mult = s || 1, this.data = o, this._mdf = !1, this.elem = I, this.container = l, this.comp = I.comp, this.k = !1, this.kf = !1, this.frameId = -1;
      var h,
        m = o.k.length;
      for (this.v = createTypedArray("float32", m), this.pv = createTypedArray("float32", m), this.vel = createTypedArray("float32", m), h = 0; h < m; h += 1) this.v[h] = o.k[h] * this.mult, this.pv[h] = o.k[h];
      this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = p, this.setVValue = f, this.addEffect = y;
    }
    function c(I, o, s, l) {
      this.propType = "unidimensional", this.keyframes = o.k, this.keyframesMetadata = [], this.offsetTime = I.data.st, this.frameId = -1, this._caching = {
        lastFrame: e,
        lastIndex: 0,
        value: 0,
        _lastKeyframeIndex: -1
      }, this.k = !0, this.kf = !0, this.data = o, this.mult = s || 1, this.elem = I, this.container = l, this.comp = I.comp, this.v = e, this.pv = e, this._isFirstFrame = !0, this.getValue = p, this.setVValue = f, this.interpolateValue = r, this.effectsSequence = [u.bind(this)], this.addEffect = y;
    }
    function E(I, o, s, l) {
      this.propType = "multidimensional";
      var h,
        m = o.k.length,
        S,
        b,
        T,
        C;
      for (h = 0; h < m - 1; h += 1) o.k[h].to && o.k[h].s && o.k[h + 1] && o.k[h + 1].s && (S = o.k[h].s, b = o.k[h + 1].s, T = o.k[h].to, C = o.k[h].ti, (S.length === 2 && !(S[0] === b[0] && S[1] === b[1]) && bez.pointOnLine2D(S[0], S[1], b[0], b[1], S[0] + T[0], S[1] + T[1]) && bez.pointOnLine2D(S[0], S[1], b[0], b[1], b[0] + C[0], b[1] + C[1]) || S.length === 3 && !(S[0] === b[0] && S[1] === b[1] && S[2] === b[2]) && bez.pointOnLine3D(S[0], S[1], S[2], b[0], b[1], b[2], S[0] + T[0], S[1] + T[1], S[2] + T[2]) && bez.pointOnLine3D(S[0], S[1], S[2], b[0], b[1], b[2], b[0] + C[0], b[1] + C[1], b[2] + C[2])) && (o.k[h].to = null, o.k[h].ti = null), S[0] === b[0] && S[1] === b[1] && T[0] === 0 && T[1] === 0 && C[0] === 0 && C[1] === 0 && (S.length === 2 || S[2] === b[2] && T[2] === 0 && C[2] === 0) && (o.k[h].to = null, o.k[h].ti = null));
      this.effectsSequence = [u.bind(this)], this.data = o, this.keyframes = o.k, this.keyframesMetadata = [], this.offsetTime = I.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = s || 1, this.elem = I, this.container = l, this.comp = I.comp, this.getValue = p, this.setVValue = f, this.interpolateValue = r, this.frameId = -1;
      var F = o.k[0].s.length;
      for (this.v = createTypedArray("float32", F), this.pv = createTypedArray("float32", F), h = 0; h < F; h += 1) this.v[h] = e, this.pv[h] = e;
      this._caching = {
        lastFrame: e,
        lastIndex: 0,
        value: createTypedArray("float32", F)
      }, this.addEffect = y;
    }
    function d(I, o, s, l, h) {
      var m;
      if (!o.k.length) m = new v(I, o, l, h);else if (typeof o.k[0] == "number") m = new A(I, o, l, h);else switch (s) {
        case 0:
          m = new c(I, o, l, h);
          break;
        case 1:
          m = new E(I, o, l, h);
          break;
      }
      return m.effectsSequence.length && h.addDynamicProperty(m), m;
    }
    var g = {
      getProp: d
    };
    return g;
  }();
function DynamicPropertyContainer() {}
DynamicPropertyContainer.prototype = {
  addDynamicProperty: function (e) {
    this.dynamicProperties.indexOf(e) === -1 && (this.dynamicProperties.push(e), this.container.addDynamicProperty(this), this._isAnimated = !0);
  },
  iterateDynamicProperties: function () {
    this._mdf = !1;
    var e,
      t = this.dynamicProperties.length;
    for (e = 0; e < t; e += 1) this.dynamicProperties[e].getValue(), this.dynamicProperties[e]._mdf && (this._mdf = !0);
  },
  initDynamicPropertyContainer: function (e) {
    this.container = e, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
  }
};
const pointPool = function () {
  function e() {
    return createTypedArray("float32", 2);
  }
  return poolFactory(8, e);
}();
function ShapePath() {
  this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
}
ShapePath.prototype.setPathData = function (e, t) {
  this.c = e, this.setLength(t);
  for (var r = 0; r < t;) this.v[r] = pointPool.newElement(), this.o[r] = pointPool.newElement(), this.i[r] = pointPool.newElement(), r += 1;
};
ShapePath.prototype.setLength = function (e) {
  for (; this._maxLength < e;) this.doubleArrayLength();
  this._length = e;
};
ShapePath.prototype.doubleArrayLength = function () {
  this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
};
ShapePath.prototype.setXYAt = function (e, t, r, i, a) {
  var n;
  switch (this._length = Math.max(this._length, i + 1), this._length >= this._maxLength && this.doubleArrayLength(), r) {
    case "v":
      n = this.v;
      break;
    case "i":
      n = this.i;
      break;
    case "o":
      n = this.o;
      break;
    default:
      n = [];
      break;
  }
  (!n[i] || n[i] && !a) && (n[i] = pointPool.newElement()), n[i][0] = e, n[i][1] = t;
};
ShapePath.prototype.setTripleAt = function (e, t, r, i, a, n, u, f) {
  this.setXYAt(e, t, "v", u, f), this.setXYAt(r, i, "o", u, f), this.setXYAt(a, n, "i", u, f);
};
ShapePath.prototype.reverse = function () {
  var e = new ShapePath();
  e.setPathData(this.c, this._length);
  var t = this.v,
    r = this.o,
    i = this.i,
    a = 0;
  this.c && (e.setTripleAt(t[0][0], t[0][1], i[0][0], i[0][1], r[0][0], r[0][1], 0, !1), a = 1);
  var n = this._length - 1,
    u = this._length,
    f;
  for (f = a; f < u; f += 1) e.setTripleAt(t[n][0], t[n][1], i[n][0], i[n][1], r[n][0], r[n][1], f, !1), n -= 1;
  return e;
};
const shapePool = function () {
  function e() {
    return new ShapePath();
  }
  function t(a) {
    var n = a._length,
      u;
    for (u = 0; u < n; u += 1) pointPool.release(a.v[u]), pointPool.release(a.i[u]), pointPool.release(a.o[u]), a.v[u] = null, a.i[u] = null, a.o[u] = null;
    a._length = 0, a.c = !1;
  }
  function r(a) {
    var n = i.newElement(),
      u,
      f = a._length === void 0 ? a.v.length : a._length;
    for (n.setLength(f), n.c = a.c, u = 0; u < f; u += 1) n.setTripleAt(a.v[u][0], a.v[u][1], a.o[u][0], a.o[u][1], a.i[u][0], a.i[u][1], u);
    return n;
  }
  var i = poolFactory(4, e, t);
  return i.clone = r, i;
}();
function ShapeCollection() {
  this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
}
ShapeCollection.prototype.addShape = function (e) {
  this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = e, this._length += 1;
};
ShapeCollection.prototype.releaseShapes = function () {
  var e;
  for (e = 0; e < this._length; e += 1) shapePool.release(this.shapes[e]);
  this._length = 0;
};
const shapeCollectionPool = function () {
    var e = {
        newShapeCollection: a,
        release: n
      },
      t = 0,
      r = 4,
      i = createSizedArray(r);
    function a() {
      var u;
      return t ? (t -= 1, u = i[t]) : u = new ShapeCollection(), u;
    }
    function n(u) {
      var f,
        p = u._length;
      for (f = 0; f < p; f += 1) shapePool.release(u.shapes[f]);
      u._length = 0, t === r && (i = pooling.double(i), r *= 2), i[t] = u, t += 1;
    }
    return e;
  }(),
  ShapePropertyFactory = function () {
    var e = -999999;
    function t(o, s, l) {
      var h = l.lastIndex,
        m,
        S,
        b,
        T,
        C,
        F,
        w,
        k,
        L,
        B = this.keyframes;
      if (o < B[0].t - this.offsetTime) m = B[0].s[0], b = !0, h = 0;else if (o >= B[B.length - 1].t - this.offsetTime) m = B[B.length - 1].s ? B[B.length - 1].s[0] : B[B.length - 2].e[0], b = !0;else {
        for (var x = h, N = B.length - 1, P = !0, _, M, R; P && (_ = B[x], M = B[x + 1], !(M.t - this.offsetTime > o));) x < N - 1 ? x += 1 : P = !1;
        if (R = this.keyframesMetadata[x] || {}, b = _.h === 1, h = x, !b) {
          if (o >= M.t - this.offsetTime) k = 1;else if (o < _.t - this.offsetTime) k = 0;else {
            var G;
            R.__fnct ? G = R.__fnct : (G = BezierFactory.getBezierEasing(_.o.x, _.o.y, _.i.x, _.i.y).get, R.__fnct = G), k = G((o - (_.t - this.offsetTime)) / (M.t - this.offsetTime - (_.t - this.offsetTime)));
          }
          S = M.s ? M.s[0] : _.e[0];
        }
        m = _.s[0];
      }
      for (F = s._length, w = m.i[0].length, l.lastIndex = h, T = 0; T < F; T += 1) for (C = 0; C < w; C += 1) L = b ? m.i[T][C] : m.i[T][C] + (S.i[T][C] - m.i[T][C]) * k, s.i[T][C] = L, L = b ? m.o[T][C] : m.o[T][C] + (S.o[T][C] - m.o[T][C]) * k, s.o[T][C] = L, L = b ? m.v[T][C] : m.v[T][C] + (S.v[T][C] - m.v[T][C]) * k, s.v[T][C] = L;
    }
    function r() {
      var o = this.comp.renderedFrame - this.offsetTime,
        s = this.keyframes[0].t - this.offsetTime,
        l = this.keyframes[this.keyframes.length - 1].t - this.offsetTime,
        h = this._caching.lastFrame;
      return h !== e && (h < s && o < s || h > l && o > l) || (this._caching.lastIndex = h < o ? this._caching.lastIndex : 0, this.interpolateShape(o, this.pv, this._caching)), this._caching.lastFrame = o, this.pv;
    }
    function i() {
      this.paths = this.localShapeCollection;
    }
    function a(o, s) {
      if (o._length !== s._length || o.c !== s.c) return !1;
      var l,
        h = o._length;
      for (l = 0; l < h; l += 1) if (o.v[l][0] !== s.v[l][0] || o.v[l][1] !== s.v[l][1] || o.o[l][0] !== s.o[l][0] || o.o[l][1] !== s.o[l][1] || o.i[l][0] !== s.i[l][0] || o.i[l][1] !== s.i[l][1]) return !1;
      return !0;
    }
    function n(o) {
      a(this.v, o) || (this.v = shapePool.clone(o), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
    }
    function u() {
      if (this.elem.globalData.frameId !== this.frameId) {
        if (!this.effectsSequence.length) {
          this._mdf = !1;
          return;
        }
        if (this.lock) {
          this.setVValue(this.pv);
          return;
        }
        this.lock = !0, this._mdf = !1;
        var o;
        this.kf ? o = this.pv : this.data.ks ? o = this.data.ks.k : o = this.data.pt.k;
        var s,
          l = this.effectsSequence.length;
        for (s = 0; s < l; s += 1) o = this.effectsSequence[s](o);
        this.setVValue(o), this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
    function f(o, s, l) {
      this.propType = "shape", this.comp = o.comp, this.container = o, this.elem = o, this.data = s, this.k = !1, this.kf = !1, this._mdf = !1;
      var h = l === 3 ? s.pt.k : s.ks.k;
      this.v = shapePool.clone(h), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = i, this.effectsSequence = [];
    }
    function p(o) {
      this.effectsSequence.push(o), this.container.addDynamicProperty(this);
    }
    f.prototype.interpolateShape = t, f.prototype.getValue = u, f.prototype.setVValue = n, f.prototype.addEffect = p;
    function y(o, s, l) {
      this.propType = "shape", this.comp = o.comp, this.elem = o, this.container = o, this.offsetTime = o.data.st, this.keyframes = l === 3 ? s.pt.k : s.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
      var h = this.keyframes[0].s[0].i.length;
      this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, h), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = e, this.reset = i, this._caching = {
        lastFrame: e,
        lastIndex: 0
      }, this.effectsSequence = [r.bind(this)];
    }
    y.prototype.getValue = u, y.prototype.interpolateShape = t, y.prototype.setVValue = n, y.prototype.addEffect = p;
    var v = function () {
        var o = roundCorner;
        function s(l, h) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = h.d, this.elem = l, this.comp = l.comp, this.frameId = -1, this.initDynamicPropertyContainer(l), this.p = PropertyFactory.getProp(l, h.p, 1, 0, this), this.s = PropertyFactory.getProp(l, h.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return s.prototype = {
          reset: i,
          getValue: function () {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
          },
          convertEllToPath: function () {
            var l = this.p.v[0],
              h = this.p.v[1],
              m = this.s.v[0] / 2,
              S = this.s.v[1] / 2,
              b = this.d !== 3,
              T = this.v;
            T.v[0][0] = l, T.v[0][1] = h - S, T.v[1][0] = b ? l + m : l - m, T.v[1][1] = h, T.v[2][0] = l, T.v[2][1] = h + S, T.v[3][0] = b ? l - m : l + m, T.v[3][1] = h, T.i[0][0] = b ? l - m * o : l + m * o, T.i[0][1] = h - S, T.i[1][0] = b ? l + m : l - m, T.i[1][1] = h - S * o, T.i[2][0] = b ? l + m * o : l - m * o, T.i[2][1] = h + S, T.i[3][0] = b ? l - m : l + m, T.i[3][1] = h + S * o, T.o[0][0] = b ? l + m * o : l - m * o, T.o[0][1] = h - S, T.o[1][0] = b ? l + m : l - m, T.o[1][1] = h + S * o, T.o[2][0] = b ? l - m * o : l + m * o, T.o[2][1] = h + S, T.o[3][0] = b ? l - m : l + m, T.o[3][1] = h - S * o;
          }
        }, extendPrototype([DynamicPropertyContainer], s), s;
      }(),
      A = function () {
        function o(s, l) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = s, this.comp = s.comp, this.data = l, this.frameId = -1, this.d = l.d, this.initDynamicPropertyContainer(s), l.sy === 1 ? (this.ir = PropertyFactory.getProp(s, l.ir, 0, 0, this), this.is = PropertyFactory.getProp(s, l.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(s, l.pt, 0, 0, this), this.p = PropertyFactory.getProp(s, l.p, 1, 0, this), this.r = PropertyFactory.getProp(s, l.r, 0, degToRads, this), this.or = PropertyFactory.getProp(s, l.or, 0, 0, this), this.os = PropertyFactory.getProp(s, l.os, 0, 0.01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return o.prototype = {
          reset: i,
          getValue: function () {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
          },
          convertStarToPath: function () {
            var s = Math.floor(this.pt.v) * 2,
              l = Math.PI * 2 / s,
              h = !0,
              m = this.or.v,
              S = this.ir.v,
              b = this.os.v,
              T = this.is.v,
              C = 2 * Math.PI * m / (s * 2),
              F = 2 * Math.PI * S / (s * 2),
              w,
              k,
              L,
              B,
              x = -Math.PI / 2;
            x += this.r.v;
            var N = this.data.d === 3 ? -1 : 1;
            for (this.v._length = 0, w = 0; w < s; w += 1) {
              k = h ? m : S, L = h ? b : T, B = h ? C : F;
              var P = k * Math.cos(x),
                _ = k * Math.sin(x),
                M = P === 0 && _ === 0 ? 0 : _ / Math.sqrt(P * P + _ * _),
                R = P === 0 && _ === 0 ? 0 : -P / Math.sqrt(P * P + _ * _);
              P += +this.p.v[0], _ += +this.p.v[1], this.v.setTripleAt(P, _, P - M * B * L * N, _ - R * B * L * N, P + M * B * L * N, _ + R * B * L * N, w, !0), h = !h, x += l * N;
            }
          },
          convertPolygonToPath: function () {
            var s = Math.floor(this.pt.v),
              l = Math.PI * 2 / s,
              h = this.or.v,
              m = this.os.v,
              S = 2 * Math.PI * h / (s * 4),
              b,
              T = -Math.PI * 0.5,
              C = this.data.d === 3 ? -1 : 1;
            for (T += this.r.v, this.v._length = 0, b = 0; b < s; b += 1) {
              var F = h * Math.cos(T),
                w = h * Math.sin(T),
                k = F === 0 && w === 0 ? 0 : w / Math.sqrt(F * F + w * w),
                L = F === 0 && w === 0 ? 0 : -F / Math.sqrt(F * F + w * w);
              F += +this.p.v[0], w += +this.p.v[1], this.v.setTripleAt(F, w, F - k * S * m * C, w - L * S * m * C, F + k * S * m * C, w + L * S * m * C, b, !0), T += l * C;
            }
            this.paths.length = 0, this.paths[0] = this.v;
          }
        }, extendPrototype([DynamicPropertyContainer], o), o;
      }(),
      c = function () {
        function o(s, l) {
          this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = s, this.comp = s.comp, this.frameId = -1, this.d = l.d, this.initDynamicPropertyContainer(s), this.p = PropertyFactory.getProp(s, l.p, 1, 0, this), this.s = PropertyFactory.getProp(s, l.s, 1, 0, this), this.r = PropertyFactory.getProp(s, l.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return o.prototype = {
          convertRectToPath: function () {
            var s = this.p.v[0],
              l = this.p.v[1],
              h = this.s.v[0] / 2,
              m = this.s.v[1] / 2,
              S = bmMin(h, m, this.r.v),
              b = S * (1 - roundCorner);
            this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(s + h, l - m + S, s + h, l - m + S, s + h, l - m + b, 0, !0), this.v.setTripleAt(s + h, l + m - S, s + h, l + m - b, s + h, l + m - S, 1, !0), S !== 0 ? (this.v.setTripleAt(s + h - S, l + m, s + h - S, l + m, s + h - b, l + m, 2, !0), this.v.setTripleAt(s - h + S, l + m, s - h + b, l + m, s - h + S, l + m, 3, !0), this.v.setTripleAt(s - h, l + m - S, s - h, l + m - S, s - h, l + m - b, 4, !0), this.v.setTripleAt(s - h, l - m + S, s - h, l - m + b, s - h, l - m + S, 5, !0), this.v.setTripleAt(s - h + S, l - m, s - h + S, l - m, s - h + b, l - m, 6, !0), this.v.setTripleAt(s + h - S, l - m, s + h - b, l - m, s + h - S, l - m, 7, !0)) : (this.v.setTripleAt(s - h, l + m, s - h + b, l + m, s - h, l + m, 2), this.v.setTripleAt(s - h, l - m, s - h, l - m + b, s - h, l - m, 3))) : (this.v.setTripleAt(s + h, l - m + S, s + h, l - m + b, s + h, l - m + S, 0, !0), S !== 0 ? (this.v.setTripleAt(s + h - S, l - m, s + h - S, l - m, s + h - b, l - m, 1, !0), this.v.setTripleAt(s - h + S, l - m, s - h + b, l - m, s - h + S, l - m, 2, !0), this.v.setTripleAt(s - h, l - m + S, s - h, l - m + S, s - h, l - m + b, 3, !0), this.v.setTripleAt(s - h, l + m - S, s - h, l + m - b, s - h, l + m - S, 4, !0), this.v.setTripleAt(s - h + S, l + m, s - h + S, l + m, s - h + b, l + m, 5, !0), this.v.setTripleAt(s + h - S, l + m, s + h - b, l + m, s + h - S, l + m, 6, !0), this.v.setTripleAt(s + h, l + m - S, s + h, l + m - S, s + h, l + m - b, 7, !0)) : (this.v.setTripleAt(s - h, l - m, s - h + b, l - m, s - h, l - m, 1, !0), this.v.setTripleAt(s - h, l + m, s - h, l + m - b, s - h, l + m, 2, !0), this.v.setTripleAt(s + h, l + m, s + h - b, l + m, s + h, l + m, 3, !0)));
          },
          getValue: function () {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
          },
          reset: i
        }, extendPrototype([DynamicPropertyContainer], o), o;
      }();
    function E(o, s, l) {
      var h;
      if (l === 3 || l === 4) {
        var m = l === 3 ? s.pt : s.ks,
          S = m.k;
        S.length ? h = new y(o, s, l) : h = new f(o, s, l);
      } else l === 5 ? h = new c(o, s) : l === 6 ? h = new v(o, s) : l === 7 && (h = new A(o, s));
      return h.k && o.addDynamicProperty(h), h;
    }
    function d() {
      return f;
    }
    function g() {
      return y;
    }
    var I = {};
    return I.getShapeProp = E, I.getConstructorFunction = d, I.getKeyframedConstructorFunction = g, I;
  }();
/*!
 Transformation Matrix v2.0
 (c) Epistemex 2014-2015
 www.epistemex.com
 By Ken Fyrstenberg
 Contributions by leeoniya.
 License: MIT, header required.
 */
const Matrix = function () {
    var e = Math.cos,
      t = Math.sin,
      r = Math.tan,
      i = Math.round;
    function a() {
      return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
    }
    function n(P) {
      if (P === 0) return this;
      var _ = e(P),
        M = t(P);
      return this._t(_, -M, 0, 0, M, _, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }
    function u(P) {
      if (P === 0) return this;
      var _ = e(P),
        M = t(P);
      return this._t(1, 0, 0, 0, 0, _, -M, 0, 0, M, _, 0, 0, 0, 0, 1);
    }
    function f(P) {
      if (P === 0) return this;
      var _ = e(P),
        M = t(P);
      return this._t(_, 0, M, 0, 0, 1, 0, 0, -M, 0, _, 0, 0, 0, 0, 1);
    }
    function p(P) {
      if (P === 0) return this;
      var _ = e(P),
        M = t(P);
      return this._t(_, -M, 0, 0, M, _, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }
    function y(P, _) {
      return this._t(1, _, P, 1, 0, 0);
    }
    function v(P, _) {
      return this.shear(r(P), r(_));
    }
    function A(P, _) {
      var M = e(_),
        R = t(_);
      return this._t(M, R, 0, 0, -R, M, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, r(P), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(M, -R, 0, 0, R, M, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }
    function c(P, _, M) {
      return !M && M !== 0 && (M = 1), P === 1 && _ === 1 && M === 1 ? this : this._t(P, 0, 0, 0, 0, _, 0, 0, 0, 0, M, 0, 0, 0, 0, 1);
    }
    function E(P, _, M, R, G, D, z, Y, Z, q, t1, r1, a1, e1, X, s1) {
      return this.props[0] = P, this.props[1] = _, this.props[2] = M, this.props[3] = R, this.props[4] = G, this.props[5] = D, this.props[6] = z, this.props[7] = Y, this.props[8] = Z, this.props[9] = q, this.props[10] = t1, this.props[11] = r1, this.props[12] = a1, this.props[13] = e1, this.props[14] = X, this.props[15] = s1, this;
    }
    function d(P, _, M) {
      return M = M || 0, P !== 0 || _ !== 0 || M !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, P, _, M, 1) : this;
    }
    function g(P, _, M, R, G, D, z, Y, Z, q, t1, r1, a1, e1, X, s1) {
      var H = this.props;
      if (P === 1 && _ === 0 && M === 0 && R === 0 && G === 0 && D === 1 && z === 0 && Y === 0 && Z === 0 && q === 0 && t1 === 1 && r1 === 0) return H[12] = H[12] * P + H[15] * a1, H[13] = H[13] * D + H[15] * e1, H[14] = H[14] * t1 + H[15] * X, H[15] *= s1, this._identityCalculated = !1, this;
      var Q = H[0],
        h1 = H[1],
        p1 = H[2],
        y1 = H[3],
        f1 = H[4],
        u1 = H[5],
        E1 = H[6],
        o1 = H[7],
        g1 = H[8],
        _1 = H[9],
        d1 = H[10],
        S1 = H[11],
        c1 = H[12],
        m1 = H[13],
        b1 = H[14],
        I1 = H[15];
      return H[0] = Q * P + h1 * G + p1 * Z + y1 * a1, H[1] = Q * _ + h1 * D + p1 * q + y1 * e1, H[2] = Q * M + h1 * z + p1 * t1 + y1 * X, H[3] = Q * R + h1 * Y + p1 * r1 + y1 * s1, H[4] = f1 * P + u1 * G + E1 * Z + o1 * a1, H[5] = f1 * _ + u1 * D + E1 * q + o1 * e1, H[6] = f1 * M + u1 * z + E1 * t1 + o1 * X, H[7] = f1 * R + u1 * Y + E1 * r1 + o1 * s1, H[8] = g1 * P + _1 * G + d1 * Z + S1 * a1, H[9] = g1 * _ + _1 * D + d1 * q + S1 * e1, H[10] = g1 * M + _1 * z + d1 * t1 + S1 * X, H[11] = g1 * R + _1 * Y + d1 * r1 + S1 * s1, H[12] = c1 * P + m1 * G + b1 * Z + I1 * a1, H[13] = c1 * _ + m1 * D + b1 * q + I1 * e1, H[14] = c1 * M + m1 * z + b1 * t1 + I1 * X, H[15] = c1 * R + m1 * Y + b1 * r1 + I1 * s1, this._identityCalculated = !1, this;
    }
    function I() {
      return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
    }
    function o(P) {
      for (var _ = 0; _ < 16;) {
        if (P.props[_] !== this.props[_]) return !1;
        _ += 1;
      }
      return !0;
    }
    function s(P) {
      var _;
      for (_ = 0; _ < 16; _ += 1) P.props[_] = this.props[_];
      return P;
    }
    function l(P) {
      var _;
      for (_ = 0; _ < 16; _ += 1) this.props[_] = P[_];
    }
    function h(P, _, M) {
      return {
        x: P * this.props[0] + _ * this.props[4] + M * this.props[8] + this.props[12],
        y: P * this.props[1] + _ * this.props[5] + M * this.props[9] + this.props[13],
        z: P * this.props[2] + _ * this.props[6] + M * this.props[10] + this.props[14]
      };
    }
    function m(P, _, M) {
      return P * this.props[0] + _ * this.props[4] + M * this.props[8] + this.props[12];
    }
    function S(P, _, M) {
      return P * this.props[1] + _ * this.props[5] + M * this.props[9] + this.props[13];
    }
    function b(P, _, M) {
      return P * this.props[2] + _ * this.props[6] + M * this.props[10] + this.props[14];
    }
    function T() {
      var P = this.props[0] * this.props[5] - this.props[1] * this.props[4],
        _ = this.props[5] / P,
        M = -this.props[1] / P,
        R = -this.props[4] / P,
        G = this.props[0] / P,
        D = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / P,
        z = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / P,
        Y = new Matrix();
      return Y.props[0] = _, Y.props[1] = M, Y.props[4] = R, Y.props[5] = G, Y.props[12] = D, Y.props[13] = z, Y;
    }
    function C(P) {
      var _ = this.getInverseMatrix();
      return _.applyToPointArray(P[0], P[1], P[2] || 0);
    }
    function F(P) {
      var _,
        M = P.length,
        R = [];
      for (_ = 0; _ < M; _ += 1) R[_] = C(P[_]);
      return R;
    }
    function w(P, _, M) {
      var R = createTypedArray("float32", 6);
      if (this.isIdentity()) R[0] = P[0], R[1] = P[1], R[2] = _[0], R[3] = _[1], R[4] = M[0], R[5] = M[1];else {
        var G = this.props[0],
          D = this.props[1],
          z = this.props[4],
          Y = this.props[5],
          Z = this.props[12],
          q = this.props[13];
        R[0] = P[0] * G + P[1] * z + Z, R[1] = P[0] * D + P[1] * Y + q, R[2] = _[0] * G + _[1] * z + Z, R[3] = _[0] * D + _[1] * Y + q, R[4] = M[0] * G + M[1] * z + Z, R[5] = M[0] * D + M[1] * Y + q;
      }
      return R;
    }
    function k(P, _, M) {
      var R;
      return this.isIdentity() ? R = [P, _, M] : R = [P * this.props[0] + _ * this.props[4] + M * this.props[8] + this.props[12], P * this.props[1] + _ * this.props[5] + M * this.props[9] + this.props[13], P * this.props[2] + _ * this.props[6] + M * this.props[10] + this.props[14]], R;
    }
    function L(P, _) {
      if (this.isIdentity()) return P + "," + _;
      var M = this.props;
      return Math.round((P * M[0] + _ * M[4] + M[12]) * 100) / 100 + "," + Math.round((P * M[1] + _ * M[5] + M[13]) * 100) / 100;
    }
    function B() {
      for (var P = 0, _ = this.props, M = "matrix3d(", R = 1e4; P < 16;) M += i(_[P] * R) / R, M += P === 15 ? ")" : ",", P += 1;
      return M;
    }
    function x(P) {
      var _ = 1e4;
      return P < 1e-6 && P > 0 || P > -1e-6 && P < 0 ? i(P * _) / _ : P;
    }
    function N() {
      var P = this.props,
        _ = x(P[0]),
        M = x(P[1]),
        R = x(P[4]),
        G = x(P[5]),
        D = x(P[12]),
        z = x(P[13]);
      return "matrix(" + _ + "," + M + "," + R + "," + G + "," + D + "," + z + ")";
    }
    return function () {
      this.reset = a, this.rotate = n, this.rotateX = u, this.rotateY = f, this.rotateZ = p, this.skew = v, this.skewFromAxis = A, this.shear = y, this.scale = c, this.setTransform = E, this.translate = d, this.transform = g, this.applyToPoint = h, this.applyToX = m, this.applyToY = S, this.applyToZ = b, this.applyToPointArray = k, this.applyToTriplePoints = w, this.applyToPointStringified = L, this.toCSS = B, this.to2dCSS = N, this.clone = s, this.cloneFromProps = l, this.equals = o, this.inversePoints = F, this.inversePoint = C, this.getInverseMatrix = T, this._t = this.transform, this.isIdentity = I, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
    };
  }(),
  lottie = {};
function setLocation(e) {
  setLocationHref(e);
}
function searchAnimations() {
  animationManager.searchAnimations();
}
function setSubframeRendering(e) {
  setSubframeEnabled(e);
}
function setPrefix(e) {
  setIdPrefix(e);
}
function loadAnimation(e) {
  return animationManager.loadAnimation(e);
}
function setQuality(e) {
  if (typeof e == "string") switch (e) {
    case "high":
      setDefaultCurveSegments(200);
      break;
    default:
    case "medium":
      setDefaultCurveSegments(50);
      break;
    case "low":
      setDefaultCurveSegments(10);
      break;
  } else !isNaN(e) && e > 1 && setDefaultCurveSegments(e);
}
function inBrowser() {
  return typeof navigator < "u";
}
function installPlugin(e, t) {
  e === "expressions" && setExpressionsPlugin(t);
}
function getFactory(e) {
  switch (e) {
    case "propertyFactory":
      return PropertyFactory;
    case "shapePropertyFactory":
      return ShapePropertyFactory;
    case "matrix":
      return Matrix;
    default:
      return null;
  }
}
lottie.play = animationManager.play;
lottie.pause = animationManager.pause;
lottie.setLocationHref = setLocation;
lottie.togglePause = animationManager.togglePause;
lottie.setSpeed = animationManager.setSpeed;
lottie.setDirection = animationManager.setDirection;
lottie.stop = animationManager.stop;
lottie.searchAnimations = searchAnimations;
lottie.registerAnimation = animationManager.registerAnimation;
lottie.loadAnimation = loadAnimation;
lottie.setSubframeRendering = setSubframeRendering;
lottie.resize = animationManager.resize;
lottie.goToAndStop = animationManager.goToAndStop;
lottie.destroy = animationManager.destroy;
lottie.setQuality = setQuality;
lottie.inBrowser = inBrowser;
lottie.installPlugin = installPlugin;
lottie.freeze = animationManager.freeze;
lottie.unfreeze = animationManager.unfreeze;
lottie.setVolume = animationManager.setVolume;
lottie.mute = animationManager.mute;
lottie.unmute = animationManager.unmute;
lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
lottie.useWebWorker = setWebWorker;
lottie.setIDPrefix = setPrefix;
lottie.__getFactory = getFactory;
lottie.version = "[[BM_VERSION]]";
function checkReady() {
  document.readyState === "complete" && (clearInterval(readyStateCheckInterval), searchAnimations());
}
function getQueryVariable(e) {
  for (var t = queryString.split("&"), r = 0; r < t.length; r += 1) {
    var i = t[r].split("=");
    if (decodeURIComponent(i[0]) == e) return decodeURIComponent(i[1]);
  }
  return null;
}
var queryString = "";
{
  var scripts = document.getElementsByTagName("script"),
    index = scripts.length - 1,
    myScript = scripts[index] || {
      src: ""
    };
  queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
}
var readyStateCheckInterval = setInterval(checkReady, 100);
try {
  !(typeof exports == "object" && typeof module < "u") && !(typeof define == "function" && define.amd) && (window.bodymovin = lottie);
} catch {}
const ShapeModifiers = function () {
  var e = {},
    t = {};
  e.registerModifier = r, e.getModifier = i;
  function r(a, n) {
    t[a] || (t[a] = n);
  }
  function i(a, n, u) {
    return new t[a](n, u);
  }
  return e;
}();
function ShapeModifier() {}
ShapeModifier.prototype.initModifierProperties = function () {};
ShapeModifier.prototype.addShapeToModifier = function () {};
ShapeModifier.prototype.addShape = function (e) {
  if (!this.closed) {
    e.sh.container.addDynamicProperty(e.sh);
    var t = {
      shape: e.sh,
      data: e,
      localShapeCollection: shapeCollectionPool.newShapeCollection()
    };
    this.shapes.push(t), this.addShapeToModifier(t), this._isAnimated && e.setAsAnimated();
  }
};
ShapeModifier.prototype.init = function (e, t) {
  this.shapes = [], this.elem = e, this.initDynamicPropertyContainer(e), this.initModifierProperties(e, t), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
};
ShapeModifier.prototype.processKeys = function () {
  this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
};
extendPrototype([DynamicPropertyContainer], ShapeModifier);
function TrimModifier() {}
extendPrototype([ShapeModifier], TrimModifier);
TrimModifier.prototype.initModifierProperties = function (e, t) {
  this.s = PropertyFactory.getProp(e, t.s, 0, 0.01, this), this.e = PropertyFactory.getProp(e, t.e, 0, 0.01, this), this.o = PropertyFactory.getProp(e, t.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = t.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
};
TrimModifier.prototype.addShapeToModifier = function (e) {
  e.pathsData = [];
};
TrimModifier.prototype.calculateShapeEdges = function (e, t, r, i, a) {
  var n = [];
  t <= 1 ? n.push({
    s: e,
    e: t
  }) : e >= 1 ? n.push({
    s: e - 1,
    e: t - 1
  }) : (n.push({
    s: e,
    e: 1
  }), n.push({
    s: 0,
    e: t - 1
  }));
  var u = [],
    f,
    p = n.length,
    y;
  for (f = 0; f < p; f += 1) if (y = n[f], !(y.e * a < i || y.s * a > i + r)) {
    var v, A;
    y.s * a <= i ? v = 0 : v = (y.s * a - i) / r, y.e * a >= i + r ? A = 1 : A = (y.e * a - i) / r, u.push([v, A]);
  }
  return u.length || u.push([0, 0]), u;
};
TrimModifier.prototype.releasePathsData = function (e) {
  var t,
    r = e.length;
  for (t = 0; t < r; t += 1) segmentsLengthPool.release(e[t]);
  return e.length = 0, e;
};
TrimModifier.prototype.processShapes = function (e) {
  var t, r;
  if (this._mdf || e) {
    var i = this.o.v % 360 / 360;
    if (i < 0 && (i += 1), this.s.v > 1 ? t = 1 + i : this.s.v < 0 ? t = 0 + i : t = this.s.v + i, this.e.v > 1 ? r = 1 + i : this.e.v < 0 ? r = 0 + i : r = this.e.v + i, t > r) {
      var a = t;
      t = r, r = a;
    }
    t = Math.round(t * 1e4) * 1e-4, r = Math.round(r * 1e4) * 1e-4, this.sValue = t, this.eValue = r;
  } else t = this.sValue, r = this.eValue;
  var n,
    u,
    f = this.shapes.length,
    p,
    y,
    v,
    A,
    c,
    E = 0;
  if (r === t) for (u = 0; u < f; u += 1) this.shapes[u].localShapeCollection.releaseShapes(), this.shapes[u].shape._mdf = !0, this.shapes[u].shape.paths = this.shapes[u].localShapeCollection, this._mdf && (this.shapes[u].pathsData.length = 0);else if (r === 1 && t === 0 || r === 0 && t === 1) {
    if (this._mdf) for (u = 0; u < f; u += 1) this.shapes[u].pathsData.length = 0, this.shapes[u].shape._mdf = !0;
  } else {
    var d = [],
      g,
      I;
    for (u = 0; u < f; u += 1) if (g = this.shapes[u], !g.shape._mdf && !this._mdf && !e && this.m !== 2) g.shape.paths = g.localShapeCollection;else {
      if (n = g.shape.paths, y = n._length, c = 0, !g.shape._mdf && g.pathsData.length) c = g.totalShapeLength;else {
        for (v = this.releasePathsData(g.pathsData), p = 0; p < y; p += 1) A = bez.getSegmentsLength(n.shapes[p]), v.push(A), c += A.totalLength;
        g.totalShapeLength = c, g.pathsData = v;
      }
      E += c, g.shape._mdf = !0;
    }
    var o = t,
      s = r,
      l = 0,
      h;
    for (u = f - 1; u >= 0; u -= 1) if (g = this.shapes[u], g.shape._mdf) {
      for (I = g.localShapeCollection, I.releaseShapes(), this.m === 2 && f > 1 ? (h = this.calculateShapeEdges(t, r, g.totalShapeLength, l, E), l += g.totalShapeLength) : h = [[o, s]], y = h.length, p = 0; p < y; p += 1) {
        o = h[p][0], s = h[p][1], d.length = 0, s <= 1 ? d.push({
          s: g.totalShapeLength * o,
          e: g.totalShapeLength * s
        }) : o >= 1 ? d.push({
          s: g.totalShapeLength * (o - 1),
          e: g.totalShapeLength * (s - 1)
        }) : (d.push({
          s: g.totalShapeLength * o,
          e: g.totalShapeLength
        }), d.push({
          s: 0,
          e: g.totalShapeLength * (s - 1)
        }));
        var m = this.addShapes(g, d[0]);
        if (d[0].s !== d[0].e) {
          if (d.length > 1) {
            var S = g.shape.paths.shapes[g.shape.paths._length - 1];
            if (S.c) {
              var b = m.pop();
              this.addPaths(m, I), m = this.addShapes(g, d[1], b);
            } else this.addPaths(m, I), m = this.addShapes(g, d[1]);
          }
          this.addPaths(m, I);
        }
      }
      g.shape.paths = I;
    }
  }
};
TrimModifier.prototype.addPaths = function (e, t) {
  var r,
    i = e.length;
  for (r = 0; r < i; r += 1) t.addShape(e[r]);
};
TrimModifier.prototype.addSegment = function (e, t, r, i, a, n, u) {
  a.setXYAt(t[0], t[1], "o", n), a.setXYAt(r[0], r[1], "i", n + 1), u && a.setXYAt(e[0], e[1], "v", n), a.setXYAt(i[0], i[1], "v", n + 1);
};
TrimModifier.prototype.addSegmentFromArray = function (e, t, r, i) {
  t.setXYAt(e[1], e[5], "o", r), t.setXYAt(e[2], e[6], "i", r + 1), i && t.setXYAt(e[0], e[4], "v", r), t.setXYAt(e[3], e[7], "v", r + 1);
};
TrimModifier.prototype.addShapes = function (e, t, r) {
  var i = e.pathsData,
    a = e.shape.paths.shapes,
    n,
    u = e.shape.paths._length,
    f,
    p,
    y = 0,
    v,
    A,
    c,
    E,
    d = [],
    g,
    I = !0;
  for (r ? (A = r._length, g = r._length) : (r = shapePool.newElement(), A = 0, g = 0), d.push(r), n = 0; n < u; n += 1) {
    for (c = i[n].lengths, r.c = a[n].c, p = a[n].c ? c.length : c.length + 1, f = 1; f < p; f += 1) if (v = c[f - 1], y + v.addedLength < t.s) y += v.addedLength, r.c = !1;else if (y > t.e) {
      r.c = !1;
      break;
    } else t.s <= y && t.e >= y + v.addedLength ? (this.addSegment(a[n].v[f - 1], a[n].o[f - 1], a[n].i[f], a[n].v[f], r, A, I), I = !1) : (E = bez.getNewSegment(a[n].v[f - 1], a[n].v[f], a[n].o[f - 1], a[n].i[f], (t.s - y) / v.addedLength, (t.e - y) / v.addedLength, c[f - 1]), this.addSegmentFromArray(E, r, A, I), I = !1, r.c = !1), y += v.addedLength, A += 1;
    if (a[n].c && c.length) {
      if (v = c[f - 1], y <= t.e) {
        var o = c[f - 1].addedLength;
        t.s <= y && t.e >= y + o ? (this.addSegment(a[n].v[f - 1], a[n].o[f - 1], a[n].i[0], a[n].v[0], r, A, I), I = !1) : (E = bez.getNewSegment(a[n].v[f - 1], a[n].v[0], a[n].o[f - 1], a[n].i[0], (t.s - y) / o, (t.e - y) / o, c[f - 1]), this.addSegmentFromArray(E, r, A, I), I = !1, r.c = !1);
      } else r.c = !1;
      y += v.addedLength, A += 1;
    }
    if (r._length && (r.setXYAt(r.v[g][0], r.v[g][1], "i", g), r.setXYAt(r.v[r._length - 1][0], r.v[r._length - 1][1], "o", r._length - 1)), y > t.e) break;
    n < u - 1 && (r = shapePool.newElement(), I = !0, d.push(r), A = 0);
  }
  return d;
};
function PuckerAndBloatModifier() {}
extendPrototype([ShapeModifier], PuckerAndBloatModifier);
PuckerAndBloatModifier.prototype.initModifierProperties = function (e, t) {
  this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(e, t.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
};
PuckerAndBloatModifier.prototype.processPath = function (e, t) {
  var r = t / 100,
    i = [0, 0],
    a = e._length,
    n = 0;
  for (n = 0; n < a; n += 1) i[0] += e.v[n][0], i[1] += e.v[n][1];
  i[0] /= a, i[1] /= a;
  var u = shapePool.newElement();
  u.c = e.c;
  var f, p, y, v, A, c;
  for (n = 0; n < a; n += 1) f = e.v[n][0] + (i[0] - e.v[n][0]) * r, p = e.v[n][1] + (i[1] - e.v[n][1]) * r, y = e.o[n][0] + (i[0] - e.o[n][0]) * -r, v = e.o[n][1] + (i[1] - e.o[n][1]) * -r, A = e.i[n][0] + (i[0] - e.i[n][0]) * -r, c = e.i[n][1] + (i[1] - e.i[n][1]) * -r, u.setTripleAt(f, p, y, v, A, c, n);
  return u;
};
PuckerAndBloatModifier.prototype.processShapes = function (e) {
  var t,
    r,
    i = this.shapes.length,
    a,
    n,
    u = this.amount.v;
  if (u !== 0) {
    var f, p;
    for (r = 0; r < i; r += 1) {
      if (f = this.shapes[r], p = f.localShapeCollection, !(!f.shape._mdf && !this._mdf && !e)) for (p.releaseShapes(), f.shape._mdf = !0, t = f.shape.paths.shapes, n = f.shape.paths._length, a = 0; a < n; a += 1) p.addShape(this.processPath(t[a], u));
      f.shape.paths = f.localShapeCollection;
    }
  }
  this.dynamicProperties.length || (this._mdf = !1);
};
const TransformPropertyFactory = function () {
  var e = [0, 0];
  function t(p) {
    var y = this._mdf;
    this.iterateDynamicProperties(), this._mdf = this._mdf || y, this.a && p.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && p.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && p.skewFromAxis(-this.sk.v, this.sa.v), this.r ? p.rotate(-this.r.v) : p.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? p.translate(this.px.v, this.py.v, -this.pz.v) : p.translate(this.px.v, this.py.v, 0) : p.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
  }
  function r(p) {
    if (this.elem.globalData.frameId !== this.frameId) {
      if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || p) {
        var y;
        if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
          var v, A;
          if (y = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (v = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / y, 0), A = this.p.getValueAtTime(this.p.keyframes[0].t / y, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (v = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / y, 0), A = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / y, 0)) : (v = this.p.pv, A = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / y, this.p.offsetTime));else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
            v = [], A = [];
            var c = this.px,
              E = this.py;
            c._caching.lastFrame + c.offsetTime <= c.keyframes[0].t ? (v[0] = c.getValueAtTime((c.keyframes[0].t + 0.01) / y, 0), v[1] = E.getValueAtTime((E.keyframes[0].t + 0.01) / y, 0), A[0] = c.getValueAtTime(c.keyframes[0].t / y, 0), A[1] = E.getValueAtTime(E.keyframes[0].t / y, 0)) : c._caching.lastFrame + c.offsetTime >= c.keyframes[c.keyframes.length - 1].t ? (v[0] = c.getValueAtTime(c.keyframes[c.keyframes.length - 1].t / y, 0), v[1] = E.getValueAtTime(E.keyframes[E.keyframes.length - 1].t / y, 0), A[0] = c.getValueAtTime((c.keyframes[c.keyframes.length - 1].t - 0.01) / y, 0), A[1] = E.getValueAtTime((E.keyframes[E.keyframes.length - 1].t - 0.01) / y, 0)) : (v = [c.pv, E.pv], A[0] = c.getValueAtTime((c._caching.lastFrame + c.offsetTime - 0.01) / y, c.offsetTime), A[1] = E.getValueAtTime((E._caching.lastFrame + E.offsetTime - 0.01) / y, E.offsetTime));
          } else A = e, v = A;
          this.v.rotate(-Math.atan2(v[1] - A[1], v[0] - A[0]));
        }
        this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
      this.frameId = this.elem.globalData.frameId;
    }
  }
  function i() {
    if (!this.a.k) this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1;else return;
    if (!this.s.effectsSequence.length) this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2;else return;
    if (this.sk) if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;else return;
    this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : !this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length && (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
  }
  function a() {}
  function n(p) {
    this._addDynamicProperty(p), this.elem.addDynamicProperty(p), this._isDirty = !0;
  }
  function u(p, y, v) {
    if (this.elem = p, this.frameId = -1, this.propType = "transform", this.data = y, this.v = new Matrix(), this.pre = new Matrix(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(v || p), y.p && y.p.s ? (this.px = PropertyFactory.getProp(p, y.p.x, 0, 0, this), this.py = PropertyFactory.getProp(p, y.p.y, 0, 0, this), y.p.z && (this.pz = PropertyFactory.getProp(p, y.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(p, y.p || {
      k: [0, 0, 0]
    }, 1, 0, this), y.rx) {
      if (this.rx = PropertyFactory.getProp(p, y.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(p, y.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(p, y.rz, 0, degToRads, this), y.or.k[0].ti) {
        var A,
          c = y.or.k.length;
        for (A = 0; A < c; A += 1) y.or.k[A].to = null, y.or.k[A].ti = null;
      }
      this.or = PropertyFactory.getProp(p, y.or, 1, degToRads, this), this.or.sh = !0;
    } else this.r = PropertyFactory.getProp(p, y.r || {
      k: 0
    }, 0, degToRads, this);
    y.sk && (this.sk = PropertyFactory.getProp(p, y.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(p, y.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(p, y.a || {
      k: [0, 0, 0]
    }, 1, 0, this), this.s = PropertyFactory.getProp(p, y.s || {
      k: [100, 100, 100]
    }, 1, 0.01, this), y.o ? this.o = PropertyFactory.getProp(p, y.o, 0, 0.01, p) : this.o = {
      _mdf: !1,
      v: 1
    }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
  }
  u.prototype = {
    applyToMatrix: t,
    getValue: r,
    precalculateMatrix: i,
    autoOrient: a
  }, extendPrototype([DynamicPropertyContainer], u), u.prototype.addDynamicProperty = n, u.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
  function f(p, y, v) {
    return new u(p, y, v);
  }
  return {
    getTransformProperty: f
  };
}();
function RepeaterModifier() {}
extendPrototype([ShapeModifier], RepeaterModifier);
RepeaterModifier.prototype.initModifierProperties = function (e, t) {
  this.getValue = this.processKeys, this.c = PropertyFactory.getProp(e, t.c, 0, null, this), this.o = PropertyFactory.getProp(e, t.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(e, t.tr, this), this.so = PropertyFactory.getProp(e, t.tr.so, 0, 0.01, this), this.eo = PropertyFactory.getProp(e, t.tr.eo, 0, 0.01, this), this.data = t, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
};
RepeaterModifier.prototype.applyTransforms = function (e, t, r, i, a, n) {
  var u = n ? -1 : 1,
    f = i.s.v[0] + (1 - i.s.v[0]) * (1 - a),
    p = i.s.v[1] + (1 - i.s.v[1]) * (1 - a);
  e.translate(i.p.v[0] * u * a, i.p.v[1] * u * a, i.p.v[2]), t.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), t.rotate(-i.r.v * u * a), t.translate(i.a.v[0], i.a.v[1], i.a.v[2]), r.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), r.scale(n ? 1 / f : f, n ? 1 / p : p), r.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
};
RepeaterModifier.prototype.init = function (e, t, r, i) {
  for (this.elem = e, this.arr = t, this.pos = r, this.elemsData = i, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(e), this.initModifierProperties(e, t[r]); r > 0;) r -= 1, this._elements.unshift(t[r]);
  this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
};
RepeaterModifier.prototype.resetElements = function (e) {
  var t,
    r = e.length;
  for (t = 0; t < r; t += 1) e[t]._processed = !1, e[t].ty === "gr" && this.resetElements(e[t].it);
};
RepeaterModifier.prototype.cloneElements = function (e) {
  var t = JSON.parse(JSON.stringify(e));
  return this.resetElements(t), t;
};
RepeaterModifier.prototype.changeGroupRender = function (e, t) {
  var r,
    i = e.length;
  for (r = 0; r < i; r += 1) e[r]._render = t, e[r].ty === "gr" && this.changeGroupRender(e[r].it, t);
};
RepeaterModifier.prototype.processShapes = function (e) {
  var t,
    r,
    i,
    a,
    n,
    u = !1;
  if (this._mdf || e) {
    var f = Math.ceil(this.c.v);
    if (this._groups.length < f) {
      for (; this._groups.length < f;) {
        var p = {
          it: this.cloneElements(this._elements),
          ty: "gr"
        };
        p.it.push({
          a: {
            a: 0,
            ix: 1,
            k: [0, 0]
          },
          nm: "Transform",
          o: {
            a: 0,
            ix: 7,
            k: 100
          },
          p: {
            a: 0,
            ix: 2,
            k: [0, 0]
          },
          r: {
            a: 1,
            ix: 6,
            k: [{
              s: 0,
              e: 0,
              t: 0
            }, {
              s: 0,
              e: 0,
              t: 1
            }]
          },
          s: {
            a: 0,
            ix: 3,
            k: [100, 100]
          },
          sa: {
            a: 0,
            ix: 5,
            k: 0
          },
          sk: {
            a: 0,
            ix: 4,
            k: 0
          },
          ty: "tr"
        }), this.arr.splice(0, 0, p), this._groups.splice(0, 0, p), this._currentCopies += 1;
      }
      this.elem.reloadShapes(), u = !0;
    }
    n = 0;
    var y;
    for (i = 0; i <= this._groups.length - 1; i += 1) {
      if (y = n < f, this._groups[i]._render = y, this.changeGroupRender(this._groups[i].it, y), !y) {
        var v = this.elemsData[i].it,
          A = v[v.length - 1];
        A.transform.op.v !== 0 ? (A.transform.op._mdf = !0, A.transform.op.v = 0) : A.transform.op._mdf = !1;
      }
      n += 1;
    }
    this._currentCopies = f;
    var c = this.o.v,
      E = c % 1,
      d = c > 0 ? Math.floor(c) : Math.ceil(c),
      g = this.pMatrix.props,
      I = this.rMatrix.props,
      o = this.sMatrix.props;
    this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
    var s = 0;
    if (c > 0) {
      for (; s < d;) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), s += 1;
      E && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, E, !1), s += E);
    } else if (c < 0) {
      for (; s > d;) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), s -= 1;
      E && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -E, !0), s -= E);
    }
    i = this.data.m === 1 ? 0 : this._currentCopies - 1, a = this.data.m === 1 ? 1 : -1, n = this._currentCopies;
    for (var l, h; n;) {
      if (t = this.elemsData[i].it, r = t[t.length - 1].transform.mProps.v.props, h = r.length, t[t.length - 1].transform.mProps._mdf = !0, t[t.length - 1].transform.op._mdf = !0, t[t.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1)), s !== 0) {
        for ((i !== 0 && a === 1 || i !== this._currentCopies - 1 && a === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(I[0], I[1], I[2], I[3], I[4], I[5], I[6], I[7], I[8], I[9], I[10], I[11], I[12], I[13], I[14], I[15]), this.matrix.transform(o[0], o[1], o[2], o[3], o[4], o[5], o[6], o[7], o[8], o[9], o[10], o[11], o[12], o[13], o[14], o[15]), this.matrix.transform(g[0], g[1], g[2], g[3], g[4], g[5], g[6], g[7], g[8], g[9], g[10], g[11], g[12], g[13], g[14], g[15]), l = 0; l < h; l += 1) r[l] = this.matrix.props[l];
        this.matrix.reset();
      } else for (this.matrix.reset(), l = 0; l < h; l += 1) r[l] = this.matrix.props[l];
      s += 1, n -= 1, i += a;
    }
  } else for (n = this._currentCopies, i = 0, a = 1; n;) t = this.elemsData[i].it, r = t[t.length - 1].transform.mProps.v.props, t[t.length - 1].transform.mProps._mdf = !1, t[t.length - 1].transform.op._mdf = !1, n -= 1, i += a;
  return u;
};
RepeaterModifier.prototype.addShape = function () {};
function RoundCornersModifier() {}
extendPrototype([ShapeModifier], RoundCornersModifier);
RoundCornersModifier.prototype.initModifierProperties = function (e, t) {
  this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(e, t.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
};
RoundCornersModifier.prototype.processPath = function (e, t) {
  var r = shapePool.newElement();
  r.c = e.c;
  var i,
    a = e._length,
    n,
    u,
    f,
    p,
    y,
    v,
    A = 0,
    c,
    E,
    d,
    g,
    I,
    o;
  for (i = 0; i < a; i += 1) n = e.v[i], f = e.o[i], u = e.i[i], n[0] === f[0] && n[1] === f[1] && n[0] === u[0] && n[1] === u[1] ? (i === 0 || i === a - 1) && !e.c ? (r.setTripleAt(n[0], n[1], f[0], f[1], u[0], u[1], A), A += 1) : (i === 0 ? p = e.v[a - 1] : p = e.v[i - 1], y = Math.sqrt(Math.pow(n[0] - p[0], 2) + Math.pow(n[1] - p[1], 2)), v = y ? Math.min(y / 2, t) / y : 0, I = n[0] + (p[0] - n[0]) * v, c = I, o = n[1] - (n[1] - p[1]) * v, E = o, d = c - (c - n[0]) * roundCorner, g = E - (E - n[1]) * roundCorner, r.setTripleAt(c, E, d, g, I, o, A), A += 1, i === a - 1 ? p = e.v[0] : p = e.v[i + 1], y = Math.sqrt(Math.pow(n[0] - p[0], 2) + Math.pow(n[1] - p[1], 2)), v = y ? Math.min(y / 2, t) / y : 0, d = n[0] + (p[0] - n[0]) * v, c = d, g = n[1] + (p[1] - n[1]) * v, E = g, I = c - (c - n[0]) * roundCorner, o = E - (E - n[1]) * roundCorner, r.setTripleAt(c, E, d, g, I, o, A), A += 1) : (r.setTripleAt(e.v[i][0], e.v[i][1], e.o[i][0], e.o[i][1], e.i[i][0], e.i[i][1], A), A += 1);
  return r;
};
RoundCornersModifier.prototype.processShapes = function (e) {
  var t,
    r,
    i = this.shapes.length,
    a,
    n,
    u = this.rd.v;
  if (u !== 0) {
    var f, p;
    for (r = 0; r < i; r += 1) {
      if (f = this.shapes[r], p = f.localShapeCollection, !(!f.shape._mdf && !this._mdf && !e)) for (p.releaseShapes(), f.shape._mdf = !0, t = f.shape.paths.shapes, n = f.shape.paths._length, a = 0; a < n; a += 1) p.addShape(this.processPath(t[a], u));
      f.shape.paths = f.localShapeCollection;
    }
  }
  this.dynamicProperties.length || (this._mdf = !1);
};
function getFontProperties(e) {
  for (var t = e.fStyle ? e.fStyle.split(" ") : [], r = "normal", i = "normal", a = t.length, n, u = 0; u < a; u += 1) switch (n = t[u].toLowerCase(), n) {
    case "italic":
      i = "italic";
      break;
    case "bold":
      r = "700";
      break;
    case "black":
      r = "900";
      break;
    case "medium":
      r = "500";
      break;
    case "regular":
    case "normal":
      r = "400";
      break;
    case "light":
    case "thin":
      r = "200";
      break;
  }
  return {
    style: i,
    weight: e.fWeight || r
  };
}
const FontManager = function () {
  var e = 5e3,
    t = {
      w: 0,
      size: 0,
      shapes: [],
      data: {
        shapes: []
      }
    },
    r = [];
  r = r.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
  var i = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"],
    a = [65039, 8205];
  function n(h) {
    var m = h.split(","),
      S,
      b = m.length,
      T = [];
    for (S = 0; S < b; S += 1) m[S] !== "sans-serif" && m[S] !== "monospace" && T.push(m[S]);
    return T.join(",");
  }
  function u(h, m) {
    var S = createTag("span");
    S.setAttribute("aria-hidden", !0), S.style.fontFamily = m;
    var b = createTag("span");
    b.innerText = "giItT1WQy@!-/#", S.style.position = "absolute", S.style.left = "-10000px", S.style.top = "-10000px", S.style.fontSize = "300px", S.style.fontVariant = "normal", S.style.fontStyle = "normal", S.style.fontWeight = "normal", S.style.letterSpacing = "0", S.appendChild(b), document.body.appendChild(S);
    var T = b.offsetWidth;
    return b.style.fontFamily = n(h) + ", " + m, {
      node: b,
      w: T,
      parent: S
    };
  }
  function f() {
    var h,
      m = this.fonts.length,
      S,
      b,
      T = m;
    for (h = 0; h < m; h += 1) this.fonts[h].loaded ? T -= 1 : this.fonts[h].fOrigin === "n" || this.fonts[h].origin === 0 ? this.fonts[h].loaded = !0 : (S = this.fonts[h].monoCase.node, b = this.fonts[h].monoCase.w, S.offsetWidth !== b ? (T -= 1, this.fonts[h].loaded = !0) : (S = this.fonts[h].sansCase.node, b = this.fonts[h].sansCase.w, S.offsetWidth !== b && (T -= 1, this.fonts[h].loaded = !0)), this.fonts[h].loaded && (this.fonts[h].sansCase.parent.parentNode.removeChild(this.fonts[h].sansCase.parent), this.fonts[h].monoCase.parent.parentNode.removeChild(this.fonts[h].monoCase.parent)));
    T !== 0 && Date.now() - this.initTime < e ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
  }
  function p(h, m) {
    var S = document.body && m ? "svg" : "canvas",
      b,
      T = getFontProperties(h);
    if (S === "svg") {
      var C = createNS("text");
      C.style.fontSize = "100px", C.setAttribute("font-family", h.fFamily), C.setAttribute("font-style", T.style), C.setAttribute("font-weight", T.weight), C.textContent = "1", h.fClass ? (C.style.fontFamily = "inherit", C.setAttribute("class", h.fClass)) : C.style.fontFamily = h.fFamily, m.appendChild(C), b = C;
    } else {
      var F = new OffscreenCanvas(500, 500).getContext("2d");
      F.font = T.style + " " + T.weight + " 100px " + h.fFamily, b = F;
    }
    function w(k) {
      return S === "svg" ? (b.textContent = k, b.getComputedTextLength()) : b.measureText(k).width;
    }
    return {
      measureText: w
    };
  }
  function y(h, m) {
    if (!h) {
      this.isLoaded = !0;
      return;
    }
    if (this.chars) {
      this.isLoaded = !0, this.fonts = h.list;
      return;
    }
    if (!document.body) {
      this.isLoaded = !0, h.list.forEach(N => {
        N.helper = p(N), N.cache = {};
      }), this.fonts = h.list;
      return;
    }
    var S = h.list,
      b,
      T = S.length,
      C = T;
    for (b = 0; b < T; b += 1) {
      var F = !0,
        w,
        k;
      if (S[b].loaded = !1, S[b].monoCase = u(S[b].fFamily, "monospace"), S[b].sansCase = u(S[b].fFamily, "sans-serif"), !S[b].fPath) S[b].loaded = !0, C -= 1;else if (S[b].fOrigin === "p" || S[b].origin === 3) {
        if (w = document.querySelectorAll('style[f-forigin="p"][f-family="' + S[b].fFamily + '"], style[f-origin="3"][f-family="' + S[b].fFamily + '"]'), w.length > 0 && (F = !1), F) {
          var L = createTag("style");
          L.setAttribute("f-forigin", S[b].fOrigin), L.setAttribute("f-origin", S[b].origin), L.setAttribute("f-family", S[b].fFamily), L.type = "text/css", L.innerText = "@font-face {font-family: " + S[b].fFamily + "; font-style: normal; src: url('" + S[b].fPath + "');}", m.appendChild(L);
        }
      } else if (S[b].fOrigin === "g" || S[b].origin === 1) {
        for (w = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), k = 0; k < w.length; k += 1) w[k].href.indexOf(S[b].fPath) !== -1 && (F = !1);
        if (F) {
          var B = createTag("link");
          B.setAttribute("f-forigin", S[b].fOrigin), B.setAttribute("f-origin", S[b].origin), B.type = "text/css", B.rel = "stylesheet", B.href = S[b].fPath, document.body.appendChild(B);
        }
      } else if (S[b].fOrigin === "t" || S[b].origin === 2) {
        for (w = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), k = 0; k < w.length; k += 1) S[b].fPath === w[k].src && (F = !1);
        if (F) {
          var x = createTag("link");
          x.setAttribute("f-forigin", S[b].fOrigin), x.setAttribute("f-origin", S[b].origin), x.setAttribute("rel", "stylesheet"), x.setAttribute("href", S[b].fPath), m.appendChild(x);
        }
      }
      S[b].helper = p(S[b], m), S[b].cache = {}, this.fonts.push(S[b]);
    }
    C === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
  }
  function v(h) {
    if (h) {
      this.chars || (this.chars = []);
      var m,
        S = h.length,
        b,
        T = this.chars.length,
        C;
      for (m = 0; m < S; m += 1) {
        for (b = 0, C = !1; b < T;) this.chars[b].style === h[m].style && this.chars[b].fFamily === h[m].fFamily && this.chars[b].ch === h[m].ch && (C = !0), b += 1;
        C || (this.chars.push(h[m]), T += 1);
      }
    }
  }
  function A(h, m, S) {
    for (var b = 0, T = this.chars.length; b < T;) {
      if (this.chars[b].ch === h && this.chars[b].style === m && this.chars[b].fFamily === S) return this.chars[b];
      b += 1;
    }
    return (typeof h == "string" && h.charCodeAt(0) !== 13 || !h) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", h, m, S)), t;
  }
  function c(h, m, S) {
    var b = this.getFontByName(m),
      T = h.charCodeAt(0);
    if (!b.cache[T + 1]) {
      var C = b.helper;
      if (h === " ") {
        var F = C.measureText("|" + h + "|"),
          w = C.measureText("||");
        b.cache[T + 1] = (F - w) / 100;
      } else b.cache[T + 1] = C.measureText(h) / 100;
    }
    return b.cache[T + 1] * S;
  }
  function E(h) {
    for (var m = 0, S = this.fonts.length; m < S;) {
      if (this.fonts[m].fName === h) return this.fonts[m];
      m += 1;
    }
    return this.fonts[0];
  }
  function d(h, m) {
    var S = h.toString(16) + m.toString(16);
    return i.indexOf(S) !== -1;
  }
  function g(h, m) {
    return m ? h === a[0] && m === a[1] : h === a[1];
  }
  function I(h) {
    return r.indexOf(h) !== -1;
  }
  function o() {
    this.isLoaded = !0;
  }
  var s = function () {
    this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
  };
  s.isModifier = d, s.isZeroWidthJoiner = g, s.isCombinedCharacter = I;
  var l = {
    addChars: v,
    addFonts: y,
    getCharData: A,
    getFontByName: E,
    measureText: c,
    checkLoadedFonts: f,
    setIsLoaded: o
  };
  return s.prototype = l, s;
}();
function RenderableElement() {}
RenderableElement.prototype = {
  initRenderable: function () {
    this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
  },
  addRenderableComponent: function (e) {
    this.renderableComponents.indexOf(e) === -1 && this.renderableComponents.push(e);
  },
  removeRenderableComponent: function (e) {
    this.renderableComponents.indexOf(e) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(e), 1);
  },
  prepareRenderableFrame: function (e) {
    this.checkLayerLimits(e);
  },
  checkTransparency: function () {
    this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
  },
  /**
     * @function
     * Initializes frame related properties.
     *
     * @param {number} num
     * current frame number in Layer's time
     *
     */
  checkLayerLimits: function (e) {
    this.data.ip - this.data.st <= e && this.data.op - this.data.st > e ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
  },
  renderRenderable: function () {
    var e,
      t = this.renderableComponents.length;
    for (e = 0; e < t; e += 1) this.renderableComponents[e].renderFrame(this._isFirstFrame);
  },
  sourceRectAtTime: function () {
    return {
      top: 0,
      left: 0,
      width: 100,
      height: 100
    };
  },
  getLayerSize: function () {
    return this.data.ty === 5 ? {
      w: this.data.textData.width,
      h: this.data.textData.height
    } : {
      w: this.data.width,
      h: this.data.height
    };
  }
};
const MaskManagerInterface = function () {
    function e(r, i) {
      this._mask = r, this._data = i;
    }
    Object.defineProperty(e.prototype, "maskPath", {
      get: function () {
        return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
      }
    }), Object.defineProperty(e.prototype, "maskOpacity", {
      get: function () {
        return this._mask.op.k && this._mask.op.getValue(), this._mask.op.v * 100;
      }
    });
    var t = function (r) {
      var i = createSizedArray(r.viewData.length),
        a,
        n = r.viewData.length;
      for (a = 0; a < n; a += 1) i[a] = new e(r.viewData[a], r.masksProperties[a]);
      var u = function (f) {
        for (a = 0; a < n;) {
          if (r.masksProperties[a].nm === f) return i[a];
          a += 1;
        }
        return null;
      };
      return u;
    };
    return t;
  }(),
  ExpressionPropertyInterface = function () {
    var e = {
        pv: 0,
        v: 0,
        mult: 1
      },
      t = {
        pv: [0, 0, 0],
        v: [0, 0, 0],
        mult: 1
      };
    function r(u, f, p) {
      Object.defineProperty(u, "velocity", {
        get: function () {
          return f.getVelocityAtTime(f.comp.currentFrame);
        }
      }), u.numKeys = f.keyframes ? f.keyframes.length : 0, u.key = function (y) {
        if (!u.numKeys) return 0;
        var v = "";
        "s" in f.keyframes[y - 1] ? v = f.keyframes[y - 1].s : "e" in f.keyframes[y - 2] ? v = f.keyframes[y - 2].e : v = f.keyframes[y - 2].s;
        var A = p === "unidimensional" ? new Number(v) : Object.assign({}, v);
        return A.time = f.keyframes[y - 1].t / f.elem.comp.globalData.frameRate, A.value = p === "unidimensional" ? v[0] : v, A;
      }, u.valueAtTime = f.getValueAtTime, u.speedAtTime = f.getSpeedAtTime, u.velocityAtTime = f.getVelocityAtTime, u.propertyGroup = f.propertyGroup;
    }
    function i(u) {
      (!u || !("pv" in u)) && (u = e);
      var f = 1 / u.mult,
        p = u.pv * f,
        y = new Number(p);
      return y.value = p, r(y, u, "unidimensional"), function () {
        return u.k && u.getValue(), p = u.v * f, y.value !== p && (y = new Number(p), y.value = p, r(y, u, "unidimensional")), y;
      };
    }
    function a(u) {
      (!u || !("pv" in u)) && (u = t);
      var f = 1 / u.mult,
        p = u.data && u.data.l || u.pv.length,
        y = createTypedArray("float32", p),
        v = createTypedArray("float32", p);
      return y.value = v, r(y, u, "multidimensional"), function () {
        u.k && u.getValue();
        for (var A = 0; A < p; A += 1) v[A] = u.v[A] * f, y[A] = v[A];
        return y;
      };
    }
    function n() {
      return e;
    }
    return function (u) {
      return u ? u.propType === "unidimensional" ? i(u) : a(u) : n;
    };
  }(),
  TransformExpressionInterface = function () {
    return function (e) {
      function t(u) {
        switch (u) {
          case "scale":
          case "Scale":
          case "ADBE Scale":
          case 6:
            return t.scale;
          case "rotation":
          case "Rotation":
          case "ADBE Rotation":
          case "ADBE Rotate Z":
          case 10:
            return t.rotation;
          case "ADBE Rotate X":
            return t.xRotation;
          case "ADBE Rotate Y":
            return t.yRotation;
          case "position":
          case "Position":
          case "ADBE Position":
          case 2:
            return t.position;
          case "ADBE Position_0":
            return t.xPosition;
          case "ADBE Position_1":
            return t.yPosition;
          case "ADBE Position_2":
            return t.zPosition;
          case "anchorPoint":
          case "AnchorPoint":
          case "Anchor Point":
          case "ADBE AnchorPoint":
          case 1:
            return t.anchorPoint;
          case "opacity":
          case "Opacity":
          case 11:
            return t.opacity;
          default:
            return null;
        }
      }
      Object.defineProperty(t, "rotation", {
        get: ExpressionPropertyInterface(e.r || e.rz)
      }), Object.defineProperty(t, "zRotation", {
        get: ExpressionPropertyInterface(e.rz || e.r)
      }), Object.defineProperty(t, "xRotation", {
        get: ExpressionPropertyInterface(e.rx)
      }), Object.defineProperty(t, "yRotation", {
        get: ExpressionPropertyInterface(e.ry)
      }), Object.defineProperty(t, "scale", {
        get: ExpressionPropertyInterface(e.s)
      });
      var r, i, a, n;
      return e.p ? n = ExpressionPropertyInterface(e.p) : (r = ExpressionPropertyInterface(e.px), i = ExpressionPropertyInterface(e.py), e.pz && (a = ExpressionPropertyInterface(e.pz))), Object.defineProperty(t, "position", {
        get: function () {
          return e.p ? n() : [r(), i(), a ? a() : 0];
        }
      }), Object.defineProperty(t, "xPosition", {
        get: ExpressionPropertyInterface(e.px)
      }), Object.defineProperty(t, "yPosition", {
        get: ExpressionPropertyInterface(e.py)
      }), Object.defineProperty(t, "zPosition", {
        get: ExpressionPropertyInterface(e.pz)
      }), Object.defineProperty(t, "anchorPoint", {
        get: ExpressionPropertyInterface(e.a)
      }), Object.defineProperty(t, "opacity", {
        get: ExpressionPropertyInterface(e.o)
      }), Object.defineProperty(t, "skew", {
        get: ExpressionPropertyInterface(e.sk)
      }), Object.defineProperty(t, "skewAxis", {
        get: ExpressionPropertyInterface(e.sa)
      }), Object.defineProperty(t, "orientation", {
        get: ExpressionPropertyInterface(e.or)
      }), t;
    };
  }(),
  LayerExpressionInterface = function () {
    function e(y) {
      var v = new Matrix();
      if (y !== void 0) {
        var A = this._elem.finalTransform.mProp.getValueAtTime(y);
        A.clone(v);
      } else {
        var c = this._elem.finalTransform.mProp;
        c.applyToMatrix(v);
      }
      return v;
    }
    function t(y, v) {
      var A = this.getMatrix(v);
      return A.props[12] = 0, A.props[13] = 0, A.props[14] = 0, this.applyPoint(A, y);
    }
    function r(y, v) {
      var A = this.getMatrix(v);
      return this.applyPoint(A, y);
    }
    function i(y, v) {
      var A = this.getMatrix(v);
      return A.props[12] = 0, A.props[13] = 0, A.props[14] = 0, this.invertPoint(A, y);
    }
    function a(y, v) {
      var A = this.getMatrix(v);
      return this.invertPoint(A, y);
    }
    function n(y, v) {
      if (this._elem.hierarchy && this._elem.hierarchy.length) {
        var A,
          c = this._elem.hierarchy.length;
        for (A = 0; A < c; A += 1) this._elem.hierarchy[A].finalTransform.mProp.applyToMatrix(y);
      }
      return y.applyToPointArray(v[0], v[1], v[2] || 0);
    }
    function u(y, v) {
      if (this._elem.hierarchy && this._elem.hierarchy.length) {
        var A,
          c = this._elem.hierarchy.length;
        for (A = 0; A < c; A += 1) this._elem.hierarchy[A].finalTransform.mProp.applyToMatrix(y);
      }
      return y.inversePoint(v);
    }
    function f(y) {
      var v = new Matrix();
      if (v.reset(), this._elem.finalTransform.mProp.applyToMatrix(v), this._elem.hierarchy && this._elem.hierarchy.length) {
        var A,
          c = this._elem.hierarchy.length;
        for (A = 0; A < c; A += 1) this._elem.hierarchy[A].finalTransform.mProp.applyToMatrix(v);
        return v.inversePoint(y);
      }
      return v.inversePoint(y);
    }
    function p() {
      return [1, 1, 1, 1];
    }
    return function (y) {
      var v;
      function A(g) {
        E.mask = new MaskManagerInterface(g, y);
      }
      function c(g) {
        E.effect = g;
      }
      function E(g) {
        switch (g) {
          case "ADBE Root Vectors Group":
          case "Contents":
          case 2:
            return E.shapeInterface;
          case 1:
          case 6:
          case "Transform":
          case "transform":
          case "ADBE Transform Group":
            return v;
          case 4:
          case "ADBE Effect Parade":
          case "effects":
          case "Effects":
            return E.effect;
          case "ADBE Text Properties":
            return E.textInterface;
          default:
            return null;
        }
      }
      E.getMatrix = e, E.invertPoint = u, E.applyPoint = n, E.toWorld = r, E.toWorldVec = t, E.fromWorld = a, E.fromWorldVec = i, E.toComp = r, E.fromComp = f, E.sampleImage = p, E.sourceRectAtTime = y.sourceRectAtTime.bind(y), E._elem = y, v = TransformExpressionInterface(y.finalTransform.mProp);
      var d = getDescriptor(v, "anchorPoint");
      return Object.defineProperties(E, {
        hasParent: {
          get: function () {
            return y.hierarchy.length;
          }
        },
        parent: {
          get: function () {
            return y.hierarchy[0].layerInterface;
          }
        },
        rotation: getDescriptor(v, "rotation"),
        scale: getDescriptor(v, "scale"),
        position: getDescriptor(v, "position"),
        opacity: getDescriptor(v, "opacity"),
        anchorPoint: d,
        anchor_point: d,
        transform: {
          get: function () {
            return v;
          }
        },
        active: {
          get: function () {
            return y.isInRange;
          }
        }
      }), E.startTime = y.data.st, E.index = y.data.ind, E.source = y.data.refId, E.height = y.data.ty === 0 ? y.data.h : 100, E.width = y.data.ty === 0 ? y.data.w : 100, E.inPoint = y.data.ip / y.comp.globalData.frameRate, E.outPoint = y.data.op / y.comp.globalData.frameRate, E._name = y.data.nm, E.registerMaskInterface = A, E.registerEffectsInterface = c, E;
    };
  }(),
  propertyGroupFactory = function () {
    return function (e, t) {
      return function (r) {
        return r = r === void 0 ? 1 : r, r <= 0 ? e : t(r - 1);
      };
    };
  }(),
  PropertyInterface = function () {
    return function (e, t) {
      var r = {
        _name: e
      };
      function i(a) {
        return a = a === void 0 ? 1 : a, a <= 0 ? r : t(a - 1);
      }
      return i;
    };
  }(),
  EffectsExpressionInterface = function () {
    var e = {
      createEffectsInterface: t
    };
    function t(a, n) {
      if (a.effectsManager) {
        var u = [],
          f = a.data.ef,
          p,
          y = a.effectsManager.effectElements.length;
        for (p = 0; p < y; p += 1) u.push(r(f[p], a.effectsManager.effectElements[p], n, a));
        var v = a.data.ef || [],
          A = function (c) {
            for (p = 0, y = v.length; p < y;) {
              if (c === v[p].nm || c === v[p].mn || c === v[p].ix) return u[p];
              p += 1;
            }
            return null;
          };
        return Object.defineProperty(A, "numProperties", {
          get: function () {
            return v.length;
          }
        }), A;
      }
      return null;
    }
    function r(a, n, u, f) {
      function p(E) {
        for (var d = a.ef, g = 0, I = d.length; g < I;) {
          if (E === d[g].nm || E === d[g].mn || E === d[g].ix) return d[g].ty === 5 ? v[g] : v[g]();
          g += 1;
        }
        throw new Error();
      }
      var y = propertyGroupFactory(p, u),
        v = [],
        A,
        c = a.ef.length;
      for (A = 0; A < c; A += 1) a.ef[A].ty === 5 ? v.push(r(a.ef[A], n.effectElements[A], n.effectElements[A].propertyGroup, f)) : v.push(i(n.effectElements[A], a.ef[A].ty, f, y));
      return a.mn === "ADBE Color Control" && Object.defineProperty(p, "color", {
        get: function () {
          return v[0]();
        }
      }), Object.defineProperties(p, {
        numProperties: {
          get: function () {
            return a.np;
          }
        },
        _name: {
          value: a.nm
        },
        propertyGroup: {
          value: y
        }
      }), p.enabled = a.en !== 0, p.active = p.enabled, p;
    }
    function i(a, n, u, f) {
      var p = ExpressionPropertyInterface(a.p);
      function y() {
        return n === 10 ? u.comp.compInterface(a.p.v) : p();
      }
      return a.p.setGroupProperty && a.p.setGroupProperty(PropertyInterface("", f)), y;
    }
    return e;
  }(),
  CompExpressionInterface = function () {
    return function (e) {
      function t(r) {
        for (var i = 0, a = e.layers.length; i < a;) {
          if (e.layers[i].nm === r || e.layers[i].ind === r) return e.elements[i].layerInterface;
          i += 1;
        }
        return null;
      }
      return Object.defineProperty(t, "_name", {
        value: e.data.nm
      }), t.layer = t, t.pixelAspect = 1, t.height = e.data.h || e.globalData.compSize.h, t.width = e.data.w || e.globalData.compSize.w, t.pixelAspect = 1, t.frameDuration = 1 / e.globalData.frameRate, t.displayStartTime = 0, t.numLayers = e.layers.length, t;
    };
  }(),
  ShapePathInterface = function () {
    return function (t, r, i) {
      var a = r.sh;
      function n(f) {
        return f === "Shape" || f === "shape" || f === "Path" || f === "path" || f === "ADBE Vector Shape" || f === 2 ? n.path : null;
      }
      var u = propertyGroupFactory(n, i);
      return a.setGroupProperty(PropertyInterface("Path", u)), Object.defineProperties(n, {
        path: {
          get: function () {
            return a.k && a.getValue(), a;
          }
        },
        shape: {
          get: function () {
            return a.k && a.getValue(), a;
          }
        },
        _name: {
          value: t.nm
        },
        ix: {
          value: t.ix
        },
        propertyIndex: {
          value: t.ix
        },
        mn: {
          value: t.mn
        },
        propertyGroup: {
          value: i
        }
      }), n;
    };
  }(),
  ShapeExpressionInterface = function () {
    function e(d, g, I) {
      var o = [],
        s,
        l = d ? d.length : 0;
      for (s = 0; s < l; s += 1) d[s].ty === "gr" ? o.push(r(d[s], g[s], I)) : d[s].ty === "fl" ? o.push(i(d[s], g[s], I)) : d[s].ty === "st" ? o.push(u(d[s], g[s], I)) : d[s].ty === "tm" ? o.push(f(d[s], g[s], I)) : d[s].ty === "tr" || (d[s].ty === "el" ? o.push(y(d[s], g[s], I)) : d[s].ty === "sr" ? o.push(v(d[s], g[s], I)) : d[s].ty === "sh" ? o.push(ShapePathInterface(d[s], g[s], I)) : d[s].ty === "rc" ? o.push(A(d[s], g[s], I)) : d[s].ty === "rd" ? o.push(c(d[s], g[s], I)) : d[s].ty === "rp" ? o.push(E(d[s], g[s], I)) : d[s].ty === "gf" ? o.push(a(d[s], g[s], I)) : o.push(n(d[s], g[s])));
      return o;
    }
    function t(d, g, I) {
      var o,
        s = function (m) {
          for (var S = 0, b = o.length; S < b;) {
            if (o[S]._name === m || o[S].mn === m || o[S].propertyIndex === m || o[S].ix === m || o[S].ind === m) return o[S];
            S += 1;
          }
          return typeof m == "number" ? o[m - 1] : null;
        };
      s.propertyGroup = propertyGroupFactory(s, I), o = e(d.it, g.it, s.propertyGroup), s.numProperties = o.length;
      var l = p(d.it[d.it.length - 1], g.it[g.it.length - 1], s.propertyGroup);
      return s.transform = l, s.propertyIndex = d.cix, s._name = d.nm, s;
    }
    function r(d, g, I) {
      var o = function (m) {
        switch (m) {
          case "ADBE Vectors Group":
          case "Contents":
          case 2:
            return o.content;
          default:
            return o.transform;
        }
      };
      o.propertyGroup = propertyGroupFactory(o, I);
      var s = t(d, g, o.propertyGroup),
        l = p(d.it[d.it.length - 1], g.it[g.it.length - 1], o.propertyGroup);
      return o.content = s, o.transform = l, Object.defineProperty(o, "_name", {
        get: function () {
          return d.nm;
        }
      }), o.numProperties = d.np, o.propertyIndex = d.ix, o.nm = d.nm, o.mn = d.mn, o;
    }
    function i(d, g, I) {
      function o(s) {
        return s === "Color" || s === "color" ? o.color : s === "Opacity" || s === "opacity" ? o.opacity : null;
      }
      return Object.defineProperties(o, {
        color: {
          get: ExpressionPropertyInterface(g.c)
        },
        opacity: {
          get: ExpressionPropertyInterface(g.o)
        },
        _name: {
          value: d.nm
        },
        mn: {
          value: d.mn
        }
      }), g.c.setGroupProperty(PropertyInterface("Color", I)), g.o.setGroupProperty(PropertyInterface("Opacity", I)), o;
    }
    function a(d, g, I) {
      function o(s) {
        return s === "Start Point" || s === "start point" ? o.startPoint : s === "End Point" || s === "end point" ? o.endPoint : s === "Opacity" || s === "opacity" ? o.opacity : null;
      }
      return Object.defineProperties(o, {
        startPoint: {
          get: ExpressionPropertyInterface(g.s)
        },
        endPoint: {
          get: ExpressionPropertyInterface(g.e)
        },
        opacity: {
          get: ExpressionPropertyInterface(g.o)
        },
        type: {
          get: function () {
            return "a";
          }
        },
        _name: {
          value: d.nm
        },
        mn: {
          value: d.mn
        }
      }), g.s.setGroupProperty(PropertyInterface("Start Point", I)), g.e.setGroupProperty(PropertyInterface("End Point", I)), g.o.setGroupProperty(PropertyInterface("Opacity", I)), o;
    }
    function n() {
      function d() {
        return null;
      }
      return d;
    }
    function u(d, g, I) {
      var o = propertyGroupFactory(b, I),
        s = propertyGroupFactory(S, o);
      function l(T) {
        Object.defineProperty(S, d.d[T].nm, {
          get: ExpressionPropertyInterface(g.d.dataProps[T].p)
        });
      }
      var h,
        m = d.d ? d.d.length : 0,
        S = {};
      for (h = 0; h < m; h += 1) l(h), g.d.dataProps[h].p.setGroupProperty(s);
      function b(T) {
        return T === "Color" || T === "color" ? b.color : T === "Opacity" || T === "opacity" ? b.opacity : T === "Stroke Width" || T === "stroke width" ? b.strokeWidth : null;
      }
      return Object.defineProperties(b, {
        color: {
          get: ExpressionPropertyInterface(g.c)
        },
        opacity: {
          get: ExpressionPropertyInterface(g.o)
        },
        strokeWidth: {
          get: ExpressionPropertyInterface(g.w)
        },
        dash: {
          get: function () {
            return S;
          }
        },
        _name: {
          value: d.nm
        },
        mn: {
          value: d.mn
        }
      }), g.c.setGroupProperty(PropertyInterface("Color", o)), g.o.setGroupProperty(PropertyInterface("Opacity", o)), g.w.setGroupProperty(PropertyInterface("Stroke Width", o)), b;
    }
    function f(d, g, I) {
      function o(l) {
        return l === d.e.ix || l === "End" || l === "end" ? o.end : l === d.s.ix ? o.start : l === d.o.ix ? o.offset : null;
      }
      var s = propertyGroupFactory(o, I);
      return o.propertyIndex = d.ix, g.s.setGroupProperty(PropertyInterface("Start", s)), g.e.setGroupProperty(PropertyInterface("End", s)), g.o.setGroupProperty(PropertyInterface("Offset", s)), o.propertyIndex = d.ix, o.propertyGroup = I, Object.defineProperties(o, {
        start: {
          get: ExpressionPropertyInterface(g.s)
        },
        end: {
          get: ExpressionPropertyInterface(g.e)
        },
        offset: {
          get: ExpressionPropertyInterface(g.o)
        },
        _name: {
          value: d.nm
        }
      }), o.mn = d.mn, o;
    }
    function p(d, g, I) {
      function o(l) {
        return d.a.ix === l || l === "Anchor Point" ? o.anchorPoint : d.o.ix === l || l === "Opacity" ? o.opacity : d.p.ix === l || l === "Position" ? o.position : d.r.ix === l || l === "Rotation" || l === "ADBE Vector Rotation" ? o.rotation : d.s.ix === l || l === "Scale" ? o.scale : d.sk && d.sk.ix === l || l === "Skew" ? o.skew : d.sa && d.sa.ix === l || l === "Skew Axis" ? o.skewAxis : null;
      }
      var s = propertyGroupFactory(o, I);
      return g.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", s)), g.transform.mProps.p.setGroupProperty(PropertyInterface("Position", s)), g.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", s)), g.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", s)), g.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", s)), g.transform.mProps.sk && (g.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", s)), g.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", s))), g.transform.op.setGroupProperty(PropertyInterface("Opacity", s)), Object.defineProperties(o, {
        opacity: {
          get: ExpressionPropertyInterface(g.transform.mProps.o)
        },
        position: {
          get: ExpressionPropertyInterface(g.transform.mProps.p)
        },
        anchorPoint: {
          get: ExpressionPropertyInterface(g.transform.mProps.a)
        },
        scale: {
          get: ExpressionPropertyInterface(g.transform.mProps.s)
        },
        rotation: {
          get: ExpressionPropertyInterface(g.transform.mProps.r)
        },
        skew: {
          get: ExpressionPropertyInterface(g.transform.mProps.sk)
        },
        skewAxis: {
          get: ExpressionPropertyInterface(g.transform.mProps.sa)
        },
        _name: {
          value: d.nm
        }
      }), o.ty = "tr", o.mn = d.mn, o.propertyGroup = I, o;
    }
    function y(d, g, I) {
      function o(h) {
        return d.p.ix === h ? o.position : d.s.ix === h ? o.size : null;
      }
      var s = propertyGroupFactory(o, I);
      o.propertyIndex = d.ix;
      var l = g.sh.ty === "tm" ? g.sh.prop : g.sh;
      return l.s.setGroupProperty(PropertyInterface("Size", s)), l.p.setGroupProperty(PropertyInterface("Position", s)), Object.defineProperties(o, {
        size: {
          get: ExpressionPropertyInterface(l.s)
        },
        position: {
          get: ExpressionPropertyInterface(l.p)
        },
        _name: {
          value: d.nm
        }
      }), o.mn = d.mn, o;
    }
    function v(d, g, I) {
      function o(h) {
        return d.p.ix === h ? o.position : d.r.ix === h ? o.rotation : d.pt.ix === h ? o.points : d.or.ix === h || h === "ADBE Vector Star Outer Radius" ? o.outerRadius : d.os.ix === h ? o.outerRoundness : d.ir && (d.ir.ix === h || h === "ADBE Vector Star Inner Radius") ? o.innerRadius : d.is && d.is.ix === h ? o.innerRoundness : null;
      }
      var s = propertyGroupFactory(o, I),
        l = g.sh.ty === "tm" ? g.sh.prop : g.sh;
      return o.propertyIndex = d.ix, l.or.setGroupProperty(PropertyInterface("Outer Radius", s)), l.os.setGroupProperty(PropertyInterface("Outer Roundness", s)), l.pt.setGroupProperty(PropertyInterface("Points", s)), l.p.setGroupProperty(PropertyInterface("Position", s)), l.r.setGroupProperty(PropertyInterface("Rotation", s)), d.ir && (l.ir.setGroupProperty(PropertyInterface("Inner Radius", s)), l.is.setGroupProperty(PropertyInterface("Inner Roundness", s))), Object.defineProperties(o, {
        position: {
          get: ExpressionPropertyInterface(l.p)
        },
        rotation: {
          get: ExpressionPropertyInterface(l.r)
        },
        points: {
          get: ExpressionPropertyInterface(l.pt)
        },
        outerRadius: {
          get: ExpressionPropertyInterface(l.or)
        },
        outerRoundness: {
          get: ExpressionPropertyInterface(l.os)
        },
        innerRadius: {
          get: ExpressionPropertyInterface(l.ir)
        },
        innerRoundness: {
          get: ExpressionPropertyInterface(l.is)
        },
        _name: {
          value: d.nm
        }
      }), o.mn = d.mn, o;
    }
    function A(d, g, I) {
      function o(h) {
        return d.p.ix === h ? o.position : d.r.ix === h ? o.roundness : d.s.ix === h || h === "Size" || h === "ADBE Vector Rect Size" ? o.size : null;
      }
      var s = propertyGroupFactory(o, I),
        l = g.sh.ty === "tm" ? g.sh.prop : g.sh;
      return o.propertyIndex = d.ix, l.p.setGroupProperty(PropertyInterface("Position", s)), l.s.setGroupProperty(PropertyInterface("Size", s)), l.r.setGroupProperty(PropertyInterface("Rotation", s)), Object.defineProperties(o, {
        position: {
          get: ExpressionPropertyInterface(l.p)
        },
        roundness: {
          get: ExpressionPropertyInterface(l.r)
        },
        size: {
          get: ExpressionPropertyInterface(l.s)
        },
        _name: {
          value: d.nm
        }
      }), o.mn = d.mn, o;
    }
    function c(d, g, I) {
      function o(h) {
        return d.r.ix === h || h === "Round Corners 1" ? o.radius : null;
      }
      var s = propertyGroupFactory(o, I),
        l = g;
      return o.propertyIndex = d.ix, l.rd.setGroupProperty(PropertyInterface("Radius", s)), Object.defineProperties(o, {
        radius: {
          get: ExpressionPropertyInterface(l.rd)
        },
        _name: {
          value: d.nm
        }
      }), o.mn = d.mn, o;
    }
    function E(d, g, I) {
      function o(h) {
        return d.c.ix === h || h === "Copies" ? o.copies : d.o.ix === h || h === "Offset" ? o.offset : null;
      }
      var s = propertyGroupFactory(o, I),
        l = g;
      return o.propertyIndex = d.ix, l.c.setGroupProperty(PropertyInterface("Copies", s)), l.o.setGroupProperty(PropertyInterface("Offset", s)), Object.defineProperties(o, {
        copies: {
          get: ExpressionPropertyInterface(l.c)
        },
        offset: {
          get: ExpressionPropertyInterface(l.o)
        },
        _name: {
          value: d.nm
        }
      }), o.mn = d.mn, o;
    }
    return function (d, g, I) {
      var o;
      function s(h) {
        if (typeof h == "number") return h = h === void 0 ? 1 : h, h === 0 ? I : o[h - 1];
        for (var m = 0, S = o.length; m < S;) {
          if (o[m]._name === h) return o[m];
          m += 1;
        }
        return null;
      }
      function l() {
        return I;
      }
      return s.propertyGroup = propertyGroupFactory(s, l), o = e(d, g, s.propertyGroup), s.numProperties = o.length, s._name = "Contents", s;
    };
  }(),
  TextExpressionInterface = function () {
    return function (e) {
      var t, r;
      function i(a) {
        switch (a) {
          case "ADBE Text Document":
            return i.sourceText;
          default:
            return null;
        }
      }
      return Object.defineProperty(i, "sourceText", {
        get: function () {
          e.textProperty.getValue();
          var a = e.textProperty.currentData.t;
          return a !== t && (e.textProperty.currentData.t = t, r = new String(a), r.value = a || new String(a)), r;
        }
      }), i;
    };
  }(),
  getBlendMode = function () {
    var e = {
      0: "source-over",
      1: "multiply",
      2: "screen",
      3: "overlay",
      4: "darken",
      5: "lighten",
      6: "color-dodge",
      7: "color-burn",
      8: "hard-light",
      9: "soft-light",
      10: "difference",
      11: "exclusion",
      12: "hue",
      13: "saturation",
      14: "color",
      15: "luminosity"
    };
    return function (t) {
      return e[t] || "";
    };
  }();
function SliderEffect(e, t, r) {
  this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
}
function AngleEffect(e, t, r) {
  this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
}
function ColorEffect(e, t, r) {
  this.p = PropertyFactory.getProp(t, e.v, 1, 0, r);
}
function PointEffect(e, t, r) {
  this.p = PropertyFactory.getProp(t, e.v, 1, 0, r);
}
function LayerIndexEffect(e, t, r) {
  this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
}
function MaskIndexEffect(e, t, r) {
  this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
}
function CheckboxEffect(e, t, r) {
  this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
}
function NoValueEffect() {
  this.p = {};
}
function EffectsManager(e, t) {
  var r = e.ef || [];
  this.effectElements = [];
  var i,
    a = r.length,
    n;
  for (i = 0; i < a; i += 1) n = new GroupEffect(r[i], t), this.effectElements.push(n);
}
function GroupEffect(e, t) {
  this.init(e, t);
}
extendPrototype([DynamicPropertyContainer], GroupEffect);
GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
GroupEffect.prototype.init = function (e, t) {
  this.data = e, this.effectElements = [], this.initDynamicPropertyContainer(t);
  var r,
    i = this.data.ef.length,
    a,
    n = this.data.ef;
  for (r = 0; r < i; r += 1) {
    switch (a = null, n[r].ty) {
      case 0:
        a = new SliderEffect(n[r], t, this);
        break;
      case 1:
        a = new AngleEffect(n[r], t, this);
        break;
      case 2:
        a = new ColorEffect(n[r], t, this);
        break;
      case 3:
        a = new PointEffect(n[r], t, this);
        break;
      case 4:
      case 7:
        a = new CheckboxEffect(n[r], t, this);
        break;
      case 10:
        a = new LayerIndexEffect(n[r], t, this);
        break;
      case 11:
        a = new MaskIndexEffect(n[r], t, this);
        break;
      case 5:
        a = new EffectsManager(n[r], t);
        break;
      default:
        a = new NoValueEffect(n[r]);
        break;
    }
    a && this.effectElements.push(a);
  }
};
function BaseElement() {}
BaseElement.prototype = {
  checkMasks: function () {
    if (!this.data.hasMask) return !1;
    for (var e = 0, t = this.data.masksProperties.length; e < t;) {
      if (this.data.masksProperties[e].mode !== "n" && this.data.masksProperties[e].cl !== !1) return !0;
      e += 1;
    }
    return !1;
  },
  initExpressions: function () {
    this.layerInterface = LayerExpressionInterface(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
    var e = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
    this.layerInterface.registerEffectsInterface(e), this.data.ty === 0 || this.data.xt ? this.compInterface = CompExpressionInterface(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = TextExpressionInterface(this), this.layerInterface.text = this.layerInterface.textInterface);
  },
  setBlendMode: function () {
    var e = getBlendMode(this.data.bm),
      t = this.baseElement || this.layerElement;
    t.style["mix-blend-mode"] = e;
  },
  initBaseData: function (e, t, r) {
    this.globalData = t, this.comp = r, this.data = e, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
  },
  getType: function () {
    return this.type;
  },
  sourceRectAtTime: function () {}
};
function FrameElement() {}
FrameElement.prototype = {
  /**
     * @function
     * Initializes frame related properties.
     *
     */
  initFrame: function () {
    this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
  },
  /**
     * @function
     * Calculates all dynamic values
     *
     * @param {number} num
     * current frame number in Layer's time
     * @param {boolean} isVisible
     * if layers is currently in range
     *
     */
  prepareProperties: function (e, t) {
    var r,
      i = this.dynamicProperties.length;
    for (r = 0; r < i; r += 1) (t || this._isParent && this.dynamicProperties[r].propType === "transform") && (this.dynamicProperties[r].getValue(), this.dynamicProperties[r]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
  },
  addDynamicProperty: function (e) {
    this.dynamicProperties.indexOf(e) === -1 && this.dynamicProperties.push(e);
  }
};
const FootageInterface = function () {
  var e = function (r) {
      var i = "",
        a = r.getFootageData();
      function n() {
        return i = "", a = r.getFootageData(), u;
      }
      function u(f) {
        if (a[f]) return i = f, a = a[f], typeof a == "object" ? u : a;
        var p = f.indexOf(i);
        if (p !== -1) {
          var y = parseInt(f.substr(p + i.length), 10);
          return a = a[y], typeof a == "object" ? u : a;
        }
        return "";
      }
      return n;
    },
    t = function (r) {
      function i(a) {
        return a === "Outline" ? i.outlineInterface() : null;
      }
      return i._name = "Outline", i.outlineInterface = e(r), i;
    };
  return function (r) {
    function i(a) {
      return a === "Data" ? i.dataInterface : null;
    }
    return i._name = "Data", i.dataInterface = t(r), i;
  };
}();
function FootageElement(e, t, r) {
  this.initFrame(), this.initRenderable(), this.assetData = t.getAssetData(e.refId), this.footageData = t.imageLoader.getAsset(this.assetData), this.initBaseData(e, t, r);
}
FootageElement.prototype.prepareFrame = function () {};
extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement);
FootageElement.prototype.getBaseElement = function () {
  return null;
};
FootageElement.prototype.renderFrame = function () {};
FootageElement.prototype.destroy = function () {};
FootageElement.prototype.initExpressions = function () {
  this.layerInterface = FootageInterface(this);
};
FootageElement.prototype.getFootageData = function () {
  return this.footageData;
};
function AudioElement(e, t, r) {
  this.initFrame(), this.initRenderable(), this.assetData = t.getAssetData(e.refId), this.initBaseData(e, t, r), this._isPlaying = !1, this._canPlay = !1;
  var i = this.globalData.getAssetsPath(this.assetData);
  this.audio = this.globalData.audioController.createAudio(i), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
    _placeholder: !0
  }, this.lv = PropertyFactory.getProp(this, e.au && e.au.lv ? e.au.lv : {
    k: [100]
  }, 1, 0.01, this);
}
AudioElement.prototype.prepareFrame = function (e) {
  if (this.prepareRenderableFrame(e, !0), this.prepareProperties(e, !0), this.tm._placeholder) this._currentTime = e / this.data.sr;else {
    var t = this.tm.v;
    this._currentTime = t;
  }
  this._volume = this.lv.v[0];
  var r = this._volume * this._volumeMultiplier;
  this._previousVolume !== r && (this._previousVolume = r, this.audio.volume(r));
};
extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement);
AudioElement.prototype.renderFrame = function () {
  this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
};
AudioElement.prototype.show = function () {};
AudioElement.prototype.hide = function () {
  this.audio.pause(), this._isPlaying = !1;
};
AudioElement.prototype.pause = function () {
  this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
};
AudioElement.prototype.resume = function () {
  this._canPlay = !0;
};
AudioElement.prototype.setRate = function (e) {
  this.audio.rate(e);
};
AudioElement.prototype.volume = function (e) {
  this._volumeMultiplier = e, this._previousVolume = e * this._volume, this.audio.volume(this._previousVolume);
};
AudioElement.prototype.getBaseElement = function () {
  return null;
};
AudioElement.prototype.destroy = function () {};
AudioElement.prototype.sourceRectAtTime = function () {};
AudioElement.prototype.initExpressions = function () {};
function BaseRenderer() {}
BaseRenderer.prototype.checkLayers = function (e) {
  var t,
    r = this.layers.length,
    i;
  for (this.completeLayers = !0, t = r - 1; t >= 0; t -= 1) this.elements[t] || (i = this.layers[t], i.ip - i.st <= e - this.layers[t].st && i.op - i.st > e - this.layers[t].st && this.buildItem(t)), this.completeLayers = this.elements[t] ? this.completeLayers : !1;
  this.checkPendingElements();
};
BaseRenderer.prototype.createItem = function (e) {
  switch (e.ty) {
    case 2:
      return this.createImage(e);
    case 0:
      return this.createComp(e);
    case 1:
      return this.createSolid(e);
    case 3:
      return this.createNull(e);
    case 4:
      return this.createShape(e);
    case 5:
      return this.createText(e);
    case 6:
      return this.createAudio(e);
    case 13:
      return this.createCamera(e);
    case 15:
      return this.createFootage(e);
    default:
      return this.createNull(e);
  }
};
BaseRenderer.prototype.createCamera = function () {
  throw new Error("You're using a 3d camera. Try the html renderer.");
};
BaseRenderer.prototype.createAudio = function (e) {
  return new AudioElement(e, this.globalData, this);
};
BaseRenderer.prototype.createFootage = function (e) {
  return new FootageElement(e, this.globalData, this);
};
BaseRenderer.prototype.buildAllItems = function () {
  var e,
    t = this.layers.length;
  for (e = 0; e < t; e += 1) this.buildItem(e);
  this.checkPendingElements();
};
BaseRenderer.prototype.includeLayers = function (e) {
  this.completeLayers = !1;
  var t,
    r = e.length,
    i,
    a = this.layers.length;
  for (t = 0; t < r; t += 1) for (i = 0; i < a;) {
    if (this.layers[i].id === e[t].id) {
      this.layers[i] = e[t];
      break;
    }
    i += 1;
  }
};
BaseRenderer.prototype.setProjectInterface = function (e) {
  this.globalData.projectInterface = e;
};
BaseRenderer.prototype.initItems = function () {
  this.globalData.progressiveLoad || this.buildAllItems();
};
BaseRenderer.prototype.buildElementParenting = function (e, t, r) {
  for (var i = this.elements, a = this.layers, n = 0, u = a.length; n < u;) a[n].ind == t && (!i[n] || i[n] === !0 ? (this.buildItem(n), this.addPendingElement(e)) : (r.push(i[n]), i[n].setAsParent(), a[n].parent !== void 0 ? this.buildElementParenting(e, a[n].parent, r) : e.setHierarchy(r))), n += 1;
};
BaseRenderer.prototype.addPendingElement = function (e) {
  this.pendingElements.push(e);
};
BaseRenderer.prototype.searchExtraCompositions = function (e) {
  var t,
    r = e.length;
  for (t = 0; t < r; t += 1) if (e[t].xt) {
    var i = this.createComp(e[t]);
    i.initExpressions(), this.globalData.projectInterface.registerComposition(i);
  }
};
BaseRenderer.prototype.getElementByPath = function (e) {
  var t = e.shift(),
    r;
  if (typeof t == "number") r = this.elements[t];else {
    var i,
      a = this.elements.length;
    for (i = 0; i < a; i += 1) if (this.elements[i].data.nm === t) {
      r = this.elements[i];
      break;
    }
  }
  return e.length === 0 ? r : r.getElementByPath(e);
};
BaseRenderer.prototype.setupGlobalData = function (e, t) {
  this.globalData.fontManager = new FontManager(), this.globalData.fontManager.addChars(e.chars), this.globalData.fontManager.addFonts(e.fonts, t), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = e.fr, this.globalData.nm = e.nm, this.globalData.compSize = {
    w: e.w,
    h: e.h
  };
};
function TransformElement() {}
TransformElement.prototype = {
  initTransform: function () {
    this.finalTransform = {
      mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
        o: 0
      },
      _matMdf: !1,
      _opMdf: !1,
      mat: new Matrix()
    }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
  },
  renderTransform: function () {
    if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
      var e,
        t = this.finalTransform.mat,
        r = 0,
        i = this.hierarchy.length;
      if (!this.finalTransform._matMdf) for (; r < i;) {
        if (this.hierarchy[r].finalTransform.mProp._mdf) {
          this.finalTransform._matMdf = !0;
          break;
        }
        r += 1;
      }
      if (this.finalTransform._matMdf) for (e = this.finalTransform.mProp.v.props, t.cloneFromProps(e), r = 0; r < i; r += 1) e = this.hierarchy[r].finalTransform.mProp.v.props, t.transform(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]);
    }
  },
  globalToLocal: function (e) {
    var t = [];
    t.push(this.finalTransform);
    for (var r = !0, i = this.comp; r;) i.finalTransform ? (i.data.hasMask && t.splice(0, 0, i.finalTransform), i = i.comp) : r = !1;
    var a,
      n = t.length,
      u;
    for (a = 0; a < n; a += 1) u = t[a].mat.applyToPointArray(0, 0, 0), e = [e[0] - u[0], e[1] - u[1], 0];
    return e;
  },
  mHelper: new Matrix()
};
function MaskElement(e, t, r) {
  this.data = e, this.element = t, this.globalData = r, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
  var i = this.globalData.defs,
    a,
    n = this.masksProperties ? this.masksProperties.length : 0;
  this.viewData = createSizedArray(n), this.solidPath = "";
  var u,
    f = this.masksProperties,
    p = 0,
    y = [],
    v,
    A,
    c = createElementID(),
    E,
    d,
    g,
    I,
    o = "clipPath",
    s = "clip-path";
  for (a = 0; a < n; a += 1) if ((f[a].mode !== "a" && f[a].mode !== "n" || f[a].inv || f[a].o.k !== 100 || f[a].o.x) && (o = "mask", s = "mask"), (f[a].mode === "s" || f[a].mode === "i") && p === 0 ? (E = createNS("rect"), E.setAttribute("fill", "#ffffff"), E.setAttribute("width", this.element.comp.data.w || 0), E.setAttribute("height", this.element.comp.data.h || 0), y.push(E)) : E = null, u = createNS("path"), f[a].mode === "n") this.viewData[a] = {
    op: PropertyFactory.getProp(this.element, f[a].o, 0, 0.01, this.element),
    prop: ShapePropertyFactory.getShapeProp(this.element, f[a], 3),
    elem: u,
    lastPath: ""
  }, i.appendChild(u);else {
    p += 1, u.setAttribute("fill", f[a].mode === "s" ? "#000000" : "#ffffff"), u.setAttribute("clip-rule", "nonzero");
    var l;
    if (f[a].x.k !== 0 ? (o = "mask", s = "mask", I = PropertyFactory.getProp(this.element, f[a].x, 0, null, this.element), l = createElementID(), d = createNS("filter"), d.setAttribute("id", l), g = createNS("feMorphology"), g.setAttribute("operator", "erode"), g.setAttribute("in", "SourceGraphic"), g.setAttribute("radius", "0"), d.appendChild(g), i.appendChild(d), u.setAttribute("stroke", f[a].mode === "s" ? "#000000" : "#ffffff")) : (g = null, I = null), this.storedData[a] = {
      elem: u,
      x: I,
      expan: g,
      lastPath: "",
      lastOperator: "",
      filterId: l,
      lastRadius: 0
    }, f[a].mode === "i") {
      A = y.length;
      var h = createNS("g");
      for (v = 0; v < A; v += 1) h.appendChild(y[v]);
      var m = createNS("mask");
      m.setAttribute("mask-type", "alpha"), m.setAttribute("id", c + "_" + p), m.appendChild(u), i.appendChild(m), h.setAttribute("mask", "url(" + getLocationHref() + "#" + c + "_" + p + ")"), y.length = 0, y.push(h);
    } else y.push(u);
    f[a].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[a] = {
      elem: u,
      lastPath: "",
      op: PropertyFactory.getProp(this.element, f[a].o, 0, 0.01, this.element),
      prop: ShapePropertyFactory.getShapeProp(this.element, f[a], 3),
      invRect: E
    }, this.viewData[a].prop.k || this.drawPath(f[a], this.viewData[a].prop.v, this.viewData[a]);
  }
  for (this.maskElement = createNS(o), n = y.length, a = 0; a < n; a += 1) this.maskElement.appendChild(y[a]);
  p > 0 && (this.maskElement.setAttribute("id", c), this.element.maskedElement.setAttribute(s, "url(" + getLocationHref() + "#" + c + ")"), i.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
}
MaskElement.prototype.getMaskProperty = function (e) {
  return this.viewData[e].prop;
};
MaskElement.prototype.renderFrame = function (e) {
  var t = this.element.finalTransform.mat,
    r,
    i = this.masksProperties.length;
  for (r = 0; r < i; r += 1) if ((this.viewData[r].prop._mdf || e) && this.drawPath(this.masksProperties[r], this.viewData[r].prop.v, this.viewData[r]), (this.viewData[r].op._mdf || e) && this.viewData[r].elem.setAttribute("fill-opacity", this.viewData[r].op.v), this.masksProperties[r].mode !== "n" && (this.viewData[r].invRect && (this.element.finalTransform.mProp._mdf || e) && this.viewData[r].invRect.setAttribute("transform", t.getInverseMatrix().to2dCSS()), this.storedData[r].x && (this.storedData[r].x._mdf || e))) {
    var a = this.storedData[r].expan;
    this.storedData[r].x.v < 0 ? (this.storedData[r].lastOperator !== "erode" && (this.storedData[r].lastOperator = "erode", this.storedData[r].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[r].filterId + ")")), a.setAttribute("radius", -this.storedData[r].x.v)) : (this.storedData[r].lastOperator !== "dilate" && (this.storedData[r].lastOperator = "dilate", this.storedData[r].elem.setAttribute("filter", null)), this.storedData[r].elem.setAttribute("stroke-width", this.storedData[r].x.v * 2));
  }
};
MaskElement.prototype.getMaskelement = function () {
  return this.maskElement;
};
MaskElement.prototype.createLayerSolidPath = function () {
  var e = "M0,0 ";
  return e += " h" + this.globalData.compSize.w, e += " v" + this.globalData.compSize.h, e += " h-" + this.globalData.compSize.w, e += " v-" + this.globalData.compSize.h + " ", e;
};
MaskElement.prototype.drawPath = function (e, t, r) {
  var i = " M" + t.v[0][0] + "," + t.v[0][1],
    a,
    n;
  for (n = t._length, a = 1; a < n; a += 1) i += " C" + t.o[a - 1][0] + "," + t.o[a - 1][1] + " " + t.i[a][0] + "," + t.i[a][1] + " " + t.v[a][0] + "," + t.v[a][1];
  if (t.c && n > 1 && (i += " C" + t.o[a - 1][0] + "," + t.o[a - 1][1] + " " + t.i[0][0] + "," + t.i[0][1] + " " + t.v[0][0] + "," + t.v[0][1]), r.lastPath !== i) {
    var u = "";
    r.elem && (t.c && (u = e.inv ? this.solidPath + i : i), r.elem.setAttribute("d", u)), r.lastPath = i;
  }
};
MaskElement.prototype.destroy = function () {
  this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
};
const filtersFactory = function () {
    var e = {};
    e.createFilter = t, e.createAlphaToLuminanceFilter = r;
    function t(i, a) {
      var n = createNS("filter");
      return n.setAttribute("id", i), a !== !0 && (n.setAttribute("filterUnits", "objectBoundingBox"), n.setAttribute("x", "0%"), n.setAttribute("y", "0%"), n.setAttribute("width", "100%"), n.setAttribute("height", "100%")), n;
    }
    function r() {
      var i = createNS("feColorMatrix");
      return i.setAttribute("type", "matrix"), i.setAttribute("color-interpolation-filters", "sRGB"), i.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), i;
    }
    return e;
  }(),
  featureSupport = function () {
    var e = {
      maskType: !0
    };
    return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (e.maskType = !1), e;
  }();
var registeredEffects = {},
  idPrefix = "filter_result_";
function SVGEffects(e) {
  var t,
    r = "SourceGraphic",
    i = e.data.ef ? e.data.ef.length : 0,
    a = createElementID(),
    n = filtersFactory.createFilter(a, !0),
    u = 0;
  this.filters = [];
  var f;
  for (t = 0; t < i; t += 1) {
    f = null;
    var p = e.data.ef[t].ty;
    if (registeredEffects[p]) {
      var y = registeredEffects[p].effect;
      f = new y(n, e.effectsManager.effectElements[t], e, idPrefix + u, r), r = idPrefix + u, registeredEffects[p].countsAsEffect && (u += 1);
    }
    f && this.filters.push(f);
  }
  u && (e.globalData.defs.appendChild(n), e.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + a + ")")), this.filters.length && e.addRenderableComponent(this);
}
SVGEffects.prototype.renderFrame = function (e) {
  var t,
    r = this.filters.length;
  for (t = 0; t < r; t += 1) this.filters[t].renderFrame(e);
};
function SVGBaseElement() {}
SVGBaseElement.prototype = {
  initRendererElement: function () {
    this.layerElement = createNS("g");
  },
  createContainerElements: function () {
    this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
    var e = null,
      t,
      r,
      i;
    if (this.data.td) {
      if (this.data.td == 3 || this.data.td == 1) {
        var a = createNS("mask");
        a.setAttribute("id", this.layerId), a.setAttribute("mask-type", this.data.td == 3 ? "luminance" : "alpha"), a.appendChild(this.layerElement), e = a, this.globalData.defs.appendChild(a), !featureSupport.maskType && this.data.td == 1 && (a.setAttribute("mask-type", "luminance"), t = createElementID(), r = filtersFactory.createFilter(t), this.globalData.defs.appendChild(r), r.appendChild(filtersFactory.createAlphaToLuminanceFilter()), i = createNS("g"), i.appendChild(this.layerElement), e = i, a.appendChild(i), i.setAttribute("filter", "url(" + getLocationHref() + "#" + t + ")"));
      } else if (this.data.td == 2) {
        var n = createNS("mask");
        n.setAttribute("id", this.layerId), n.setAttribute("mask-type", "alpha");
        var u = createNS("g");
        n.appendChild(u), t = createElementID(), r = filtersFactory.createFilter(t);
        var f = createNS("feComponentTransfer");
        f.setAttribute("in", "SourceGraphic"), r.appendChild(f);
        var p = createNS("feFuncA");
        p.setAttribute("type", "table"), p.setAttribute("tableValues", "1.0 0.0"), f.appendChild(p), this.globalData.defs.appendChild(r);
        var y = createNS("rect");
        y.setAttribute("width", this.comp.data.w), y.setAttribute("height", this.comp.data.h), y.setAttribute("x", "0"), y.setAttribute("y", "0"), y.setAttribute("fill", "#ffffff"), y.setAttribute("opacity", "0"), u.setAttribute("filter", "url(" + getLocationHref() + "#" + t + ")"), u.appendChild(y), u.appendChild(this.layerElement), e = u, featureSupport.maskType || (n.setAttribute("mask-type", "luminance"), r.appendChild(filtersFactory.createAlphaToLuminanceFilter()), i = createNS("g"), u.appendChild(y), i.appendChild(this.layerElement), e = i, u.appendChild(i)), this.globalData.defs.appendChild(n);
      }
    } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), e = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
    if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
      var v = createNS("clipPath"),
        A = createNS("path");
      A.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
      var c = createElementID();
      if (v.setAttribute("id", c), v.appendChild(A), this.globalData.defs.appendChild(v), this.checkMasks()) {
        var E = createNS("g");
        E.setAttribute("clip-path", "url(" + getLocationHref() + "#" + c + ")"), E.appendChild(this.layerElement), this.transformedElement = E, e ? e.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
      } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + c + ")");
    }
    this.data.bm !== 0 && this.setBlendMode();
  },
  renderElement: function () {
    this.finalTransform._matMdf && this.transformedElement.setAttribute("transform", this.finalTransform.mat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.mProp.o.v);
  },
  destroyBaseElement: function () {
    this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
  },
  getBaseElement: function () {
    return this.data.hd ? null : this.baseElement;
  },
  createRenderableComponents: function () {
    this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this);
  },
  setMatte: function (e) {
    this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + e + ")");
  }
};
function HierarchyElement() {}
HierarchyElement.prototype = {
  /**
     * @function
     * Initializes hierarchy properties
     *
     */
  initHierarchy: function () {
    this.hierarchy = [], this._isParent = !1, this.checkParenting();
  },
  /**
     * @function
     * Sets layer's hierarchy.
     * @param {array} hierarch
     * layer's parent list
     *
     */
  setHierarchy: function (e) {
    this.hierarchy = e;
  },
  /**
     * @function
     * Sets layer as parent.
     *
     */
  setAsParent: function () {
    this._isParent = !0;
  },
  /**
     * @function
     * Searches layer's parenting chain
     *
     */
  checkParenting: function () {
    this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
  }
};
function RenderableDOMElement() {}
(function () {
  var e = {
    initElement: function (t, r, i) {
      this.initFrame(), this.initBaseData(t, r, i), this.initTransform(t, r, i), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
    },
    hide: function () {
      if (!this.hidden && (!this.isInRange || this.isTransparent)) {
        var t = this.baseElement || this.layerElement;
        t.style.display = "none", this.hidden = !0;
      }
    },
    show: function () {
      if (this.isInRange && !this.isTransparent) {
        if (!this.data.hd) {
          var t = this.baseElement || this.layerElement;
          t.style.display = "block";
        }
        this.hidden = !1, this._isFirstFrame = !0;
      }
    },
    renderFrame: function () {
      this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
    },
    renderInnerContent: function () {},
    prepareFrame: function (t) {
      this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.checkTransparency();
    },
    destroy: function () {
      this.innerElem = null, this.destroyBaseElement();
    }
  };
  extendPrototype([RenderableElement, createProxyFunction(e)], RenderableDOMElement);
})();
function IImageElement(e, t, r) {
  this.assetData = t.getAssetData(e.refId), this.initElement(e, t, r), this.sourceRect = {
    top: 0,
    left: 0,
    width: this.assetData.w,
    height: this.assetData.h
  };
}
extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement);
IImageElement.prototype.createContent = function () {
  var e = this.globalData.getAssetsPath(this.assetData);
  this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this.layerElement.appendChild(this.innerElem);
};
IImageElement.prototype.sourceRectAtTime = function () {
  return this.sourceRect;
};
function ProcessedElement(e, t) {
  this.elem = e, this.pos = t;
}
function IShapeElement() {}
IShapeElement.prototype = {
  addShapeToModifiers: function (e) {
    var t,
      r = this.shapeModifiers.length;
    for (t = 0; t < r; t += 1) this.shapeModifiers[t].addShape(e);
  },
  isShapeInAnimatedModifiers: function (e) {
    for (var t = 0, r = this.shapeModifiers.length; t < r;) if (this.shapeModifiers[t].isAnimatedWithShape(e)) return !0;
    return !1;
  },
  renderModifiers: function () {
    if (this.shapeModifiers.length) {
      var e,
        t = this.shapes.length;
      for (e = 0; e < t; e += 1) this.shapes[e].sh.reset();
      t = this.shapeModifiers.length;
      var r;
      for (e = t - 1; e >= 0 && (r = this.shapeModifiers[e].processShapes(this._isFirstFrame), !r); e -= 1);
    }
  },
  searchProcessedElement: function (e) {
    for (var t = this.processedElements, r = 0, i = t.length; r < i;) {
      if (t[r].elem === e) return t[r].pos;
      r += 1;
    }
    return 0;
  },
  addProcessedElement: function (e, t) {
    for (var r = this.processedElements, i = r.length; i;) if (i -= 1, r[i].elem === e) {
      r[i].pos = t;
      return;
    }
    r.push(new ProcessedElement(e, t));
  },
  prepareFrame: function (e) {
    this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange);
  }
};
const lineCapEnum = {
    1: "butt",
    2: "round",
    3: "square"
  },
  lineJoinEnum = {
    1: "miter",
    2: "round",
    3: "bevel"
  };
function SVGShapeData(e, t, r) {
  this.caches = [], this.styles = [], this.transformers = e, this.lStr = "", this.sh = r, this.lvl = t, this._isAnimated = !!r.k;
  for (var i = 0, a = e.length; i < a;) {
    if (e[i].mProps.dynamicProperties.length) {
      this._isAnimated = !0;
      break;
    }
    i += 1;
  }
}
SVGShapeData.prototype.setAsAnimated = function () {
  this._isAnimated = !0;
};
function SVGStyleData(e, t) {
  this.data = e, this.type = e.ty, this.d = "", this.lvl = t, this._mdf = !1, this.closed = e.hd === !0, this.pElem = createNS("path"), this.msElem = null;
}
SVGStyleData.prototype.reset = function () {
  this.d = "", this._mdf = !1;
};
function DashProperty(e, t, r, i) {
  this.elem = e, this.frameId = -1, this.dataProps = createSizedArray(t.length), this.renderer = r, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", t.length ? t.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(i);
  var a,
    n = t.length || 0,
    u;
  for (a = 0; a < n; a += 1) u = PropertyFactory.getProp(e, t[a].v, 0, 0, this), this.k = u.k || this.k, this.dataProps[a] = {
    n: t[a].n,
    p: u
  };
  this.k || this.getValue(!0), this._isAnimated = this.k;
}
DashProperty.prototype.getValue = function (e) {
  if (!(this.elem.globalData.frameId === this.frameId && !e) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || e, this._mdf)) {
    var t = 0,
      r = this.dataProps.length;
    for (this.renderer === "svg" && (this.dashStr = ""), t = 0; t < r; t += 1) this.dataProps[t].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[t].p.v : this.dashArray[t] = this.dataProps[t].p.v : this.dashoffset[0] = this.dataProps[t].p.v;
  }
};
extendPrototype([DynamicPropertyContainer], DashProperty);
function SVGStrokeStyleData(e, t, r) {
  this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.w = PropertyFactory.getProp(e, t.w, 0, null, this), this.d = new DashProperty(e, t.d || {}, "svg", this), this.c = PropertyFactory.getProp(e, t.c, 1, 255, this), this.style = r, this._isAnimated = !!this._isAnimated;
}
extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
function SVGFillStyleData(e, t, r) {
  this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.c = PropertyFactory.getProp(e, t.c, 1, 255, this), this.style = r;
}
extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
function SVGNoStyleData(e, t, r) {
  this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.style = r;
}
extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
function GradientProperty(e, t, r) {
  this.data = t, this.c = createTypedArray("uint8c", t.p * 4);
  var i = t.k.k[0].s ? t.k.k[0].s.length - t.p * 4 : t.k.k.length - t.p * 4;
  this.o = createTypedArray("float32", i), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = i, this.initDynamicPropertyContainer(r), this.prop = PropertyFactory.getProp(e, t.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
}
GradientProperty.prototype.comparePoints = function (e, t) {
  for (var r = 0, i = this.o.length / 2, a; r < i;) {
    if (a = Math.abs(e[r * 4] - e[t * 4 + r * 2]), a > 0.01) return !1;
    r += 1;
  }
  return !0;
};
GradientProperty.prototype.checkCollapsable = function () {
  if (this.o.length / 2 !== this.c.length / 4) return !1;
  if (this.data.k.k[0].s) for (var e = 0, t = this.data.k.k.length; e < t;) {
    if (!this.comparePoints(this.data.k.k[e].s, this.data.p)) return !1;
    e += 1;
  } else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
  return !0;
};
GradientProperty.prototype.getValue = function (e) {
  if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || e) {
    var t,
      r = this.data.p * 4,
      i,
      a;
    for (t = 0; t < r; t += 1) i = t % 4 === 0 ? 100 : 255, a = Math.round(this.prop.v[t] * i), this.c[t] !== a && (this.c[t] = a, this._cmdf = !e);
    if (this.o.length) for (r = this.prop.v.length, t = this.data.p * 4; t < r; t += 1) i = t % 2 === 0 ? 100 : 1, a = t % 2 === 0 ? Math.round(this.prop.v[t] * 100) : this.prop.v[t], this.o[t - this.data.p * 4] !== a && (this.o[t - this.data.p * 4] = a, this._omdf = !e);
    this._mdf = !e;
  }
};
extendPrototype([DynamicPropertyContainer], GradientProperty);
function SVGGradientFillStyleData(e, t, r) {
  this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.initGradientData(e, t, r);
}
SVGGradientFillStyleData.prototype.initGradientData = function (e, t, r) {
  this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.s = PropertyFactory.getProp(e, t.s, 1, null, this), this.e = PropertyFactory.getProp(e, t.e, 1, null, this), this.h = PropertyFactory.getProp(e, t.h || {
    k: 0
  }, 0, 0.01, this), this.a = PropertyFactory.getProp(e, t.a || {
    k: 0
  }, 0, degToRads, this), this.g = new GradientProperty(e, t.g, this), this.style = r, this.stops = [], this.setGradientData(r.pElem, t), this.setGradientOpacity(t, r), this._isAnimated = !!this._isAnimated;
};
SVGGradientFillStyleData.prototype.setGradientData = function (e, t) {
  var r = createElementID(),
    i = createNS(t.t === 1 ? "linearGradient" : "radialGradient");
  i.setAttribute("id", r), i.setAttribute("spreadMethod", "pad"), i.setAttribute("gradientUnits", "userSpaceOnUse");
  var a = [],
    n,
    u,
    f;
  for (f = t.g.p * 4, u = 0; u < f; u += 4) n = createNS("stop"), i.appendChild(n), a.push(n);
  e.setAttribute(t.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + r + ")"), this.gf = i, this.cst = a;
};
SVGGradientFillStyleData.prototype.setGradientOpacity = function (e, t) {
  if (this.g._hasOpacity && !this.g._collapsable) {
    var r,
      i,
      a,
      n = createNS("mask"),
      u = createNS("path");
    n.appendChild(u);
    var f = createElementID(),
      p = createElementID();
    n.setAttribute("id", p);
    var y = createNS(e.t === 1 ? "linearGradient" : "radialGradient");
    y.setAttribute("id", f), y.setAttribute("spreadMethod", "pad"), y.setAttribute("gradientUnits", "userSpaceOnUse"), a = e.g.k.k[0].s ? e.g.k.k[0].s.length : e.g.k.k.length;
    var v = this.stops;
    for (i = e.g.p * 4; i < a; i += 2) r = createNS("stop"), r.setAttribute("stop-color", "rgb(255,255,255)"), y.appendChild(r), v.push(r);
    u.setAttribute(e.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + f + ")"), e.ty === "gs" && (u.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]), u.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]), e.lj === 1 && u.setAttribute("stroke-miterlimit", e.ml)), this.of = y, this.ms = n, this.ost = v, this.maskId = p, t.msElem = u;
  }
};
extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
function SVGGradientStrokeStyleData(e, t, r) {
  this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(e, t.w, 0, null, this), this.d = new DashProperty(e, t.d || {}, "svg", this), this.initGradientData(e, t, r), this._isAnimated = !!this._isAnimated;
}
extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
function ShapeGroupData() {
  this.it = [], this.prevViewData = [], this.gr = createNS("g");
}
function SVGTransformData(e, t, r) {
  this.transform = {
    mProps: e,
    op: t,
    container: r
  }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
}
const buildShapeString = function (e, t, r, i) {
    if (t === 0) return "";
    var a = e.o,
      n = e.i,
      u = e.v,
      f,
      p = " M" + i.applyToPointStringified(u[0][0], u[0][1]);
    for (f = 1; f < t; f += 1) p += " C" + i.applyToPointStringified(a[f - 1][0], a[f - 1][1]) + " " + i.applyToPointStringified(n[f][0], n[f][1]) + " " + i.applyToPointStringified(u[f][0], u[f][1]);
    return r && t && (p += " C" + i.applyToPointStringified(a[f - 1][0], a[f - 1][1]) + " " + i.applyToPointStringified(n[0][0], n[0][1]) + " " + i.applyToPointStringified(u[0][0], u[0][1]), p += "z"), p;
  },
  SVGElementsRenderer = function () {
    var e = new Matrix(),
      t = new Matrix(),
      r = {
        createRenderFunction: i
      };
    function i(A) {
      switch (A.ty) {
        case "fl":
          return f;
        case "gf":
          return y;
        case "gs":
          return p;
        case "st":
          return v;
        case "sh":
        case "el":
        case "rc":
        case "sr":
          return u;
        case "tr":
          return a;
        case "no":
          return n;
        default:
          return null;
      }
    }
    function a(A, c, E) {
      (E || c.transform.op._mdf) && c.transform.container.setAttribute("opacity", c.transform.op.v), (E || c.transform.mProps._mdf) && c.transform.container.setAttribute("transform", c.transform.mProps.v.to2dCSS());
    }
    function n() {}
    function u(A, c, E) {
      var d,
        g,
        I,
        o,
        s,
        l,
        h = c.styles.length,
        m = c.lvl,
        S,
        b,
        T,
        C,
        F;
      for (l = 0; l < h; l += 1) {
        if (o = c.sh._mdf || E, c.styles[l].lvl < m) {
          for (b = t.reset(), C = m - c.styles[l].lvl, F = c.transformers.length - 1; !o && C > 0;) o = c.transformers[F].mProps._mdf || o, C -= 1, F -= 1;
          if (o) for (C = m - c.styles[l].lvl, F = c.transformers.length - 1; C > 0;) T = c.transformers[F].mProps.v.props, b.transform(T[0], T[1], T[2], T[3], T[4], T[5], T[6], T[7], T[8], T[9], T[10], T[11], T[12], T[13], T[14], T[15]), C -= 1, F -= 1;
        } else b = e;
        if (S = c.sh.paths, g = S._length, o) {
          for (I = "", d = 0; d < g; d += 1) s = S.shapes[d], s && s._length && (I += buildShapeString(s, s._length, s.c, b));
          c.caches[l] = I;
        } else I = c.caches[l];
        c.styles[l].d += A.hd === !0 ? "" : I, c.styles[l]._mdf = o || c.styles[l]._mdf;
      }
    }
    function f(A, c, E) {
      var d = c.style;
      (c.c._mdf || E) && d.pElem.setAttribute("fill", "rgb(" + bmFloor(c.c.v[0]) + "," + bmFloor(c.c.v[1]) + "," + bmFloor(c.c.v[2]) + ")"), (c.o._mdf || E) && d.pElem.setAttribute("fill-opacity", c.o.v);
    }
    function p(A, c, E) {
      y(A, c, E), v(A, c, E);
    }
    function y(A, c, E) {
      var d = c.gf,
        g = c.g._hasOpacity,
        I = c.s.v,
        o = c.e.v;
      if (c.o._mdf || E) {
        var s = A.ty === "gf" ? "fill-opacity" : "stroke-opacity";
        c.style.pElem.setAttribute(s, c.o.v);
      }
      if (c.s._mdf || E) {
        var l = A.t === 1 ? "x1" : "cx",
          h = l === "x1" ? "y1" : "cy";
        d.setAttribute(l, I[0]), d.setAttribute(h, I[1]), g && !c.g._collapsable && (c.of.setAttribute(l, I[0]), c.of.setAttribute(h, I[1]));
      }
      var m, S, b, T;
      if (c.g._cmdf || E) {
        m = c.cst;
        var C = c.g.c;
        for (b = m.length, S = 0; S < b; S += 1) T = m[S], T.setAttribute("offset", C[S * 4] + "%"), T.setAttribute("stop-color", "rgb(" + C[S * 4 + 1] + "," + C[S * 4 + 2] + "," + C[S * 4 + 3] + ")");
      }
      if (g && (c.g._omdf || E)) {
        var F = c.g.o;
        for (c.g._collapsable ? m = c.cst : m = c.ost, b = m.length, S = 0; S < b; S += 1) T = m[S], c.g._collapsable || T.setAttribute("offset", F[S * 2] + "%"), T.setAttribute("stop-opacity", F[S * 2 + 1]);
      }
      if (A.t === 1) (c.e._mdf || E) && (d.setAttribute("x2", o[0]), d.setAttribute("y2", o[1]), g && !c.g._collapsable && (c.of.setAttribute("x2", o[0]), c.of.setAttribute("y2", o[1])));else {
        var w;
        if ((c.s._mdf || c.e._mdf || E) && (w = Math.sqrt(Math.pow(I[0] - o[0], 2) + Math.pow(I[1] - o[1], 2)), d.setAttribute("r", w), g && !c.g._collapsable && c.of.setAttribute("r", w)), c.e._mdf || c.h._mdf || c.a._mdf || E) {
          w || (w = Math.sqrt(Math.pow(I[0] - o[0], 2) + Math.pow(I[1] - o[1], 2)));
          var k = Math.atan2(o[1] - I[1], o[0] - I[0]),
            L = c.h.v;
          L >= 1 ? L = 0.99 : L <= -1 && (L = -0.99);
          var B = w * L,
            x = Math.cos(k + c.a.v) * B + I[0],
            N = Math.sin(k + c.a.v) * B + I[1];
          d.setAttribute("fx", x), d.setAttribute("fy", N), g && !c.g._collapsable && (c.of.setAttribute("fx", x), c.of.setAttribute("fy", N));
        }
      }
    }
    function v(A, c, E) {
      var d = c.style,
        g = c.d;
      g && (g._mdf || E) && g.dashStr && (d.pElem.setAttribute("stroke-dasharray", g.dashStr), d.pElem.setAttribute("stroke-dashoffset", g.dashoffset[0])), c.c && (c.c._mdf || E) && d.pElem.setAttribute("stroke", "rgb(" + bmFloor(c.c.v[0]) + "," + bmFloor(c.c.v[1]) + "," + bmFloor(c.c.v[2]) + ")"), (c.o._mdf || E) && d.pElem.setAttribute("stroke-opacity", c.o.v), (c.w._mdf || E) && (d.pElem.setAttribute("stroke-width", c.w.v), d.msElem && d.msElem.setAttribute("stroke-width", c.w.v));
    }
    return r;
  }();
function SVGShapeElement(e, t, r) {
  this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(e, t, r), this.prevViewData = [];
}
extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement);
SVGShapeElement.prototype.initSecondaryElement = function () {};
SVGShapeElement.prototype.identityMatrix = new Matrix();
SVGShapeElement.prototype.buildExpressionInterface = function () {};
SVGShapeElement.prototype.createContent = function () {
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
};
SVGShapeElement.prototype.filterUniqueShapes = function () {
  var e,
    t = this.shapes.length,
    r,
    i,
    a = this.stylesList.length,
    n,
    u = [],
    f = !1;
  for (i = 0; i < a; i += 1) {
    for (n = this.stylesList[i], f = !1, u.length = 0, e = 0; e < t; e += 1) r = this.shapes[e], r.styles.indexOf(n) !== -1 && (u.push(r), f = r._isAnimated || f);
    u.length > 1 && f && this.setShapesAsAnimated(u);
  }
};
SVGShapeElement.prototype.setShapesAsAnimated = function (e) {
  var t,
    r = e.length;
  for (t = 0; t < r; t += 1) e[t].setAsAnimated();
};
SVGShapeElement.prototype.createStyleElement = function (e, t) {
  var r,
    i = new SVGStyleData(e, t),
    a = i.pElem;
  if (e.ty === "st") r = new SVGStrokeStyleData(this, e, i);else if (e.ty === "fl") r = new SVGFillStyleData(this, e, i);else if (e.ty === "gf" || e.ty === "gs") {
    var n = e.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
    r = new n(this, e, i), this.globalData.defs.appendChild(r.gf), r.maskId && (this.globalData.defs.appendChild(r.ms), this.globalData.defs.appendChild(r.of), a.setAttribute("mask", "url(" + getLocationHref() + "#" + r.maskId + ")"));
  } else e.ty === "no" && (r = new SVGNoStyleData(this, e, i));
  return (e.ty === "st" || e.ty === "gs") && (a.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]), a.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]), a.setAttribute("fill-opacity", "0"), e.lj === 1 && a.setAttribute("stroke-miterlimit", e.ml)), e.r === 2 && a.setAttribute("fill-rule", "evenodd"), e.ln && a.setAttribute("id", e.ln), e.cl && a.setAttribute("class", e.cl), e.bm && (a.style["mix-blend-mode"] = getBlendMode(e.bm)), this.stylesList.push(i), this.addToAnimatedContents(e, r), r;
};
SVGShapeElement.prototype.createGroupElement = function (e) {
  var t = new ShapeGroupData();
  return e.ln && t.gr.setAttribute("id", e.ln), e.cl && t.gr.setAttribute("class", e.cl), e.bm && (t.gr.style["mix-blend-mode"] = getBlendMode(e.bm)), t;
};
SVGShapeElement.prototype.createTransformElement = function (e, t) {
  var r = TransformPropertyFactory.getTransformProperty(this, e, this),
    i = new SVGTransformData(r, r.o, t);
  return this.addToAnimatedContents(e, i), i;
};
SVGShapeElement.prototype.createShapeElement = function (e, t, r) {
  var i = 4;
  e.ty === "rc" ? i = 5 : e.ty === "el" ? i = 6 : e.ty === "sr" && (i = 7);
  var a = ShapePropertyFactory.getShapeProp(this, e, i, this),
    n = new SVGShapeData(t, r, a);
  return this.shapes.push(n), this.addShapeToModifiers(n), this.addToAnimatedContents(e, n), n;
};
SVGShapeElement.prototype.addToAnimatedContents = function (e, t) {
  for (var r = 0, i = this.animatedContents.length; r < i;) {
    if (this.animatedContents[r].element === t) return;
    r += 1;
  }
  this.animatedContents.push({
    fn: SVGElementsRenderer.createRenderFunction(e),
    element: t,
    data: e
  });
};
SVGShapeElement.prototype.setElementStyles = function (e) {
  var t = e.styles,
    r,
    i = this.stylesList.length;
  for (r = 0; r < i; r += 1) this.stylesList[r].closed || t.push(this.stylesList[r]);
};
SVGShapeElement.prototype.reloadShapes = function () {
  this._isFirstFrame = !0;
  var e,
    t = this.itemsData.length;
  for (e = 0; e < t; e += 1) this.prevViewData[e] = this.itemsData[e];
  for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), t = this.dynamicProperties.length, e = 0; e < t; e += 1) this.dynamicProperties[e].getValue();
  this.renderModifiers();
};
SVGShapeElement.prototype.searchShapes = function (e, t, r, i, a, n, u) {
  var f = [].concat(n),
    p,
    y = e.length - 1,
    v,
    A,
    c = [],
    E = [],
    d,
    g,
    I;
  for (p = y; p >= 0; p -= 1) {
    if (I = this.searchProcessedElement(e[p]), I ? t[p] = r[I - 1] : e[p]._render = u, e[p].ty === "fl" || e[p].ty === "st" || e[p].ty === "gf" || e[p].ty === "gs" || e[p].ty === "no") I ? t[p].style.closed = !1 : t[p] = this.createStyleElement(e[p], a), e[p]._render && t[p].style.pElem.parentNode !== i && i.appendChild(t[p].style.pElem), c.push(t[p].style);else if (e[p].ty === "gr") {
      if (!I) t[p] = this.createGroupElement(e[p]);else for (A = t[p].it.length, v = 0; v < A; v += 1) t[p].prevViewData[v] = t[p].it[v];
      this.searchShapes(e[p].it, t[p].it, t[p].prevViewData, t[p].gr, a + 1, f, u), e[p]._render && t[p].gr.parentNode !== i && i.appendChild(t[p].gr);
    } else e[p].ty === "tr" ? (I || (t[p] = this.createTransformElement(e[p], i)), d = t[p].transform, f.push(d)) : e[p].ty === "sh" || e[p].ty === "rc" || e[p].ty === "el" || e[p].ty === "sr" ? (I || (t[p] = this.createShapeElement(e[p], f, a)), this.setElementStyles(t[p])) : e[p].ty === "tm" || e[p].ty === "rd" || e[p].ty === "ms" || e[p].ty === "pb" ? (I ? (g = t[p], g.closed = !1) : (g = ShapeModifiers.getModifier(e[p].ty), g.init(this, e[p]), t[p] = g, this.shapeModifiers.push(g)), E.push(g)) : e[p].ty === "rp" && (I ? (g = t[p], g.closed = !0) : (g = ShapeModifiers.getModifier(e[p].ty), t[p] = g, g.init(this, e, p, t), this.shapeModifiers.push(g), u = !1), E.push(g));
    this.addProcessedElement(e[p], p + 1);
  }
  for (y = c.length, p = 0; p < y; p += 1) c[p].closed = !0;
  for (y = E.length, p = 0; p < y; p += 1) E[p].closed = !0;
};
SVGShapeElement.prototype.renderInnerContent = function () {
  this.renderModifiers();
  var e,
    t = this.stylesList.length;
  for (e = 0; e < t; e += 1) this.stylesList[e].reset();
  for (this.renderShape(), e = 0; e < t; e += 1) (this.stylesList[e]._mdf || this._isFirstFrame) && (this.stylesList[e].msElem && (this.stylesList[e].msElem.setAttribute("d", this.stylesList[e].d), this.stylesList[e].d = "M0 0" + this.stylesList[e].d), this.stylesList[e].pElem.setAttribute("d", this.stylesList[e].d || "M0 0"));
};
SVGShapeElement.prototype.renderShape = function () {
  var e,
    t = this.animatedContents.length,
    r;
  for (e = 0; e < t; e += 1) r = this.animatedContents[e], (this._isFirstFrame || r.element._isAnimated) && r.data !== !0 && r.fn(r.data, r.element, this._isFirstFrame);
};
SVGShapeElement.prototype.destroy = function () {
  this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
};
function LetterProps(e, t, r, i, a, n) {
  this.o = e, this.sw = t, this.sc = r, this.fc = i, this.m = a, this.p = n, this._mdf = {
    o: !0,
    sw: !!t,
    sc: !!r,
    fc: !!i,
    m: !0,
    p: !0
  };
}
LetterProps.prototype.update = function (e, t, r, i, a, n) {
  this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
  var u = !1;
  return this.o !== e && (this.o = e, this._mdf.o = !0, u = !0), this.sw !== t && (this.sw = t, this._mdf.sw = !0, u = !0), this.sc !== r && (this.sc = r, this._mdf.sc = !0, u = !0), this.fc !== i && (this.fc = i, this._mdf.fc = !0, u = !0), this.m !== a && (this.m = a, this._mdf.m = !0, u = !0), n.length && (this.p[0] !== n[0] || this.p[1] !== n[1] || this.p[4] !== n[4] || this.p[5] !== n[5] || this.p[12] !== n[12] || this.p[13] !== n[13]) && (this.p = n, this._mdf.p = !0, u = !0), u;
};
function TextProperty(e, t) {
  this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, this.data = t, this.elem = e, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
    ascent: 0,
    boxWidth: this.defaultBoxWidth,
    f: "",
    fStyle: "",
    fWeight: "",
    fc: "",
    j: "",
    justifyOffset: "",
    l: [],
    lh: 0,
    lineWidths: [],
    ls: "",
    of: "",
    s: "",
    sc: "",
    sw: 0,
    t: 0,
    tr: 0,
    sz: 0,
    ps: null,
    fillColorAnim: !1,
    strokeColorAnim: !1,
    strokeWidthAnim: !1,
    yOffset: 0,
    finalSize: 0,
    finalText: [],
    finalLineHeight: 0,
    __complete: !1
  }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
}
TextProperty.prototype.defaultBoxWidth = [0, 0];
TextProperty.prototype.copyData = function (e, t) {
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  return e;
};
TextProperty.prototype.setCurrentData = function (e) {
  e.__complete || this.completeTextData(e), this.currentData = e, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
};
TextProperty.prototype.searchProperty = function () {
  return this.searchKeyframes();
};
TextProperty.prototype.searchKeyframes = function () {
  return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
};
TextProperty.prototype.addEffect = function (e) {
  this.effectsSequence.push(e), this.elem.addDynamicProperty(this);
};
TextProperty.prototype.getValue = function (e) {
  if (!((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !e)) {
    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
    var t = this.currentData,
      r = this.keysIndex;
    if (this.lock) {
      this.setCurrentData(this.currentData);
      return;
    }
    this.lock = !0, this._mdf = !1;
    var i,
      a = this.effectsSequence.length,
      n = e || this.data.d.k[this.keysIndex].s;
    for (i = 0; i < a; i += 1) r !== this.keysIndex ? n = this.effectsSequence[i](n, n.t) : n = this.effectsSequence[i](this.currentData, n.t);
    t !== n && this.setCurrentData(n), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
  }
};
TextProperty.prototype.getKeyframeValue = function () {
  for (var e = this.data.d.k, t = this.elem.comp.renderedFrame, r = 0, i = e.length; r <= i - 1 && !(r === i - 1 || e[r + 1].t > t);) r += 1;
  return this.keysIndex !== r && (this.keysIndex = r), this.data.d.k[this.keysIndex].s;
};
TextProperty.prototype.buildFinalText = function (e) {
  for (var t = [], r = 0, i = e.length, a, n, u = !1; r < i;) a = e.charCodeAt(r), FontManager.isCombinedCharacter(a) ? t[t.length - 1] += e.charAt(r) : a >= 55296 && a <= 56319 ? (n = e.charCodeAt(r + 1), n >= 56320 && n <= 57343 ? (u || FontManager.isModifier(a, n) ? (t[t.length - 1] += e.substr(r, 2), u = !1) : t.push(e.substr(r, 2)), r += 1) : t.push(e.charAt(r))) : a > 56319 ? (n = e.charCodeAt(r + 1), FontManager.isZeroWidthJoiner(a, n) ? (u = !0, t[t.length - 1] += e.substr(r, 2), r += 1) : t.push(e.charAt(r))) : FontManager.isZeroWidthJoiner(a) ? (t[t.length - 1] += e.charAt(r), u = !0) : t.push(e.charAt(r)), r += 1;
  return t;
};
TextProperty.prototype.completeTextData = function (e) {
  e.__complete = !0;
  var t = this.elem.globalData.fontManager,
    r = this.data,
    i = [],
    a,
    n,
    u,
    f = 0,
    p,
    y = r.m.g,
    v = 0,
    A = 0,
    c = 0,
    E = [],
    d = 0,
    g = 0,
    I,
    o,
    s = t.getFontByName(e.f),
    l,
    h = 0,
    m = getFontProperties(s);
  e.fWeight = m.weight, e.fStyle = m.style, e.finalSize = e.s, e.finalText = this.buildFinalText(e.t), n = e.finalText.length, e.finalLineHeight = e.lh;
  var S = e.tr / 1e3 * e.finalSize,
    b;
  if (e.sz) for (var T = !0, C = e.sz[0], F = e.sz[1], w, k; T;) {
    k = this.buildFinalText(e.t), w = 0, d = 0, n = k.length, S = e.tr / 1e3 * e.finalSize;
    var L = -1;
    for (a = 0; a < n; a += 1) b = k[a].charCodeAt(0), u = !1, k[a] === " " ? L = a : (b === 13 || b === 3) && (d = 0, u = !0, w += e.finalLineHeight || e.finalSize * 1.2), t.chars ? (l = t.getCharData(k[a], s.fStyle, s.fFamily), h = u ? 0 : l.w * e.finalSize / 100) : h = t.measureText(k[a], e.f, e.finalSize), d + h > C && k[a] !== " " ? (L === -1 ? n += 1 : a = L, w += e.finalLineHeight || e.finalSize * 1.2, k.splice(a, L === a ? 1 : 0, "\r"), L = -1, d = 0) : (d += h, d += S);
    w += s.ascent * e.finalSize / 100, this.canResize && e.finalSize > this.minimumFontSize && F < w ? (e.finalSize -= 1, e.finalLineHeight = e.finalSize * e.lh / e.s) : (e.finalText = k, n = e.finalText.length, T = !1);
  }
  d = -S, h = 0;
  var B = 0,
    x;
  for (a = 0; a < n; a += 1) if (u = !1, x = e.finalText[a], b = x.charCodeAt(0), b === 13 || b === 3 ? (B = 0, E.push(d), g = d > g ? d : g, d = -2 * S, p = "", u = !0, c += 1) : p = x, t.chars ? (l = t.getCharData(x, s.fStyle, t.getFontByName(e.f).fFamily), h = u ? 0 : l.w * e.finalSize / 100) : h = t.measureText(p, e.f, e.finalSize), x === " " ? B += h + S : (d += h + S + B, B = 0), i.push({
    l: h,
    an: h,
    add: v,
    n: u,
    anIndexes: [],
    val: p,
    line: c,
    animatorJustifyOffset: 0
  }), y == 2) {
    if (v += h, p === "" || p === " " || a === n - 1) {
      for ((p === "" || p === " ") && (v -= h); A <= a;) i[A].an = v, i[A].ind = f, i[A].extra = h, A += 1;
      f += 1, v = 0;
    }
  } else if (y == 3) {
    if (v += h, p === "" || a === n - 1) {
      for (p === "" && (v -= h); A <= a;) i[A].an = v, i[A].ind = f, i[A].extra = h, A += 1;
      v = 0, f += 1;
    }
  } else i[f].ind = f, i[f].extra = 0, f += 1;
  if (e.l = i, g = d > g ? d : g, E.push(d), e.sz) e.boxWidth = e.sz[0], e.justifyOffset = 0;else switch (e.boxWidth = g, e.j) {
    case 1:
      e.justifyOffset = -e.boxWidth;
      break;
    case 2:
      e.justifyOffset = -e.boxWidth / 2;
      break;
    default:
      e.justifyOffset = 0;
  }
  e.lineWidths = E;
  var N = r.a,
    P,
    _;
  o = N.length;
  var M,
    R,
    G = [];
  for (I = 0; I < o; I += 1) {
    for (P = N[I], P.a.sc && (e.strokeColorAnim = !0), P.a.sw && (e.strokeWidthAnim = !0), (P.a.fc || P.a.fh || P.a.fs || P.a.fb) && (e.fillColorAnim = !0), R = 0, M = P.s.b, a = 0; a < n; a += 1) _ = i[a], _.anIndexes[I] = R, (M == 1 && _.val !== "" || M == 2 && _.val !== "" && _.val !== " " || M == 3 && (_.n || _.val == " " || a == n - 1) || M == 4 && (_.n || a == n - 1)) && (P.s.rn === 1 && G.push(R), R += 1);
    r.a[I].s.totalChars = R;
    var D = -1,
      z;
    if (P.s.rn === 1) for (a = 0; a < n; a += 1) _ = i[a], D != _.anIndexes[I] && (D = _.anIndexes[I], z = G.splice(Math.floor(Math.random() * G.length), 1)[0]), _.anIndexes[I] = z;
  }
  e.yOffset = e.finalLineHeight || e.finalSize * 1.2, e.ls = e.ls || 0, e.ascent = s.ascent * e.finalSize / 100;
};
TextProperty.prototype.updateDocumentData = function (e, t) {
  t = t === void 0 ? this.keysIndex : t;
  var r = this.copyData({}, this.data.d.k[t].s);
  r = this.copyData(r, e), this.data.d.k[t].s = r, this.recalculate(t), this.elem.addDynamicProperty(this);
};
TextProperty.prototype.recalculate = function (e) {
  var t = this.data.d.k[e].s;
  t.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(t);
};
TextProperty.prototype.canResizeFont = function (e) {
  this.canResize = e, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
};
TextProperty.prototype.setMinimumFontSize = function (e) {
  this.minimumFontSize = Math.floor(e) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
};
const TextSelectorProp = function () {
  var e = Math.max,
    t = Math.min,
    r = Math.floor;
  function i(n, u) {
    this._currentTextLength = -1, this.k = !1, this.data = u, this.elem = n, this.comp = n.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(n), this.s = PropertyFactory.getProp(n, u.s || {
      k: 0
    }, 0, 0, this), "e" in u ? this.e = PropertyFactory.getProp(n, u.e, 0, 0, this) : this.e = {
      v: 100
    }, this.o = PropertyFactory.getProp(n, u.o || {
      k: 0
    }, 0, 0, this), this.xe = PropertyFactory.getProp(n, u.xe || {
      k: 0
    }, 0, 0, this), this.ne = PropertyFactory.getProp(n, u.ne || {
      k: 0
    }, 0, 0, this), this.sm = PropertyFactory.getProp(n, u.sm || {
      k: 100
    }, 0, 0, this), this.a = PropertyFactory.getProp(n, u.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
  }
  i.prototype = {
    getMult: function (n) {
      this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
      var u = 0,
        f = 0,
        p = 1,
        y = 1;
      this.ne.v > 0 ? u = this.ne.v / 100 : f = -this.ne.v / 100, this.xe.v > 0 ? p = 1 - this.xe.v / 100 : y = 1 + this.xe.v / 100;
      var v = BezierFactory.getBezierEasing(u, f, p, y).get,
        A = 0,
        c = this.finalS,
        E = this.finalE,
        d = this.data.sh;
      if (d === 2) E === c ? A = n >= E ? 1 : 0 : A = e(0, t(0.5 / (E - c) + (n - c) / (E - c), 1)), A = v(A);else if (d === 3) E === c ? A = n >= E ? 0 : 1 : A = 1 - e(0, t(0.5 / (E - c) + (n - c) / (E - c), 1)), A = v(A);else if (d === 4) E === c ? A = 0 : (A = e(0, t(0.5 / (E - c) + (n - c) / (E - c), 1)), A < 0.5 ? A *= 2 : A = 1 - 2 * (A - 0.5)), A = v(A);else if (d === 5) {
        if (E === c) A = 0;else {
          var g = E - c;
          n = t(e(0, n + 0.5 - c), E - c);
          var I = -g / 2 + n,
            o = g / 2;
          A = Math.sqrt(1 - I * I / (o * o));
        }
        A = v(A);
      } else d === 6 ? (E === c ? A = 0 : (n = t(e(0, n + 0.5 - c), E - c), A = (1 + Math.cos(Math.PI + Math.PI * 2 * n / (E - c))) / 2), A = v(A)) : (n >= r(c) && (n - c < 0 ? A = e(0, t(t(E, 1) - (c - n), 1)) : A = e(0, t(E - n, 1))), A = v(A));
      if (this.sm.v !== 100) {
        var s = this.sm.v * 0.01;
        s === 0 && (s = 1e-8);
        var l = 0.5 - s * 0.5;
        A < l ? A = 0 : (A = (A - l) / s, A > 1 && (A = 1));
      }
      return A * this.a.v;
    },
    getValue: function (n) {
      this.iterateDynamicProperties(), this._mdf = n || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, n && this.data.r === 2 && (this.e.v = this._currentTextLength);
      var u = this.data.r === 2 ? 1 : 100 / this.data.totalChars,
        f = this.o.v / u,
        p = this.s.v / u + f,
        y = this.e.v / u + f;
      if (p > y) {
        var v = p;
        p = y, y = v;
      }
      this.finalS = p, this.finalE = y;
    }
  }, extendPrototype([DynamicPropertyContainer], i);
  function a(n, u, f) {
    return new i(n, u);
  }
  return {
    getTextSelectorProp: a
  };
}();
function TextAnimatorDataProperty(e, t, r) {
  var i = {
      propType: !1
    },
    a = PropertyFactory.getProp,
    n = t.a;
  this.a = {
    r: n.r ? a(e, n.r, 0, degToRads, r) : i,
    rx: n.rx ? a(e, n.rx, 0, degToRads, r) : i,
    ry: n.ry ? a(e, n.ry, 0, degToRads, r) : i,
    sk: n.sk ? a(e, n.sk, 0, degToRads, r) : i,
    sa: n.sa ? a(e, n.sa, 0, degToRads, r) : i,
    s: n.s ? a(e, n.s, 1, 0.01, r) : i,
    a: n.a ? a(e, n.a, 1, 0, r) : i,
    o: n.o ? a(e, n.o, 0, 0.01, r) : i,
    p: n.p ? a(e, n.p, 1, 0, r) : i,
    sw: n.sw ? a(e, n.sw, 0, 0, r) : i,
    sc: n.sc ? a(e, n.sc, 1, 0, r) : i,
    fc: n.fc ? a(e, n.fc, 1, 0, r) : i,
    fh: n.fh ? a(e, n.fh, 0, 0, r) : i,
    fs: n.fs ? a(e, n.fs, 0, 0.01, r) : i,
    fb: n.fb ? a(e, n.fb, 0, 0.01, r) : i,
    t: n.t ? a(e, n.t, 0, 0, r) : i
  }, this.s = TextSelectorProp.getTextSelectorProp(e, t.s, r), this.s.t = t.s.t;
}
function TextAnimatorProperty(e, t, r) {
  this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = e, this._renderType = t, this._elem = r, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
    alignment: {}
  }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(r);
}
TextAnimatorProperty.prototype.searchProperties = function () {
  var e,
    t = this._textData.a.length,
    r,
    i = PropertyFactory.getProp;
  for (e = 0; e < t; e += 1) r = this._textData.a[e], this._animatorsData[e] = new TextAnimatorDataProperty(this._elem, r, this);
  this._textData.p && "m" in this._textData.p ? (this._pathData = {
    a: i(this._elem, this._textData.p.a, 0, 0, this),
    f: i(this._elem, this._textData.p.f, 0, 0, this),
    l: i(this._elem, this._textData.p.l, 0, 0, this),
    r: i(this._elem, this._textData.p.r, 0, 0, this),
    p: i(this._elem, this._textData.p.p, 0, 0, this),
    m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
  }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = i(this._elem, this._textData.m.a, 1, 0, this);
};
TextAnimatorProperty.prototype.getMeasures = function (e, t) {
  if (this.lettersChangedFlag = t, !(!this._mdf && !this._isFirstFrame && !t && (!this._hasMaskedPath || !this._pathData.m._mdf))) {
    this._isFirstFrame = !1;
    var r = this._moreOptions.alignment.v,
      i = this._animatorsData,
      a = this._textData,
      n = this.mHelper,
      u = this._renderType,
      f = this.renderedLetters.length,
      p,
      y,
      v,
      A,
      c = e.l,
      E,
      d,
      g,
      I,
      o,
      s,
      l,
      h,
      m,
      S,
      b,
      T,
      C,
      F,
      w;
    if (this._hasMaskedPath) {
      if (w = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
        var k = w.v;
        this._pathData.r.v && (k = k.reverse()), E = {
          tLength: 0,
          segments: []
        }, A = k._length - 1;
        var L;
        for (T = 0, v = 0; v < A; v += 1) L = bez.buildBezierData(k.v[v], k.v[v + 1], [k.o[v][0] - k.v[v][0], k.o[v][1] - k.v[v][1]], [k.i[v + 1][0] - k.v[v + 1][0], k.i[v + 1][1] - k.v[v + 1][1]]), E.tLength += L.segmentLength, E.segments.push(L), T += L.segmentLength;
        v = A, w.v.c && (L = bez.buildBezierData(k.v[v], k.v[0], [k.o[v][0] - k.v[v][0], k.o[v][1] - k.v[v][1]], [k.i[0][0] - k.v[0][0], k.i[0][1] - k.v[0][1]]), E.tLength += L.segmentLength, E.segments.push(L), T += L.segmentLength), this._pathData.pi = E;
      }
      if (E = this._pathData.pi, d = this._pathData.f.v, l = 0, s = 1, I = 0, o = !0, S = E.segments, d < 0 && w.v.c) for (E.tLength < Math.abs(d) && (d = -Math.abs(d) % E.tLength), l = S.length - 1, m = S[l].points, s = m.length - 1; d < 0;) d += m[s].partialLength, s -= 1, s < 0 && (l -= 1, m = S[l].points, s = m.length - 1);
      m = S[l].points, h = m[s - 1], g = m[s], b = g.partialLength;
    }
    A = c.length, p = 0, y = 0;
    var B = e.finalSize * 1.2 * 0.714,
      x = !0,
      N,
      P,
      _,
      M,
      R;
    M = i.length;
    var G,
      D = -1,
      z,
      Y,
      Z,
      q = d,
      t1 = l,
      r1 = s,
      a1 = -1,
      e1,
      X,
      s1,
      H,
      Q,
      h1,
      p1,
      y1,
      f1 = "",
      u1 = this.defaultPropsArray,
      E1;
    if (e.j === 2 || e.j === 1) {
      var o1 = 0,
        g1 = 0,
        _1 = e.j === 2 ? -0.5 : -1,
        d1 = 0,
        S1 = !0;
      for (v = 0; v < A; v += 1) if (c[v].n) {
        for (o1 && (o1 += g1); d1 < v;) c[d1].animatorJustifyOffset = o1, d1 += 1;
        o1 = 0, S1 = !0;
      } else {
        for (_ = 0; _ < M; _ += 1) N = i[_].a, N.t.propType && (S1 && e.j === 2 && (g1 += N.t.v * _1), P = i[_].s, G = P.getMult(c[v].anIndexes[_], a.a[_].s.totalChars), G.length ? o1 += N.t.v * G[0] * _1 : o1 += N.t.v * G * _1);
        S1 = !1;
      }
      for (o1 && (o1 += g1); d1 < v;) c[d1].animatorJustifyOffset = o1, d1 += 1;
    }
    for (v = 0; v < A; v += 1) {
      if (n.reset(), e1 = 1, c[v].n) p = 0, y += e.yOffset, y += x ? 1 : 0, d = q, x = !1, this._hasMaskedPath && (l = t1, s = r1, m = S[l].points, h = m[s - 1], g = m[s], b = g.partialLength, I = 0), f1 = "", y1 = "", h1 = "", E1 = "", u1 = this.defaultPropsArray;else {
        if (this._hasMaskedPath) {
          if (a1 !== c[v].line) {
            switch (e.j) {
              case 1:
                d += T - e.lineWidths[c[v].line];
                break;
              case 2:
                d += (T - e.lineWidths[c[v].line]) / 2;
                break;
            }
            a1 = c[v].line;
          }
          D !== c[v].ind && (c[D] && (d += c[D].extra), d += c[v].an / 2, D = c[v].ind), d += r[0] * c[v].an * 5e-3;
          var c1 = 0;
          for (_ = 0; _ < M; _ += 1) N = i[_].a, N.p.propType && (P = i[_].s, G = P.getMult(c[v].anIndexes[_], a.a[_].s.totalChars), G.length ? c1 += N.p.v[0] * G[0] : c1 += N.p.v[0] * G), N.a.propType && (P = i[_].s, G = P.getMult(c[v].anIndexes[_], a.a[_].s.totalChars), G.length ? c1 += N.a.v[0] * G[0] : c1 += N.a.v[0] * G);
          for (o = !0, this._pathData.a.v && (d = c[0].an * 0.5 + (T - this._pathData.f.v - c[0].an * 0.5 - c[c.length - 1].an * 0.5) * D / (A - 1), d += this._pathData.f.v); o;) I + b >= d + c1 || !m ? (C = (d + c1 - I) / g.partialLength, Y = h.point[0] + (g.point[0] - h.point[0]) * C, Z = h.point[1] + (g.point[1] - h.point[1]) * C, n.translate(-r[0] * c[v].an * 5e-3, -(r[1] * B) * 0.01), o = !1) : m && (I += g.partialLength, s += 1, s >= m.length && (s = 0, l += 1, S[l] ? m = S[l].points : w.v.c ? (s = 0, l = 0, m = S[l].points) : (I -= g.partialLength, m = null)), m && (h = g, g = m[s], b = g.partialLength));
          z = c[v].an / 2 - c[v].add, n.translate(-z, 0, 0);
        } else z = c[v].an / 2 - c[v].add, n.translate(-z, 0, 0), n.translate(-r[0] * c[v].an * 5e-3, -r[1] * B * 0.01, 0);
        for (_ = 0; _ < M; _ += 1) N = i[_].a, N.t.propType && (P = i[_].s, G = P.getMult(c[v].anIndexes[_], a.a[_].s.totalChars), (p !== 0 || e.j !== 0) && (this._hasMaskedPath ? G.length ? d += N.t.v * G[0] : d += N.t.v * G : G.length ? p += N.t.v * G[0] : p += N.t.v * G));
        for (e.strokeWidthAnim && (s1 = e.sw || 0), e.strokeColorAnim && (e.sc ? X = [e.sc[0], e.sc[1], e.sc[2]] : X = [0, 0, 0]), e.fillColorAnim && e.fc && (H = [e.fc[0], e.fc[1], e.fc[2]]), _ = 0; _ < M; _ += 1) N = i[_].a, N.a.propType && (P = i[_].s, G = P.getMult(c[v].anIndexes[_], a.a[_].s.totalChars), G.length ? n.translate(-N.a.v[0] * G[0], -N.a.v[1] * G[1], N.a.v[2] * G[2]) : n.translate(-N.a.v[0] * G, -N.a.v[1] * G, N.a.v[2] * G));
        for (_ = 0; _ < M; _ += 1) N = i[_].a, N.s.propType && (P = i[_].s, G = P.getMult(c[v].anIndexes[_], a.a[_].s.totalChars), G.length ? n.scale(1 + (N.s.v[0] - 1) * G[0], 1 + (N.s.v[1] - 1) * G[1], 1) : n.scale(1 + (N.s.v[0] - 1) * G, 1 + (N.s.v[1] - 1) * G, 1));
        for (_ = 0; _ < M; _ += 1) {
          if (N = i[_].a, P = i[_].s, G = P.getMult(c[v].anIndexes[_], a.a[_].s.totalChars), N.sk.propType && (G.length ? n.skewFromAxis(-N.sk.v * G[0], N.sa.v * G[1]) : n.skewFromAxis(-N.sk.v * G, N.sa.v * G)), N.r.propType && (G.length ? n.rotateZ(-N.r.v * G[2]) : n.rotateZ(-N.r.v * G)), N.ry.propType && (G.length ? n.rotateY(N.ry.v * G[1]) : n.rotateY(N.ry.v * G)), N.rx.propType && (G.length ? n.rotateX(N.rx.v * G[0]) : n.rotateX(N.rx.v * G)), N.o.propType && (G.length ? e1 += (N.o.v * G[0] - e1) * G[0] : e1 += (N.o.v * G - e1) * G), e.strokeWidthAnim && N.sw.propType && (G.length ? s1 += N.sw.v * G[0] : s1 += N.sw.v * G), e.strokeColorAnim && N.sc.propType) for (Q = 0; Q < 3; Q += 1) G.length ? X[Q] += (N.sc.v[Q] - X[Q]) * G[0] : X[Q] += (N.sc.v[Q] - X[Q]) * G;
          if (e.fillColorAnim && e.fc) {
            if (N.fc.propType) for (Q = 0; Q < 3; Q += 1) G.length ? H[Q] += (N.fc.v[Q] - H[Q]) * G[0] : H[Q] += (N.fc.v[Q] - H[Q]) * G;
            N.fh.propType && (G.length ? H = addHueToRGB(H, N.fh.v * G[0]) : H = addHueToRGB(H, N.fh.v * G)), N.fs.propType && (G.length ? H = addSaturationToRGB(H, N.fs.v * G[0]) : H = addSaturationToRGB(H, N.fs.v * G)), N.fb.propType && (G.length ? H = addBrightnessToRGB(H, N.fb.v * G[0]) : H = addBrightnessToRGB(H, N.fb.v * G));
          }
        }
        for (_ = 0; _ < M; _ += 1) N = i[_].a, N.p.propType && (P = i[_].s, G = P.getMult(c[v].anIndexes[_], a.a[_].s.totalChars), this._hasMaskedPath ? G.length ? n.translate(0, N.p.v[1] * G[0], -N.p.v[2] * G[1]) : n.translate(0, N.p.v[1] * G, -N.p.v[2] * G) : G.length ? n.translate(N.p.v[0] * G[0], N.p.v[1] * G[1], -N.p.v[2] * G[2]) : n.translate(N.p.v[0] * G, N.p.v[1] * G, -N.p.v[2] * G));
        if (e.strokeWidthAnim && (h1 = s1 < 0 ? 0 : s1), e.strokeColorAnim && (p1 = "rgb(" + Math.round(X[0] * 255) + "," + Math.round(X[1] * 255) + "," + Math.round(X[2] * 255) + ")"), e.fillColorAnim && e.fc && (y1 = "rgb(" + Math.round(H[0] * 255) + "," + Math.round(H[1] * 255) + "," + Math.round(H[2] * 255) + ")"), this._hasMaskedPath) {
          if (n.translate(0, -e.ls), n.translate(0, r[1] * B * 0.01 + y, 0), this._pathData.p.v) {
            F = (g.point[1] - h.point[1]) / (g.point[0] - h.point[0]);
            var m1 = Math.atan(F) * 180 / Math.PI;
            g.point[0] < h.point[0] && (m1 += 180), n.rotate(-m1 * Math.PI / 180);
          }
          n.translate(Y, Z, 0), d -= r[0] * c[v].an * 5e-3, c[v + 1] && D !== c[v + 1].ind && (d += c[v].an / 2, d += e.tr * 1e-3 * e.finalSize);
        } else {
          switch (n.translate(p, y, 0), e.ps && n.translate(e.ps[0], e.ps[1] + e.ascent, 0), e.j) {
            case 1:
              n.translate(c[v].animatorJustifyOffset + e.justifyOffset + (e.boxWidth - e.lineWidths[c[v].line]), 0, 0);
              break;
            case 2:
              n.translate(c[v].animatorJustifyOffset + e.justifyOffset + (e.boxWidth - e.lineWidths[c[v].line]) / 2, 0, 0);
              break;
          }
          n.translate(0, -e.ls), n.translate(z, 0, 0), n.translate(r[0] * c[v].an * 5e-3, r[1] * B * 0.01, 0), p += c[v].l + e.tr * 1e-3 * e.finalSize;
        }
        u === "html" ? f1 = n.toCSS() : u === "svg" ? f1 = n.to2dCSS() : u1 = [n.props[0], n.props[1], n.props[2], n.props[3], n.props[4], n.props[5], n.props[6], n.props[7], n.props[8], n.props[9], n.props[10], n.props[11], n.props[12], n.props[13], n.props[14], n.props[15]], E1 = e1;
      }
      f <= v ? (R = new LetterProps(E1, h1, p1, y1, f1, u1), this.renderedLetters.push(R), f += 1, this.lettersChangedFlag = !0) : (R = this.renderedLetters[v], this.lettersChangedFlag = R.update(E1, h1, p1, y1, f1, u1) || this.lettersChangedFlag);
    }
  }
};
TextAnimatorProperty.prototype.getValue = function () {
  this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
};
TextAnimatorProperty.prototype.mHelper = new Matrix();
TextAnimatorProperty.prototype.defaultPropsArray = [];
extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
function ITextElement() {}
ITextElement.prototype.initElement = function (e, t, r) {
  this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(e, t, r), this.textProperty = new TextProperty(this, e.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(e.t, this.renderType, this), this.initTransform(e, t, r), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
};
ITextElement.prototype.prepareFrame = function (e) {
  this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange), (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
};
ITextElement.prototype.createPathShape = function (e, t) {
  var r,
    i = t.length,
    a,
    n = "";
  for (r = 0; r < i; r += 1) t[r].ty === "sh" && (a = t[r].ks.k, n += buildShapeString(a, a.i.length, !0, e));
  return n;
};
ITextElement.prototype.updateDocumentData = function (e, t) {
  this.textProperty.updateDocumentData(e, t);
};
ITextElement.prototype.canResizeFont = function (e) {
  this.textProperty.canResizeFont(e);
};
ITextElement.prototype.setMinimumFontSize = function (e) {
  this.textProperty.setMinimumFontSize(e);
};
ITextElement.prototype.applyTextPropertiesToMatrix = function (e, t, r, i, a) {
  switch (e.ps && t.translate(e.ps[0], e.ps[1] + e.ascent, 0), t.translate(0, -e.ls, 0), e.j) {
    case 1:
      t.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[r]), 0, 0);
      break;
    case 2:
      t.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[r]) / 2, 0, 0);
      break;
  }
  t.translate(i, a, 0);
};
ITextElement.prototype.buildColor = function (e) {
  return "rgb(" + Math.round(e[0] * 255) + "," + Math.round(e[1] * 255) + "," + Math.round(e[2] * 255) + ")";
};
ITextElement.prototype.emptyProp = new LetterProps();
ITextElement.prototype.destroy = function () {};
var emptyShapeData = {
  shapes: []
};
function SVGTextLottieElement(e, t, r) {
  this.textSpans = [], this.renderType = "svg", this.initElement(e, t, r);
}
extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement);
SVGTextLottieElement.prototype.createContent = function () {
  this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
};
SVGTextLottieElement.prototype.buildTextContents = function (e) {
  for (var t = 0, r = e.length, i = [], a = ""; t < r;) e[t] === String.fromCharCode(13) || e[t] === String.fromCharCode(3) ? (i.push(a), a = "") : a += e[t], t += 1;
  return i.push(a), i;
};
SVGTextLottieElement.prototype.buildShapeData = function (e, t) {
  if (e.shapes && e.shapes.length) {
    var r = e.shapes[0];
    if (r.it) {
      var i = r.it[r.it.length - 1];
      i.s && (i.s.k[0] = t, i.s.k[1] = t);
    }
  }
  return e;
};
SVGTextLottieElement.prototype.buildNewText = function () {
  this.addDynamicProperty(this);
  var e,
    t,
    r = this.textProperty.currentData;
  this.renderedLetters = createSizedArray(r ? r.l.length : 0), r.fc ? this.layerElement.setAttribute("fill", this.buildColor(r.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), r.sc && (this.layerElement.setAttribute("stroke", this.buildColor(r.sc)), this.layerElement.setAttribute("stroke-width", r.sw)), this.layerElement.setAttribute("font-size", r.finalSize);
  var i = this.globalData.fontManager.getFontByName(r.f);
  if (i.fClass) this.layerElement.setAttribute("class", i.fClass);else {
    this.layerElement.setAttribute("font-family", i.fFamily);
    var a = r.fWeight,
      n = r.fStyle;
    this.layerElement.setAttribute("font-style", n), this.layerElement.setAttribute("font-weight", a);
  }
  this.layerElement.setAttribute("aria-label", r.t);
  var u = r.l || [],
    f = !!this.globalData.fontManager.chars;
  t = u.length;
  var p,
    y = this.mHelper,
    v = "",
    A = this.data.singleShape,
    c = 0,
    E = 0,
    d = !0,
    g = r.tr * 1e-3 * r.finalSize;
  if (A && !f && !r.sz) {
    var I = this.textContainer,
      o = "start";
    switch (r.j) {
      case 1:
        o = "end";
        break;
      case 2:
        o = "middle";
        break;
      default:
        o = "start";
        break;
    }
    I.setAttribute("text-anchor", o), I.setAttribute("letter-spacing", g);
    var s = this.buildTextContents(r.finalText);
    for (t = s.length, E = r.ps ? r.ps[1] + r.ascent : 0, e = 0; e < t; e += 1) p = this.textSpans[e].span || createNS("tspan"), p.textContent = s[e], p.setAttribute("x", 0), p.setAttribute("y", E), p.style.display = "inherit", I.appendChild(p), this.textSpans[e] || (this.textSpans[e] = {
      span: null,
      glyph: null
    }), this.textSpans[e].span = p, E += r.finalLineHeight;
    this.layerElement.appendChild(I);
  } else {
    var l = this.textSpans.length,
      h;
    for (e = 0; e < t; e += 1) {
      if (this.textSpans[e] || (this.textSpans[e] = {
        span: null,
        childSpan: null,
        glyph: null
      }), !f || !A || e === 0) {
        if (p = l > e ? this.textSpans[e].span : createNS(f ? "g" : "text"), l <= e) {
          if (p.setAttribute("stroke-linecap", "butt"), p.setAttribute("stroke-linejoin", "round"), p.setAttribute("stroke-miterlimit", "4"), this.textSpans[e].span = p, f) {
            var m = createNS("g");
            p.appendChild(m), this.textSpans[e].childSpan = m;
          }
          this.textSpans[e].span = p, this.layerElement.appendChild(p);
        }
        p.style.display = "inherit";
      }
      if (y.reset(), A && (u[e].n && (c = -g, E += r.yOffset, E += d ? 1 : 0, d = !1), this.applyTextPropertiesToMatrix(r, y, u[e].line, c, E), c += u[e].l || 0, c += g), f) {
        h = this.globalData.fontManager.getCharData(r.finalText[e], i.fStyle, this.globalData.fontManager.getFontByName(r.f).fFamily);
        var S;
        if (h.t === 1) S = new SVGCompElement(h.data, this.globalData, this);else {
          var b = emptyShapeData;
          h.data && h.data.shapes && (b = this.buildShapeData(h.data, r.finalSize)), S = new SVGShapeElement(b, this.globalData, this);
        }
        if (this.textSpans[e].glyph) {
          var T = this.textSpans[e].glyph;
          this.textSpans[e].childSpan.removeChild(T.layerElement), T.destroy();
        }
        this.textSpans[e].glyph = S, S._debug = !0, S.prepareFrame(0), S.renderFrame(), this.textSpans[e].childSpan.appendChild(S.layerElement), h.t === 1 && this.textSpans[e].childSpan.setAttribute("transform", "scale(" + r.finalSize / 100 + "," + r.finalSize / 100 + ")");
      } else A && p.setAttribute("transform", "translate(" + y.props[12] + "," + y.props[13] + ")"), p.textContent = u[e].val, p.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
    }
    A && p && p.setAttribute("d", v);
  }
  for (; e < this.textSpans.length;) this.textSpans[e].span.style.display = "none", e += 1;
  this._sizeChanged = !0;
};
SVGTextLottieElement.prototype.sourceRectAtTime = function () {
  if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
    this._sizeChanged = !1;
    var e = this.layerElement.getBBox();
    this.bbox = {
      top: e.y,
      left: e.x,
      width: e.width,
      height: e.height
    };
  }
  return this.bbox;
};
SVGTextLottieElement.prototype.getValue = function () {
  var e,
    t = this.textSpans.length,
    r;
  for (this.renderedFrame = this.comp.renderedFrame, e = 0; e < t; e += 1) r = this.textSpans[e].glyph, r && (r.prepareFrame(this.comp.renderedFrame - this.data.st), r._mdf && (this._mdf = !0));
};
SVGTextLottieElement.prototype.renderInnerContent = function () {
  if ((!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
    this._sizeChanged = !0;
    var e,
      t,
      r = this.textAnimator.renderedLetters,
      i = this.textProperty.currentData.l;
    t = i.length;
    var a, n, u;
    for (e = 0; e < t; e += 1) i[e].n || (a = r[e], n = this.textSpans[e].span, u = this.textSpans[e].glyph, u && u.renderFrame(), a._mdf.m && n.setAttribute("transform", a.m), a._mdf.o && n.setAttribute("opacity", a.o), a._mdf.sw && n.setAttribute("stroke-width", a.sw), a._mdf.sc && n.setAttribute("stroke", a.sc), a._mdf.fc && n.setAttribute("fill", a.fc));
  }
};
function ISolidElement(e, t, r) {
  this.initElement(e, t, r);
}
extendPrototype([IImageElement], ISolidElement);
ISolidElement.prototype.createContent = function () {
  var e = createNS("rect");
  e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), e.setAttribute("fill", this.data.sc), this.layerElement.appendChild(e);
};
function NullElement(e, t, r) {
  this.initFrame(), this.initBaseData(e, t, r), this.initFrame(), this.initTransform(e, t, r), this.initHierarchy();
}
NullElement.prototype.prepareFrame = function (e) {
  this.prepareProperties(e, !0);
};
NullElement.prototype.renderFrame = function () {};
NullElement.prototype.getBaseElement = function () {
  return null;
};
NullElement.prototype.destroy = function () {};
NullElement.prototype.sourceRectAtTime = function () {};
NullElement.prototype.hide = function () {};
extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
function SVGRendererBase() {}
extendPrototype([BaseRenderer], SVGRendererBase);
SVGRendererBase.prototype.createNull = function (e) {
  return new NullElement(e, this.globalData, this);
};
SVGRendererBase.prototype.createShape = function (e) {
  return new SVGShapeElement(e, this.globalData, this);
};
SVGRendererBase.prototype.createText = function (e) {
  return new SVGTextLottieElement(e, this.globalData, this);
};
SVGRendererBase.prototype.createImage = function (e) {
  return new IImageElement(e, this.globalData, this);
};
SVGRendererBase.prototype.createSolid = function (e) {
  return new ISolidElement(e, this.globalData, this);
};
SVGRendererBase.prototype.configAnimation = function (e) {
  this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + e.w + " " + e.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", e.w), this.svgElement.setAttribute("height", e.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
  var t = this.globalData.defs;
  this.setupGlobalData(e, t), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = e;
  var r = createNS("clipPath"),
    i = createNS("rect");
  i.setAttribute("width", e.w), i.setAttribute("height", e.h), i.setAttribute("x", 0), i.setAttribute("y", 0);
  var a = createElementID();
  r.setAttribute("id", a), r.appendChild(i), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")"), t.appendChild(r), this.layers = e.layers, this.elements = createSizedArray(e.layers.length);
};
SVGRendererBase.prototype.destroy = function () {
  this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
  var e,
    t = this.layers ? this.layers.length : 0;
  for (e = 0; e < t; e += 1) this.elements[e] && this.elements[e].destroy();
  this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
};
SVGRendererBase.prototype.updateContainerSize = function () {};
SVGRendererBase.prototype.buildItem = function (e) {
  var t = this.elements;
  if (!(t[e] || this.layers[e].ty === 99)) {
    t[e] = !0;
    var r = this.createItem(this.layers[e]);
    t[e] = r, getExpressionsPlugin() && (this.layers[e].ty === 0 && this.globalData.projectInterface.registerComposition(r), r.initExpressions()), this.appendElementInPos(r, e), this.layers[e].tt && (!this.elements[e - 1] || this.elements[e - 1] === !0 ? (this.buildItem(e - 1), this.addPendingElement(r)) : r.setMatte(t[e - 1].layerId));
  }
};
SVGRendererBase.prototype.checkPendingElements = function () {
  for (; this.pendingElements.length;) {
    var e = this.pendingElements.pop();
    if (e.checkParenting(), e.data.tt) for (var t = 0, r = this.elements.length; t < r;) {
      if (this.elements[t] === e) {
        e.setMatte(this.elements[t - 1].layerId);
        break;
      }
      t += 1;
    }
  }
};
SVGRendererBase.prototype.renderFrame = function (e) {
  if (!(this.renderedFrame === e || this.destroyed)) {
    e === null ? e = this.renderedFrame : this.renderedFrame = e, this.globalData.frameNum = e, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = e, this.globalData._mdf = !1;
    var t,
      r = this.layers.length;
    for (this.completeLayers || this.checkLayers(e), t = r - 1; t >= 0; t -= 1) (this.completeLayers || this.elements[t]) && this.elements[t].prepareFrame(e - this.layers[t].st);
    if (this.globalData._mdf) for (t = 0; t < r; t += 1) (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
  }
};
SVGRendererBase.prototype.appendElementInPos = function (e, t) {
  var r = e.getBaseElement();
  if (r) {
    for (var i = 0, a; i < t;) this.elements[i] && this.elements[i] !== !0 && this.elements[i].getBaseElement() && (a = this.elements[i].getBaseElement()), i += 1;
    a ? this.layerElement.insertBefore(r, a) : this.layerElement.appendChild(r);
  }
};
SVGRendererBase.prototype.hide = function () {
  this.layerElement.style.display = "none";
};
SVGRendererBase.prototype.show = function () {
  this.layerElement.style.display = "block";
};
function ICompElement() {}
extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);
ICompElement.prototype.initElement = function (e, t, r) {
  this.initFrame(), this.initBaseData(e, t, r), this.initTransform(e, t, r), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), (this.data.xt || !t.progressiveLoad) && this.buildAllItems(), this.hide();
};
ICompElement.prototype.prepareFrame = function (e) {
  if (this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange), !(!this.isInRange && !this.data.xt)) {
    if (this.tm._placeholder) this.renderedFrame = e / this.data.sr;else {
      var t = this.tm.v;
      t === this.data.op && (t = this.data.op - 1), this.renderedFrame = t;
    }
    var r,
      i = this.elements.length;
    for (this.completeLayers || this.checkLayers(this.renderedFrame), r = i - 1; r >= 0; r -= 1) (this.completeLayers || this.elements[r]) && (this.elements[r].prepareFrame(this.renderedFrame - this.layers[r].st), this.elements[r]._mdf && (this._mdf = !0));
  }
};
ICompElement.prototype.renderInnerContent = function () {
  var e,
    t = this.layers.length;
  for (e = 0; e < t; e += 1) (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
};
ICompElement.prototype.setElements = function (e) {
  this.elements = e;
};
ICompElement.prototype.getElements = function () {
  return this.elements;
};
ICompElement.prototype.destroyElements = function () {
  var e,
    t = this.layers.length;
  for (e = 0; e < t; e += 1) this.elements[e] && this.elements[e].destroy();
};
ICompElement.prototype.destroy = function () {
  this.destroyElements(), this.destroyBaseElement();
};
function SVGCompElement(e, t, r) {
  this.layers = e.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(e, t, r), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
    _placeholder: !0
  };
}
extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement);
SVGCompElement.prototype.createComp = function (e) {
  return new SVGCompElement(e, this.globalData, this);
};
function SVGRenderer(e, t) {
  this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
  var r = "";
  if (t && t.title) {
    var i = createNS("title"),
      a = createElementID();
    i.setAttribute("id", a), i.textContent = t.title, this.svgElement.appendChild(i), r += a;
  }
  if (t && t.description) {
    var n = createNS("desc"),
      u = createElementID();
    n.setAttribute("id", u), n.textContent = t.description, this.svgElement.appendChild(n), r += " " + u;
  }
  r && this.svgElement.setAttribute("aria-labelledby", r);
  var f = createNS("defs");
  this.svgElement.appendChild(f);
  var p = createNS("g");
  this.svgElement.appendChild(p), this.layerElement = p, this.renderConfig = {
    preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet",
    imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
    contentVisibility: t && t.contentVisibility || "visible",
    progressiveLoad: t && t.progressiveLoad || !1,
    hideOnTransparent: !(t && t.hideOnTransparent === !1),
    viewBoxOnly: t && t.viewBoxOnly || !1,
    viewBoxSize: t && t.viewBoxSize || !1,
    className: t && t.className || "",
    id: t && t.id || "",
    focusable: t && t.focusable,
    filterSize: {
      width: t && t.filterSize && t.filterSize.width || "100%",
      height: t && t.filterSize && t.filterSize.height || "100%",
      x: t && t.filterSize && t.filterSize.x || "0%",
      y: t && t.filterSize && t.filterSize.y || "0%"
    },
    width: t && t.width,
    height: t && t.height
  }, this.globalData = {
    _mdf: !1,
    frameNum: -1,
    defs: f,
    renderConfig: this.renderConfig
  }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
}
extendPrototype([SVGRendererBase], SVGRenderer);
SVGRenderer.prototype.createComp = function (e) {
  return new SVGCompElement(e, this.globalData, this);
};
function CVContextData() {
  this.saved = [], this.cArrPos = 0, this.cTr = new Matrix(), this.cO = 1;
  var e,
    t = 15;
  for (this.savedOp = createTypedArray("float32", t), e = 0; e < t; e += 1) this.saved[e] = createTypedArray("float32", 16);
  this._length = t;
}
CVContextData.prototype.duplicate = function () {
  var e = this._length * 2,
    t = this.savedOp;
  this.savedOp = createTypedArray("float32", e), this.savedOp.set(t);
  var r = 0;
  for (r = this._length; r < e; r += 1) this.saved[r] = createTypedArray("float32", 16);
  this._length = e;
};
CVContextData.prototype.reset = function () {
  this.cArrPos = 0, this.cTr.reset(), this.cO = 1;
};
function ShapeTransformManager() {
  this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
}
ShapeTransformManager.prototype = {
  addTransformSequence: function (e) {
    var t,
      r = e.length,
      i = "_";
    for (t = 0; t < r; t += 1) i += e[t].transform.key + "_";
    var a = this.sequences[i];
    return a || (a = {
      transforms: [].concat(e),
      finalTransform: new Matrix(),
      _mdf: !1
    }, this.sequences[i] = a, this.sequenceList.push(a)), a;
  },
  processSequence: function (e, t) {
    for (var r = 0, i = e.transforms.length, a = t; r < i && !t;) {
      if (e.transforms[r].transform.mProps._mdf) {
        a = !0;
        break;
      }
      r += 1;
    }
    if (a) {
      var n;
      for (e.finalTransform.reset(), r = i - 1; r >= 0; r -= 1) n = e.transforms[r].transform.mProps.v.props, e.finalTransform.transform(n[0], n[1], n[2], n[3], n[4], n[5], n[6], n[7], n[8], n[9], n[10], n[11], n[12], n[13], n[14], n[15]);
    }
    e._mdf = a;
  },
  processSequences: function (e) {
    var t,
      r = this.sequenceList.length;
    for (t = 0; t < r; t += 1) this.processSequence(this.sequenceList[t], e);
  },
  getNewKey: function () {
    return this.transform_key_count += 1, "_" + this.transform_key_count;
  }
};
function CVEffects() {}
CVEffects.prototype.renderFrame = function () {};
function CVMaskElement(e, t) {
  this.data = e, this.element = t, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
  var r,
    i = this.masksProperties.length,
    a = !1;
  for (r = 0; r < i; r += 1) this.masksProperties[r].mode !== "n" && (a = !0), this.viewData[r] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r], 3);
  this.hasMasks = a, a && this.element.addRenderableComponent(this);
}
CVMaskElement.prototype.renderFrame = function () {
  if (this.hasMasks) {
    var e = this.element.finalTransform.mat,
      t = this.element.canvasContext,
      r,
      i = this.masksProperties.length,
      a,
      n,
      u;
    for (t.beginPath(), r = 0; r < i; r += 1) if (this.masksProperties[r].mode !== "n") {
      this.masksProperties[r].inv && (t.moveTo(0, 0), t.lineTo(this.element.globalData.compSize.w, 0), t.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), t.lineTo(0, this.element.globalData.compSize.h), t.lineTo(0, 0)), u = this.viewData[r].v, a = e.applyToPointArray(u.v[0][0], u.v[0][1], 0), t.moveTo(a[0], a[1]);
      var f,
        p = u._length;
      for (f = 1; f < p; f += 1) n = e.applyToTriplePoints(u.o[f - 1], u.i[f], u.v[f]), t.bezierCurveTo(n[0], n[1], n[2], n[3], n[4], n[5]);
      n = e.applyToTriplePoints(u.o[f - 1], u.i[0], u.v[0]), t.bezierCurveTo(n[0], n[1], n[2], n[3], n[4], n[5]);
    }
    this.element.globalData.renderer.save(!0), t.clip();
  }
};
CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
CVMaskElement.prototype.destroy = function () {
  this.element = null;
};
function CVBaseElement() {}
CVBaseElement.prototype = {
  createElements: function () {},
  initRendererElement: function () {},
  createContainerElements: function () {
    this.canvasContext = this.globalData.canvasContext, this.renderableEffectsManager = new CVEffects();
  },
  createContent: function () {},
  setBlendMode: function () {
    var e = this.globalData;
    if (e.blendMode !== this.data.bm) {
      e.blendMode = this.data.bm;
      var t = getBlendMode(this.data.bm);
      e.canvasContext.globalCompositeOperation = t;
    }
  },
  createRenderableComponents: function () {
    this.maskManager = new CVMaskElement(this.data, this);
  },
  hideElement: function () {
    !this.hidden && (!this.isInRange || this.isTransparent) && (this.hidden = !0);
  },
  showElement: function () {
    this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
  },
  renderFrame: function () {
    if (!(this.hidden || this.data.hd)) {
      this.renderTransform(), this.renderRenderable(), this.setBlendMode();
      var e = this.data.ty === 0;
      this.globalData.renderer.save(e), this.globalData.renderer.ctxTransform(this.finalTransform.mat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v), this.renderInnerContent(), this.globalData.renderer.restore(e), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
    }
  },
  destroy: function () {
    this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
  },
  mHelper: new Matrix()
};
CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
function CVShapeData(e, t, r, i) {
  this.styledShapes = [], this.tr = [0, 0, 0, 0, 0, 0];
  var a = 4;
  t.ty === "rc" ? a = 5 : t.ty === "el" ? a = 6 : t.ty === "sr" && (a = 7), this.sh = ShapePropertyFactory.getShapeProp(e, t, a, e);
  var n,
    u = r.length,
    f;
  for (n = 0; n < u; n += 1) r[n].closed || (f = {
    transforms: i.addTransformSequence(r[n].transforms),
    trNodes: []
  }, this.styledShapes.push(f), r[n].elements.push(f));
}
CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
function CVShapeElement(e, t, r) {
  this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager(), this.initElement(e, t, r);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement);
CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
CVShapeElement.prototype.transformHelper = {
  opacity: 1,
  _opMdf: !1
};
CVShapeElement.prototype.dashResetter = [];
CVShapeElement.prototype.createContent = function () {
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
};
CVShapeElement.prototype.createStyleElement = function (e, t) {
  var r = {
      data: e,
      type: e.ty,
      preTransforms: this.transformsManager.addTransformSequence(t),
      transforms: [],
      elements: [],
      closed: e.hd === !0
    },
    i = {};
  if (e.ty === "fl" || e.ty === "st" ? (i.c = PropertyFactory.getProp(this, e.c, 1, 255, this), i.c.k || (r.co = "rgb(" + bmFloor(i.c.v[0]) + "," + bmFloor(i.c.v[1]) + "," + bmFloor(i.c.v[2]) + ")")) : (e.ty === "gf" || e.ty === "gs") && (i.s = PropertyFactory.getProp(this, e.s, 1, null, this), i.e = PropertyFactory.getProp(this, e.e, 1, null, this), i.h = PropertyFactory.getProp(this, e.h || {
    k: 0
  }, 0, 0.01, this), i.a = PropertyFactory.getProp(this, e.a || {
    k: 0
  }, 0, degToRads, this), i.g = new GradientProperty(this, e.g, this)), i.o = PropertyFactory.getProp(this, e.o, 0, 0.01, this), e.ty === "st" || e.ty === "gs") {
    if (r.lc = lineCapEnum[e.lc || 2], r.lj = lineJoinEnum[e.lj || 2], e.lj == 1 && (r.ml = e.ml), i.w = PropertyFactory.getProp(this, e.w, 0, null, this), i.w.k || (r.wi = i.w.v), e.d) {
      var a = new DashProperty(this, e.d, "canvas", this);
      i.d = a, i.d.k || (r.da = i.d.dashArray, r.do = i.d.dashoffset[0]);
    }
  } else r.r = e.r === 2 ? "evenodd" : "nonzero";
  return this.stylesList.push(r), i.style = r, i;
};
CVShapeElement.prototype.createGroupElement = function () {
  var e = {
    it: [],
    prevViewData: []
  };
  return e;
};
CVShapeElement.prototype.createTransformElement = function (e) {
  var t = {
    transform: {
      opacity: 1,
      _opMdf: !1,
      key: this.transformsManager.getNewKey(),
      op: PropertyFactory.getProp(this, e.o, 0, 0.01, this),
      mProps: TransformPropertyFactory.getTransformProperty(this, e, this)
    }
  };
  return t;
};
CVShapeElement.prototype.createShapeElement = function (e) {
  var t = new CVShapeData(this, e, this.stylesList, this.transformsManager);
  return this.shapes.push(t), this.addShapeToModifiers(t), t;
};
CVShapeElement.prototype.reloadShapes = function () {
  this._isFirstFrame = !0;
  var e,
    t = this.itemsData.length;
  for (e = 0; e < t; e += 1) this.prevViewData[e] = this.itemsData[e];
  for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), t = this.dynamicProperties.length, e = 0; e < t; e += 1) this.dynamicProperties[e].getValue();
  this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
};
CVShapeElement.prototype.addTransformToStyleList = function (e) {
  var t,
    r = this.stylesList.length;
  for (t = 0; t < r; t += 1) this.stylesList[t].closed || this.stylesList[t].transforms.push(e);
};
CVShapeElement.prototype.removeTransformFromStyleList = function () {
  var e,
    t = this.stylesList.length;
  for (e = 0; e < t; e += 1) this.stylesList[e].closed || this.stylesList[e].transforms.pop();
};
CVShapeElement.prototype.closeStyles = function (e) {
  var t,
    r = e.length;
  for (t = 0; t < r; t += 1) e[t].closed = !0;
};
CVShapeElement.prototype.searchShapes = function (e, t, r, i, a) {
  var n,
    u = e.length - 1,
    f,
    p,
    y = [],
    v = [],
    A,
    c,
    E,
    d = [].concat(a);
  for (n = u; n >= 0; n -= 1) {
    if (A = this.searchProcessedElement(e[n]), A ? t[n] = r[A - 1] : e[n]._shouldRender = i, e[n].ty === "fl" || e[n].ty === "st" || e[n].ty === "gf" || e[n].ty === "gs") A ? t[n].style.closed = !1 : t[n] = this.createStyleElement(e[n], d), y.push(t[n].style);else if (e[n].ty === "gr") {
      if (!A) t[n] = this.createGroupElement(e[n]);else for (p = t[n].it.length, f = 0; f < p; f += 1) t[n].prevViewData[f] = t[n].it[f];
      this.searchShapes(e[n].it, t[n].it, t[n].prevViewData, i, d);
    } else e[n].ty === "tr" ? (A || (E = this.createTransformElement(e[n]), t[n] = E), d.push(t[n]), this.addTransformToStyleList(t[n])) : e[n].ty === "sh" || e[n].ty === "rc" || e[n].ty === "el" || e[n].ty === "sr" ? A || (t[n] = this.createShapeElement(e[n])) : e[n].ty === "tm" || e[n].ty === "rd" || e[n].ty === "pb" ? (A ? (c = t[n], c.closed = !1) : (c = ShapeModifiers.getModifier(e[n].ty), c.init(this, e[n]), t[n] = c, this.shapeModifiers.push(c)), v.push(c)) : e[n].ty === "rp" && (A ? (c = t[n], c.closed = !0) : (c = ShapeModifiers.getModifier(e[n].ty), t[n] = c, c.init(this, e, n, t), this.shapeModifiers.push(c), i = !1), v.push(c));
    this.addProcessedElement(e[n], n + 1);
  }
  for (this.removeTransformFromStyleList(), this.closeStyles(y), u = v.length, n = 0; n < u; n += 1) v[n].closed = !0;
};
CVShapeElement.prototype.renderInnerContent = function () {
  this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
};
CVShapeElement.prototype.renderShapeTransform = function (e, t) {
  (e._opMdf || t.op._mdf || this._isFirstFrame) && (t.opacity = e.opacity, t.opacity *= t.op.v, t._opMdf = !0);
};
CVShapeElement.prototype.drawLayer = function () {
  var e,
    t = this.stylesList.length,
    r,
    i,
    a,
    n,
    u,
    f,
    p = this.globalData.renderer,
    y = this.globalData.canvasContext,
    v,
    A;
  for (e = 0; e < t; e += 1) if (A = this.stylesList[e], v = A.type, !((v === "st" || v === "gs") && A.wi === 0 || !A.data._shouldRender || A.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
    for (p.save(), u = A.elements, v === "st" || v === "gs" ? (y.strokeStyle = v === "st" ? A.co : A.grd, y.lineWidth = A.wi, y.lineCap = A.lc, y.lineJoin = A.lj, y.miterLimit = A.ml || 0) : y.fillStyle = v === "fl" ? A.co : A.grd, p.ctxOpacity(A.coOp), v !== "st" && v !== "gs" && y.beginPath(), p.ctxTransform(A.preTransforms.finalTransform.props), i = u.length, r = 0; r < i; r += 1) {
      for ((v === "st" || v === "gs") && (y.beginPath(), A.da && (y.setLineDash(A.da), y.lineDashOffset = A.do)), f = u[r].trNodes, n = f.length, a = 0; a < n; a += 1) f[a].t === "m" ? y.moveTo(f[a].p[0], f[a].p[1]) : f[a].t === "c" ? y.bezierCurveTo(f[a].pts[0], f[a].pts[1], f[a].pts[2], f[a].pts[3], f[a].pts[4], f[a].pts[5]) : y.closePath();
      (v === "st" || v === "gs") && (y.stroke(), A.da && y.setLineDash(this.dashResetter));
    }
    v !== "st" && v !== "gs" && y.fill(A.r), p.restore();
  }
};
CVShapeElement.prototype.renderShape = function (e, t, r, i) {
  var a,
    n = t.length - 1,
    u;
  for (u = e, a = n; a >= 0; a -= 1) t[a].ty === "tr" ? (u = r[a].transform, this.renderShapeTransform(e, u)) : t[a].ty === "sh" || t[a].ty === "el" || t[a].ty === "rc" || t[a].ty === "sr" ? this.renderPath(t[a], r[a]) : t[a].ty === "fl" ? this.renderFill(t[a], r[a], u) : t[a].ty === "st" ? this.renderStroke(t[a], r[a], u) : t[a].ty === "gf" || t[a].ty === "gs" ? this.renderGradientFill(t[a], r[a], u) : t[a].ty === "gr" ? this.renderShape(u, t[a].it, r[a].it) : t[a].ty;
  i && this.drawLayer();
};
CVShapeElement.prototype.renderStyledShape = function (e, t) {
  if (this._isFirstFrame || t._mdf || e.transforms._mdf) {
    var r = e.trNodes,
      i = t.paths,
      a,
      n,
      u,
      f = i._length;
    r.length = 0;
    var p = e.transforms.finalTransform;
    for (u = 0; u < f; u += 1) {
      var y = i.shapes[u];
      if (y && y.v) {
        for (n = y._length, a = 1; a < n; a += 1) a === 1 && r.push({
          t: "m",
          p: p.applyToPointArray(y.v[0][0], y.v[0][1], 0)
        }), r.push({
          t: "c",
          pts: p.applyToTriplePoints(y.o[a - 1], y.i[a], y.v[a])
        });
        n === 1 && r.push({
          t: "m",
          p: p.applyToPointArray(y.v[0][0], y.v[0][1], 0)
        }), y.c && n && (r.push({
          t: "c",
          pts: p.applyToTriplePoints(y.o[a - 1], y.i[0], y.v[0])
        }), r.push({
          t: "z"
        }));
      }
    }
    e.trNodes = r;
  }
};
CVShapeElement.prototype.renderPath = function (e, t) {
  if (e.hd !== !0 && e._shouldRender) {
    var r,
      i = t.styledShapes.length;
    for (r = 0; r < i; r += 1) this.renderStyledShape(t.styledShapes[r], t.sh);
  }
};
CVShapeElement.prototype.renderFill = function (e, t, r) {
  var i = t.style;
  (t.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(t.c.v[0]) + "," + bmFloor(t.c.v[1]) + "," + bmFloor(t.c.v[2]) + ")"), (t.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = t.o.v * r.opacity);
};
CVShapeElement.prototype.renderGradientFill = function (e, t, r) {
  var i = t.style,
    a;
  if (!i.grd || t.g._mdf || t.s._mdf || t.e._mdf || e.t !== 1 && (t.h._mdf || t.a._mdf)) {
    var n = this.globalData.canvasContext,
      u = t.s.v,
      f = t.e.v;
    if (e.t === 1) a = n.createLinearGradient(u[0], u[1], f[0], f[1]);else {
      var p = Math.sqrt(Math.pow(u[0] - f[0], 2) + Math.pow(u[1] - f[1], 2)),
        y = Math.atan2(f[1] - u[1], f[0] - u[0]),
        v = t.h.v;
      v >= 1 ? v = 0.99 : v <= -1 && (v = -0.99);
      var A = p * v,
        c = Math.cos(y + t.a.v) * A + u[0],
        E = Math.sin(y + t.a.v) * A + u[1];
      a = n.createRadialGradient(c, E, 0, u[0], u[1], p);
    }
    var d,
      g = e.g.p,
      I = t.g.c,
      o = 1;
    for (d = 0; d < g; d += 1) t.g._hasOpacity && t.g._collapsable && (o = t.g.o[d * 2 + 1]), a.addColorStop(I[d * 4] / 100, "rgba(" + I[d * 4 + 1] + "," + I[d * 4 + 2] + "," + I[d * 4 + 3] + "," + o + ")");
    i.grd = a;
  }
  i.coOp = t.o.v * r.opacity;
};
CVShapeElement.prototype.renderStroke = function (e, t, r) {
  var i = t.style,
    a = t.d;
  a && (a._mdf || this._isFirstFrame) && (i.da = a.dashArray, i.do = a.dashoffset[0]), (t.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(t.c.v[0]) + "," + bmFloor(t.c.v[1]) + "," + bmFloor(t.c.v[2]) + ")"), (t.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = t.o.v * r.opacity), (t.w._mdf || this._isFirstFrame) && (i.wi = t.w.v);
};
CVShapeElement.prototype.destroy = function () {
  this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
};
function CVTextElement(e, t, r) {
  this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
    fill: "rgba(0,0,0,0)",
    stroke: "rgba(0,0,0,0)",
    sWidth: 0,
    fValue: ""
  }, this.initElement(e, t, r);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement);
CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d");
CVTextElement.prototype.buildNewText = function () {
  var e = this.textProperty.currentData;
  this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
  var t = !1;
  e.fc ? (t = !0, this.values.fill = this.buildColor(e.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = t;
  var r = !1;
  e.sc && (r = !0, this.values.stroke = this.buildColor(e.sc), this.values.sWidth = e.sw);
  var i = this.globalData.fontManager.getFontByName(e.f),
    a,
    n,
    u = e.l,
    f = this.mHelper;
  this.stroke = r, this.values.fValue = e.finalSize + "px " + this.globalData.fontManager.getFontByName(e.f).fFamily, n = e.finalText.length;
  var p,
    y,
    v,
    A,
    c,
    E,
    d,
    g,
    I,
    o,
    s = this.data.singleShape,
    l = e.tr * 1e-3 * e.finalSize,
    h = 0,
    m = 0,
    S = !0,
    b = 0;
  for (a = 0; a < n; a += 1) {
    p = this.globalData.fontManager.getCharData(e.finalText[a], i.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily), y = p && p.data || {}, f.reset(), s && u[a].n && (h = -l, m += e.yOffset, m += S ? 1 : 0, S = !1), c = y.shapes ? y.shapes[0].it : [], d = c.length, f.scale(e.finalSize / 100, e.finalSize / 100), s && this.applyTextPropertiesToMatrix(e, f, u[a].line, h, m), I = createSizedArray(d - 1);
    var T = 0;
    for (E = 0; E < d; E += 1) if (c[E].ty === "sh") {
      for (A = c[E].ks.k.i.length, g = c[E].ks.k, o = [], v = 1; v < A; v += 1) v === 1 && o.push(f.applyToX(g.v[0][0], g.v[0][1], 0), f.applyToY(g.v[0][0], g.v[0][1], 0)), o.push(f.applyToX(g.o[v - 1][0], g.o[v - 1][1], 0), f.applyToY(g.o[v - 1][0], g.o[v - 1][1], 0), f.applyToX(g.i[v][0], g.i[v][1], 0), f.applyToY(g.i[v][0], g.i[v][1], 0), f.applyToX(g.v[v][0], g.v[v][1], 0), f.applyToY(g.v[v][0], g.v[v][1], 0));
      o.push(f.applyToX(g.o[v - 1][0], g.o[v - 1][1], 0), f.applyToY(g.o[v - 1][0], g.o[v - 1][1], 0), f.applyToX(g.i[0][0], g.i[0][1], 0), f.applyToY(g.i[0][0], g.i[0][1], 0), f.applyToX(g.v[0][0], g.v[0][1], 0), f.applyToY(g.v[0][0], g.v[0][1], 0)), I[T] = o, T += 1;
    }
    s && (h += u[a].l, h += l), this.textSpans[b] ? this.textSpans[b].elem = I : this.textSpans[b] = {
      elem: I
    }, b += 1;
  }
};
CVTextElement.prototype.renderInnerContent = function () {
  var e = this.canvasContext;
  e.font = this.values.fValue, e.lineCap = "butt", e.lineJoin = "miter", e.miterLimit = 4, this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
  var t,
    r,
    i,
    a,
    n,
    u,
    f = this.textAnimator.renderedLetters,
    p = this.textProperty.currentData.l;
  r = p.length;
  var y,
    v = null,
    A = null,
    c = null,
    E,
    d;
  for (t = 0; t < r; t += 1) if (!p[t].n) {
    if (y = f[t], y && (this.globalData.renderer.save(), this.globalData.renderer.ctxTransform(y.p), this.globalData.renderer.ctxOpacity(y.o)), this.fill) {
      for (y && y.fc ? v !== y.fc && (v = y.fc, e.fillStyle = y.fc) : v !== this.values.fill && (v = this.values.fill, e.fillStyle = this.values.fill), E = this.textSpans[t].elem, a = E.length, this.globalData.canvasContext.beginPath(), i = 0; i < a; i += 1) for (d = E[i], u = d.length, this.globalData.canvasContext.moveTo(d[0], d[1]), n = 2; n < u; n += 6) this.globalData.canvasContext.bezierCurveTo(d[n], d[n + 1], d[n + 2], d[n + 3], d[n + 4], d[n + 5]);
      this.globalData.canvasContext.closePath(), this.globalData.canvasContext.fill();
    }
    if (this.stroke) {
      for (y && y.sw ? c !== y.sw && (c = y.sw, e.lineWidth = y.sw) : c !== this.values.sWidth && (c = this.values.sWidth, e.lineWidth = this.values.sWidth), y && y.sc ? A !== y.sc && (A = y.sc, e.strokeStyle = y.sc) : A !== this.values.stroke && (A = this.values.stroke, e.strokeStyle = this.values.stroke), E = this.textSpans[t].elem, a = E.length, this.globalData.canvasContext.beginPath(), i = 0; i < a; i += 1) for (d = E[i], u = d.length, this.globalData.canvasContext.moveTo(d[0], d[1]), n = 2; n < u; n += 6) this.globalData.canvasContext.bezierCurveTo(d[n], d[n + 1], d[n + 2], d[n + 3], d[n + 4], d[n + 5]);
      this.globalData.canvasContext.closePath(), this.globalData.canvasContext.stroke();
    }
    y && this.globalData.renderer.restore();
  }
};
function CVImageElement(e, t, r) {
  this.assetData = t.getAssetData(e.refId), this.img = t.imageLoader.getAsset(this.assetData), this.initElement(e, t, r);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);
CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
CVImageElement.prototype.createContent = function () {
  if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
    var e = createTag("canvas");
    e.width = this.assetData.w, e.height = this.assetData.h;
    var t = e.getContext("2d"),
      r = this.img.width,
      i = this.img.height,
      a = r / i,
      n = this.assetData.w / this.assetData.h,
      u,
      f,
      p = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
    a > n && p === "xMidYMid slice" || a < n && p !== "xMidYMid slice" ? (f = i, u = f * n) : (u = r, f = u / n), t.drawImage(this.img, (r - u) / 2, (i - f) / 2, u, f, 0, 0, this.assetData.w, this.assetData.h), this.img = e;
  }
};
CVImageElement.prototype.renderInnerContent = function () {
  this.canvasContext.drawImage(this.img, 0, 0);
};
CVImageElement.prototype.destroy = function () {
  this.img = null;
};
function CVSolidElement(e, t, r) {
  this.initElement(e, t, r);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);
CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
CVSolidElement.prototype.renderInnerContent = function () {
  var e = this.canvasContext;
  e.fillStyle = this.data.sc, e.fillRect(0, 0, this.data.sw, this.data.sh);
};
function CanvasRendererBase(e, t) {
  this.animationItem = e, this.renderConfig = {
    clearCanvas: t && t.clearCanvas !== void 0 ? t.clearCanvas : !0,
    context: t && t.context || null,
    progressiveLoad: t && t.progressiveLoad || !1,
    preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet",
    imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
    contentVisibility: t && t.contentVisibility || "visible",
    className: t && t.className || "",
    id: t && t.id || ""
  }, this.renderConfig.dpr = t && t.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = t && t.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
    frameNum: -1,
    _mdf: !1,
    renderConfig: this.renderConfig,
    currentGlobalAlpha: -1
  }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas";
}
extendPrototype([BaseRenderer], CanvasRendererBase);
CanvasRendererBase.prototype.createShape = function (e) {
  return new CVShapeElement(e, this.globalData, this);
};
CanvasRendererBase.prototype.createText = function (e) {
  return new CVTextElement(e, this.globalData, this);
};
CanvasRendererBase.prototype.createImage = function (e) {
  return new CVImageElement(e, this.globalData, this);
};
CanvasRendererBase.prototype.createSolid = function (e) {
  return new CVSolidElement(e, this.globalData, this);
};
CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
CanvasRendererBase.prototype.ctxTransform = function (e) {
  if (!(e[0] === 1 && e[1] === 0 && e[4] === 0 && e[5] === 1 && e[12] === 0 && e[13] === 0)) {
    if (!this.renderConfig.clearCanvas) {
      this.canvasContext.transform(e[0], e[1], e[4], e[5], e[12], e[13]);
      return;
    }
    this.transformMat.cloneFromProps(e);
    var t = this.contextData.cTr.props;
    this.transformMat.transform(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]), this.contextData.cTr.cloneFromProps(this.transformMat.props);
    var r = this.contextData.cTr.props;
    this.canvasContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]);
  }
};
CanvasRendererBase.prototype.ctxOpacity = function (e) {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.globalAlpha *= e < 0 ? 0 : e, this.globalData.currentGlobalAlpha = this.contextData.cO;
    return;
  }
  this.contextData.cO *= e < 0 ? 0 : e, this.globalData.currentGlobalAlpha !== this.contextData.cO && (this.canvasContext.globalAlpha = this.contextData.cO, this.globalData.currentGlobalAlpha = this.contextData.cO);
};
CanvasRendererBase.prototype.reset = function () {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.restore();
    return;
  }
  this.contextData.reset();
};
CanvasRendererBase.prototype.save = function (e) {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.save();
    return;
  }
  e && this.canvasContext.save();
  var t = this.contextData.cTr.props;
  this.contextData._length <= this.contextData.cArrPos && this.contextData.duplicate();
  var r,
    i = this.contextData.saved[this.contextData.cArrPos];
  for (r = 0; r < 16; r += 1) i[r] = t[r];
  this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO, this.contextData.cArrPos += 1;
};
CanvasRendererBase.prototype.restore = function (e) {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.restore();
    return;
  }
  e && (this.canvasContext.restore(), this.globalData.blendMode = "source-over"), this.contextData.cArrPos -= 1;
  var t = this.contextData.saved[this.contextData.cArrPos],
    r,
    i = this.contextData.cTr.props;
  for (r = 0; r < 16; r += 1) i[r] = t[r];
  this.canvasContext.setTransform(t[0], t[1], t[4], t[5], t[12], t[13]), t = this.contextData.savedOp[this.contextData.cArrPos], this.contextData.cO = t, this.globalData.currentGlobalAlpha !== t && (this.canvasContext.globalAlpha = t, this.globalData.currentGlobalAlpha = t);
};
CanvasRendererBase.prototype.configAnimation = function (e) {
  if (this.animationItem.wrapper) {
    this.animationItem.container = createTag("canvas");
    var t = this.animationItem.container.style;
    t.width = "100%", t.height = "100%";
    var r = "0px 0px 0px";
    t.transformOrigin = r, t.mozTransformOrigin = r, t.webkitTransformOrigin = r, t["-webkit-transform"] = r, t.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
  } else this.canvasContext = this.renderConfig.context;
  this.data = e, this.layers = e.layers, this.transformCanvas = {
    w: e.w,
    h: e.h,
    sx: 0,
    sy: 0,
    tx: 0,
    ty: 0
  }, this.setupGlobalData(e, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(e.layers.length), this.updateContainerSize();
};
CanvasRendererBase.prototype.updateContainerSize = function () {
  this.reset();
  var e, t;
  this.animationItem.wrapper && this.animationItem.container ? (e = this.animationItem.wrapper.offsetWidth, t = this.animationItem.wrapper.offsetHeight, this.animationItem.container.setAttribute("width", e * this.renderConfig.dpr), this.animationItem.container.setAttribute("height", t * this.renderConfig.dpr)) : (e = this.canvasContext.canvas.width * this.renderConfig.dpr, t = this.canvasContext.canvas.height * this.renderConfig.dpr);
  var r, i;
  if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
    var a = this.renderConfig.preserveAspectRatio.split(" "),
      n = a[1] || "meet",
      u = a[0] || "xMidYMid",
      f = u.substr(0, 4),
      p = u.substr(4);
    r = e / t, i = this.transformCanvas.w / this.transformCanvas.h, i > r && n === "meet" || i < r && n === "slice" ? (this.transformCanvas.sx = e / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = e / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = t / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = t / (this.transformCanvas.h / this.renderConfig.dpr)), f === "xMid" && (i < r && n === "meet" || i > r && n === "slice") ? this.transformCanvas.tx = (e - this.transformCanvas.w * (t / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : f === "xMax" && (i < r && n === "meet" || i > r && n === "slice") ? this.transformCanvas.tx = (e - this.transformCanvas.w * (t / this.transformCanvas.h)) * this.renderConfig.dpr : this.transformCanvas.tx = 0, p === "YMid" && (i > r && n === "meet" || i < r && n === "slice") ? this.transformCanvas.ty = (t - this.transformCanvas.h * (e / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : p === "YMax" && (i > r && n === "meet" || i < r && n === "slice") ? this.transformCanvas.ty = (t - this.transformCanvas.h * (e / this.transformCanvas.w)) * this.renderConfig.dpr : this.transformCanvas.ty = 0;
  } else this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = e / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = t / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
  this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
};
CanvasRendererBase.prototype.destroy = function () {
  this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = "");
  var e,
    t = this.layers ? this.layers.length : 0;
  for (e = t - 1; e >= 0; e -= 1) this.elements[e] && this.elements[e].destroy();
  this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
};
CanvasRendererBase.prototype.renderFrame = function (e, t) {
  if (!(this.renderedFrame === e && this.renderConfig.clearCanvas === !0 && !t || this.destroyed || e === -1)) {
    this.renderedFrame = e, this.globalData.frameNum = e - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || t, this.globalData.projectInterface.currentFrame = e;
    var r,
      i = this.layers.length;
    for (this.completeLayers || this.checkLayers(e), r = 0; r < i; r += 1) (this.completeLayers || this.elements[r]) && this.elements[r].prepareFrame(e - this.layers[r].st);
    if (this.globalData._mdf) {
      for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), r = i - 1; r >= 0; r -= 1) (this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
      this.renderConfig.clearCanvas !== !0 && this.restore();
    }
  }
};
CanvasRendererBase.prototype.buildItem = function (e) {
  var t = this.elements;
  if (!(t[e] || this.layers[e].ty === 99)) {
    var r = this.createItem(this.layers[e], this, this.globalData);
    t[e] = r, r.initExpressions();
  }
};
CanvasRendererBase.prototype.checkPendingElements = function () {
  for (; this.pendingElements.length;) {
    var e = this.pendingElements.pop();
    e.checkParenting();
  }
};
CanvasRendererBase.prototype.hide = function () {
  this.animationItem.container.style.display = "none";
};
CanvasRendererBase.prototype.show = function () {
  this.animationItem.container.style.display = "block";
};
function CVCompElement(e, t, r) {
  this.completeLayers = !1, this.layers = e.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(e, t, r), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
    _placeholder: !0
  };
}
extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement);
CVCompElement.prototype.renderInnerContent = function () {
  var e = this.canvasContext;
  e.beginPath(), e.moveTo(0, 0), e.lineTo(this.data.w, 0), e.lineTo(this.data.w, this.data.h), e.lineTo(0, this.data.h), e.lineTo(0, 0), e.clip();
  var t,
    r = this.layers.length;
  for (t = r - 1; t >= 0; t -= 1) (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
};
CVCompElement.prototype.destroy = function () {
  var e,
    t = this.layers.length;
  for (e = t - 1; e >= 0; e -= 1) this.elements[e] && this.elements[e].destroy();
  this.layers = null, this.elements = null;
};
CVCompElement.prototype.createComp = function (e) {
  return new CVCompElement(e, this.globalData, this);
};
function CanvasRenderer(e, t) {
  this.animationItem = e, this.renderConfig = {
    clearCanvas: t && t.clearCanvas !== void 0 ? t.clearCanvas : !0,
    context: t && t.context || null,
    progressiveLoad: t && t.progressiveLoad || !1,
    preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet",
    imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
    contentVisibility: t && t.contentVisibility || "visible",
    className: t && t.className || "",
    id: t && t.id || ""
  }, this.renderConfig.dpr = t && t.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = t && t.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
    frameNum: -1,
    _mdf: !1,
    renderConfig: this.renderConfig,
    currentGlobalAlpha: -1
  }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas";
}
extendPrototype([CanvasRendererBase], CanvasRenderer);
CanvasRenderer.prototype.createComp = function (e) {
  return new CVCompElement(e, this.globalData, this);
};
registerRenderer("canvas", CanvasRenderer);
ShapeModifiers.registerModifier("tm", TrimModifier);
ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier);
ShapeModifiers.registerModifier("rp", RepeaterModifier);
ShapeModifiers.registerModifier("rd", RoundCornersModifier);
const Expressions = function () {
  var e = {};
  e.initExpressions = t;
  function t(r) {
    var i = 0,
      a = [];
    function n() {
      i += 1;
    }
    function u() {
      i -= 1, i === 0 && p();
    }
    function f(y) {
      a.indexOf(y) === -1 && a.push(y);
    }
    function p() {
      var y,
        v = a.length;
      for (y = 0; y < v; y += 1) a[y].release();
      a.length = 0;
    }
    r.renderer.compInterface = CompExpressionInterface(r.renderer), r.renderer.globalData.projectInterface.registerComposition(r.renderer), r.renderer.globalData.pushExpression = n, r.renderer.globalData.popExpression = u, r.renderer.globalData.registerExpressionProperty = f;
  }
  return e;
}();
function seedRandom(e, t) {
  var r = this,
    i = 256,
    a = 6,
    n = 52,
    u = "random",
    f = t.pow(i, a),
    p = t.pow(2, n),
    y = p * 2,
    v = i - 1,
    A;
  function c(l, h, m) {
    var S = [];
    h = h === !0 ? {
      entropy: !0
    } : h || {};
    var b = I(g(h.entropy ? [l, s(e)] : l === null ? o() : l, 3), S),
      T = new E(S),
      C = function () {
        for (var F = T.g(a), w = f, k = 0; F < p;) F = (F + k) * i, w *= i, k = T.g(1);
        for (; F >= y;) F /= 2, w /= 2, k >>>= 1;
        return (F + k) / w;
      };
    return C.int32 = function () {
      return T.g(4) | 0;
    }, C.quick = function () {
      return T.g(4) / 4294967296;
    }, C.double = C, I(s(T.S), e), (h.pass || m || function (F, w, k, L) {
      return L && (L.S && d(L, T), F.state = function () {
        return d(T, {});
      }), k ? (t[u] = F, w) : F;
    })(C, b, "global" in h ? h.global : this == t, h.state);
  }
  t["seed" + u] = c;
  function E(l) {
    var h,
      m = l.length,
      S = this,
      b = 0,
      T = S.i = S.j = 0,
      C = S.S = [];
    for (m || (l = [m++]); b < i;) C[b] = b++;
    for (b = 0; b < i; b++) C[b] = C[T = v & T + l[b % m] + (h = C[b])], C[T] = h;
    S.g = function (F) {
      for (var w, k = 0, L = S.i, B = S.j, x = S.S; F--;) w = x[L = v & L + 1], k = k * i + x[v & (x[L] = x[B = v & B + w]) + (x[B] = w)];
      return S.i = L, S.j = B, k;
    };
  }
  function d(l, h) {
    return h.i = l.i, h.j = l.j, h.S = l.S.slice(), h;
  }
  function g(l, h) {
    var m = [],
      S = typeof l,
      b;
    if (h && S == "object") for (b in l) try {
      m.push(g(l[b], h - 1));
    } catch {}
    return m.length ? m : S == "string" ? l : l + "\0";
  }
  function I(l, h) {
    for (var m = l + "", S, b = 0; b < m.length;) h[v & b] = v & (S ^= h[v & b] * 19) + m.charCodeAt(b++);
    return s(h);
  }
  function o() {
    try {
      var l = new Uint8Array(i);
      return (r.crypto || r.msCrypto).getRandomValues(l), s(l);
    } catch {
      var h = r.navigator,
        m = h && h.plugins;
      return [+new Date(), r, m, r.screen, s(e)];
    }
  }
  function s(l) {
    return String.fromCharCode.apply(0, l);
  }
  I(t.random(), e);
}
function initialize$2(e) {
  seedRandom([], e);
}
var propTypes = {
  SHAPE: "shape"
};
const ExpressionManager = function () {
    var ob = {},
      Math = BMMath,
      window = null,
      document = null,
      XMLHttpRequest = null,
      fetch = null,
      frames = null;
    initialize$2(BMMath);
    function $bm_isInstanceOfArray(e) {
      return e.constructor === Array || e.constructor === Float32Array;
    }
    function isNumerable(e, t) {
      return e === "number" || e === "boolean" || e === "string" || t instanceof Number;
    }
    function $bm_neg(e) {
      var t = typeof e;
      if (t === "number" || t === "boolean" || e instanceof Number) return -e;
      if ($bm_isInstanceOfArray(e)) {
        var r,
          i = e.length,
          a = [];
        for (r = 0; r < i; r += 1) a[r] = -e[r];
        return a;
      }
      return e.propType ? e.v : -e;
    }
    var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get,
      easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get,
      easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
    function sum(e, t) {
      var r = typeof e,
        i = typeof t;
      if (r === "string" || i === "string" || isNumerable(r, e) && isNumerable(i, t)) return e + t;
      if ($bm_isInstanceOfArray(e) && isNumerable(i, t)) return e = e.slice(0), e[0] += t, e;
      if (isNumerable(r, e) && $bm_isInstanceOfArray(t)) return t = t.slice(0), t[0] = e + t[0], t;
      if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(t)) {
        for (var a = 0, n = e.length, u = t.length, f = []; a < n || a < u;) (typeof e[a] == "number" || e[a] instanceof Number) && (typeof t[a] == "number" || t[a] instanceof Number) ? f[a] = e[a] + t[a] : f[a] = t[a] === void 0 ? e[a] : e[a] || t[a], a += 1;
        return f;
      }
      return 0;
    }
    var add = sum;
    function sub(e, t) {
      var r = typeof e,
        i = typeof t;
      if (isNumerable(r, e) && isNumerable(i, t)) return r === "string" && (e = parseInt(e, 10)), i === "string" && (t = parseInt(t, 10)), e - t;
      if ($bm_isInstanceOfArray(e) && isNumerable(i, t)) return e = e.slice(0), e[0] -= t, e;
      if (isNumerable(r, e) && $bm_isInstanceOfArray(t)) return t = t.slice(0), t[0] = e - t[0], t;
      if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(t)) {
        for (var a = 0, n = e.length, u = t.length, f = []; a < n || a < u;) (typeof e[a] == "number" || e[a] instanceof Number) && (typeof t[a] == "number" || t[a] instanceof Number) ? f[a] = e[a] - t[a] : f[a] = t[a] === void 0 ? e[a] : e[a] || t[a], a += 1;
        return f;
      }
      return 0;
    }
    function mul(e, t) {
      var r = typeof e,
        i = typeof t,
        a;
      if (isNumerable(r, e) && isNumerable(i, t)) return e * t;
      var n, u;
      if ($bm_isInstanceOfArray(e) && isNumerable(i, t)) {
        for (u = e.length, a = createTypedArray("float32", u), n = 0; n < u; n += 1) a[n] = e[n] * t;
        return a;
      }
      if (isNumerable(r, e) && $bm_isInstanceOfArray(t)) {
        for (u = t.length, a = createTypedArray("float32", u), n = 0; n < u; n += 1) a[n] = e * t[n];
        return a;
      }
      return 0;
    }
    function div(e, t) {
      var r = typeof e,
        i = typeof t,
        a;
      if (isNumerable(r, e) && isNumerable(i, t)) return e / t;
      var n, u;
      if ($bm_isInstanceOfArray(e) && isNumerable(i, t)) {
        for (u = e.length, a = createTypedArray("float32", u), n = 0; n < u; n += 1) a[n] = e[n] / t;
        return a;
      }
      if (isNumerable(r, e) && $bm_isInstanceOfArray(t)) {
        for (u = t.length, a = createTypedArray("float32", u), n = 0; n < u; n += 1) a[n] = e / t[n];
        return a;
      }
      return 0;
    }
    function mod(e, t) {
      return typeof e == "string" && (e = parseInt(e, 10)), typeof t == "string" && (t = parseInt(t, 10)), e % t;
    }
    var $bm_sum = sum,
      $bm_sub = sub,
      $bm_mul = mul,
      $bm_div = div,
      $bm_mod = mod;
    function clamp(e, t, r) {
      if (t > r) {
        var i = r;
        r = t, t = i;
      }
      return Math.min(Math.max(e, t), r);
    }
    function radiansToDegrees(e) {
      return e / degToRads;
    }
    var radians_to_degrees = radiansToDegrees;
    function degreesToRadians(e) {
      return e * degToRads;
    }
    var degrees_to_radians = radiansToDegrees,
      helperLengthArray = [0, 0, 0, 0, 0, 0];
    function length(e, t) {
      if (typeof e == "number" || e instanceof Number) return t = t || 0, Math.abs(e - t);
      t || (t = helperLengthArray);
      var r,
        i = Math.min(e.length, t.length),
        a = 0;
      for (r = 0; r < i; r += 1) a += Math.pow(t[r] - e[r], 2);
      return Math.sqrt(a);
    }
    function normalize(e) {
      return div(e, length(e));
    }
    function rgbToHsl(e) {
      var t = e[0],
        r = e[1],
        i = e[2],
        a = Math.max(t, r, i),
        n = Math.min(t, r, i),
        u,
        f,
        p = (a + n) / 2;
      if (a === n) u = 0, f = 0;else {
        var y = a - n;
        switch (f = p > 0.5 ? y / (2 - a - n) : y / (a + n), a) {
          case t:
            u = (r - i) / y + (r < i ? 6 : 0);
            break;
          case r:
            u = (i - t) / y + 2;
            break;
          case i:
            u = (t - r) / y + 4;
            break;
        }
        u /= 6;
      }
      return [u, f, p, e[3]];
    }
    function hue2rgb(e, t, r) {
      return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + (t - e) * 6 * r : r < 1 / 2 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
    }
    function hslToRgb(e) {
      var t = e[0],
        r = e[1],
        i = e[2],
        a,
        n,
        u;
      if (r === 0) a = i, u = i, n = i;else {
        var f = i < 0.5 ? i * (1 + r) : i + r - i * r,
          p = 2 * i - f;
        a = hue2rgb(p, f, t + 1 / 3), n = hue2rgb(p, f, t), u = hue2rgb(p, f, t - 1 / 3);
      }
      return [a, n, u, e[3]];
    }
    function linear(e, t, r, i, a) {
      if ((i === void 0 || a === void 0) && (i = t, a = r, t = 0, r = 1), r < t) {
        var n = r;
        r = t, t = n;
      }
      if (e <= t) return i;
      if (e >= r) return a;
      var u = r === t ? 0 : (e - t) / (r - t);
      if (!i.length) return i + (a - i) * u;
      var f,
        p = i.length,
        y = createTypedArray("float32", p);
      for (f = 0; f < p; f += 1) y[f] = i[f] + (a[f] - i[f]) * u;
      return y;
    }
    function random(e, t) {
      if (t === void 0 && (e === void 0 ? (e = 0, t = 1) : (t = e, e = void 0)), t.length) {
        var r,
          i = t.length;
        e || (e = createTypedArray("float32", i));
        var a = createTypedArray("float32", i),
          n = BMMath.random();
        for (r = 0; r < i; r += 1) a[r] = e[r] + n * (t[r] - e[r]);
        return a;
      }
      e === void 0 && (e = 0);
      var u = BMMath.random();
      return e + u * (t - e);
    }
    function createPath(e, t, r, i) {
      var a,
        n = e.length,
        u = shapePool.newElement();
      u.setPathData(!!i, n);
      var f = [0, 0],
        p,
        y;
      for (a = 0; a < n; a += 1) p = t && t[a] ? t[a] : f, y = r && r[a] ? r[a] : f, u.setTripleAt(e[a][0], e[a][1], y[0] + e[a][0], y[1] + e[a][1], p[0] + e[a][0], p[1] + e[a][1], a, !0);
      return u;
    }
    function initiateExpression(elem, data, property) {
      var val = data.x,
        needsVelocity = /velocity(?![\w\d])/.test(val),
        _needsRandom = val.indexOf("random") !== -1,
        elemType = elem.data.ty,
        transform,
        $bm_transform,
        content,
        effect,
        thisProperty = property;
      thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
        get: function () {
          return thisProperty.v;
        }
      }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
      var inPoint = elem.data.ip / elem.comp.globalData.frameRate,
        outPoint = elem.data.op / elem.comp.globalData.frameRate,
        width = elem.data.sw ? elem.data.sw : 0,
        height = elem.data.sh ? elem.data.sh : 0,
        name = elem.data.nm,
        loopIn,
        loop_in,
        loopOut,
        loop_out,
        smooth,
        toWorld,
        fromWorld,
        fromComp,
        toComp,
        fromCompToSurface,
        position,
        rotation,
        anchorPoint,
        scale,
        thisLayer,
        thisComp,
        mask,
        valueAtTime,
        velocityAtTime,
        scoped_bm_rt,
        expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0],
        numKeys = property.kf ? data.k.length : 0,
        active = !this.data || this.data.hd !== !0,
        wiggle = function e(t, r) {
          var i,
            a,
            n = this.pv.length ? this.pv.length : 1,
            u = createTypedArray("float32", n);
          t = 5;
          var f = Math.floor(time * t);
          for (i = 0, a = 0; i < f;) {
            for (a = 0; a < n; a += 1) u[a] += -r + r * 2 * BMMath.random();
            i += 1;
          }
          var p = time * t,
            y = p - Math.floor(p),
            v = createTypedArray("float32", n);
          if (n > 1) {
            for (a = 0; a < n; a += 1) v[a] = this.pv[a] + u[a] + (-r + r * 2 * BMMath.random()) * y;
            return v;
          }
          return this.pv + u[0] + (-r + r * 2 * BMMath.random()) * y;
        }.bind(this);
      thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty));
      function loopInDuration(e, t) {
        return loopIn(e, t, !0);
      }
      function loopOutDuration(e, t) {
        return loopOut(e, t, !0);
      }
      this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
      var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
      function lookAt(e, t) {
        var r = [t[0] - e[0], t[1] - e[1], t[2] - e[2]],
          i = Math.atan2(r[0], Math.sqrt(r[1] * r[1] + r[2] * r[2])) / degToRads,
          a = -Math.atan2(r[1], r[2]) / degToRads;
        return [a, i, 0];
      }
      function easeOut(e, t, r, i, a) {
        return applyEase(easeOutBez, e, t, r, i, a);
      }
      function easeIn(e, t, r, i, a) {
        return applyEase(easeInBez, e, t, r, i, a);
      }
      function ease(e, t, r, i, a) {
        return applyEase(easeInOutBez, e, t, r, i, a);
      }
      function applyEase(e, t, r, i, a, n) {
        a === void 0 ? (a = r, n = i) : t = (t - r) / (i - r), t > 1 ? t = 1 : t < 0 && (t = 0);
        var u = e(t);
        if ($bm_isInstanceOfArray(a)) {
          var f,
            p = a.length,
            y = createTypedArray("float32", p);
          for (f = 0; f < p; f += 1) y[f] = (n[f] - a[f]) * u + a[f];
          return y;
        }
        return (n - a) * u + a;
      }
      function nearestKey(e) {
        var t,
          r = data.k.length,
          i,
          a;
        if (!data.k.length || typeof data.k[0] == "number") i = 0, a = 0;else if (i = -1, e *= elem.comp.globalData.frameRate, e < data.k[0].t) i = 1, a = data.k[0].t;else {
          for (t = 0; t < r - 1; t += 1) if (e === data.k[t].t) {
            i = t + 1, a = data.k[t].t;
            break;
          } else if (e > data.k[t].t && e < data.k[t + 1].t) {
            e - data.k[t].t > data.k[t + 1].t - e ? (i = t + 2, a = data.k[t + 1].t) : (i = t + 1, a = data.k[t].t);
            break;
          }
          i === -1 && (i = t + 1, a = data.k[t].t);
        }
        var n = {};
        return n.index = i, n.time = a / elem.comp.globalData.frameRate, n;
      }
      function key(e) {
        var t, r, i;
        if (!data.k.length || typeof data.k[0] == "number") throw new Error("The property has no keyframe at index " + e);
        e -= 1, t = {
          time: data.k[e].t / elem.comp.globalData.frameRate,
          value: []
        };
        var a = Object.prototype.hasOwnProperty.call(data.k[e], "s") ? data.k[e].s : data.k[e - 1].e;
        for (i = a.length, r = 0; r < i; r += 1) t[r] = a[r], t.value[r] = a[r];
        return t;
      }
      function framesToTime(e, t) {
        return t || (t = elem.comp.globalData.frameRate), e / t;
      }
      function timeToFrames(e, t) {
        return !e && e !== 0 && (e = time), t || (t = elem.comp.globalData.frameRate), e * t;
      }
      function seedRandom(e) {
        BMMath.seedrandom(randSeed + e);
      }
      function sourceRectAtTime() {
        return elem.sourceRectAtTime();
      }
      function substring(e, t) {
        return typeof value == "string" ? t === void 0 ? value.substring(e) : value.substring(e, t) : "";
      }
      function substr(e, t) {
        return typeof value == "string" ? t === void 0 ? value.substr(e) : value.substr(e, t) : "";
      }
      function posterizeTime(e) {
        time = e === 0 ? 0 : Math.floor(time * e) / e, value = valueAtTime(time);
      }
      var time,
        velocity,
        value,
        text,
        textIndex,
        textTotal,
        selectorValue,
        index = elem.data.ind,
        hasParent = !!(elem.hierarchy && elem.hierarchy.length),
        parent,
        randSeed = Math.floor(Math.random() * 1e6),
        globalData = elem.globalData;
      function executeExpression(e) {
        return value = e, this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), elemType === 4 && !content && (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), hasParent = !!(elem.hierarchy && elem.hierarchy.length), hasParent && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt, scoped_bm_rt);
      }
      return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData], executeExpression;
    }
    return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath], ob;
  }(),
  expressionHelpers = function () {
    function e(u, f, p) {
      f.x && (p.k = !0, p.x = !0, p.initiateExpression = ExpressionManager.initiateExpression, p.effectsSequence.push(p.initiateExpression(u, f, p).bind(p)));
    }
    function t(u) {
      return u *= this.elem.globalData.frameRate, u -= this.offsetTime, u !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < u ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(u, this._cachingAtTime), this._cachingAtTime.lastFrame = u), this._cachingAtTime.value;
    }
    function r(u) {
      var f = -0.01,
        p = this.getValueAtTime(u),
        y = this.getValueAtTime(u + f),
        v = 0;
      if (p.length) {
        var A;
        for (A = 0; A < p.length; A += 1) v += Math.pow(y[A] - p[A], 2);
        v = Math.sqrt(v) * 100;
      } else v = 0;
      return v;
    }
    function i(u) {
      if (this.vel !== void 0) return this.vel;
      var f = -1e-3,
        p = this.getValueAtTime(u),
        y = this.getValueAtTime(u + f),
        v;
      if (p.length) {
        v = createTypedArray("float32", p.length);
        var A;
        for (A = 0; A < p.length; A += 1) v[A] = (y[A] - p[A]) / f;
      } else v = (y - p) / f;
      return v;
    }
    function a() {
      return this.pv;
    }
    function n(u) {
      this.propertyGroup = u;
    }
    return {
      searchExpressions: e,
      getSpeedAtTime: r,
      getVelocityAtTime: i,
      getValueAtTime: t,
      getStaticValueAtTime: a,
      setGroupProperty: n
    };
  }();
function addPropertyDecorator() {
  function e(c, E, d) {
    if (!this.k || !this.keyframes) return this.pv;
    c = c ? c.toLowerCase() : "";
    var g = this.comp.renderedFrame,
      I = this.keyframes,
      o = I[I.length - 1].t;
    if (g <= o) return this.pv;
    var s, l;
    d ? (E ? s = Math.abs(o - this.elem.comp.globalData.frameRate * E) : s = Math.max(0, o - this.elem.data.ip), l = o - s) : ((!E || E > I.length - 1) && (E = I.length - 1), l = I[I.length - 1 - E].t, s = o - l);
    var h, m, S;
    if (c === "pingpong") {
      var b = Math.floor((g - l) / s);
      if (b % 2 !== 0) return this.getValueAtTime((s - (g - l) % s + l) / this.comp.globalData.frameRate, 0);
    } else if (c === "offset") {
      var T = this.getValueAtTime(l / this.comp.globalData.frameRate, 0),
        C = this.getValueAtTime(o / this.comp.globalData.frameRate, 0),
        F = this.getValueAtTime(((g - l) % s + l) / this.comp.globalData.frameRate, 0),
        w = Math.floor((g - l) / s);
      if (this.pv.length) {
        for (S = new Array(T.length), m = S.length, h = 0; h < m; h += 1) S[h] = (C[h] - T[h]) * w + F[h];
        return S;
      }
      return (C - T) * w + F;
    } else if (c === "continue") {
      var k = this.getValueAtTime(o / this.comp.globalData.frameRate, 0),
        L = this.getValueAtTime((o - 1e-3) / this.comp.globalData.frameRate, 0);
      if (this.pv.length) {
        for (S = new Array(k.length), m = S.length, h = 0; h < m; h += 1) S[h] = k[h] + (k[h] - L[h]) * ((g - o) / this.comp.globalData.frameRate) / 5e-4;
        return S;
      }
      return k + (k - L) * ((g - o) / 1e-3);
    }
    return this.getValueAtTime(((g - l) % s + l) / this.comp.globalData.frameRate, 0);
  }
  function t(c, E, d) {
    if (!this.k) return this.pv;
    c = c ? c.toLowerCase() : "";
    var g = this.comp.renderedFrame,
      I = this.keyframes,
      o = I[0].t;
    if (g >= o) return this.pv;
    var s, l;
    d ? (E ? s = Math.abs(this.elem.comp.globalData.frameRate * E) : s = Math.max(0, this.elem.data.op - o), l = o + s) : ((!E || E > I.length - 1) && (E = I.length - 1), l = I[E].t, s = l - o);
    var h, m, S;
    if (c === "pingpong") {
      var b = Math.floor((o - g) / s);
      if (b % 2 === 0) return this.getValueAtTime(((o - g) % s + o) / this.comp.globalData.frameRate, 0);
    } else if (c === "offset") {
      var T = this.getValueAtTime(o / this.comp.globalData.frameRate, 0),
        C = this.getValueAtTime(l / this.comp.globalData.frameRate, 0),
        F = this.getValueAtTime((s - (o - g) % s + o) / this.comp.globalData.frameRate, 0),
        w = Math.floor((o - g) / s) + 1;
      if (this.pv.length) {
        for (S = new Array(T.length), m = S.length, h = 0; h < m; h += 1) S[h] = F[h] - (C[h] - T[h]) * w;
        return S;
      }
      return F - (C - T) * w;
    } else if (c === "continue") {
      var k = this.getValueAtTime(o / this.comp.globalData.frameRate, 0),
        L = this.getValueAtTime((o + 1e-3) / this.comp.globalData.frameRate, 0);
      if (this.pv.length) {
        for (S = new Array(k.length), m = S.length, h = 0; h < m; h += 1) S[h] = k[h] + (k[h] - L[h]) * (o - g) / 1e-3;
        return S;
      }
      return k + (k - L) * (o - g) / 1e-3;
    }
    return this.getValueAtTime((s - ((o - g) % s + o)) / this.comp.globalData.frameRate, 0);
  }
  function r(c, E) {
    if (!this.k) return this.pv;
    if (c = (c || 0.4) * 0.5, E = Math.floor(E || 5), E <= 1) return this.pv;
    var d = this.comp.renderedFrame / this.comp.globalData.frameRate,
      g = d - c,
      I = d + c,
      o = E > 1 ? (I - g) / (E - 1) : 1,
      s = 0,
      l = 0,
      h;
    this.pv.length ? h = createTypedArray("float32", this.pv.length) : h = 0;
    for (var m; s < E;) {
      if (m = this.getValueAtTime(g + s * o), this.pv.length) for (l = 0; l < this.pv.length; l += 1) h[l] += m[l];else h += m;
      s += 1;
    }
    if (this.pv.length) for (l = 0; l < this.pv.length; l += 1) h[l] /= E;else h /= E;
    return h;
  }
  function i(c) {
    this._transformCachingAtTime || (this._transformCachingAtTime = {
      v: new Matrix()
    });
    var E = this._transformCachingAtTime.v;
    if (E.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
      var d = this.a.getValueAtTime(c);
      E.translate(-d[0] * this.a.mult, -d[1] * this.a.mult, d[2] * this.a.mult);
    }
    if (this.appliedTransformations < 2) {
      var g = this.s.getValueAtTime(c);
      E.scale(g[0] * this.s.mult, g[1] * this.s.mult, g[2] * this.s.mult);
    }
    if (this.sk && this.appliedTransformations < 3) {
      var I = this.sk.getValueAtTime(c),
        o = this.sa.getValueAtTime(c);
      E.skewFromAxis(-I * this.sk.mult, o * this.sa.mult);
    }
    if (this.r && this.appliedTransformations < 4) {
      var s = this.r.getValueAtTime(c);
      E.rotate(-s * this.r.mult);
    } else if (!this.r && this.appliedTransformations < 4) {
      var l = this.rz.getValueAtTime(c),
        h = this.ry.getValueAtTime(c),
        m = this.rx.getValueAtTime(c),
        S = this.or.getValueAtTime(c);
      E.rotateZ(-l * this.rz.mult).rotateY(h * this.ry.mult).rotateX(m * this.rx.mult).rotateZ(-S[2] * this.or.mult).rotateY(S[1] * this.or.mult).rotateX(S[0] * this.or.mult);
    }
    if (this.data.p && this.data.p.s) {
      var b = this.px.getValueAtTime(c),
        T = this.py.getValueAtTime(c);
      if (this.data.p.z) {
        var C = this.pz.getValueAtTime(c);
        E.translate(b * this.px.mult, T * this.py.mult, -C * this.pz.mult);
      } else E.translate(b * this.px.mult, T * this.py.mult, 0);
    } else {
      var F = this.p.getValueAtTime(c);
      E.translate(F[0] * this.p.mult, F[1] * this.p.mult, -F[2] * this.p.mult);
    }
    return E;
  }
  function a() {
    return this.v.clone(new Matrix());
  }
  var n = TransformPropertyFactory.getTransformProperty;
  TransformPropertyFactory.getTransformProperty = function (c, E, d) {
    var g = n(c, E, d);
    return g.dynamicProperties.length ? g.getValueAtTime = i.bind(g) : g.getValueAtTime = a.bind(g), g.setGroupProperty = expressionHelpers.setGroupProperty, g;
  };
  var u = PropertyFactory.getProp;
  PropertyFactory.getProp = function (c, E, d, g, I) {
    var o = u(c, E, d, g, I);
    o.kf ? o.getValueAtTime = expressionHelpers.getValueAtTime.bind(o) : o.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(o), o.setGroupProperty = expressionHelpers.setGroupProperty, o.loopOut = e, o.loopIn = t, o.smooth = r, o.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(o), o.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(o), o.numKeys = E.a === 1 ? E.k.length : 0, o.propertyIndex = E.ix;
    var s = 0;
    return d !== 0 && (s = createTypedArray("float32", E.a === 1 ? E.k[0].s.length : E.k.length)), o._cachingAtTime = {
      lastFrame: initialDefaultFrame,
      lastIndex: 0,
      value: s
    }, expressionHelpers.searchExpressions(c, E, o), o.k && I.addDynamicProperty(o), o;
  };
  function f(c) {
    return this._cachingAtTime || (this._cachingAtTime = {
      shapeValue: shapePool.clone(this.pv),
      lastIndex: 0,
      lastTime: initialDefaultFrame
    }), c *= this.elem.globalData.frameRate, c -= this.offsetTime, c !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < c ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = c, this.interpolateShape(c, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
  }
  var p = ShapePropertyFactory.getConstructorFunction(),
    y = ShapePropertyFactory.getKeyframedConstructorFunction();
  function v() {}
  v.prototype = {
    vertices: function (c, E) {
      this.k && this.getValue();
      var d = this.v;
      E !== void 0 && (d = this.getValueAtTime(E, 0));
      var g,
        I = d._length,
        o = d[c],
        s = d.v,
        l = createSizedArray(I);
      for (g = 0; g < I; g += 1) c === "i" || c === "o" ? l[g] = [o[g][0] - s[g][0], o[g][1] - s[g][1]] : l[g] = [o[g][0], o[g][1]];
      return l;
    },
    points: function (c) {
      return this.vertices("v", c);
    },
    inTangents: function (c) {
      return this.vertices("i", c);
    },
    outTangents: function (c) {
      return this.vertices("o", c);
    },
    isClosed: function () {
      return this.v.c;
    },
    pointOnPath: function (c, E) {
      var d = this.v;
      E !== void 0 && (d = this.getValueAtTime(E, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(d));
      for (var g = this._segmentsLength, I = g.lengths, o = g.totalLength * c, s = 0, l = I.length, h = 0, m; s < l;) {
        if (h + I[s].addedLength > o) {
          var S = s,
            b = d.c && s === l - 1 ? 0 : s + 1,
            T = (o - h) / I[s].addedLength;
          m = bez.getPointInSegment(d.v[S], d.v[b], d.o[S], d.i[b], T, I[s]);
          break;
        } else h += I[s].addedLength;
        s += 1;
      }
      return m || (m = d.c ? [d.v[0][0], d.v[0][1]] : [d.v[d._length - 1][0], d.v[d._length - 1][1]]), m;
    },
    vectorOnPath: function (c, E, d) {
      c == 1 ? c = this.v.c : c == 0 && (c = 0.999);
      var g = this.pointOnPath(c, E),
        I = this.pointOnPath(c + 1e-3, E),
        o = I[0] - g[0],
        s = I[1] - g[1],
        l = Math.sqrt(Math.pow(o, 2) + Math.pow(s, 2));
      if (l === 0) return [0, 0];
      var h = d === "tangent" ? [o / l, s / l] : [-s / l, o / l];
      return h;
    },
    tangentOnPath: function (c, E) {
      return this.vectorOnPath(c, E, "tangent");
    },
    normalOnPath: function (c, E) {
      return this.vectorOnPath(c, E, "normal");
    },
    setGroupProperty: expressionHelpers.setGroupProperty,
    getValueAtTime: expressionHelpers.getStaticValueAtTime
  }, extendPrototype([v], p), extendPrototype([v], y), y.prototype.getValueAtTime = f, y.prototype.initiateExpression = ExpressionManager.initiateExpression;
  var A = ShapePropertyFactory.getShapeProp;
  ShapePropertyFactory.getShapeProp = function (c, E, d, g, I) {
    var o = A(c, E, d, g, I);
    return o.propertyIndex = E.ix, o.lock = !1, d === 3 ? expressionHelpers.searchExpressions(c, E.pt, o) : d === 4 && expressionHelpers.searchExpressions(c, E.ks, o), o.k && c.addDynamicProperty(o), o;
  };
}
function initialize$1() {
  addPropertyDecorator();
}
function addDecorator() {
  function e() {
    return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
  }
  TextProperty.prototype.getExpressionValue = function (t, r) {
    var i = this.calculateExpression(r);
    if (t.t !== i) {
      var a = {};
      return this.copyData(a, t), a.t = i.toString(), a.__complete = !1, a;
    }
    return t;
  }, TextProperty.prototype.searchProperty = function () {
    var t = this.searchKeyframes(),
      r = this.searchExpressions();
    return this.kf = t || r, this.kf;
  }, TextProperty.prototype.searchExpressions = e;
}
function initialize() {
  addDecorator();
}
setExpressionsPlugin(Expressions);
initialize$1();
initialize();
class LottieLoader extends Loader {
  setQuality(t) {
    this._quality = t;
  }
  load(t, r, i, a) {
    const n = this._quality || 1,
      u = new CanvasTexture();
    u.minFilter = NearestFilter;
    const f = new FileLoader(this.manager);
    return f.setPath(this.path), f.setWithCredentials(this.withCredentials), f.load(t, function (p) {
      const y = JSON.parse(p),
        v = document.createElement("div");
      v.style.width = y.w + "px", v.style.height = y.h + "px", document.body.appendChild(v);
      const A = lottie.loadAnimation({
        container: v,
        animType: "canvas",
        loop: !0,
        autoplay: !0,
        animationData: y,
        rendererSettings: {
          dpr: n
        }
      });
      u.animation = A, u.image = A.container, A.addEventListener("enterFrame", function () {
        u.needsUpdate = !0;
      }), v.style.display = "none", r !== void 0 && r(u);
    }, i, a), u;
  }
}
const Postmanauts = forwardRef((e, t) => {
  const r = useRef(),
    i = useRef(),
    [a, n] = useState(!1),
    u = useRef(1),
    {
      floatSpeed: f,
      postManautScale: p,
      floatingRangeMin: y,
      floatingRangeMax: v,
      postManautPosition: A
    } = useControls("Postmanaut", {
      postManautScale: {
        label: "Scale",
        value: e.postManautScale,
        min: 0.75,
        max: 1.25,
        step: 0.01
      },
      postManautPosition: {
        label: "Position",
        value: e.postManautPosition,
        step: 0.01
      },
      floatSpeed: {
        label: "Float Speed",
        value: e.postManautFloatSpeed,
        min: 0,
        max: 15,
        step: 0.01
      },
      floatingRangeMin: {
        label: "Float Min Range",
        value: e.postManautFloatBounds[0],
        min: 0,
        max: 2,
        step: 0.01
      },
      floatingRangeMax: {
        label: "Float Max Range",
        value: e.postManautFloatBounds[1],
        min: 0,
        max: 2,
        step: 0.01
      }
    }, {
      collapsed: !0
    });
  useEffect(() => {
    const E = new LottieLoader();
    E.setQuality(2), E.load(`${e.assetsFolder}/postmanaut.json`, d => {
      r.current.material.map = d, r.current.material.needsUpdate = !0, d.animation.autoplay = !1, d.animation.loop = !1, i.current = d.animation, n(!0);
    });
  }, []);
  function c() {
    u.current = u.current === 1 ? -1 : 1, i.current.setDirection(u.current), i.current.play();
  }
  return useEffect(() => {
    if (a) return i.current.addEventListener("complete", c), () => {
      i.current.removeEventListener("complete", c);
    };
  }, [a]), /* @__PURE__ */jsx("group", {
    ref: t,
    ...e,
    children: /* @__PURE__ */jsx("group", {
      position: A,
      children: /* @__PURE__ */jsx(Float, {
        speed: f,
        rotationIntensity: 0,
        floatIntensity: 2,
        floatingRange: [v, y],
        children: /* @__PURE__ */jsxs("mesh", {
          ref: r,
          scale: [p, p * (334 / 250), p],
          children: [/* @__PURE__ */jsx("planeGeometry", {
            args: [1, 1]
          }), /* @__PURE__ */jsx("meshBasicMaterial", {
            transparent: !0
          })]
        })
      })
    })
  });
});
function PostmanGlobe(_ref14) {
  let {
    aspectRatio: e = 1.5,
    width: t = "845px",
    maxWidth: r = "100%",
    border: i = "1px solid rgba(0, 0, 0, 0.1)",
    stars1Seed: a = 237,
    stars1Amount: n = 1300,
    stars1Size: u = 17.5,
    stars2Seed: f = 15,
    stars2Amount: p = 2500,
    stars2Size: y = 17.5,
    assetsFolder: v = "",
    startRotation: A = [0.72, 0.1],
    radius: c = 1.65,
    outlineThickness: E = 1.1,
    countryFillNoData: d = "#ffd099",
    countryFillHasData: g = "#ffb967",
    countryFillHover: I = "#ff8a01",
    countryStrokes: o = !0,
    countryStrokeOpacity: s = 1,
    infoBoxHeaderColor: l = "#ff8a01",
    infoBoxShadowOpacity: h = 1,
    infoBoxShadowDistance: m = 4,
    infoBoxWidth: S = 300,
    infoBoxHeight: b = 230,
    infoBoxScale: T = 0.8,
    cameraPan: C = [0.5, 0.25],
    cameraPanRotation: F = 2.5,
    postManautScale: w = 1,
    postManautPosition: k = [-1.65, -1.75, 2],
    postManautFloatSpeed: L = 4,
    postManautFloatBounds: B = [0.5, 0.65]
  } = _ref14;
  const x = useRef(),
    N = useRef(),
    P = /[?&]debug/.test(location.search);
  useControls({
    "Animate in": button(() => Y(x.current))
  });
  const {
      widthControl: _,
      maxWidthControl: M,
      aspectRatioControl: R
    } = useControls("Canvas", {
      widthControl: {
        label: "Base width",
        value: t
      },
      maxWidthControl: {
        label: "Max Width",
        value: r
      },
      aspectRatioControl: {
        label: "Aspect Ratio",
        value: e,
        min: 0,
        max: 2,
        step: 1e-3
      }
    }, {
      collapsed: !0
    }),
    G = useRef(),
    D = useRef(),
    z = {
      cam: {
        position: [0, 0, 12.5],
        near: 0.1,
        fov: 20
      },
      initialGroupPosition: [0, 5, -2],
      initialStarsPosition: [0, 20, 0]
    },
    Y = X => {
      X !== null && (x.current = X, anime({
        targets: X.position,
        x: [z.initialGroupPosition[0], 0],
        y: [z.initialGroupPosition[1], 0],
        z: [z.initialGroupPosition[2], 0],
        easing: "easeOutExpo",
        duration: 3e3
      }), anime({
        targets: D.current.position,
        y: [5, 0],
        easing: "easeOutExpo",
        duration: 3e3
      }), anime({
        targets: N.current.position,
        x: [z.initialStarsPosition[0], 0],
        y: [z.initialStarsPosition[1], 0],
        z: [z.initialStarsPosition[2], 0],
        easing: "easeOutExpo",
        begin: () => {
          N.current.visible = !0;
        },
        duration: 3e3
      }));
    },
    {
      stars1SeedControl: Z,
      stars1AmountControl: q,
      stars1SizeControl: t1
    } = useControls("Stars 1 (big)", {
      stars1SeedControl: {
        label: "Seed",
        value: a,
        min: 0,
        max: 1e3,
        step: 1
      },
      stars1AmountControl: {
        label: "Amount",
        value: n,
        min: 0,
        max: 5e3,
        step: 100
      },
      stars1SizeControl: {
        label: "Size",
        value: u,
        min: 0,
        max: 100,
        step: 0.1
      }
    }, {
      collapsed: !0
    }),
    {
      stars2SeedControl: r1,
      stars2AmountControl: a1,
      stars2SizeControl: e1
    } = useControls("Stars 2 (small)", {
      stars2SeedControl: {
        label: "Seed",
        value: f,
        min: 0,
        max: 1e3,
        step: 1
      },
      stars2AmountControl: {
        label: "Amount",
        value: p,
        min: 0,
        max: 5e3,
        step: 100
      },
      stars2SizeControl: {
        label: "Size",
        value: y,
        min: 0,
        max: 100,
        step: 0.1
      }
    }, {
      collapsed: !0
    });
  return /* @__PURE__ */jsxs("div", {
    className: "postman-globe",
    style: {
      aspectRatio: R,
      width: _,
      maxWidth: M,
      border: i
    },
    children: [/* @__PURE__ */jsx(Leva, {
      hidden: !P
    }), /* @__PURE__ */jsxs(Canvas, {
      gl: {
        toneMapping: NoToneMapping
      },
      dpr: [1, 2],
      style: {
        overflow: ""
      },
      children: [/* @__PURE__ */jsx(PerspectiveCamera, {
        ref: G,
        makeDefault: !0,
        position: z.cam.position,
        near: z.cam.near,
        fov: z.cam.fov
      }), /* @__PURE__ */jsx("ambientLight", {
        intensity: 1
      }), /* @__PURE__ */jsx(Suspense, {
        fallback: null,
        children: /* @__PURE__ */jsxs("group", {
          ref: P ? x : Y,
          children: [/* @__PURE__ */jsxs("group", {
            ref: N,
            visible: P,
            children: [/* @__PURE__ */jsx(Stars, {
              image: `${v}/Star1.png`,
              size: t1,
              count: q,
              seed: Z,
              distance: 250
            }), /* @__PURE__ */jsx(Stars, {
              image: `${v}/Star2.png`,
              size: e1,
              count: a1,
              seed: r1,
              distance: 250
            })]
          }), /* @__PURE__ */jsx(RotatableMesh, {
            startRotation: A,
            children: /* @__PURE__ */jsx("group", {
              children: /* @__PURE__ */jsx(Globe, {
                radius: c,
                outlineThickness: E,
                countryFillNoData: d,
                countryFillHasData: g,
                countryFillHover: I,
                countryStrokes: o,
                countryStrokeOpacity: s,
                infoBoxHeaderColor: l,
                infoBoxShadowOpacity: h,
                infoBoxShadowDistance: m,
                infoBoxWidth: S,
                infoBoxHeight: b,
                infoBoxScale: T
              })
            })
          }), /* @__PURE__ */jsx(Rig, {
            cameraPan: C,
            cameraPanRotation: F
          }), /* @__PURE__ */jsx(Postmanauts, {
            ref: D,
            assetsFolder: v,
            postManautScale: w,
            postManautPosition: k,
            postManautFloatSpeed: L,
            postManautFloatBounds: B
          })]
        })
      })]
    })]
  });
}
export { PostmanGlobe };